import {
  toString1pkumu07cwy4m as toString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  createThis2j2avj17cvnv2 as createThis,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Unit_instance104q5opgivhr8 as Unit_instance,
  addAll1k27qatfgp3k5 as addAll,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  first58ocm7j58k3q as first,
  to2cs3ny02qtbcb as to,
  mapOf2zpbbmyqk8xpf as mapOf,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  firstOrNulltrxqttxfxqju as firstOrNull,
  Char19o2r8palgjof as Char,
  toString30pk9tzaqopn as toString_0,
  startsWith26w8qjqapeeq6 as startsWith,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  startsWith1bgirhbedtv2y as startsWith_0,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toInt2q8uldh7sc951 as toInt,
  last1vo29oleiqj36 as last,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  emptyList1g2z5xcrvp2zy as emptyList,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KtList3hktaavzmj137 as KtList,
  plus39kp8wyage607 as plus,
  lines3g90sq0zeq43v as lines,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  contains2el4s70rdq4ld as contains,
  toBoolean2azvnq2ukl7b3 as toBoolean,
  split2bvyvnrlcifjv as split_0,
  listOfvhqybd2zx248 as listOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Enum3alwj03lh1n41 as Enum,
  toList3jhuyej2anx2q as toList,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  lazy2hsh8ze7j6ikd as lazy,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  until1jbpn0z3f8lbg as until,
  listOf1jh22dvmctj1r as listOf_0,
  abs1kdzbjes1idip as abs,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  mapOf1xd03cq9cnmy8 as mapOf_0,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt_0,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains_0,
  Collection1k04j3hzsbod0 as Collection,
  indexOff2hgzjbxdcp4 as indexOf,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  sum2ku6kbgxq0lee as sum,
  Char__toInt_impl_vasixd1g1ubcha2b2yr as Char__toInt_impl_vasixd,
  protoOf180f3jzyo7rfj as protoOf,
  HashMap1a0ld5kgwhmhv as HashMap,
  firstOrNullf6vlo6vdgu1e as firstOrNull_0,
  first28gmhyvs4kf06 as first_0,
  toMap1vec9topfei08 as toMap,
  plus310ted5e4i90h as plus_0,
  numberToChar93r9buh19yek as numberToChar,
  toString26mv3gzfo7fn as toString_1,
  toDouble1kn912gjoizjp as toDouble,
  Char__rangeTo_impl_tkncvp2up16j2a74v0 as Char__rangeTo_impl_tkncvp,
  joinToString1cxrrlmo0chqs as joinToString,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toIntArray2d4xwvtjb01mq as toIntArray,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs2ntz2k8jdtq63 as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  println2shhhgwwt4c61 as println,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  roundToInt1ue8x8yshtznx as roundToInt,
  firstOrNull1982767dljvdy as firstOrNull_1,
  CancellationException3b36o9qz53rgr as CancellationException,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration__toString_impl_8d916b1f2vqqjkgwgjr as Duration__toString_impl_8d916b,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  distinct10qe1scfdvu5k as distinct,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjue8oeapgr66d as Char__plus_impl_qi7pgj,
  Default_getInstance324kkay623mzd as Default_getInstance,
  step18s9qzr5xwxat as step,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  toIntArray27j90pvfixv10 as toIntArray_0,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortWith4fnm6b3vw03s as sortWith,
  contains3ue2qo8xhmpf1 as contains_1,
  slice2g43wio9c6zdv as slice,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_1,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  Duration5ynfiptaqcrg as Duration,
  toMapcf6xfku344cz as toMap_0,
  endsWith3cq61xxngobwh as endsWith,
  Duration__hashCode_impl_u4exz62r1u73vv4y0lk as Duration__hashCode_impl_u4exz6,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  Duration__div_impl_dknbf438qfgvtpimpa9 as Duration__div_impl_dknbf4,
  lastOrNull1aq5oz189qoe1 as lastOrNull_0,
  lastOrNulllcnpzslswkag as lastOrNull_1,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart5ewg8zf6cs5u as trimStart,
  trimEnd17pt8cbotbalj as trimEnd,
  Regexxgw0gjiagf4z as Regex,
  drop3na99dw9feawf as drop,
  plus20p0vtfmu0596 as plus_2,
  removeLast3759euu1xvfa3 as removeLast,
  dropLast1vpiyky649o34 as dropLast,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  Companion_getInstance1pxg306pnafvz as Companion_getInstance_0,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  KProperty02ce7r476m8633 as KProperty0,
  Paire9pteg33gng7 as Pair,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  Char__hashCode_impl_otmysaxeh01anngge as Char__hashCode_impl_otmys,
  ValueTimeMark__minus_impl_f87sko1pcxed03k2z1m as ValueTimeMark__minus_impl_f87sko,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_1,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_2,
  MarginInt3jiec8xsxkfd as MarginInt,
  Companion_instance3cau272s9vxbi as Companion_instance_0,
  Companion_getInstance9hqru60m2833 as Companion_getInstance_3,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_4,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstance3om7tc9mg7edv as Companion_getInstance_5,
  _BoundsBuilder___get_bounds__impl__s1l1gx3cti8ahdxq1b5 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7x3c46o898gf5al as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7x3pz0lxdivao0o as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance1ygiwm9bgjia3 as Companion_getInstance_6,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901frdiuz4dirxfxh as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd1uvzni4k9abn0 as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndt1v9it5377zvl as Angle__hashCode_impl_szcndt,
  get_degrees1wvulgxbo1fy6 as get_degrees_0,
  get_radians87y5j8tewvub as get_radians,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m23vaitgwxe5y8m as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh71jc5bjlliwupe as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbouv25pt0ki4b7 as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7x1gtmpkit3llyq as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians_0,
  _Angle___get_degrees__impl__qg56vw1zqnfrqkp8did as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m1vusxs8sthxgw as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on42zzwqtrc65vpb as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg2y0izha8gzbzd as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstancevamvzsx28k56 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt523wqxa1jdhpa1 as _Angle___get_radians__impl__n00yt5,
} from './korlibs-korlibs-math-vector.mjs';
import {
  Dyn__get_impl_6l2p806an9lmzdx97q as Dyn__get_impl_6l2p80,
  _Dyn___get_int__impl__sh8lhm1cuta1m3oa6bm as _Dyn___get_int__impl__sh8lhm,
  _Dyn___get_bool__impl__nv3iun3b5fbq0u806ya as _Dyn___get_bool__impl__nv3iun,
  get_dynw5edstkdie96 as get_dyn,
  Dyng396lmez04lc as Dyn,
  _Dyn___get_value__impl__bemnlg289snf7781s03 as _Dyn___get_value__impl__bemnlg,
  _Dyn___get_list__impl__qpwjpy1x88d8kx8tg as _Dyn___get_list__impl__qpwjp,
  _Dyn___get_orNull__impl__ox3tzj2fenqk0jjmmjz as _Dyn___get_orNull__impl__ox3tzj,
  _Dyn___get_str__impl__dup4cs3qkjliiqi5l9f as _Dyn___get_str__impl__dup4cs,
  _Dyn___get_double__impl__jlvfa039ekym31xde58 as _Dyn___get_double__impl__jlvfa0,
  Dyn__toDoubleDefault_impl_fspogf18eiqqlf0n9f2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1o7rt6j433mfo as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgr1ih96kqmm5wba as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s1r5ef9jhsnww1 as Dyn__toString_impl_9l0v3s,
} from './korlibs-korlibs-dyn.mjs';
import {
  Companion_getInstance2cvx1jnjzsvrw as Companion_getInstance_7,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2xqbs5alo5x1q as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  SliceOrientation__toString_impl_tdph6rkheevwtbsa49 as SliceOrientation__toString_impl_tdph6r,
  SliceOrientation__hashCode_impl_7mjkdw2ysf4kjaf6c21 as SliceOrientation__hashCode_impl_7mjkdw,
  Companion_instance3s1b22cepz6i7 as Companion_instance_1,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bxjxyk0h8ndav as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o1742ytu7rgu88 as _SliceOrientation___get_rotation__impl__m65r0o,
  MVector42dr6dus5luca5 as MVector4,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_3,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default2o4ca59st3p6v as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  splitInRows1cyiez6sz0yy1 as splitInRows,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  cubic3uw6rftl1cilc as cubic,
  get_EASE_CLAMP_START3mw7sc31t8amo as get_EASE_CLAMP_START,
  get_EASE_CLAMP_END2i469hpc6wipw as get_EASE_CLAMP_END,
  interpolate2729pk90l3f88 as interpolate,
  _SliceOrientation___get_raw__impl__tj3u8w3gfaax2oun1df as _SliceOrientation___get_raw__impl__tj3u8w,
  SliceOrientation__flippedX_impl_m25zo9238kxt6n8vuqd as SliceOrientation__flippedX_impl_m25zo9,
  SliceOrientation__flippedY_impl_mj7m2g3ohocif0hlnub as SliceOrientation__flippedY_impl_mj7m2g,
  SliceOrientation__rotatedRight_impl_m8di3ghw918f3d536q as SliceOrientation__rotatedRight_impl_m8di3g,
  Winding_EVEN_ODD_getInstance2nlckv54zgzhj as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance2yrgpxwoeu923 as Companion_getInstance_8,
  LineScaleMode_NORMAL_getInstance349p0dssy4fun as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstanceb57ygh36gdst as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance3doesgezxmixn as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance2zsru2lm79i6x as Winding_NON_ZERO_getInstance,
  moveTo1v59p8psmu2yv as moveTo,
  lineTo35eirmrqxz1l0 as lineTo,
  line3u2mk0n2uhnlh as line,
  arcTo1g4ivunekrrtg as arcTo,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  rect31ka0uv7vbtav as rect_2,
  roundRect2sqmspzw5002d as roundRect,
  roundRect3456nlcytya47 as roundRect_0,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  ellipse2rxvxxfaddo1k as ellipse,
  lineToHqj5ppmwlqa9l as lineToH,
  lineToV2af0qnj7t3mk2 as lineToV,
  rLineToH2txnr065wfrbz as rLineToH,
  rLineToV3iwt0xj4dbrft as rLineToV,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance2iuza9dwssjbj as Companion_getInstance_9,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  Companion_instancepc31xltlz6n5 as Companion_instance_2,
  Companion_instance1s5n1f8qczy96 as Companion_instance_3,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-korlibs-math.mjs';
import {
  Companion_getInstance1ijxhf2kvgag6 as Companion_getInstance_10,
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  get_isText26l7ptq9ktzap as get_isText,
} from './korlibs-korlibs-serialization.mjs';
import {
  ListReader37jxep6q6wbzq as ListReader,
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instance1nrsidgsshcc7 as Companion_instance_4,
  Companion_instance1pvn6c7thxh4 as Companion_instance_5,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  toLinkedMap37vdtde5j2z8d as toLinkedMap,
  reader2h6ma9ht1vbo2 as reader,
  expect28ynvao96agxo as expect,
  toDeque2gx2crptp8sro as toDeque,
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  BaseDelegatedStackedArray2i6xcy52y4r2o as BaseDelegatedStackedArray2,
  StackedLongArray2rhxzonenq3dr as StackedLongArray2,
  IStackedArray2Baseutd8qm80cz0q as IStackedArray2Base,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgtbdasgrb15naj as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t3meiyro65i033 as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa03row6p4nvthsp as TGenStack__pop_impl_qisxa0,
} from './korlibs-korlibs-datastructure.mjs';
import {
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  extractScaledFF37en8uu0vajkj as extractScaledFF,
  extractScaledFFDefault1jt5eyc4afdti as extractScaledFFDefault,
  interpolate1wglaj6k11c6v as interpolate_0,
  interpolatexm8yaf0iv9q9 as interpolate_1,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  Ratio__toFloat_impl_1ftup5294anfb3s41c1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  clamp012a0sd8pj80ati as clamp01_0,
  toRatio1hooqit5gulhr as toRatio_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance_11,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  hasBitSet141smdymg86x0 as hasBitSet,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2cg32u2k0cnlg as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  Ratio__toDouble_impl_o7epze3e3zsci3ipwe7 as Ratio__toDouble_impl_o7epze,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  Companion_getInstancech3bi94cc2ym as Companion_getInstance_12,
  Ratio__toString_impl_mfgt3e2hpoo0nu4cwhr as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v7lufr2urxbhm as Ratio__hashCode_impl_quhc2v,
  Ratio__compareTo_impl_z2ienc1iwi3w3dhe1b7 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange_0,
  Ratio136tf4z2t0p2d as Ratio,
  _Ratio___init__impl__9mwvn21rjrz0s2y877i as _Ratio___init__impl__9mwvn2_0,
  interpolate2g7wzskc23f1q as interpolate_2,
  interpolate35pbs3ac913y4 as interpolate_3,
  Ratio__times_impl_ucdh7y1eb1bj32n3p46 as Ratio__times_impl_ucdh7y,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  extract16Signed1oywtbmsx4vcm as extract16Signed,
  fromLowHigh12fm8h1tmjclj as fromLowHigh,
  insert2fz5125p2hdyd as insert_0,
  Companion_instance1hng7e117o7dr as Companion_instance_6,
  IntMaskRange__extractSigned_impl_s8qphq2famz7h8sv4u4 as IntMaskRange__extractSigned_impl_s8qphq,
  maskkmj9g5rvi2pr as mask,
  umod164hvijxhfi8p as umod,
  _Ratio___init__impl__9mwvn21qo8ztog8o9ep as _Ratio___init__impl__9mwvn2_1,
  umodgae5ifx362au as umod_0,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-korlibs-math-core.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  toFastList32ukjb68l6wd7 as toFastList,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  getExtra307y0o9pd6mp3 as getExtra,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-korlibs-datastructure-core.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_13,
  Companion_instance21jklwk36y3dn as Companion_instance_7,
  expand3u1pyjx0md5pc as expand,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstancel551vnoq34sw as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstancelbfxpgu7xewo as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
} from './korlibs-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a12ofefwxigfcv as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45322e8gdcoopwt46 as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3pdjaoxauimyc as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb82ugyoyyu34uy3 as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2x2oeh0jr5fvg as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k1fu51oh2yw4qc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getS32Array39c2ui7l3wxdu as getS32Array,
  getS32ArrayLE2u84ix7qnexrb as getS32ArrayLE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu2cberlddfaqn1 as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  _UByteArrayInt___get_size__impl__bcjnte3rwa3i1eytgix as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstanceyicqcjxy8shz as Companion_getInstance_14,
  Charsets_instancenv17fp98ne59 as Charsets_instance,
  ASCII_getInstance1x38t72vrtpyt as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  Companion_instance29c5vc3xudisn as Companion_instance_8,
  skipWhile2q7z6jpi2pkj6 as skipWhile,
  splitInChunks2h1zfocl4rvqy as splitInChunks,
  splitKeep2hxk3xif9u3vx as splitKeep,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu291ypbecez861 as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
  get_isNumeric3g36pzg3a1w7z as get_isNumeric,
  get_eofrk1bzx8ckgtd as get_eof,
  skipSpaces25iogcdi8m3q2 as skipSpaces,
  skipExpect1tagjz9aj6y5q as skipExpect,
  isLetterOrDigit1ja5dr081kl50 as isLetterOrDigit,
  isDigit1w4owst7y9rdz as isDigit,
  isWhitespaceFast2iszcfvpi3biz as isWhitespaceFast,
} from './korlibs-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-korlibs-encoding.mjs';
import {
  Companion_getInstance27y7ak0p8xjnv as Companion_getInstance_15,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-korlibs-compression.mjs';
import {
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_16,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  Level_DEBUG_getInstance2cjwrm9110zsz as Level_DEBUG_getInstance,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
} from './korlibs-korlibs-logger.mjs';
import {
  VfsFileFromData3esxwyyzmvxag as VfsFileFromData,
  get_baseName2yf63efofm8te as get_baseName,
  MemoryVfs23lbcbyysxxy3 as MemoryVfs,
  readAsSyncStream1fxi8ije69l8f as readAsSyncStream,
  get_extensionLC3gx4qkgbywkav as get_extensionLC,
  getUnderlyingUnscapedFile1x96alth7xqs as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-korlibs-io-vfs.mjs';
import { localVfs1bmv3sf89y0wp as localVfs } from './korlibs-korlibs-io.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
} from './kotlinx-coroutines-core.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  runBlockingNoJs1ylyxdz3tnq2x as runBlockingNoJs,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-korlibs-concurrent.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  AsyncStream2lau9k1bvym4m as AsyncStream,
  readBytesUpTo9uslmwqcrcrn as readBytesUpTo,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readBytesExact2w7t0p09xkbt6 as readBytesExact,
  readU16LE24dnvocwt4zgx as readU16LE,
  readS32LE3aqh95gxznf4n as readS32LE,
  readU32LE336f0p4nkvbi as readU32LE,
  readU82o15i0epsnmc5 as readU8,
  readS16LE375f28fer5dhk as readS16LE,
  readStreamp6bgvjd275ek as readStream,
  readAvailablecuh5du6kum51 as readAvailable,
  readString20u8kjncp0xlx as readString,
  sliceHere36xxn3efrum43 as sliceHere,
  readString2uttbyypy7i6f as readString_0,
  readU163oe0yrg3omvh6 as readU16,
  readS32hadcfcfqfot3 as readS32,
  readBytesExactclsk6o5m4pur as readBytesExact_0,
  sliceStart2elugg4aq9q3w as sliceStart,
  readStringztu0bw928vdf2 as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_1,
  readBytes3l26albs0coyl as readBytes,
  readAllc0x1zv8qqb58 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof_0,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream_0,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-korlibs-io-stream.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
} from './korlibs-korlibs-time-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class Entry {
  constructor($outer, info, page) {
    this.q4l_1 = $outer;
    this.m4l_1 = info;
    this.n4l_1 = page;
    var tmp = this;
    var tmp0_elvis_lhs = this.q4l_1.r4l_1.k3(this.n4l_1.v4l_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't find '" + this.n4l_1.v4l_1 + "' in " + toString(this.q4l_1.r4l_1.l3());
      throw IllegalStateException.m5(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.o4l_1 = tmp_0;
    this.p4l_1 = this.o4l_1.x42(this.m4l_1.e4m_1, this.m4l_1.d4m_1, VOID, this.m4l_1.g4m_1).a43(this.m4l_1.f4m_1);
  }
  j4m() {
    return this.m4l_1.d4m_1;
  }
}
class Atlas {
  static k4m(textures, info) {
    info = info === VOID ? AtlasInfo.p4m() : info;
    var $this = createThis(this);
    $this.r4l_1 = textures;
    $this.s4l_1 = info;
    var tmp = $this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = $this.s4l_1.m4m_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.atlas.Atlas.entries.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = element.c4m_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.f1();
      while (tmp0_iterator_0.g1()) {
        var item = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.atlas.Atlas.entries.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Entry($this, item, element);
        destination_0.f(tmp$ret$0);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    tmp.t4l_1 = destination;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_2 = $this.t4l_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap.wc(capacity);
    var tmp0_iterator_1 = this_2.f1();
    while (tmp0_iterator_1.g1()) {
      var element_0 = tmp0_iterator_1.h1();
      // Inline function 'korlibs.image.atlas.Atlas.entriesMap.<anonymous>' call
      var tmp$ret$6 = element_0.j4m();
      destination_1.r3(tmp$ret$6, element_0);
    }
    tmp_0.u4l_1 = destination_1;
    return $this;
  }
  static q4m(texture, info) {
    info = info === VOID ? AtlasInfo.p4m() : info;
    return this.k4m(mapOf(to(first(info.m4m_1).v4l_1, texture)), info);
  }
  r4m(name) {
    return this.u4l_1.k3(name);
  }
}
class Companion {
  constructor() {
    this.y4m_1 = '1.0.0';
  }
}
class Meta {
  constructor(app, format, image, scale, size, version, frameTags, layers, slices) {
    app = app === VOID ? 'app' : app;
    format = format === VOID ? 'format' : format;
    image = image === VOID ? 'image' : image;
    scale = scale === VOID ? 1.0 : scale;
    size = size === VOID ? SizeInt.c2v(1, 1) : size;
    version = version === VOID ? Companion_instance_9.y4m_1 : version;
    var tmp;
    if (frameTags === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = frameTags;
    }
    frameTags = tmp;
    var tmp_0;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    } else {
      tmp_0 = layers;
    }
    layers = tmp_0;
    var tmp_1;
    if (slices === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = slices;
    }
    slices = tmp_1;
    this.a4n_1 = app;
    this.b4n_1 = format;
    this.c4n_1 = image;
    this.d4n_1 = scale;
    this.e4n_1 = size;
    this.f4n_1 = version;
    this.g4n_1 = frameTags;
    this.h4n_1 = layers;
    this.i4n_1 = slices;
  }
  toString() {
    return 'Meta(app=' + this.a4n_1 + ', format=' + this.b4n_1 + ', image=' + this.c4n_1 + ', scale=' + this.d4n_1 + ', size=' + this.e4n_1.toString() + ', version=' + this.f4n_1 + ', frameTags=' + toString(this.g4n_1) + ', layers=' + toString(this.h4n_1) + ', slices=' + toString(this.i4n_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a4n_1);
    result = imul(result, 31) + getStringHashCode(this.b4n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c4n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4n_1) | 0;
    result = imul(result, 31) + this.e4n_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.f4n_1) | 0;
    result = imul(result, 31) + hashCode(this.g4n_1) | 0;
    result = imul(result, 31) + hashCode(this.h4n_1) | 0;
    result = imul(result, 31) + hashCode(this.i4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Meta))
      return false;
    var tmp0_other_with_cast = other instanceof Meta ? other : THROW_CCE();
    if (!(this.a4n_1 === tmp0_other_with_cast.a4n_1))
      return false;
    if (!(this.b4n_1 === tmp0_other_with_cast.b4n_1))
      return false;
    if (!(this.c4n_1 === tmp0_other_with_cast.c4n_1))
      return false;
    if (!equals(this.d4n_1, tmp0_other_with_cast.d4n_1))
      return false;
    if (!this.e4n_1.equals(tmp0_other_with_cast.e4n_1))
      return false;
    if (!(this.f4n_1 === tmp0_other_with_cast.f4n_1))
      return false;
    if (!equals(this.g4n_1, tmp0_other_with_cast.g4n_1))
      return false;
    if (!equals(this.h4n_1, tmp0_other_with_cast.h4n_1))
      return false;
    if (!equals(this.i4n_1, tmp0_other_with_cast.i4n_1))
      return false;
    return true;
  }
}
class FrameTag {
  constructor(name, from, to, direction) {
    name = name === VOID ? '' : name;
    from = from === VOID ? 0 : from;
    to = to === VOID ? 0 : to;
    direction = direction === VOID ? '' : direction;
    this.j4n_1 = name;
    this.k4n_1 = from;
    this.l4n_1 = to;
    this.m4n_1 = direction;
  }
  toString() {
    return 'FrameTag(name=' + this.j4n_1 + ', from=' + this.k4n_1 + ', to=' + this.l4n_1 + ', direction=' + this.m4n_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.j4n_1);
    result = imul(result, 31) + this.k4n_1 | 0;
    result = imul(result, 31) + this.l4n_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.m4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FrameTag))
      return false;
    var tmp0_other_with_cast = other instanceof FrameTag ? other : THROW_CCE();
    if (!(this.j4n_1 === tmp0_other_with_cast.j4n_1))
      return false;
    if (!(this.k4n_1 === tmp0_other_with_cast.k4n_1))
      return false;
    if (!(this.l4n_1 === tmp0_other_with_cast.l4n_1))
      return false;
    if (!(this.m4n_1 === tmp0_other_with_cast.m4n_1))
      return false;
    return true;
  }
}
class Layer {
  constructor(name, opacity, blendMode) {
    name = name === VOID ? '' : name;
    opacity = opacity === VOID ? 255 : opacity;
    blendMode = blendMode === VOID ? '' : blendMode;
    this.n4n_1 = name;
    this.o4n_1 = opacity;
    this.p4n_1 = blendMode;
  }
  toString() {
    return 'Layer(name=' + this.n4n_1 + ', opacity=' + this.o4n_1 + ', blendMode=' + this.p4n_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n4n_1);
    result = imul(result, 31) + this.o4n_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.p4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Layer))
      return false;
    var tmp0_other_with_cast = other instanceof Layer ? other : THROW_CCE();
    if (!(this.n4n_1 === tmp0_other_with_cast.n4n_1))
      return false;
    if (!(this.o4n_1 === tmp0_other_with_cast.o4n_1))
      return false;
    if (!(this.p4n_1 === tmp0_other_with_cast.p4n_1))
      return false;
    return true;
  }
}
class Slice {
  constructor(name, color, keys) {
    name = name === VOID ? 'slice' : name;
    color = color === VOID ? '#0000ffff' : color;
    this.q4n_1 = name;
    this.r4n_1 = color;
    this.s4n_1 = keys;
  }
  toString() {
    return 'Slice(name=' + this.q4n_1 + ', color=' + this.r4n_1 + ', keys=' + toString(this.s4n_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.q4n_1);
    result = imul(result, 31) + getStringHashCode(this.r4n_1) | 0;
    result = imul(result, 31) + hashCode(this.s4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Slice))
      return false;
    var tmp0_other_with_cast = other instanceof Slice ? other : THROW_CCE();
    if (!(this.q4n_1 === tmp0_other_with_cast.q4n_1))
      return false;
    if (!(this.r4n_1 === tmp0_other_with_cast.r4n_1))
      return false;
    if (!equals(this.s4n_1, tmp0_other_with_cast.s4n_1))
      return false;
    return true;
  }
}
class Key {
  constructor(frame, bounds) {
    frame = frame === VOID ? 0 : frame;
    this.t4n_1 = frame;
    this.u4n_1 = bounds;
  }
  toString() {
    return 'Key(frame=' + this.t4n_1 + ', bounds=' + this.u4n_1.toString() + ')';
  }
  hashCode() {
    var result = this.t4n_1;
    result = imul(result, 31) + this.u4n_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Key))
      return false;
    var tmp0_other_with_cast = other instanceof Key ? other : THROW_CCE();
    if (!(this.t4n_1 === tmp0_other_with_cast.t4n_1))
      return false;
    if (!this.u4n_1.equals(tmp0_other_with_cast.u4n_1))
      return false;
    return true;
  }
}
class Page {
  constructor(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) {
    this.v4l_1 = fileName;
    this.w4l_1 = size;
    this.x4l_1 = format;
    this.y4l_1 = filterMin;
    this.z4l_1 = filterMag;
    this.a4m_1 = repeatX;
    this.b4m_1 = repeatY;
    this.c4m_1 = regions;
  }
  v4n(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) {
    return new Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions);
  }
  w4n(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions, $super) {
    fileName = fileName === VOID ? this.v4l_1 : fileName;
    size = size === VOID ? this.w4l_1 : size;
    format = format === VOID ? this.x4l_1 : format;
    filterMin = filterMin === VOID ? this.y4l_1 : filterMin;
    filterMag = filterMag === VOID ? this.z4l_1 : filterMag;
    repeatX = repeatX === VOID ? this.a4m_1 : repeatX;
    repeatY = repeatY === VOID ? this.b4m_1 : repeatY;
    regions = regions === VOID ? this.c4m_1 : regions;
    return $super === VOID ? this.v4n(fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions) : $super.v4n.call(this, fileName, size, format, filterMin, filterMag, repeatX, repeatY, regions);
  }
  toString() {
    return 'Page(fileName=' + this.v4l_1 + ', size=' + this.w4l_1.toString() + ', format=' + this.x4l_1 + ', filterMin=' + this.y4l_1 + ', filterMag=' + this.z4l_1 + ', repeatX=' + this.a4m_1 + ', repeatY=' + this.b4m_1 + ', regions=' + toString(this.c4m_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.v4l_1);
    result = imul(result, 31) + this.w4l_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.x4l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y4l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z4l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a4m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b4m_1) | 0;
    result = imul(result, 31) + hashCode(this.c4m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Page))
      return false;
    var tmp0_other_with_cast = other instanceof Page ? other : THROW_CCE();
    if (!(this.v4l_1 === tmp0_other_with_cast.v4l_1))
      return false;
    if (!this.w4l_1.equals(tmp0_other_with_cast.w4l_1))
      return false;
    if (!(this.x4l_1 === tmp0_other_with_cast.x4l_1))
      return false;
    if (!(this.y4l_1 === tmp0_other_with_cast.y4l_1))
      return false;
    if (!(this.z4l_1 === tmp0_other_with_cast.z4l_1))
      return false;
    if (!(this.a4m_1 === tmp0_other_with_cast.a4m_1))
      return false;
    if (!(this.b4m_1 === tmp0_other_with_cast.b4m_1))
      return false;
    if (!equals(this.c4m_1, tmp0_other_with_cast.c4m_1))
      return false;
    return true;
  }
}
class Region {
  static z4m(name, frame, virtFrame, imageOrientation) {
    virtFrame = virtFrame === VOID ? null : virtFrame;
    var tmp;
    if (imageOrientation === VOID) {
      // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call
      tmp = Companion_getInstance_7().v40_1;
    } else {
      tmp = imageOrientation;
    }
    imageOrientation = tmp;
    var $this = createThis(this);
    $this.d4m_1 = name;
    $this.e4m_1 = frame;
    $this.f4m_1 = virtFrame;
    $this.g4m_1 = imageOrientation;
    $this.h4m_1 = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this.g4m_1) ? $this.e4m_1.c2u_1 : $this.e4m_1.b2u_1;
    $this.i4m_1 = _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this.g4m_1) ? $this.e4m_1.b2u_1 : $this.e4m_1.c2u_1;
    return $this;
  }
  static x4n(name, frame, rotated, sourceSize, spriteSourceSize, trimmed, orig, offset) {
    orig = orig === VOID ? SizeInt.c2v(0, 0) : orig;
    offset = offset === VOID ? Companion_getInstance_1().a2i_1 : offset;
    return this.z4m(name, frame, !(offset.i2h_1 === 0.0) || !(offset.j2h_1 === 0.0) || !(orig.a2v_1 === 0) || !(orig.b2v_1 === 0) ? RectangleInt.d2u(numberToInt(offset.i2h_1), numberToInt(offset.j2h_1), orig.a2v_1, orig.b2v_1) : !(spriteSourceSize.z2t_1 === 0) || !(spriteSourceSize.a2u_1 === 0) || !(sourceSize.a2v_1 === frame.c2u_1) || !(sourceSize.b2v_1 === frame.b2u_1) ? RectangleInt.d2u(spriteSourceSize.z2t_1, spriteSourceSize.a2u_1, sourceSize.a2v_1, sourceSize.b2v_1) : null, rotated ? Companion_getInstance_7().w40_1 : Companion_getInstance_7().v40_1);
  }
  toString() {
    return 'Region(name=' + this.d4m_1 + ', frame=' + this.e4m_1.toString() + ', virtFrame=' + toString_0(this.f4m_1) + ', imageOrientation=' + SliceOrientation__toString_impl_tdph6r(this.g4m_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.d4m_1);
    result = imul(result, 31) + this.e4m_1.hashCode() | 0;
    result = imul(result, 31) + (this.f4m_1 == null ? 0 : this.f4m_1.hashCode()) | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.g4m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Region))
      return false;
    var tmp0_other_with_cast = other instanceof Region ? other : THROW_CCE();
    if (!(this.d4m_1 === tmp0_other_with_cast.d4m_1))
      return false;
    if (!this.e4m_1.equals(tmp0_other_with_cast.e4m_1))
      return false;
    if (!equals(this.f4m_1, tmp0_other_with_cast.f4m_1))
      return false;
    if (!(this.g4m_1 === tmp0_other_with_cast.g4m_1))
      return false;
    return true;
  }
}
class Companion_0 {
  x4m(json) {
    var it = get_dyn(Companion_getInstance_10().i2d(json));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
    var framesDyn = Dyn__get_impl_6l2p80(it, 'frames');
    var frames = _Dyn___get_value__impl__bemnlg(framesDyn);
    var tmp;
    if (!(frames == null) ? isInterface(frames, KtMap) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = frames.l3();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        var tmp$ret$0 = createEntry(Companion_instance_10, _Dyn___get_str__impl__dup4cs(get_dyn(item)), Dyn__get_impl_6l2p80(framesDyn, _Dyn___get_str__impl__dup4cs(get_dyn(item))));
        destination.f(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_1 = _Dyn___get_list__impl__qpwjp(framesDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.f1();
      while (tmp0_iterator_0.g1()) {
        var item_0 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        var it_0 = item_0.e3h_1;
        var tmp_0 = Companion_instance_10;
        var tmp6_safe_receiver = _Dyn___get_orNull__impl__ox3tzj(Dyn__get_impl_6l2p80(it_0, 'name'));
        var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : _Dyn___get_str__impl__dup4cs(tmp6_safe_receiver.e3h_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          var tmp7_safe_receiver = _Dyn___get_orNull__impl__ox3tzj(Dyn__get_impl_6l2p80(it_0, 'filename'));
          tmp_1 = tmp7_safe_receiver == null ? null : _Dyn___get_str__impl__dup4cs(tmp7_safe_receiver.e3h_1);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var tmp1_elvis_lhs = tmp_1;
        var tmp$ret$3 = createEntry(tmp_0, tmp1_elvis_lhs == null ? 'unknown' : tmp1_elvis_lhs, it_0);
        destination_0.f(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var tmp_2 = tmp;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
    var it_1 = Dyn__get_impl_6l2p80(it, 'meta');
    var tmp_3 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'app'));
    var tmp_4 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'format'));
    var tmp_5 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'image'));
    var tmp_6 = _Dyn___get_double__impl__jlvfa0(Dyn__get_impl_6l2p80(it_1, 'scale'));
    var tmp_7 = toSize(Dyn__get_impl_6l2p80(it_1, 'size'), Companion_instance_10);
    var tmp_8 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_1, 'version'));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var frameTagsDyn = Dyn__get_impl_6l2p80(it_1, 'frameTags');
    var frameTags = _Dyn___get_value__impl__bemnlg(frameTagsDyn);
    var tmp_9;
    if (!(frameTags == null) ? isInterface(frameTags, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_2 = _Dyn___get_list__impl__qpwjp(frameTagsDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_1 = this_2.f1();
      while (tmp0_iterator_1.g1()) {
        var item_1 = tmp0_iterator_1.h1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var it_2 = item_1.e3h_1;
        var tmp$ret$8 = new FrameTag(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_2, 'name')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_2, 'from')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_2, 'to')), _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_2, 'direction')));
        destination_1.f(tmp$ret$8);
      }
      tmp_9 = destination_1;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_9 = emptyList();
    }
    var tmp_10 = tmp_9;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var layersDyn = Dyn__get_impl_6l2p80(it_1, 'layers');
    var layers = _Dyn___get_value__impl__bemnlg(layersDyn);
    var tmp_11;
    if (!(layers == null) ? isInterface(layers, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_3 = _Dyn___get_list__impl__qpwjp(layersDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
      var tmp0_iterator_2 = this_3.f1();
      while (tmp0_iterator_2.g1()) {
        var item_2 = tmp0_iterator_2.h1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var it_3 = item_2.e3h_1;
        var tmp$ret$14 = new Layer(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_3, 'name')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_3, 'opacity')), _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_3, 'blendMode')));
        destination_2.f(tmp$ret$14);
      }
      tmp_11 = destination_2;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_11 = emptyList();
    }
    var tmp_12 = tmp_11;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
    var slicesDyn = Dyn__get_impl_6l2p80(it_1, 'slices');
    var slices = _Dyn___get_value__impl__bemnlg(slicesDyn);
    var tmp_13;
    if (!(slices == null) ? isInterface(slices, KtList) : false) {
      // Inline function 'kotlin.collections.map' call
      var this_4 = _Dyn___get_list__impl__qpwjp(slicesDyn);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList.w(collectionSizeOrDefault(this_4, 10));
      var tmp0_iterator_3 = this_4.f1();
      while (tmp0_iterator_3.g1()) {
        var item_3 = tmp0_iterator_3.h1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        var it_4 = item_3.e3h_1;
        var tmp_14 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_4, 'name'));
        var tmp_15 = _Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80(it_4, 'color'));
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        var keysDyn = Dyn__get_impl_6l2p80(it_4, 'keys');
        var keys = _Dyn___get_value__impl__bemnlg(keysDyn);
        var tmp_16;
        if (!(keys == null) ? isInterface(keys, KtList) : false) {
          // Inline function 'kotlin.collections.map' call
          var this_5 = _Dyn___get_list__impl__qpwjp(keysDyn);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_4 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
          var tmp0_iterator_4 = this_5.f1();
          while (tmp0_iterator_4.g1()) {
            var item_4 = tmp0_iterator_4.h1();
            // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var it_5 = item_4.e3h_1;
            var tmp$ret$20 = new Key(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_5, 'frame')), toRect(Dyn__get_impl_6l2p80(it_5, 'bounds'), Companion_instance_10));
            destination_4.f(tmp$ret$20);
          }
          tmp_16 = destination_4;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          tmp_16 = emptyList();
        }
        var tmp$ret$25 = tmp_16;
        var tmp$ret$26 = new Slice(tmp_14, tmp_15, tmp$ret$25);
        destination_3.f(tmp$ret$26);
      }
      tmp_13 = destination_3;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_13 = emptyList();
    }
    var tmp$ret$31 = tmp_13;
    var tmp$ret$33 = new Meta(tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_12, tmp$ret$31);
    var info = AtlasInfo.y4n(tmp_2, tmp$ret$33);
    // Inline function 'kotlin.collections.map' call
    var this_6 = info.m4m_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList.w(collectionSizeOrDefault(this_6, 10));
    var tmp0_iterator_5 = this_6.f1();
    while (tmp0_iterator_5.g1()) {
      var item_5 = tmp0_iterator_5.h1();
      // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_7 = item_5.c4m_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_6 = ArrayList.w(collectionSizeOrDefault(this_7, 10));
      var tmp0_iterator_6 = this_7.f1();
      while (tmp0_iterator_6.g1()) {
        var item_6 = tmp0_iterator_6.h1();
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.atlas.Companion.loadJsonSpriter.<anonymous>.<anonymous>.<anonymous>' call
        destination_6.f(item_6);
      }
      var tmp$ret$39 = item_5.w4n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, destination_6);
      destination_5.f(tmp$ret$39);
    }
    return info.z4n(VOID, destination_5);
  }
  w4m(content) {
    var xml = Xml(content);
    var imagePath = xml.y2f('imagePath');
    var size = SizeInt.c2v(xml.b2g('width', -1), xml.b2g('height', -1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = plus(xml.t2f('SubTexture'), xml.t2f('sprite'));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.atlas.Companion.loadXml.<anonymous>' call
      var virtFrame = RectangleInt.d2u(imul(item.b2g('frameX', 0), -1), imul(item.b2g('frameY', 0), -1), item.b2g('frameWidth', 0), item.b2g('frameHeight', 0));
      var tmp0_elvis_lhs = item.g2g('name');
      var tmp = tmp0_elvis_lhs == null ? item.y2f('n') : tmp0_elvis_lhs;
      var tmp_0 = item.c2g('x');
      var tmp_1 = item.c2g('y');
      var tmp1_elvis_lhs = item.f2g('width');
      var tmp_2 = tmp1_elvis_lhs == null ? item.c2g('w') : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = item.f2g('height');
      var tmp$ret$0 = Region.z4m(tmp, RectangleInt.d2u(tmp_0, tmp_1, tmp_2, tmp2_elvis_lhs == null ? item.c2g('h') : tmp2_elvis_lhs), !(virtFrame.b2u_1 === 0) || !(virtFrame.c2u_1 === 0) ? virtFrame : null, item.w2f('rotated', false) ? Companion_getInstance_7().y40_1 : Companion_getInstance_7().v40_1);
      destination.f(tmp$ret$0);
    }
    return AtlasInfo.y4n(destination, new Meta('Unknown', 'xml', imagePath, 1.0, size, '1.0'));
  }
  v4m(content) {
    var r = new ListReader(lines(content));
    var pageImage = null;
    // Inline function 'kotlin.collections.arrayListOf' call
    var currentEntryList = ArrayList.m1();
    // Inline function 'kotlin.collections.arrayListOf' call
    var pages = ArrayList.m1();
    $l$loop: while (r.uy()) {
      // Inline function 'kotlin.text.trim' call
      var this_0 = r.p1v();
      var line = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(line) === 0) {
        if (r.ty())
          break $l$loop;
        // Inline function 'kotlin.text.trim' call
        var this_1 = r.p1v();
        var fileName = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        var size = SizeInt.c2v(0, 0);
        var format = 'rgba8888';
        var filterMin = false;
        var filterMag = false;
        var repeatX = false;
        var repeatY = false;
        while (r.uy() && contains(r.v38(), _Char___init__impl__6a9atx(58))) {
          // Inline function 'kotlin.text.trim' call
          var this_2 = r.p1v();
          var tmp$ret$5 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
          var _destruct__k2r9zo = loadText$keyValue(tmp$ret$5);
          var key = _destruct__k2r9zo.km();
          var value = _destruct__k2r9zo.lm();
          switch (key) {
            case 'size':
              size = loadText$size(value);
              break;
            case 'format':
              format = value;
              break;
            case 'filter':
              // Inline function 'kotlin.collections.map' call

              var this_3 = split_0(value, [',']);
              // Inline function 'kotlin.collections.mapTo' call

              var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
              var tmp0_iterator = this_3.f1();
              while (tmp0_iterator.g1()) {
                var item = tmp0_iterator.h1();
                // Inline function 'korlibs.image.atlas.Companion.loadText.<anonymous>' call
                // Inline function 'kotlin.text.toLowerCase' call
                // Inline function 'kotlin.text.trim' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$9 = toString(trim(isCharSequence(item) ? item : THROW_CCE())).toLowerCase();
                destination.f(tmp$ret$9);
              }

              var filter = destination;
              filterMin = loadText$filter(first(filter));
              filterMag = loadText$filter(last(filter));
              break;
            case 'repeat':
              repeatX = contains(value, _Char___init__impl__6a9atx(120));
              repeatY = contains(value, _Char___init__impl__6a9atx(121));
              break;
          }
        }
        // Inline function 'kotlin.collections.arrayListOf' call
        currentEntryList = ArrayList.m1();
        pages.f(new Page(fileName, size, format, filterMin, filterMag, repeatX, repeatY, currentEntryList));
      } else {
        var name = line;
        var rotate = false;
        var xy = Companion_getInstance_1().a2i_1;
        var size_0 = SizeInt.c2v(0, 0);
        var orig = SizeInt.c2v(0, 0);
        var offset = Companion_getInstance_1().a2i_1;
        while (r.uy() && contains(r.v38(), _Char___init__impl__6a9atx(58))) {
          // Inline function 'kotlin.text.trim' call
          var this_4 = r.p1v();
          var tmp$ret$13 = toString(trim(isCharSequence(this_4) ? this_4 : THROW_CCE()));
          var _destruct__k2r9zo_0 = loadText$keyValue(tmp$ret$13);
          var key_0 = _destruct__k2r9zo_0.km();
          var value_0 = _destruct__k2r9zo_0.lm();
          switch (key_0) {
            case 'rotate':
              rotate = toBoolean(value_0);
              break;
            case 'xy':
              xy = loadText$point(value_0);
              break;
            case 'size':
              size_0 = loadText$size(value_0);
              break;
            case 'orig':
              orig = loadText$size(value_0);
              break;
            case 'offset':
              offset = loadText$point(value_0);
              break;
          }
        }
        var orientation = rotate ? Companion_getInstance_7().w40_1 : Companion_getInstance_7().v40_1;
        var w = !rotate ? size_0.a2v_1 : size_0.b2v_1;
        var h = !rotate ? size_0.b2v_1 : size_0.a2v_1;
        var oW = orig.a2v_1;
        var oH = orig.b2v_1;
        currentEntryList.f(Region.z4m(name, RectangleInt.d2u(numberToInt(xy.i2h_1), numberToInt(xy.j2h_1), w, h), RectangleInt.d2u(numberToInt(offset.i2h_1), (orig.b2v_1 - size_0.b2v_1 | 0) - numberToInt(offset.j2h_1) | 0, oW, oH), orientation));
      }
    }
    var firstPage = first(pages);
    return AtlasInfo.p4m(new Meta('unknown', firstPage.x4l_1, firstPage.v4l_1, 1.0, firstPage.w4l_1, '1.0'), pages);
  }
}
class AtlasInfo {
  static p4m(meta, pages) {
    meta = meta === VOID ? new Meta() : meta;
    var tmp;
    if (pages === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = pages;
    }
    pages = tmp;
    var $this = createThis(this);
    $this.l4m_1 = meta;
    $this.m4m_1 = pages;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = $this.m4m_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.atlas.AtlasInfo.frames.<anonymous>' call
      var list = element.c4m_1;
      addAll(destination, list);
    }
    tmp_0.n4m_1 = destination;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = $this.n4m_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.wc(capacity);
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.image.atlas.AtlasInfo.framesMap.<anonymous>' call
      var tmp$ret$4 = element_0.d4m_1;
      destination_0.r3(tmp$ret$4, element_0);
    }
    tmp_1.o4m_1 = destination_0;
    return $this;
  }
  static y4n(frames, meta) {
    return this.p4m(meta, listOf(new Page(meta.c4n_1, meta.e4n_1, meta.b4n_1, true, true, false, false, frames)));
  }
  a4o(meta, pages) {
    return AtlasInfo.p4m(meta, pages);
  }
  z4n(meta, pages, $super) {
    meta = meta === VOID ? this.l4m_1 : meta;
    pages = pages === VOID ? this.m4m_1 : pages;
    return $super === VOID ? this.a4o(meta, pages) : $super.a4o.call(this, meta, pages);
  }
  toString() {
    return 'AtlasInfo(meta=' + this.l4m_1.toString() + ', pages=' + toString(this.m4m_1) + ')';
  }
  hashCode() {
    var result = this.l4m_1.hashCode();
    result = imul(result, 31) + hashCode(this.m4m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AtlasInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AtlasInfo ? other : THROW_CCE();
    if (!this.l4m_1.equals(tmp0_other_with_cast.l4m_1))
      return false;
    if (!equals(this.m4m_1, tmp0_other_with_cast.m4m_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(item, originalSlice, slice, rectWithBorder, rect) {
    this.b4o_1 = item;
    this.c4o_1 = originalSlice;
    this.d4o_1 = slice;
    this.e4o_1 = rectWithBorder;
    this.f4o_1 = rect;
  }
  toString() {
    return 'Entry(item=' + toString_0(this.b4o_1) + ', originalSlice=' + this.c4o_1.toString() + ', slice=' + this.d4o_1.toString() + ', rectWithBorder=' + this.e4o_1.toString() + ', rect=' + this.f4o_1.toString() + ')';
  }
  hashCode() {
    var result = this.b4o_1 == null ? 0 : hashCode(this.b4o_1);
    result = imul(result, 31) + this.c4o_1.hashCode() | 0;
    result = imul(result, 31) + this.d4o_1.hashCode() | 0;
    result = imul(result, 31) + this.e4o_1.hashCode() | 0;
    result = imul(result, 31) + this.f4o_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!equals(this.b4o_1, tmp0_other_with_cast.b4o_1))
      return false;
    if (!this.c4o_1.equals(tmp0_other_with_cast.c4o_1))
      return false;
    if (!this.d4o_1.equals(tmp0_other_with_cast.d4o_1))
      return false;
    if (!this.e4o_1.equals(tmp0_other_with_cast.e4o_1))
      return false;
    if (!this.f4o_1.equals(tmp0_other_with_cast.f4o_1))
      return false;
    return true;
  }
}
class AtlasResult {
  constructor(tex, atlas, packedItems) {
    this.g4o_1 = tex;
    this.h4o_1 = atlas;
    this.i4o_1 = packedItems;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.i4o_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.atlas.AtlasResult.packedItemsByItem.<anonymous>' call
      var tmp$ret$0 = element.b4o_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.j4o_1 = destination;
  }
  toString() {
    return 'AtlasResult(tex=' + this.g4o_1.toString() + ', atlas=' + toString(this.h4o_1) + ', packedItems=' + toString(this.i4o_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.g4o_1);
    result = imul(result, 31) + hashCode(this.h4o_1) | 0;
    result = imul(result, 31) + hashCode(this.i4o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AtlasResult))
      return false;
    var tmp0_other_with_cast = other instanceof AtlasResult ? other : THROW_CCE();
    if (!equals(this.g4o_1, tmp0_other_with_cast.g4o_1))
      return false;
    if (!equals(this.h4o_1, tmp0_other_with_cast.h4o_1))
      return false;
    if (!equals(this.i4o_1, tmp0_other_with_cast.i4o_1))
      return false;
    return true;
  }
}
class Result {
  constructor(atlases) {
    this.k4o_1 = atlases;
  }
  toString() {
    return 'Result(atlases=' + toString(this.k4o_1) + ')';
  }
  hashCode() {
    return hashCode(this.k4o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.k4o_1, tmp0_other_with_cast.k4o_1))
      return false;
    return true;
  }
}
class AtlasPacker {
  l4o(items, maxSide, maxTextures, borderSize, fileName) {
    var borderSize2 = imul(borderSize, 2);
    var tmp = Companion_instance_1;
    var tmp_0 = Size2D.f2j(maxSide, maxSide);
    var packs = tmp.k3z(tmp_0, items, AtlasPacker$pack$lambda(borderSize2));
    if (packs.j1() > maxTextures) {
      // Inline function 'kotlin.error' call
      var message = 'textures:' + packs.j1() + ' > maxTextures:' + maxTextures;
      throw IllegalStateException.m5(toString(message));
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(packs, 10));
    var tmp0_iterator = packs.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.atlas.AtlasPacker.pack.<anonymous>' call
      var out = Bitmap32.c4p(get_nextPowerOfTwo(numberToInt(item.d3z_1)), get_nextPowerOfTwo(numberToInt(item.e3z_1)), VOID, true);
      // Inline function 'kotlin.collections.arrayListOf' call
      var packedItems = ArrayList.m1();
      var _iterator__ex2g4s = item.b3z_1.f1();
      while (_iterator__ex2g4s.g1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s.h1();
        var item_0 = _destruct__k2r9zo.km();
        var rectOrNull = _destruct__k2r9zo.lm();
        var rectWithBorder = rectOrNull == null ? Companion_getInstance_2().d2t(0, 0, 1, 1) : rectOrNull;
        var width = item_0.jm_1.o41_1;
        var height = item_0.jm_1.p41_1;
        var x0 = numberToInt(rectWithBorder.i2i_1) + borderSize | 0;
        var y0 = numberToInt(rectWithBorder.j2i_1) + borderSize | 0;
        var rect = Companion_getInstance_2().d2t(x0, y0, width, height);
        var x1 = (x0 + width | 0) - 1 | 0;
        var y1 = (y0 + height | 0) - 1 | 0;
        var bmp = extract_0(item_0.jm_1).q4p().r4p();
        out.s4p(bmp, x0, y0);
        var inductionVariable = 1;
        if (inductionVariable <= borderSize)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            Companion_getInstance_19().u4p(out, x0, y0, out, x0 - i | 0, y0, 1, height);
            Companion_getInstance_19().u4p(out, x1, y0, out, x1 + i | 0, y0, 1, height);
          }
           while (!(i === borderSize));
        var inductionVariable_0 = 1;
        if (inductionVariable_0 <= borderSize)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            Companion_getInstance_19().u4p(out, x0 - borderSize | 0, y0, out, x0 - borderSize | 0, y0 - i_0 | 0, width + borderSize2 | 0, 1);
            Companion_getInstance_19().u4p(out, x0 - borderSize | 0, y1, out, x0 - borderSize | 0, y1 + i_0 | 0, width + borderSize2 | 0, 1);
          }
           while (!(i_0 === borderSize));
        packedItems.f(new Entry_0(item_0.im_1, item_0.jm_1, slice_0(out, rect.q2()), rectWithBorder, rect));
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(packedItems, 10));
      var tmp0_iterator_0 = packedItems.f1();
      while (tmp0_iterator_0.g1()) {
        var item_1 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.atlas.AtlasPacker.pack.<anonymous>.<anonymous>' call
        var bmp_0 = item_1.d4o_1;
        var r = item_1.e4o_1;
        var rect_0 = Companion_getInstance_2().d2t(numberToInt(r.i2i_1) + 2 | 0, numberToInt(r.j2i_1) + 2 | 0, bmp_0.o41_1, bmp_0.p41_1).q2();
        var filename = item_1.c4o_1.j41_1;
        var tmp$ret$1 = Region.x4n(filename == null ? 'unknown' : filename, rect_0, false, rect_0.j1(), RectangleInt.d2u(0, 0, rect_0.b2u_1, rect_0.c2u_1), false);
        destination_0.f(tmp$ret$1);
      }
      var atlasInfo = AtlasInfo.y4n(destination_0, new Meta('korge', 'RGBA8888', fileName, 1.0, SizeInt.c2v(out.j2y(), out.k2y()), Companion_instance_9.y4m_1));
      var tmp$ret$4 = new AtlasResult(out, Atlas.q4m(slice_0(out), atlasInfo), packedItems);
      destination.f(tmp$ret$4);
    }
    return new Result(destination);
  }
  v4p(items, maxSide, maxTextures, borderSize, fileName, $super) {
    maxSide = maxSide === VOID ? 2048 : maxSide;
    maxTextures = maxTextures === VOID ? 16 : maxTextures;
    borderSize = borderSize === VOID ? 2 : borderSize;
    fileName = fileName === VOID ? 'atlas.png' : fileName;
    return $super === VOID ? this.l4o(items, maxSide, maxTextures, borderSize, fileName) : $super.l4o.call(this, items, maxSide, maxTextures, borderSize, fileName);
  }
}
class GrowMethod extends Enum {}
class Entry_1 {
  constructor(slice, data) {
    this.w4p_1 = slice;
    this.x4p_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.w4p_1.toString() + ', data=' + toString_0(this.x4p_1) + ')';
  }
  hashCode() {
    var result = this.w4p_1.hashCode();
    result = imul(result, 31) + (this.x4p_1 == null ? 0 : hashCode(this.x4p_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_1))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_1 ? other : THROW_CCE();
    if (!this.w4p_1.equals(tmp0_other_with_cast.w4p_1))
      return false;
    if (!equals(this.x4p_1, tmp0_other_with_cast.x4p_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static k4q(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.y4p_1 = binPacker;
    $this.z4p_1 = border;
    $this.a4q_1 = premultiplied;
    $this.b4q_1 = allowToGrow;
    $this.c4q_1 = growMethod;
    $this.d4q_1 = MarginInt.g2m($this.z4p_1);
    $this.e4q_1 = Bitmap32.c4p($this.j2y(), $this.k2y(), VOID, $this.a4q_1);
    $this.f4q_1 = arrayListOf([$this.e4q_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.g4q_1 = ArrayList.m1();
    $this.h4q_1 = LinkedHashMap.vc();
    $this.i4q_1 = null;
    return $this;
  }
  static l4q(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.k4q(Companion_instance_1.j3z(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  j2y() {
    return numberToInt(this.y4p_1.j2y());
  }
  k2y() {
    return numberToInt(this.y4p_1.k2y());
  }
  j1() {
    return this.g4q_1.j1();
  }
  m4q(bmp, data, name) {
    return this.j4q(slice_0(bmp, VOID, name), data, name);
  }
  n4q(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.j1() : name;
    return $super === VOID ? this.m4q(bmp, data, name) : $super.m4q.call(this, bmp, data, name);
  }
  j4q(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.m4q(extract_0(bmp).o4q(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.j1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.i4q_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.i4q_1).w4p_1;
        if (bigEmptySlice.o41_1 >= bmp.o41_1 && bigEmptySlice.p41_1 >= bmp.p41_1) {
          entry = new Entry_1(bigEmptySlice.x42(RectangleInt.d2u(0, 0, bmp.o41_1, bmp.p41_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.y4p_1.r3e(bmp.o41_1 + imul(this.z4p_1, 2), bmp.p41_1 + imul(this.z4p_1, 2));
        var slice = sliceWithSize(this.e4q_1, numberToInt(rect.p2i() + this.z4p_1), numberToInt(rect.r2i() + this.z4p_1), bmp.o41_1, bmp.p41_1, rname);
        var dstX = slice.p2i();
        var dstY = slice.r2i();
        var boundsWithBorder = get_bounds_0(slice).f2u(this.d4q_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.e4q_1;
        if (true) {
          this_0.w1w();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.e4q_1.p4q(bmp, dstX, dstY);
          expandBorder(this.e4q_1, slice.g41_1, this.z4p_1);
        }finally {
          result = true ? this_0.q4q(boundsWithBorder) : 0;
        }
        entry = new Entry_1(slice, data);
        if (this.i4q_1 == null || bmp.x2u() > ensureNotNull(this.i4q_1).w4p_1.x2u()) {
          this.i4q_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.g4q_1;
      var element = entry;
      this_1.f(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.h4q_1;
      var value = entry;
      this_2.r3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.b4q_1)
          throw e;
        growAtlas(this, bmp);
        return this.j4q(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  r4q(bmp, data, name, $super) {
    name = name === VOID ? bmp.j41_1 : name;
    return $super === VOID ? this.j4q(bmp, data, name) : $super.j4q.call(this, bmp, data, name);
  }
}
class Bitmap {
  static s4q(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.d4p_1 = new Mixin();
    $this.e4p_1 = width;
    $this.f4p_1 = height;
    $this.g4p_1 = bpp;
    $this.h4p_1 = backingArray;
    $this.i4p_1 = RectangleInt.d2u(0, 0, $this.j2y(), $this.k2y());
    $this.j4p_1 = null;
    $this.k4p_1 = premultiplied;
    $this.l4p_1 = false;
    var tmp = $this;
    tmp.m4p_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.n4p_1 = 0;
    $this.o4p_1 = null;
    $this.p4p_1 = false;
    return $this;
  }
  n13(_set____db54di) {
    this.d4p_1.n13(_set____db54di);
  }
  o13() {
    return this.d4p_1.o13();
  }
  j2y() {
    return this.e4p_1;
  }
  k2y() {
    return this.f4p_1;
  }
  t4q() {
    return this.g4p_1;
  }
  j1() {
    return SizeInt.c2v(this.j2y(), this.k2y());
  }
  u4q(value) {
    this.k4p_1 = value;
  }
  v4q() {
    return this.k4p_1;
  }
  w4q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m4p_1;
    tempInts$factory();
    return this_0.b2();
  }
  x4q() {
    return _RgbaArray___init__impl__oib4y4(this.w4q());
  }
  y4q() {
    return imul(this.j2y(), this.t4q()) / 8 | 0;
  }
  x2u() {
    return imul(this.j2y(), this.k2y());
  }
  z4q(x, y) {
    return imul(y, this.j2y()) + x | 0;
  }
  a4r() {
    if (!(this.o4p_1 == null)) {
      this.o4p_1 = null;
    }
  }
  w1w() {
    return Unit_instance;
  }
  q4q(rect) {
    if (this.o4p_1 == null)
      this.o4p_1 = rect;
    else
      this.o4p_1 = Companion_instance_0.q2u(ensureNotNull(this.o4p_1), rect);
    this.n4p_1 = this.n4p_1 + 1 | 0;
    return this.n4p_1;
  }
  b4r(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.c4r(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  d4r(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.e4r(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  f4r(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.d4r(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.d4r.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  e4r(x, y, v) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.oe();
  }
  c4r(x, y) {
    return Colors_getInstance().l4r_1;
  }
  y4w(x, y, color) {
    return Unit_instance;
  }
  z4w(x, y) {
    return 0;
  }
  a4x(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.j2y() || y0 >= this.k2y())
      return Colors_getInstance().l4r_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.j2y() - 1 | 0);
    var y1Inside = y1 < (this.k2y() - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.c4r(x0, y0);
    var c10 = x1Inside ? this.c4r(x1, y0) : c00;
    var c01 = y1Inside ? this.c4r(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.c4r(x1, y1) : c01;
    return Companion_getInstance_28().g4x(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  h4x(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.i4x(srcX);
    var srcX1 = src.i4x(srcX + width | 0);
    var srcY0 = src.j4x(srcY);
    var srcY1 = src.j4x(srcY + height | 0);
    var dstX0 = dst.i4x(dstX);
    var dstX1 = dst.i4x(dstX + width | 0);
    var dstY0 = dst.j4x(dstY);
    var dstY1 = dst.j4x(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.k4x(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  k4x(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.b4r(srcX, srcY + y | 0, width, 1, this.w4q(), 0);
        dst.d4r(dstX, dstY + y | 0, width, 1, this.w4q(), 0);
      }
       while (inductionVariable < height);
  }
  l4x(x) {
    return x >= 0 && x < this.j2y();
  }
  m4x(y) {
    return y >= 0 && y < this.k2y();
  }
  n4x(x, y) {
    return this.l4x(x) && this.m4x(y);
  }
  o4x(x) {
    return clamp(x, 0, this.j2y() - 1 | 0);
  }
  p4x(y) {
    return clamp(y, 0, this.k2y() - 1 | 0);
  }
  i4x(x) {
    return clamp(x, 0, this.j2y());
  }
  j4x(y) {
    return clamp(y, 0, this.k2y());
  }
  q4x() {
    var inductionVariable = 0;
    var last = this.k2y() / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.r4x(y, (this.k2y() - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  s4x() {
    var inductionVariable = 0;
    var last = this.j2y() / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.t4x(x, (this.j2y() - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  u4x(rotation) {
    var tmp;
    switch (rotation.v3_1) {
      case 0:
        tmp = this.j13();
        break;
      case 1:
        tmp = this.v4x().s4x();
        break;
      case 2:
        tmp = this.v4x().s4x().v4x().s4x();
        break;
      case 3:
        tmp = this.v4x().q4x();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  w4x(orientation) {
    var out = this.j13();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.s4x();
    }
    return out.u4x(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  v4x() {
    var temp = new IntArray2(this.j2y(), this.k2y(), readPixelsUnsafe(this, 0, 0, this.j2y(), this.k2y()));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.k2y();
    var height = this.j2y();
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.k2y();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.j2y();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.p2y(y, x, temp.z2k(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.x4x(this.k2y(), this.j2y());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.f4r(0, 0, this.k2y(), this.j2y(), out.i2y_1);
    return this_0;
  }
  r4x(y0, y1) {
    var inductionVariable = 0;
    var last = this.j2y();
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.z4w(x, y0);
        var c1 = this.z4w(x, y1);
        this.y4w(x, y0, c1);
        this.y4w(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  t4x(x0, x1) {
    var inductionVariable = 0;
    var last = this.k2y();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.z4w(x0, y);
        var c1 = this.z4w(x1, y);
        this.y4w(x0, y, c1);
        this.y4w(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  y4x(antialiasing) {
    throw UnsupportedOperationException.ua('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  z4x(antialiasing, $super) {
    antialiasing = antialiasing === VOID ? true : antialiasing;
    return $super === VOID ? this.y4x(antialiasing) : $super.y4x.call(this, antialiasing);
  }
  x4x(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString(this) + ')');
  }
  o4q() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.c4p(this.j2y(), this.k2y(), VOID, this.v4q());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.b4r(0, 0, this.j2y(), this.k2y(), this_0.z4o_1, 0);
    return this_0;
  }
  q4p() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.o4q();
    }
    return tmp;
  }
  j13() {
    var out = this.x4x(this.j2y(), this.k2y());
    this.k4x(0, 0, out, 0, 0, this.j2y(), this.k2y());
    return out;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_11 = this;
    this.t4p_1 = Bitmap32.c4p(0, 0, VOID, true);
  }
  j4y(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.c4p(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.z4o_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  k4y(width, height, premultiplied) {
    return Bitmap32.c4p(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  l4y(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.p4y_1;
    var dstShift = dstChannel.p4y_1;
    var dstClear = dstChannel.r4y_1;
    var dstData = dst.z4o_1;
    var srcData = src.z4o_1;
    var inductionVariable = 0;
    var last = dst.x2u();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  s4y(src, dst, dstChannel) {
    var destShift = imul(dstChannel.o4y_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.x2u();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.n4z()[n] & 255;
        dst.z4o_1[n] = dst.z4o_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  o4z(src, srcChannel, dst) {
    var shift = srcChannel.p4y_1;
    var inductionVariable = 0;
    var last = src.x2u();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.n4z()[n] = toByte((src.z4o_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
  u4p(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.h4x(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.h4y_1 = this$0;
  }
  p4z($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$iterator, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.p4z(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static c4p(width, height, ints, premultiplied) {
    Companion_getInstance_19();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.s4q(width, height, 32, premultiplied, ints);
    $this.z4o_1 = ints;
    if ($this.z4o_1.length < imul(width, height))
      throw RuntimeException.db('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.z4o_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.a4p_1 = new Int32Array(tmp$ret$0);
    $this.b4p_1 = RectangleInt.d2u(0, 0, width, height);
    return $this;
  }
  static q4z(width, height, value) {
    Companion_getInstance_19();
    return this.c4p(width, height, _RgbaArray___get_ints__impl__u2kps1(value), false);
  }
  x4x(width, height) {
    return Bitmap32.c4p(width, height, VOID, this.v4q());
  }
  k4x(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.k4x(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.z4o_1;
    var dstArray = dst.z4o_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.z4q(srcX, srcY + y | 0), dstArray, dst.z4q(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  r4z(x, y, color) {
    this.s4z(x, y, color);
  }
  t4z(x, y) {
    return this.u4z(x, y);
  }
  y4w(x, y, color) {
    this.z4o_1[this.z4q(x, y)] = color;
  }
  z4w(x, y) {
    return this.z4o_1[this.z4q(x, y)];
  }
  c4r(x, y) {
    return _RGBA___init__impl__lqpay5(this.z4w(x, y));
  }
  e4r(x, y, v) {
    return this.y4w(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  s4z(x, y, v) {
    return this.v4z(this.z4q(x, y), v);
  }
  u4z(x, y) {
    return this.i4y(this.z4q(x, y));
  }
  v4z(n, color) {
    this.z4o_1[n] = this.v4q() ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  w4z(n, color) {
    var tmp;
    if (this.v4q()) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.z4o_1[n] = tmp;
  }
  i4y(n) {
    var tmp;
    if (this.v4q()) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.z4o_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.z4o_1[n]);
    }
    return tmp;
  }
  x4z(n) {
    return this.v4q() ? _RGBAPremultiplied___init__impl__uos02x(this.z4o_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.z4o_1[n]));
  }
  y4z(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.z4q(dx, dy + y | 0);
        var srcOffset = src.z4q(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.w4z(dstOffset + x | 0, mix(dst.x4z(dstOffset + x | 0), src.x4z(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.v4q() === src.v4q()) {
            arraycopy(src.z4o_1, srcOffset, dst.z4o_1, dstOffset, width);
          } else if (!dst.v4q()) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.v4z(dstOffset + x_0 | 0, src.i4y(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.w4z(dstOffset + x_1 | 0, src.x4z(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  z4z(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.j2y() - dx_0 | 0;
    var availableHeight = this.k2y() - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.y4z(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  a50(mix, other, _dx, _dy) {
    this.z4z(other, _dx, _dy, 0, 0, other.j2y(), other.k2y(), mix);
  }
  b50(color, x, y, width, height) {
    var x1 = this.o4x(x);
    var x2 = this.o4x((x + width | 0) - 1 | 0);
    var y1 = this.p4x(y);
    var y2 = this.p4x((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.v4q());
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.z4o_1, colorInt, this.z4q(x1, cy), this.z4q(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  c50(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.j2y() - x | 0 : width;
    height = height === VOID ? this.k2y() - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.b50(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.b50.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  d50(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.z4z(get_bmp(src), dx, dy, b.p2i(), b.r2i(), b.q2i(), b.s2i(), mix);
  }
  e50(src, dx, dy) {
    return this.a50(false, src, dx, dy);
  }
  s4p(src, dx, dy) {
    return this.a50(true, src, dx, dy);
  }
  f50(src, dx, dy) {
    return this.d50(src, dx, dy, false);
  }
  p4q(src, dx, dy) {
    return this.d50(src, dx, dy, true);
  }
  g50(x, y, width, height) {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_19().k4y(width, height, this.v4q());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.copySliceWithSize.<anonymous>' call
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var yy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(this.z4o_1, this.z4q(x, y + yy | 0), this_0.z4o_1, this_0.z4q(0, yy), width);
      }
       while (inductionVariable < height);
    return this_0;
  }
  h50(destination, input, source) {
    return Companion_getInstance_19().l4y(input, source, this, destination);
  }
  i50(destination, input) {
    return Companion_getInstance_19().s4y(input, this, destination);
  }
  j50(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_19().o4z(this, channel, out);
    return out;
  }
  k50(channel, out, $super) {
    out = out === VOID ? Bitmap8.f51(this.j2y(), this.k2y()) : out;
    return $super === VOID ? this.j50(channel, out) : $super.j50.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.ic('Bitmap32(');
    this_0.oh(this.j2y());
    this_0.ic(', ');
    this_0.oh(this.k2y());
    if (!(this.j4p_1 == null)) {
      this_0.ic(', name=');
      this_0.ic(this.j4p_1);
    }
    this_0.ic(')');
    return this_0.toString();
  }
  r4x(y0, y1) {
    var s0 = this.z4q(0, y0);
    var s1 = this.z4q(0, y1);
    arraycopy(this.z4o_1, s0, this.a4p_1, 0, this.j2y());
    arraycopy(this.z4o_1, s1, this.z4o_1, s0, this.j2y());
    arraycopy(this.a4p_1, 0, this.z4o_1, s1, this.j2y());
  }
  j13() {
    var tmp = this.j2y();
    var tmp_0 = this.k2y();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.z4o_1.slice();
    return Bitmap32.c4p(tmp, tmp_0, tmp$ret$1, this.v4q());
  }
  y4x(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  r4p() {
    return this.v4q() ? this : this.copyPremultiplied();
  }
  g51() {
    return !this.v4q() ? this : this.h51();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.j13();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.i51();
    return this_0;
  }
  h51() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.j13();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.j51();
    return this_0;
  }
  i51() {
    if (this.v4q())
      return Unit_instance;
    this.u4q(true);
    var inductionVariable = 0;
    var last = this.x2u();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.z4o_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.z4o_1[n])));
      }
       while (inductionVariable < last);
  }
  j51() {
    if (!this.v4q())
      return Unit_instance;
    this.u4q(false);
    var inductionVariable = 0;
    var last = this.x2u();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.z4o_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.z4o_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  k51(levels) {
    var temp = this.j13();
    temp.i51();
    var dst = _RgbaPremultipliedArray___init__impl__lx83hy(temp.z4o_1);
    var twidth = this.j2y();
    var theight = this.k2y();
    var inductionVariable = 0;
    if (inductionVariable < levels)
      do {
        var level = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        twidth = twidth / 2 | 0;
        theight = theight / 2 | 0;
        var inductionVariable_0 = 0;
        var last = theight;
        if (inductionVariable_0 < last)
          do {
            var y = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var n = temp.z4q(0, y);
            var m = temp.z4q(0, imul(y, 2));
            var inductionVariable_1 = 0;
            var last_0 = twidth;
            if (inductionVariable_1 < last_0)
              do {
                var x = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var c1 = RgbaPremultipliedArray__get_impl_1u69ta(dst, m + 0 | 0);
                var c2 = RgbaPremultipliedArray__get_impl_1u69ta(dst, m + 1 | 0);
                var c3 = RgbaPremultipliedArray__get_impl_1u69ta(dst, (m + this.j2y() | 0) + 0 | 0);
                var c4 = RgbaPremultipliedArray__get_impl_1u69ta(dst, (m + this.j2y() | 0) + 1 | 0);
                RgbaPremultipliedArray__set_impl_7fwbby(dst, n, Companion_instance_21.n51(c1, c2, c3, c4));
                m = m + 2 | 0;
                n = n + 1 | 0;
              }
               while (inductionVariable_1 < last_0);
          }
           while (inductionVariable_0 < last);
      }
       while (inductionVariable < levels);
    return temp.g50(0, 0, twidth, theight);
  }
  f1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  o51(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.z4o_1, this.z4q(x, y), width);
    } else {
      var m = this.z4q(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.z4o_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  o4q() {
    return this;
  }
}
class Companion_2 {
  p51(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.h4x(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static r51(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_19.q51(1 << bpp) : palette;
    var $this = this.s4q(width, height, bpp, false, bytes);
    $this.g4z_1 = bytes;
    $this.h4z_1 = palette;
    if ($this.u51().length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.db('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.n4z().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.i4z_1 = new Int8Array(tmp$ret$0);
    $this.j4z_1 = _UByteArrayInt___init__impl__xif7bu($this.n4z());
    $this.k4z_1 = 8 / bpp | 0;
    $this.l4z_1 = ilog2($this.k4z_1);
    $this.m4z_1 = $this.k4z_1 - 1 | 0;
    return $this;
  }
  u51() {
    return this.g4z_1;
  }
  n4z() {
    return this.u51();
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.t4q() + ', width=' + this.j2y() + ', height=' + this.k2y() + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.h4z_1) + ')';
  }
  z4w(x, y) {
    return this.t51(this.z4q(x, y));
  }
  y4w(x, y, color) {
    return this.s51(this.z4q(x, y), color);
  }
  t51(n) {
    var iD = this.w51(n);
    var iM = this.x51(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.j4z_1, iD), imul(this.t4q(), iM), this.t4q());
  }
  s51(n, color) {
    var iD = this.w51(n);
    var iM = this.x51(n);
    UByteArrayInt__set_impl_gn4532(this.j4z_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.j4z_1, iD), color, imul(this.t4q(), iM), this.t4q()));
  }
  c4r(x, y) {
    var tmp = this.h4z_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.z4w(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  v51(x, y) {
    return this.w51(this.z4q(x, y));
  }
  w51(n) {
    return n >>> this.l4z_1 | 0;
  }
  x51(n) {
    return n & this.m4z_1;
  }
  r4x(y0, y1) {
    var s0 = this.v51(0, y0);
    var s1 = this.v51(0, y1);
    arraycopy_0(this.n4z(), s0, this.i4z_1, 0, this.y4q());
    arraycopy_0(this.n4z(), s1, this.n4z(), s0, this.y4q());
    arraycopy_0(this.i4z_1, 0, this.n4z(), s1, this.y4q());
  }
  y51(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.n4z(), this.z4q(x, y), width / this.k4z_1 | 0);
    } else {
      var m = this.z4q(x, y);
      var inductionVariable = 0;
      var last = width / this.k4z_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.n4z()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  o4q() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.c4p(this.j2y(), this.k2y(), VOID, this.v4q());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.z4o_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.h4z_1);
    var inductionVariable = 0;
    var last = this.x2u();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.t51(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static f51(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_19.q51(256) : palette;
    return this.r51(8, width, height, data, palette);
  }
  x4x(width, height) {
    return Bitmap8.f51(width, height, VOID, this.h4z_1);
  }
  y4w(x, y, color) {
    return this.s51(this.z4q(x, y), color);
  }
  z4w(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.j4z_1, this.z4q(x, y));
  }
  c4r(x, y) {
    var tmp = this.h4z_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.z4w(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  t51(n) {
    return UByteArrayInt__get_impl_px6q8a(this.j4z_1, n);
  }
  s51(n, color) {
    UByteArrayInt__set_impl_gn4532(this.j4z_1, n, color);
  }
  k4x(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.k4x(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.n4z();
        var tmp_0 = this.z4q(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).n4z(), dst.z4q(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  j13() {
    var tmp = this.j2y();
    var tmp_0 = this.k2y();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = this.n4z().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.h4z_1).slice();
    return Bitmap8.f51(tmp, tmp_0, tmp_1, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.j2y() + ', ' + this.k2y() + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.h4z_1) + ')';
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_13 = this;
    this.z51_1 = values();
  }
  i1(index) {
    return this.z51_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.o4y_1 = index;
    this.p4y_1 = imul(this.o4y_1, 8);
    this.q4y_1 = 255 << this.p4y_1;
    this.r4y_1 = ~this.q4y_1;
  }
}
class Bitmaps {}
class Companion_4 {
  constructor() {
    this.a52_1 = 1.0;
    this.b52_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.c52_1 = width;
    this.d52_1 = height;
    this.e52_1 = d;
    this.f52_1 = px;
    this.g52_1 = py;
    this.h52_1 = imul(this.c52_1, this.d52_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.e52_1.length >= this.h52_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.m5(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.f52_1.length >= this.h52_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.m5(toString(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.g52_1.length >= this.h52_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.m5(toString(message_1));
    }
  }
  l4x(x) {
    return x >= 0 && x < this.c52_1;
  }
  m4x(y) {
    return y >= 0 && y < this.d52_1;
  }
  n4x(x, y) {
    return this.l4x(x) && this.m4x(y);
  }
  z4q(x, y) {
    return imul(y, this.c52_1) + x | 0;
  }
  m52(x, y) {
    return this.n4x(x, y) ? this.e52_1[this.z4q(x, y)] : Infinity;
  }
  j52(x, y) {
    return this.n4x(x, y) ? this.f52_1[this.z4q(x, y)] : -1;
  }
  k52(x, y) {
    return this.n4x(x, y) ? this.g52_1[this.z4q(x, y)] : -1;
  }
  l52(x, y, d) {
    if (!this.n4x(x, y))
      return Unit_instance;
    this.e52_1[this.z4q(x, y)] = d;
  }
  n52(x, y, px, py) {
    if (!this.n4x(x, y))
      return Unit_instance;
    var index = this.z4q(x, y);
    this.f52_1[index] = px;
    this.g52_1[index] = py;
  }
  i52(x, y, px, py) {
    return this.n52(x, y, this.j52(px, py), this.k52(px, py));
  }
  o52(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.c52_1 === bmp.j2y())) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.m5(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.d52_1 === bmp.k2y())) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.m5(toString(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.d52_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.c52_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.l52(x, y, Infinity);
            this.n52(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.d52_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.c52_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.l52(x_0, y_0, 0.0);
              this.n52(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.d52_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.c52_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.d52_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.c52_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.d52_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.c52_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.l52(x_3, y_3, -this.m52(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static d53(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.s4q(width, height, 32, premultiplied, data);
    $this.c53_1 = data;
    return $this;
  }
  e4r(x, y, v) {
    var rindex = index4(this, x, y);
    this.c53_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.c53_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.c53_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.c53_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  c4r(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_28().e53(this.c53_1[rindex + 0 | 0], this.c53_1[rindex + 1 | 0], this.c53_1[rindex + 2 | 0], this.c53_1[rindex + 3 | 0]);
  }
  f53(x, y) {
    return this.c53_1[index4(this, x, y) + 0 | 0];
  }
  g53(x, y) {
    return this.c53_1[index4(this, x, y) + 1 | 0];
  }
  h53(x, y) {
    return this.c53_1[index4(this, x, y) + 2 | 0];
  }
  i53(x, y) {
    return this.c53_1[index4(this, x, y) + 3 | 0];
  }
  j53(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.c53_1[rindex + 0 | 0] = r;
    this.c53_1[rindex + 1 | 0] = g;
    this.c53_1[rindex + 2 | 0] = b;
    this.c53_1[rindex + 3 | 0] = a;
  }
  k53(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.c53_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.c53_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.c53_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.c53_1[rindex + 3 | 0]);
    return out;
  }
  l53(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.j2y() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.k2y() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.z4q(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.k53(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  m53(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.l53(out) : $super.l53.call(this, out);
  }
  n53(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.j2y() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.k2y() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.z4q(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.k53(x, y, out);
            this.j53(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  o53(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.n53(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.n53.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  p53() {
    var _destruct__k2r9zo = this.m53();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.o53(-range, +range);
  }
  q53(scale) {
    return this.r53(scale, scale, scale, scale);
  }
  r53(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.j2y() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.k2y() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.z4q(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.j53(x, y, this.f53(x, y) * scaleRed, this.g53(x, y) * scaleGreen, this.h53(x, y) * scaleBlue, this.i53(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  s53(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.j2y() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.k2y() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.z4q(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.f53(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.g53(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.h53(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.i53(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.j53(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static h54(width, height, data, premultiplied) {
    var $this = this.s4q(width, height, 32, premultiplied, null);
    $this.g54_1 = data;
    return $this;
  }
  o4q() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_19().k4y(this.j2y(), this.k2y(), this.v4q());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.b4r(0, 0, this.j2y(), this.k2y(), this_0.z4o_1, 0);
    return this_0;
  }
  e4r(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.x4q(), 0, v);
    this.d4r(x, y, 1, 1, this.w4q(), 0);
  }
  c4r(x, y) {
    this.b4r(x, y, 1, 1, this.w4q(), 0);
    return RgbaArray__get_impl_nzyo1o(this.x4q(), 0);
  }
  y4w(x, y, color) {
    return this.e4r(x, y, _RGBA___init__impl__lqpay5(color));
  }
  z4w(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.c4r(x, y));
  }
  q4x() {
    var tmp = this.j2y();
    var tmp_0 = this.k2y();
    var tmp_1 = this.o4q().q4x();
    this.f4r(0, 0, tmp, tmp_0, (tmp_1 instanceof Bitmap32 ? tmp_1 : THROW_CCE()).z4o_1);
    return this;
  }
  s4x() {
    var tmp = this.j2y();
    var tmp_0 = this.k2y();
    var tmp_1 = this.o4q().s4x();
    this.f4r(0, 0, tmp, tmp_0, (tmp_1 instanceof Bitmap32 ? tmp_1 : THROW_CCE()).z4o_1);
    return this;
  }
  r4x(y0, y1) {
    this.b4r(0, y0, this.j2y(), 1, this.w4q(), 0);
    this.b4r(0, y1, this.j2y(), 1, this.w4q(), this.j2y());
    this.d4r(0, y1, this.j2y(), 1, this.w4q(), 0);
    this.d4r(0, y0, this.j2y(), 1, this.w4q(), this.j2y());
  }
  t4x(x0, x1) {
    this.b4r(x0, 0, 1, this.k2y(), this.w4q(), 0);
    this.b4r(x1, 0, 1, this.k2y(), this.w4q(), this.j2y());
    this.d4r(x1, 0, 1, this.k2y(), this.w4q(), 0);
    this.d4r(x0, 0, 1, this.k2y(), this.w4q(), this.j2y());
  }
  x4x(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.w3() + '(' + this.j2y() + ', ' + this.k2y() + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class Companion_5 {
  m54(bmp, left, top, right, bottom) {
    return new NinePatchBmpSlice(bmp, NinePatchInfo.d55(bmp.o41_1, bmp.p41_1, left, top, right, bottom, bmp));
  }
}
class NinePatchBmpSlice {
  constructor(content, info, bmpSlice) {
    bmpSlice = bmpSlice === VOID ? content : bmpSlice;
    this.e55_1 = content;
    this.f55_1 = info;
    this.g55_1 = bmpSlice;
  }
}
class AxisSegment {
  constructor(scaled, range) {
    this.q55_1 = scaled;
    this.r55_1 = range;
  }
  s55() {
    return !this.q55_1;
  }
  a() {
    return get_length(this.r55_1);
  }
}
class AxisInfo {
  constructor(ranges, totalLen) {
    this.t55_1 = ranges;
    this.u55_1 = totalLen;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.t55_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.segments.<anonymous>' call
      var tmp$ret$0 = new AxisSegment(item.im_1, item.jm_1);
      destination.f(tmp$ret$0);
    }
    tmp.v55_1 = toFastList(destination);
    var tmp_0 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = this.v55_1;
    var destination_0 = ArrayList.m1();
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element = tmp0_iterator_0.h1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      if (element.s55()) {
        destination_0.f(element);
      }
    }
    var sum = 0;
    var tmp0_iterator_1 = destination_0.f1();
    while (tmp0_iterator_1.g1()) {
      var element_0 = tmp0_iterator_1.h1();
      var tmp_1 = sum;
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      sum = tmp_1 + element_0.a() | 0;
    }
    var b = sum;
    tmp_0.w55_1 = Math.max(1, b);
    var tmp_2 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = this.v55_1;
    var destination_1 = ArrayList.m1();
    var tmp0_iterator_2 = this_2.f1();
    while (tmp0_iterator_2.g1()) {
      var element_1 = tmp0_iterator_2.h1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      if (element_1.q55_1) {
        destination_1.f(element_1);
      }
    }
    var sum_0 = 0;
    var tmp0_iterator_3 = destination_1.f1();
    while (tmp0_iterator_3.g1()) {
      var element_2 = tmp0_iterator_3.h1();
      var tmp_3 = sum_0;
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      sum_0 = tmp_3 + element_2.a() | 0;
    }
    var b_0 = sum_0;
    tmp_2.x55_1 = Math.max(1, b_0);
  }
  toString() {
    return 'AxisInfo(ranges=' + toString(this.t55_1) + ', totalLen=' + this.u55_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t55_1);
    result = imul(result, 31) + this.u55_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AxisInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AxisInfo ? other : THROW_CCE();
    if (!equals(this.t55_1, tmp0_other_with_cast.t55_1))
      return false;
    if (!(this.u55_1 === tmp0_other_with_cast.u55_1))
      return false;
    return true;
  }
}
class Segment {
  constructor(info, rect, x, y) {
    this.h55_1 = new Mixin();
    this.i55_1 = info;
    this.j55_1 = rect;
    this.k55_1 = x;
    this.l55_1 = y;
    this.m55_1 = this.k55_1.q55_1;
    this.n55_1 = this.l55_1.q55_1;
    var tmp = this;
    var tmp20_safe_receiver = this.i55_1.r54_1;
    tmp.o55_1 = tmp20_safe_receiver == null ? null : tmp20_safe_receiver.x42(this.j55_1);
    var tmp_0 = this;
    tmp_0.p55_1 = lazy(NinePatchInfo$Segment$bmp$delegate$lambda(this));
  }
  n13(_set____db54di) {
    this.h55_1.n13(_set____db54di);
  }
  o13() {
    return this.h55_1.o13();
  }
}
class NinePatchInfo {
  static y55(xranges, yranges, width, height, content) {
    content = content === VOID ? null : content;
    var $this = createThis(this);
    $this.n54_1 = xranges;
    $this.o54_1 = yranges;
    $this.p54_1 = width;
    $this.q54_1 = height;
    $this.r54_1 = content;
    $this.s54_1 = new AxisInfo($this.n54_1, $this.p54_1);
    $this.t54_1 = new AxisInfo($this.o54_1, $this.q54_1);
    $this.u54_1 = $this.s54_1.v55_1;
    $this.v54_1 = $this.t54_1.v55_1;
    $this.w54_1 = $this.s54_1.w55_1;
    $this.x54_1 = $this.t54_1.w55_1;
    $this.y54_1 = $this.s54_1.x55_1;
    $this.z54_1 = $this.t54_1.x55_1;
    var tmp = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.v54_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = $this.u54_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.f1();
      while (tmp0_iterator_0.g1()) {
        var item_0 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Segment($this, Companion_instance_0.h2t(item_0.r55_1.k2_1, item.r55_1.k2_1, item_0.r55_1.l2_1 + 1 | 0, item.r55_1.l2_1 + 1 | 0), item_0, item);
        destination_0.f(tmp$ret$0);
      }
      var tmp$ret$3 = toFastList(destination_0);
      destination.f(tmp$ret$3);
    }
    tmp.a55_1 = toFastList(destination);
    $this.b55_1 = new Int32Array(64);
    $this.c55_1 = new Int32Array(64);
    return $this;
  }
  static d55(width, height, left, top, right, bottom, content) {
    content = content === VOID ? null : content;
    return this.y55(listOf_0([to(false, until(0, left)), to(true, until(left, right)), to(false, until(right, width))]), listOf_0([to(false, until(0, top)), to(true, until(top, bottom)), to(false, until(bottom, height))]), width, height, content);
  }
  toString() {
    return 'NinePatchInfo(xranges=' + toString(this.n54_1) + ', yranges=' + toString(this.o54_1) + ', width=' + this.p54_1 + ', height=' + this.q54_1 + ', content=' + toString_0(this.r54_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.n54_1);
    result = imul(result, 31) + hashCode(this.o54_1) | 0;
    result = imul(result, 31) + this.p54_1 | 0;
    result = imul(result, 31) + this.q54_1 | 0;
    result = imul(result, 31) + (this.r54_1 == null ? 0 : this.r54_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NinePatchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof NinePatchInfo ? other : THROW_CCE();
    if (!equals(this.n54_1, tmp0_other_with_cast.n54_1))
      return false;
    if (!equals(this.o54_1, tmp0_other_with_cast.o54_1))
      return false;
    if (!(this.p54_1 === tmp0_other_with_cast.p54_1))
      return false;
    if (!(this.q54_1 === tmp0_other_with_cast.q54_1))
      return false;
    if (!equals(this.r54_1, tmp0_other_with_cast.r54_1))
      return false;
    return true;
  }
}
class NullBitmap extends Bitmap {
  static m56(width, height, premultiplied) {
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.s4q(width, height, 32, premultiplied, null);
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.n56_1 = colors;
    this.o56_1 = names;
    this.p56_1 = changeStart;
    this.q56_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.ic('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.n56_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.n56_1, n);
        var tmp22_safe_receiver = this.o56_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.ic(', ');
        }
        if (!(name == null)) {
          this_0.ic(name);
          this_0.ic(': ');
        }
        this_0.ic(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.ic(')');
    return this_0.toString();
  }
}
class BitmapEffect {
  constructor(blurRadius, dropShadowX, dropShadowY, dropShadowRadius, dropShadowColor, borderSize, borderColor) {
    blurRadius = blurRadius === VOID ? 0 : blurRadius;
    dropShadowX = dropShadowX === VOID ? 0 : dropShadowX;
    dropShadowY = dropShadowY === VOID ? 0 : dropShadowY;
    dropShadowRadius = dropShadowRadius === VOID ? 0 : dropShadowRadius;
    dropShadowColor = dropShadowColor === VOID ? Colors_getInstance().h4r_1 : dropShadowColor;
    borderSize = borderSize === VOID ? 0 : borderSize;
    borderColor = borderColor === VOID ? Colors_getInstance().h4r_1 : borderColor;
    this.r56_1 = blurRadius;
    this.s56_1 = dropShadowX;
    this.t56_1 = dropShadowY;
    this.u56_1 = dropShadowRadius;
    this.v56_1 = dropShadowColor;
    this.w56_1 = borderSize;
    this.x56_1 = borderColor;
  }
  y56() {
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.max' call
    var a = this.r56_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.s56_1;
    var b = abs(this_0);
    var a_0 = Math.max(a, b);
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = this.t56_1;
    var b_0 = abs(this_1);
    var a_1 = Math.max(a_0, b_0);
    var b_1 = this.w56_1;
    return Math.max(a_1, b_1);
  }
  toString() {
    return 'BitmapEffect(blurRadius=' + this.r56_1 + ', dropShadowX=' + this.s56_1 + ', dropShadowY=' + this.t56_1 + ', dropShadowRadius=' + this.u56_1 + ', dropShadowColor=' + RGBA__toString_impl_4lw6dp(this.v56_1) + ', borderSize=' + this.w56_1 + ', borderColor=' + RGBA__toString_impl_4lw6dp(this.x56_1) + ')';
  }
  hashCode() {
    var result = this.r56_1;
    result = imul(result, 31) + this.s56_1 | 0;
    result = imul(result, 31) + this.t56_1 | 0;
    result = imul(result, 31) + this.u56_1 | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.v56_1) | 0;
    result = imul(result, 31) + this.w56_1 | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.x56_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapEffect))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapEffect ? other : THROW_CCE();
    if (!(this.r56_1 === tmp0_other_with_cast.r56_1))
      return false;
    if (!(this.s56_1 === tmp0_other_with_cast.s56_1))
      return false;
    if (!(this.t56_1 === tmp0_other_with_cast.t56_1))
      return false;
    if (!(this.u56_1 === tmp0_other_with_cast.u56_1))
      return false;
    if (!(this.v56_1 === tmp0_other_with_cast.v56_1))
      return false;
    if (!(this.w56_1 === tmp0_other_with_cast.w56_1))
      return false;
    if (!(this.x56_1 === tmp0_other_with_cast.x56_1))
      return false;
    return true;
  }
}
class Result_0 {
  constructor(bmp, buffer, radius, cutoff) {
    this.b57_1 = bmp;
    this.c57_1 = buffer;
    this.d57_1 = radius;
    this.e57_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.b57_1.toString() + ', buffer=' + this.c57_1 + ', radius=' + this.d57_1 + ', cutoff=' + this.e57_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b57_1);
    result = imul(result, 31) + this.c57_1 | 0;
    result = imul(result, 31) + this.d57_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.e57_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result_0))
      return false;
    var tmp0_other_with_cast = other instanceof Result_0 ? other : THROW_CCE();
    if (!equals(this.b57_1, tmp0_other_with_cast.b57_1))
      return false;
    if (!(this.c57_1 === tmp0_other_with_cast.c57_1))
      return false;
    if (!(this.d57_1 === tmp0_other_with_cast.d57_1))
      return false;
    if (!equals(this.e57_1, tmp0_other_with_cast.e57_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.f57_1 = 1.0E10;
  }
  g57(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.c4p(bmp.j2y() + imul(buffer, 2) | 0, bmp.k2y() + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.j2y();
    var height = out.k2y();
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.j2y();
    var height_0 = out.k2y();
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.k2y();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.j2y();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.t4z(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.a2z(x0, y0, 1.0E10);
                gridInner.a2z(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.a2z(x0, y0, 0.0);
                gridInner.a2z(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.a2z(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.a2z(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.h57(gridOuter.y2y_1, 0, 0, out.j2y(), out.k2y(), gridOuter.j2y(), f, v, z);
    this.h57(gridInner.y2y_1, buffer, buffer, bmp.j2y(), bmp.k2y(), gridInner.j2y(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.k2y();
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.j2y();
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.z2k(x_0, y_0);
            var gin = gridInner.z2k(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.r4z(x_0, y_0, Companion_getInstance_28().a57(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result_0(out, buffer, radius, cutoff);
  }
  i57(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.j2y();
      var b = bmp.k2y();
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.g57(bmp, maxSide, buffer, radius, cutoff) : $super.g57.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  h57(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.j57(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.j57(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  j57(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class BGRA {
  constructor() {
    BGRA_instance = this;
    this.k57_1 = new Mixin_0(32, 16, 8, 8, 8, 0, 8, 24, 8);
  }
  l57(v) {
    return this.k57_1.l57(v);
  }
  v57(v) {
    return this.k57_1.v57(v);
  }
  w57(v) {
    return this.k57_1.w57(v);
  }
  x57(v) {
    return this.k57_1.x57(v);
  }
  t4q() {
    return this.k57_1.m57_1;
  }
}
class Mixin_0 {
  constructor(bpp, rOffset, rSize, gOffset, gSize, bOffset, bSize, aOffset, aSize) {
    this.m57_1 = bpp;
    this.n57_1 = rOffset;
    this.o57_1 = rSize;
    this.p57_1 = gOffset;
    this.q57_1 = gSize;
    this.r57_1 = bOffset;
    this.s57_1 = bSize;
    this.t57_1 = aOffset;
    this.u57_1 = aSize;
  }
  t4q() {
    return this.m57_1;
  }
  l57(v) {
    return extractScaledFF(v, this.n57_1, this.o57_1);
  }
  v57(v) {
    return extractScaledFF(v, this.p57_1, this.q57_1);
  }
  w57(v) {
    return extractScaledFF(v, this.r57_1, this.s57_1);
  }
  x57(v) {
    return extractScaledFFDefault(v, this.t57_1, this.u57_1, 255);
  }
}
class ColorFormat32 {
  constructor() {
    this.y57_1 = 32;
  }
  t4q() {
    return this.y57_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.z57_1 = 24;
  }
  t4q() {
    return this.z57_1;
  }
}
class Companion_6 {}
class ColorTransform {
  constructor(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA) {
    this.a58_1 = _mR;
    this.b58_1 = _mG;
    this.c58_1 = _mB;
    this.d58_1 = _mA;
    this.e58_1 = _aR;
    this.f58_1 = _aG;
    this.g58_1 = _aB;
    this.h58_1 = _aA;
    this.i58_1 = true;
    this.j58_1 = true;
    this.k58_1 = Colors_getInstance().g4r_1;
    this.l58_1 = _ColorAdd___init__impl__q78um5(0);
  }
  m58(ratio, l, r) {
    return this.v58(interpolate_0(ratio, l.n58(), r.n58()), interpolate_0(ratio, l.o58(), r.o58()), interpolate_0(ratio, l.p58(), r.p58()), interpolate_0(ratio, l.q58(), r.q58()), interpolate_1(ratio, l.r58(), r.r58()), interpolate_1(ratio, l.s58(), r.s58()), interpolate_1(ratio, l.t58(), r.t58()), interpolate_1(ratio, l.u58(), r.u58()));
  }
  w58(ratio, other) {
    // Inline function 'korlibs.image.color.ColorTransform' call
    var multiply = Colors_getInstance().g4r_1;
    // Inline function 'korlibs.image.color.Companion.invoke' call
    var add = _ColorAdd___init__impl__q78um5(ColorAdd_pack(0, 0, 0, 0));
    return (new ColorTransform(_RGBA___get_rf__impl__kvz75k(multiply), _RGBA___get_gf__impl__5gcu1f(multiply), _RGBA___get_bf__impl__1xz5yg(multiply), _RGBA___get_af__impl__vu36qv(multiply), _ColorAdd___get_r__impl__j9xkne(add), _ColorAdd___get_g__impl__itrhk1(add), _ColorAdd___get_b__impl__grv87a(add), _ColorAdd___get_a__impl__c1r8ux(add))).m58(ratio, this, other);
  }
  d10(ratio, other) {
    return this.w58(ratio, other instanceof ColorTransform ? other : THROW_CCE());
  }
  x58() {
    computeColorMul(this);
    return this.k58_1;
  }
  n58() {
    return this.a58_1;
  }
  o58() {
    return this.b58_1;
  }
  p58() {
    return this.c58_1;
  }
  q58() {
    return this.d58_1;
  }
  r58() {
    return this.e58_1;
  }
  s58() {
    return this.f58_1;
  }
  t58() {
    return this.g58_1;
  }
  u58() {
    return this.h58_1;
  }
  y58(mR, mG, mB, mA) {
    this.a58_1 = mR;
    this.b58_1 = mG;
    this.c58_1 = mB;
    this.d58_1 = mA;
    this.i58_1 = true;
    return this;
  }
  z58(aR, aG, aB, aA) {
    this.e58_1 = aR;
    this.f58_1 = aG;
    this.g58_1 = aB;
    this.h58_1 = aA;
    this.j58_1 = true;
    return this;
  }
  v58(mR, mG, mB, mA, aR, aG, aB, aA) {
    return this.y58(mR, mG, mB, mA).z58(aR, aG, aB, aA);
  }
  toString() {
    return 'ColorTransform(*[' + get_niceStr(this.n58()) + ', ' + get_niceStr(this.o58()) + ', ' + get_niceStr(this.p58()) + ', ' + get_niceStr(this.q58()) + ']+[' + this.r58() + ', ' + this.s58() + ', ' + this.t58() + ', ' + this.u58() + '])';
  }
  a59() {
    return this.v58(1.0, 1.0, 1.0, 1.0, 0, 0, 0, 0);
  }
  hashCode() {
    var result = getNumberHashCode(this.a58_1);
    result = imul(result, 31) + getNumberHashCode(this.b58_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c58_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d58_1) | 0;
    result = imul(result, 31) + this.e58_1 | 0;
    result = imul(result, 31) + this.f58_1 | 0;
    result = imul(result, 31) + this.g58_1 | 0;
    result = imul(result, 31) + this.h58_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransform))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransform ? other : THROW_CCE();
    if (!equals(this.a58_1, tmp0_other_with_cast.a58_1))
      return false;
    if (!equals(this.b58_1, tmp0_other_with_cast.b58_1))
      return false;
    if (!equals(this.c58_1, tmp0_other_with_cast.c58_1))
      return false;
    if (!equals(this.d58_1, tmp0_other_with_cast.d58_1))
      return false;
    if (!(this.e58_1 === tmp0_other_with_cast.e58_1))
      return false;
    if (!(this.f58_1 === tmp0_other_with_cast.f58_1))
      return false;
    if (!(this.g58_1 === tmp0_other_with_cast.g58_1))
      return false;
    if (!(this.h58_1 === tmp0_other_with_cast.h58_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.b59_1 = _r;
    this.c59_1 = _g;
    this.d59_1 = _b;
    this.e59_1 = _a;
    this.f59_1 = true;
    this.g59_1 = Colors_getInstance().g4r_1;
  }
  h59() {
    return this.b59_1;
  }
  i59() {
    return this.c59_1;
  }
  j59() {
    return this.d59_1;
  }
  k59(value) {
    this.e59_1 = value;
    this.f59_1 = true;
  }
  l59() {
    return this.e59_1;
  }
  m59(v) {
    this.n59(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.g59_1 = v;
    this.f59_1 = false;
  }
  x58() {
    if (this.f59_1) {
      this.f59_1 = false;
      this.g59_1 = Companion_getInstance_28().e53(this.b59_1, this.c59_1, this.d59_1, this.e59_1);
    }
    return this.g59_1;
  }
  n59(r, g, b, a) {
    this.b59_1 = r;
    this.c59_1 = g;
    this.d59_1 = b;
    this.e59_1 = a;
    this.f59_1 = true;
  }
  o59(other) {
    return this.n59(other.b59_1, other.c59_1, other.d59_1, other.e59_1);
  }
  p59(a, b) {
    return this.n59(a.h59() * b.h59(), a.i59() * b.i59(), a.j59() * b.j59(), a.l59() * b.l59());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.b59_1 + ', _g=' + this.c59_1 + ', _b=' + this.d59_1 + ', _a=' + this.e59_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b59_1);
    result = imul(result, 31) + getNumberHashCode(this.c59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e59_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.b59_1, tmp0_other_with_cast.b59_1))
      return false;
    if (!equals(this.c59_1, tmp0_other_with_cast.c59_1))
      return false;
    if (!equals(this.d59_1, tmp0_other_with_cast.d59_1))
      return false;
    if (!equals(this.e59_1, tmp0_other_with_cast.e59_1))
      return false;
    return true;
  }
}
class WithDefault {
  constructor(defaultColor) {
    this.q59_1 = defaultColor;
  }
  r59(str) {
    return Colors_getInstance().s59(str, this.q59_1);
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.g4r_1 = Companion_getInstance_28().a57(255, 255, 255, 255);
    this.h4r_1 = Companion_getInstance_28().a57(0, 0, 0, 255);
    this.i4r_1 = Companion_getInstance_28().a57(255, 0, 0, 255);
    this.j4r_1 = Companion_getInstance_28().a57(0, 255, 0, 255);
    this.k4r_1 = Companion_getInstance_28().a57(0, 0, 255, 255);
    this.l4r_1 = Companion_getInstance_28().a57(0, 0, 0, 0);
    this.m4r_1 = Companion_getInstance_28().a57(255, 255, 255, 0);
    this.n4r_1 = Companion_getInstance_28().t59(240, 248, 255);
    this.o4r_1 = Companion_getInstance_28().t59(250, 235, 215);
    this.p4r_1 = Companion_getInstance_28().t59(0, 255, 255);
    this.q4r_1 = Companion_getInstance_28().t59(127, 255, 212);
    this.r4r_1 = Companion_getInstance_28().t59(240, 255, 255);
    this.s4r_1 = Companion_getInstance_28().t59(245, 245, 220);
    this.t4r_1 = Companion_getInstance_28().t59(255, 228, 196);
    this.u4r_1 = Companion_getInstance_28().t59(255, 235, 205);
    this.v4r_1 = Companion_getInstance_28().t59(138, 43, 226);
    this.w4r_1 = Companion_getInstance_28().t59(165, 42, 42);
    this.x4r_1 = Companion_getInstance_28().t59(222, 184, 135);
    this.y4r_1 = Companion_getInstance_28().t59(95, 158, 160);
    this.z4r_1 = Companion_getInstance_28().t59(127, 255, 0);
    this.a4s_1 = Companion_getInstance_28().t59(210, 105, 30);
    this.b4s_1 = Companion_getInstance_28().t59(255, 127, 80);
    this.c4s_1 = Companion_getInstance_28().t59(100, 149, 237);
    this.d4s_1 = Companion_getInstance_28().t59(255, 248, 220);
    this.e4s_1 = Companion_getInstance_28().t59(220, 20, 60);
    this.f4s_1 = Companion_getInstance_28().t59(0, 0, 139);
    this.g4s_1 = Companion_getInstance_28().t59(0, 255, 255);
    this.h4s_1 = Companion_getInstance_28().t59(0, 139, 139);
    this.i4s_1 = Companion_getInstance_28().t59(184, 134, 11);
    this.j4s_1 = Companion_getInstance_28().t59(169, 169, 169);
    this.k4s_1 = Companion_getInstance_28().t59(0, 100, 0);
    this.l4s_1 = Companion_getInstance_28().t59(169, 169, 169);
    this.m4s_1 = Companion_getInstance_28().t59(189, 183, 107);
    this.n4s_1 = Companion_getInstance_28().t59(255, 0, 255);
    this.o4s_1 = Companion_getInstance_28().t59(139, 0, 139);
    this.p4s_1 = Companion_getInstance_28().t59(85, 107, 47);
    this.q4s_1 = Companion_getInstance_28().t59(255, 140, 0);
    this.r4s_1 = Companion_getInstance_28().t59(153, 50, 204);
    this.s4s_1 = Companion_getInstance_28().t59(139, 0, 0);
    this.t4s_1 = Companion_getInstance_28().t59(233, 150, 122);
    this.u4s_1 = Companion_getInstance_28().t59(143, 188, 143);
    this.v4s_1 = Companion_getInstance_28().t59(72, 61, 139);
    this.w4s_1 = Companion_getInstance_28().t59(47, 79, 79);
    this.x4s_1 = Companion_getInstance_28().t59(47, 79, 79);
    this.y4s_1 = Companion_getInstance_28().t59(0, 206, 209);
    this.z4s_1 = Companion_getInstance_28().t59(148, 0, 211);
    this.a4t_1 = Companion_getInstance_28().t59(255, 20, 147);
    this.b4t_1 = Companion_getInstance_28().t59(0, 191, 255);
    this.c4t_1 = Companion_getInstance_28().t59(105, 105, 105);
    this.d4t_1 = Companion_getInstance_28().t59(105, 105, 105);
    this.e4t_1 = Companion_getInstance_28().t59(30, 144, 255);
    this.f4t_1 = Companion_getInstance_28().t59(178, 34, 34);
    this.g4t_1 = Companion_getInstance_28().t59(255, 250, 240);
    this.h4t_1 = Companion_getInstance_28().t59(34, 139, 34);
    this.i4t_1 = Companion_getInstance_28().t59(255, 0, 255);
    this.j4t_1 = Companion_getInstance_28().t59(220, 220, 220);
    this.k4t_1 = Companion_getInstance_28().t59(248, 248, 255);
    this.l4t_1 = Companion_getInstance_28().t59(255, 215, 0);
    this.m4t_1 = Companion_getInstance_28().t59(218, 165, 32);
    this.n4t_1 = Companion_getInstance_28().t59(173, 255, 47);
    this.o4t_1 = Companion_getInstance_28().t59(240, 255, 240);
    this.p4t_1 = Companion_getInstance_28().t59(255, 105, 180);
    this.q4t_1 = Companion_getInstance_28().t59(205, 92, 92);
    this.r4t_1 = Companion_getInstance_28().t59(75, 0, 130);
    this.s4t_1 = Companion_getInstance_28().t59(255, 255, 240);
    this.t4t_1 = Companion_getInstance_28().t59(240, 230, 140);
    this.u4t_1 = Companion_getInstance_28().t59(230, 230, 250);
    this.v4t_1 = Companion_getInstance_28().t59(255, 240, 245);
    this.w4t_1 = Companion_getInstance_28().t59(124, 252, 0);
    this.x4t_1 = Companion_getInstance_28().t59(255, 250, 205);
    this.y4t_1 = Companion_getInstance_28().t59(173, 216, 230);
    this.z4t_1 = Companion_getInstance_28().t59(240, 128, 128);
    this.a4u_1 = Companion_getInstance_28().t59(224, 255, 255);
    this.b4u_1 = Companion_getInstance_28().t59(250, 250, 210);
    this.c4u_1 = Companion_getInstance_28().t59(211, 211, 211);
    this.d4u_1 = Companion_getInstance_28().t59(144, 238, 144);
    this.e4u_1 = Companion_getInstance_28().t59(211, 211, 211);
    this.f4u_1 = Companion_getInstance_28().t59(255, 182, 193);
    this.g4u_1 = Companion_getInstance_28().t59(255, 160, 122);
    this.h4u_1 = Companion_getInstance_28().t59(32, 178, 170);
    this.i4u_1 = Companion_getInstance_28().t59(135, 206, 250);
    this.j4u_1 = Companion_getInstance_28().t59(119, 136, 153);
    this.k4u_1 = Companion_getInstance_28().t59(119, 136, 153);
    this.l4u_1 = Companion_getInstance_28().t59(176, 196, 222);
    this.m4u_1 = Companion_getInstance_28().t59(255, 255, 224);
    this.n4u_1 = Companion_getInstance_28().t59(0, 255, 0);
    this.o4u_1 = Companion_getInstance_28().t59(50, 205, 50);
    this.p4u_1 = Companion_getInstance_28().t59(250, 240, 230);
    this.q4u_1 = Companion_getInstance_28().t59(128, 0, 0);
    this.r4u_1 = Companion_getInstance_28().t59(102, 205, 170);
    this.s4u_1 = Companion_getInstance_28().t59(0, 0, 205);
    this.t4u_1 = Companion_getInstance_28().t59(186, 85, 211);
    this.u4u_1 = Companion_getInstance_28().t59(147, 112, 219);
    this.v4u_1 = Companion_getInstance_28().t59(60, 179, 113);
    this.w4u_1 = Companion_getInstance_28().t59(123, 104, 238);
    this.x4u_1 = Companion_getInstance_28().t59(0, 250, 154);
    this.y4u_1 = Companion_getInstance_28().t59(72, 209, 204);
    this.z4u_1 = Companion_getInstance_28().t59(199, 21, 133);
    this.a4v_1 = Companion_getInstance_28().t59(25, 25, 112);
    this.b4v_1 = Companion_getInstance_28().t59(245, 255, 250);
    this.c4v_1 = Companion_getInstance_28().t59(255, 228, 225);
    this.d4v_1 = Companion_getInstance_28().t59(255, 228, 181);
    this.e4v_1 = Companion_getInstance_28().t59(255, 222, 173);
    this.f4v_1 = Companion_getInstance_28().t59(0, 0, 128);
    this.g4v_1 = Companion_getInstance_28().t59(253, 245, 230);
    this.h4v_1 = Companion_getInstance_28().t59(128, 128, 0);
    this.i4v_1 = Companion_getInstance_28().t59(107, 142, 35);
    this.j4v_1 = Companion_getInstance_28().t59(255, 165, 0);
    this.k4v_1 = Companion_getInstance_28().t59(255, 69, 0);
    this.l4v_1 = Companion_getInstance_28().t59(218, 112, 214);
    this.m4v_1 = Companion_getInstance_28().t59(238, 232, 170);
    this.n4v_1 = Companion_getInstance_28().t59(152, 251, 152);
    this.o4v_1 = Companion_getInstance_28().t59(175, 238, 238);
    this.p4v_1 = Companion_getInstance_28().t59(219, 112, 147);
    this.q4v_1 = Companion_getInstance_28().t59(255, 239, 213);
    this.r4v_1 = Companion_getInstance_28().t59(255, 218, 185);
    this.s4v_1 = Companion_getInstance_28().t59(205, 133, 63);
    this.t4v_1 = Companion_getInstance_28().t59(255, 192, 203);
    this.u4v_1 = Companion_getInstance_28().t59(221, 160, 221);
    this.v4v_1 = Companion_getInstance_28().t59(176, 224, 230);
    this.w4v_1 = Companion_getInstance_28().t59(128, 0, 128);
    this.x4v_1 = Companion_getInstance_28().t59(188, 143, 143);
    this.y4v_1 = Companion_getInstance_28().t59(65, 105, 225);
    this.z4v_1 = Companion_getInstance_28().t59(139, 69, 19);
    this.a4w_1 = Companion_getInstance_28().t59(250, 128, 114);
    this.b4w_1 = Companion_getInstance_28().t59(244, 164, 96);
    this.c4w_1 = Companion_getInstance_28().t59(46, 139, 87);
    this.d4w_1 = Companion_getInstance_28().t59(255, 245, 238);
    this.e4w_1 = Companion_getInstance_28().t59(160, 82, 45);
    this.f4w_1 = Companion_getInstance_28().t59(192, 192, 192);
    this.g4w_1 = Companion_getInstance_28().t59(135, 206, 235);
    this.h4w_1 = Companion_getInstance_28().t59(106, 90, 205);
    this.i4w_1 = Companion_getInstance_28().t59(112, 128, 144);
    this.j4w_1 = Companion_getInstance_28().t59(112, 128, 144);
    this.k4w_1 = Companion_getInstance_28().t59(255, 250, 250);
    this.l4w_1 = Companion_getInstance_28().t59(0, 255, 127);
    this.m4w_1 = Companion_getInstance_28().t59(70, 130, 180);
    this.n4w_1 = Companion_getInstance_28().t59(210, 180, 140);
    this.o4w_1 = Companion_getInstance_28().t59(0, 128, 128);
    this.p4w_1 = Companion_getInstance_28().t59(216, 191, 216);
    this.q4w_1 = Companion_getInstance_28().t59(255, 99, 71);
    this.r4w_1 = Companion_getInstance_28().t59(64, 224, 208);
    this.s4w_1 = Companion_getInstance_28().t59(238, 130, 238);
    this.t4w_1 = Companion_getInstance_28().t59(245, 222, 179);
    this.u4w_1 = Companion_getInstance_28().t59(245, 245, 245);
    this.v4w_1 = Companion_getInstance_28().t59(154, 205, 50);
    this.w4w_1 = Companion_getInstance_28().t59(255, 255, 0);
    this.x4w_1 = mapOf_0([to('black', new RGBA(this.h4r_1)), to('white', new RGBA(this.g4r_1)), to('red', new RGBA(this.i4r_1)), to('green', new RGBA(this.j4r_1)), to('blue', new RGBA(this.k4r_1)), to('aliceblue', new RGBA(this.n4r_1)), to('antiquewhite', new RGBA(this.o4r_1)), to('aqua', new RGBA(this.p4r_1)), to('aquamarine', new RGBA(this.q4r_1)), to('azure', new RGBA(this.r4r_1)), to('beige', new RGBA(this.s4r_1)), to('bisque', new RGBA(this.t4r_1)), to('blanchedalmond', new RGBA(this.u4r_1)), to('blueviolet', new RGBA(this.v4r_1)), to('brown', new RGBA(this.w4r_1)), to('burlywood', new RGBA(this.x4r_1)), to('cadetblue', new RGBA(this.y4r_1)), to('chartreuse', new RGBA(this.z4r_1)), to('chocolate', new RGBA(this.a4s_1)), to('coral', new RGBA(this.b4s_1)), to('cornflowerblue', new RGBA(this.c4s_1)), to('cornsilk', new RGBA(this.d4s_1)), to('crimson', new RGBA(this.e4s_1)), to('cyan', new RGBA(this.g4s_1)), to('darkblue', new RGBA(this.f4s_1)), to('darkcyan', new RGBA(this.h4s_1)), to('darkgoldenrod', new RGBA(this.i4s_1)), to('darkgray', new RGBA(this.j4s_1)), to('darkgreen', new RGBA(this.k4s_1)), to('darkgrey', new RGBA(this.l4s_1)), to('darkkhaki', new RGBA(this.m4s_1)), to('darkmagenta', new RGBA(this.o4s_1)), to('darkolivegreen', new RGBA(this.p4s_1)), to('darkorange', new RGBA(this.q4s_1)), to('darkorchid', new RGBA(this.r4s_1)), to('darkred', new RGBA(this.s4s_1)), to('darksalmon', new RGBA(this.t4s_1)), to('darkseagreen', new RGBA(this.u4s_1)), to('darkslateblue', new RGBA(this.v4s_1)), to('darkslategray', new RGBA(this.w4s_1)), to('darkslategrey', new RGBA(this.x4s_1)), to('darkturquoise', new RGBA(this.y4s_1)), to('darkviolet', new RGBA(this.z4s_1)), to('deeppink', new RGBA(this.a4t_1)), to('deepskyblue', new RGBA(this.b4t_1)), to('dimgray', new RGBA(this.c4t_1)), to('dimgrey', new RGBA(this.d4t_1)), to('dodgerblue', new RGBA(this.e4t_1)), to('firebrick', new RGBA(this.f4t_1)), to('floralwhite', new RGBA(this.g4t_1)), to('forestgreen', new RGBA(this.h4t_1)), to('fuchsia', new RGBA(this.i4t_1)), to('gainsboro', new RGBA(this.j4t_1)), to('ghostwhite', new RGBA(this.k4t_1)), to('gold', new RGBA(this.l4t_1)), to('goldenrod', new RGBA(this.m4t_1)), to('greenyellow', new RGBA(this.n4t_1)), to('honeydew', new RGBA(this.o4t_1)), to('hotpink', new RGBA(this.p4t_1)), to('indianred', new RGBA(this.q4t_1)), to('indigo', new RGBA(this.r4t_1)), to('ivory', new RGBA(this.s4t_1)), to('khaki', new RGBA(this.t4t_1)), to('lavender', new RGBA(this.u4t_1)), to('lavenderblush', new RGBA(this.v4t_1)), to('lawngreen', new RGBA(this.w4t_1)), to('lemonchiffon', new RGBA(this.x4t_1)), to('lightblue', new RGBA(this.y4t_1)), to('lightcoral', new RGBA(this.z4t_1)), to('lightcyan', new RGBA(this.a4u_1)), to('lightgoldenrodyellow', new RGBA(this.b4u_1)), to('lightgray', new RGBA(this.c4u_1)), to('lightgreen', new RGBA(this.d4u_1)), to('lightgrey', new RGBA(this.e4u_1)), to('lightpink', new RGBA(this.f4u_1)), to('lightsalmon', new RGBA(this.g4u_1)), to('lightseagreen', new RGBA(this.h4u_1)), to('lightskyblue', new RGBA(this.i4u_1)), to('lightslategray', new RGBA(this.j4u_1)), to('lightslategrey', new RGBA(this.k4u_1)), to('lightsteelblue', new RGBA(this.l4u_1)), to('lightyellow', new RGBA(this.m4u_1)), to('lime', new RGBA(this.n4u_1)), to('limegreen', new RGBA(this.o4u_1)), to('linen', new RGBA(this.p4u_1)), to('magenta', new RGBA(this.n4s_1)), to('maroon', new RGBA(this.q4u_1)), to('mediumaquamarine', new RGBA(this.r4u_1)), to('mediumblue', new RGBA(this.s4u_1)), to('mediumorchid', new RGBA(this.t4u_1)), to('mediumpurple', new RGBA(this.u4u_1)), to('mediumseagreen', new RGBA(this.v4u_1)), to('mediumslateblue', new RGBA(this.w4u_1)), to('mediumspringgreen', new RGBA(this.x4u_1)), to('mediumturquoise', new RGBA(this.y4u_1)), to('mediumvioletred', new RGBA(this.z4u_1)), to('midnightblue', new RGBA(this.a4v_1)), to('mintcream', new RGBA(this.b4v_1)), to('mistyrose', new RGBA(this.c4v_1)), to('moccasin', new RGBA(this.d4v_1)), to('navajowhite', new RGBA(this.e4v_1)), to('navy', new RGBA(this.f4v_1)), to('oldlace', new RGBA(this.g4v_1)), to('olive', new RGBA(this.h4v_1)), to('olivedrab', new RGBA(this.i4v_1)), to('orange', new RGBA(this.j4v_1)), to('orangered', new RGBA(this.k4v_1)), to('orchid', new RGBA(this.l4v_1)), to('palegoldenrod', new RGBA(this.m4v_1)), to('palegreen', new RGBA(this.n4v_1)), to('paleturquoise', new RGBA(this.o4v_1)), to('palevioletred', new RGBA(this.p4v_1)), to('papayawhip', new RGBA(this.q4v_1)), to('peachpuff', new RGBA(this.r4v_1)), to('peru', new RGBA(this.s4v_1)), to('pink', new RGBA(this.t4v_1)), to('plum', new RGBA(this.u4v_1)), to('powderblue', new RGBA(this.v4v_1)), to('purple', new RGBA(this.w4v_1)), to('rosybrown', new RGBA(this.x4v_1)), to('royalblue', new RGBA(this.y4v_1)), to('saddlebrown', new RGBA(this.z4v_1)), to('salmon', new RGBA(this.a4w_1)), to('sandybrown', new RGBA(this.b4w_1)), to('seagreen', new RGBA(this.c4w_1)), to('seashell', new RGBA(this.d4w_1)), to('sienna', new RGBA(this.e4w_1)), to('silver', new RGBA(this.f4w_1)), to('skyblue', new RGBA(this.g4w_1)), to('slateblue', new RGBA(this.h4w_1)), to('slategray', new RGBA(this.i4w_1)), to('slategrey', new RGBA(this.j4w_1)), to('snow', new RGBA(this.k4w_1)), to('springgreen', new RGBA(this.l4w_1)), to('steelblue', new RGBA(this.m4w_1)), to('tan', new RGBA(this.n4w_1)), to('teal', new RGBA(this.o4w_1)), to('thistle', new RGBA(this.p4w_1)), to('tomato', new RGBA(this.q4w_1)), to('turquoise', new RGBA(this.r4w_1)), to('violet', new RGBA(this.s4w_1)), to('wheat', new RGBA(this.t4w_1)), to('whitesmoke', new RGBA(this.u4w_1)), to('yellowgreen', new RGBA(this.v4w_1)), to('yellow', new RGBA(this.w4w_1))]);
  }
  r59(str) {
    return this.u59(str, this.l4r_1, true);
  }
  u59(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).f3(hex.length))
          return this.h4r_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt_0(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt_0(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt_0(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt_0(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_28().a57(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split_0(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.j1() : false) {
          tmp = parts.i1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.j1() : false) {
          tmp_0 = parts.i1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.j1() : false) {
          tmp_1 = parts.i1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.j1() : false) {
          tmp_2 = parts.i1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_28().a57(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.x4w_1.k3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.v59_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.s59('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().i4r_1;
      } else {
        throw $p;
      }
    }
  }
  s59(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.u59(str, default_0, errorOnDefault) : $super.u59.call(this, str, new RGBA(default_0), errorOnDefault).v59_1;
  }
}
class MaterialColors {
  constructor() {
    MaterialColors_instance = this;
    this.w59_1 = Colors_getInstance().r59('#FFEBEE');
    this.x59_1 = Colors_getInstance().r59('#FFCDD2');
    this.y59_1 = Colors_getInstance().r59('#EF9A9A');
    this.z59_1 = Colors_getInstance().r59('#E57373');
    this.a5a_1 = Colors_getInstance().r59('#EF5350');
    this.b5a_1 = Colors_getInstance().r59('#F44336');
    this.c5a_1 = Colors_getInstance().r59('#E53935');
    this.d5a_1 = Colors_getInstance().r59('#D32F2F');
    this.e5a_1 = Colors_getInstance().r59('#C62828');
    this.f5a_1 = Colors_getInstance().r59('#B71C1C');
    this.g5a_1 = Colors_getInstance().r59('#FF8A80');
    this.h5a_1 = Colors_getInstance().r59('#FF5252');
    this.i5a_1 = Colors_getInstance().r59('#FF1744');
    this.j5a_1 = Colors_getInstance().r59('#D50000');
    this.k5a_1 = Colors_getInstance().r59('#FCE4EC');
    this.l5a_1 = Colors_getInstance().r59('#F8BBD0');
    this.m5a_1 = Colors_getInstance().r59('#F48FB1');
    this.n5a_1 = Colors_getInstance().r59('#F06292');
    this.o5a_1 = Colors_getInstance().r59('#EC407A');
    this.p5a_1 = Colors_getInstance().r59('#E91E63');
    this.q5a_1 = Colors_getInstance().r59('#D81B60');
    this.r5a_1 = Colors_getInstance().r59('#C2185B');
    this.s5a_1 = Colors_getInstance().r59('#AD1457');
    this.t5a_1 = Colors_getInstance().r59('#880E4F');
    this.u5a_1 = Colors_getInstance().r59('#FF80AB');
    this.v5a_1 = Colors_getInstance().r59('#FF4081');
    this.w5a_1 = Colors_getInstance().r59('#F50057');
    this.x5a_1 = Colors_getInstance().r59('#C51162');
    this.y5a_1 = Colors_getInstance().r59('#F3E5F5');
    this.z5a_1 = Colors_getInstance().r59('#E1BEE7');
    this.a5b_1 = Colors_getInstance().r59('#CE93D8');
    this.b5b_1 = Colors_getInstance().r59('#BA68C8');
    this.c5b_1 = Colors_getInstance().r59('#AB47BC');
    this.d5b_1 = Colors_getInstance().r59('#9C27B0');
    this.e5b_1 = Colors_getInstance().r59('#8E24AA');
    this.f5b_1 = Colors_getInstance().r59('#7B1FA2');
    this.g5b_1 = Colors_getInstance().r59('#6A1B9A');
    this.h5b_1 = Colors_getInstance().r59('#4A148C');
    this.i5b_1 = Colors_getInstance().r59('#EA80FC');
    this.j5b_1 = Colors_getInstance().r59('#E040FB');
    this.k5b_1 = Colors_getInstance().r59('#D500F9');
    this.l5b_1 = Colors_getInstance().r59('#AA00FF');
    this.m5b_1 = Colors_getInstance().r59('#EDE7F6');
    this.n5b_1 = Colors_getInstance().r59('#D1C4E9');
    this.o5b_1 = Colors_getInstance().r59('#B39DDB');
    this.p5b_1 = Colors_getInstance().r59('#9575CD');
    this.q5b_1 = Colors_getInstance().r59('#7E57C2');
    this.r5b_1 = Colors_getInstance().r59('#673AB7');
    this.s5b_1 = Colors_getInstance().r59('#5E35B1');
    this.t5b_1 = Colors_getInstance().r59('#512DA8');
    this.u5b_1 = Colors_getInstance().r59('#4527A0');
    this.v5b_1 = Colors_getInstance().r59('#311B92');
    this.w5b_1 = Colors_getInstance().r59('#B388FF');
    this.x5b_1 = Colors_getInstance().r59('#7C4DFF');
    this.y5b_1 = Colors_getInstance().r59('#651FFF');
    this.z5b_1 = Colors_getInstance().r59('#6200EA');
    this.a5c_1 = Colors_getInstance().r59('#E3F2FD');
    this.b5c_1 = Colors_getInstance().r59('#BBDEFB');
    this.c5c_1 = Colors_getInstance().r59('#90CAF9');
    this.d5c_1 = Colors_getInstance().r59('#64B5F6');
    this.e5c_1 = Colors_getInstance().r59('#42A5F5');
    this.f5c_1 = Colors_getInstance().r59('#2196F3');
    this.g5c_1 = Colors_getInstance().r59('#1E88E5');
    this.h5c_1 = Colors_getInstance().r59('#1976D2');
    this.i5c_1 = Colors_getInstance().r59('#1565C0');
    this.j5c_1 = Colors_getInstance().r59('#0D47A1');
    this.k5c_1 = Colors_getInstance().r59('#82B1FF');
    this.l5c_1 = Colors_getInstance().r59('#448AFF');
    this.m5c_1 = Colors_getInstance().r59('#2979FF');
    this.n5c_1 = Colors_getInstance().r59('#2962FF');
    this.o5c_1 = Colors_getInstance().r59('#E1F5FE');
    this.p5c_1 = Colors_getInstance().r59('#B3E5FC');
    this.q5c_1 = Colors_getInstance().r59('#81D4FA');
    this.r5c_1 = Colors_getInstance().r59('#4FC3F7');
    this.s5c_1 = Colors_getInstance().r59('#29B6F6');
    this.t5c_1 = Colors_getInstance().r59('#03A9F4');
    this.u5c_1 = Colors_getInstance().r59('#039BE5');
    this.v5c_1 = Colors_getInstance().r59('#0288D1');
    this.w5c_1 = Colors_getInstance().r59('#0277BD');
    this.x5c_1 = Colors_getInstance().r59('#01579B');
    this.y5c_1 = Colors_getInstance().r59('#80D8FF');
    this.z5c_1 = Colors_getInstance().r59('#40C4FF');
    this.a5d_1 = Colors_getInstance().r59('#00B0FF');
    this.b5d_1 = Colors_getInstance().r59('#0091EA');
    this.c5d_1 = Colors_getInstance().r59('#E0F7FA');
    this.d5d_1 = Colors_getInstance().r59('#B2EBF2');
    this.e5d_1 = Colors_getInstance().r59('#80DEEA');
    this.f5d_1 = Colors_getInstance().r59('#4DD0E1');
    this.g5d_1 = Colors_getInstance().r59('#26C6DA');
    this.h5d_1 = Colors_getInstance().r59('#00BCD4');
    this.i5d_1 = Colors_getInstance().r59('#00ACC1');
    this.j5d_1 = Colors_getInstance().r59('#0097A7');
    this.k5d_1 = Colors_getInstance().r59('#00838F');
    this.l5d_1 = Colors_getInstance().r59('#006064');
    this.m5d_1 = Colors_getInstance().r59('#84FFFF');
    this.n5d_1 = Colors_getInstance().r59('#18FFFF');
    this.o5d_1 = Colors_getInstance().r59('#00E5FF');
    this.p5d_1 = Colors_getInstance().r59('#00B8D4');
    this.q5d_1 = Colors_getInstance().r59('#E0F2F1');
    this.r5d_1 = Colors_getInstance().r59('#B2DFDB');
    this.s5d_1 = Colors_getInstance().r59('#80CBC4');
    this.t5d_1 = Colors_getInstance().r59('#4DB6AC');
    this.u5d_1 = Colors_getInstance().r59('#26A69A');
    this.v5d_1 = Colors_getInstance().r59('#009688');
    this.w5d_1 = Colors_getInstance().r59('#00897B');
    this.x5d_1 = Colors_getInstance().r59('#00796B');
    this.y5d_1 = Colors_getInstance().r59('#00695C');
    this.z5d_1 = Colors_getInstance().r59('#004D40');
    this.a5e_1 = Colors_getInstance().r59('#A7FFEB');
    this.b5e_1 = Colors_getInstance().r59('#64FFDA');
    this.c5e_1 = Colors_getInstance().r59('#1DE9B6');
    this.d5e_1 = Colors_getInstance().r59('#00BFA5');
    this.e5e_1 = Colors_getInstance().r59('#E8F5E9');
    this.f5e_1 = Colors_getInstance().r59('#C8E6C9');
    this.g5e_1 = Colors_getInstance().r59('#A5D6A7');
    this.h5e_1 = Colors_getInstance().r59('#81C784');
    this.i5e_1 = Colors_getInstance().r59('#66BB6A');
    this.j5e_1 = Colors_getInstance().r59('#4CAF50');
    this.k5e_1 = Colors_getInstance().r59('#43A047');
    this.l5e_1 = Colors_getInstance().r59('#388E3C');
    this.m5e_1 = Colors_getInstance().r59('#2E7D32');
    this.n5e_1 = Colors_getInstance().r59('#1B5E20');
    this.o5e_1 = Colors_getInstance().r59('#B9F6CA');
    this.p5e_1 = Colors_getInstance().r59('#69F0AE');
    this.q5e_1 = Colors_getInstance().r59('#00E676');
    this.r5e_1 = Colors_getInstance().r59('#00C853');
    this.s5e_1 = Colors_getInstance().r59('#F1F8E9');
    this.t5e_1 = Colors_getInstance().r59('#DCEDC8');
    this.u5e_1 = Colors_getInstance().r59('#C5E1A5');
    this.v5e_1 = Colors_getInstance().r59('#AED581');
    this.w5e_1 = Colors_getInstance().r59('#9CCC65');
    this.x5e_1 = Colors_getInstance().r59('#8BC34A');
    this.y5e_1 = Colors_getInstance().r59('#7CB342');
    this.z5e_1 = Colors_getInstance().r59('#689F38');
    this.a5f_1 = Colors_getInstance().r59('#558B2F');
    this.b5f_1 = Colors_getInstance().r59('#33691E');
    this.c5f_1 = Colors_getInstance().r59('#CCFF90');
    this.d5f_1 = Colors_getInstance().r59('#B2FF59');
    this.e5f_1 = Colors_getInstance().r59('#76FF03');
    this.f5f_1 = Colors_getInstance().r59('#64DD17');
    this.g5f_1 = Colors_getInstance().r59('#F9FBE7');
    this.h5f_1 = Colors_getInstance().r59('#F0F4C3');
    this.i5f_1 = Colors_getInstance().r59('#E6EE9C');
    this.j5f_1 = Colors_getInstance().r59('#DCE775');
    this.k5f_1 = Colors_getInstance().r59('#D4E157');
    this.l5f_1 = Colors_getInstance().r59('#CDDC39');
    this.m5f_1 = Colors_getInstance().r59('#C0CA33');
    this.n5f_1 = Colors_getInstance().r59('#AFB42B');
    this.o5f_1 = Colors_getInstance().r59('#9E9D24');
    this.p5f_1 = Colors_getInstance().r59('#827717');
    this.q5f_1 = Colors_getInstance().r59('#F4FF81');
    this.r5f_1 = Colors_getInstance().r59('#EEFF41');
    this.s5f_1 = Colors_getInstance().r59('#C6FF00');
    this.t5f_1 = Colors_getInstance().r59('#AEEA00');
    this.u5f_1 = Colors_getInstance().r59('#FFFDE7');
    this.v5f_1 = Colors_getInstance().r59('#FFF9C4');
    this.w5f_1 = Colors_getInstance().r59('#FFF59D');
    this.x5f_1 = Colors_getInstance().r59('#FFF176');
    this.y5f_1 = Colors_getInstance().r59('#FFEE58');
    this.z5f_1 = Colors_getInstance().r59('#FFEB3B');
    this.a5g_1 = Colors_getInstance().r59('#FDD835');
    this.b5g_1 = Colors_getInstance().r59('#FBC02D');
    this.c5g_1 = Colors_getInstance().r59('#F9A825');
    this.d5g_1 = Colors_getInstance().r59('#F57F17');
    this.e5g_1 = Colors_getInstance().r59('#FFFF8D');
    this.f5g_1 = Colors_getInstance().r59('#FFFF00');
    this.g5g_1 = Colors_getInstance().r59('#FFEA00');
    this.h5g_1 = Colors_getInstance().r59('#FFD600');
    this.i5g_1 = Colors_getInstance().r59('#FFF8E1');
    this.j5g_1 = Colors_getInstance().r59('#FFECB3');
    this.k5g_1 = Colors_getInstance().r59('#FFE082');
    this.l5g_1 = Colors_getInstance().r59('#FFD54F');
    this.m5g_1 = Colors_getInstance().r59('#FFCA28');
    this.n5g_1 = Colors_getInstance().r59('#FFC107');
    this.o5g_1 = Colors_getInstance().r59('#FFB300');
    this.p5g_1 = Colors_getInstance().r59('#FFA000');
    this.q5g_1 = Colors_getInstance().r59('#FF8F00');
    this.r5g_1 = Colors_getInstance().r59('#FF6F00');
    this.s5g_1 = Colors_getInstance().r59('#FFE57F');
    this.t5g_1 = Colors_getInstance().r59('#FFD740');
    this.u5g_1 = Colors_getInstance().r59('#FFC400');
    this.v5g_1 = Colors_getInstance().r59('#FFAB00');
    this.w5g_1 = Colors_getInstance().r59('#FFF3E0');
    this.x5g_1 = Colors_getInstance().r59('#FFE0B2');
    this.y5g_1 = Colors_getInstance().r59('#FFCC80');
    this.z5g_1 = Colors_getInstance().r59('#FFB74D');
    this.a5h_1 = Colors_getInstance().r59('#FFA726');
    this.b5h_1 = Colors_getInstance().r59('#FF9800');
    this.c5h_1 = Colors_getInstance().r59('#FB8C00');
    this.d5h_1 = Colors_getInstance().r59('#F57C00');
    this.e5h_1 = Colors_getInstance().r59('#EF6C00');
    this.f5h_1 = Colors_getInstance().r59('#E65100');
    this.g5h_1 = Colors_getInstance().r59('#FFD180');
    this.h5h_1 = Colors_getInstance().r59('#FFAB40');
    this.i5h_1 = Colors_getInstance().r59('#FF9100');
    this.j5h_1 = Colors_getInstance().r59('#FF6D00');
    this.k5h_1 = Colors_getInstance().r59('#FBE9E7');
    this.l5h_1 = Colors_getInstance().r59('#FFCCBC');
    this.m5h_1 = Colors_getInstance().r59('#FFAB91');
    this.n5h_1 = Colors_getInstance().r59('#FF8A65');
    this.o5h_1 = Colors_getInstance().r59('#FF7043');
    this.p5h_1 = Colors_getInstance().r59('#FF5722');
    this.q5h_1 = Colors_getInstance().r59('#F4511E');
    this.r5h_1 = Colors_getInstance().r59('#E64A19');
    this.s5h_1 = Colors_getInstance().r59('#D84315');
    this.t5h_1 = Colors_getInstance().r59('#BF360C');
    this.u5h_1 = Colors_getInstance().r59('#FF9E80');
    this.v5h_1 = Colors_getInstance().r59('#FF6E40');
    this.w5h_1 = Colors_getInstance().r59('#FF3D00');
    this.x5h_1 = Colors_getInstance().r59('#DD2C00');
    this.y5h_1 = Colors_getInstance().r59('#EFEBE9');
    this.z5h_1 = Colors_getInstance().r59('#EFEBE9');
    this.a5i_1 = Colors_getInstance().r59('#D7CCC8');
    this.b5i_1 = Colors_getInstance().r59('#BCAAA4');
    this.c5i_1 = Colors_getInstance().r59('#8D6E63');
    this.d5i_1 = Colors_getInstance().r59('#795548');
    this.e5i_1 = Colors_getInstance().r59('#6D4C41');
    this.f5i_1 = Colors_getInstance().r59('#5D4037');
    this.g5i_1 = Colors_getInstance().r59('#4E342E');
    this.h5i_1 = Colors_getInstance().r59('#3E2723');
    this.i5i_1 = Colors_getInstance().r59('#FAFAFA');
    this.j5i_1 = Colors_getInstance().r59('#F5F5F5');
    this.k5i_1 = Colors_getInstance().r59('#EEEEEE');
    this.l5i_1 = Colors_getInstance().r59('#E0E0E0');
    this.m5i_1 = Colors_getInstance().r59('#BDBDBD');
    this.n5i_1 = Colors_getInstance().r59('#9E9E9E');
    this.o5i_1 = Colors_getInstance().r59('#757575');
    this.p5i_1 = Colors_getInstance().r59('#616161');
    this.q5i_1 = Colors_getInstance().r59('#424242');
    this.r5i_1 = Colors_getInstance().r59('#212121');
    this.s5i_1 = Colors_getInstance().r59('#ECEFF1');
    this.t5i_1 = Colors_getInstance().r59('#CFD8DC');
    this.u5i_1 = Colors_getInstance().r59('#B0BEC5');
    this.v5i_1 = Colors_getInstance().r59('#90A4AE');
    this.w5i_1 = Colors_getInstance().r59('#78909C');
    this.x5i_1 = Colors_getInstance().r59('#607D8B');
    this.y5i_1 = Colors_getInstance().r59('#546E7A');
    this.z5i_1 = Colors_getInstance().r59('#455A64');
    this.a5j_1 = Colors_getInstance().r59('#37474F');
    this.b5j_1 = Colors_getInstance().r59('#263238');
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_26();
    super();
    this.d5j_1 = rOffset;
    this.e5j_1 = gOffset;
    this.f5j_1 = bOffset;
  }
  l57(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.d5j_1 | 0) & 255;
  }
  v57(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.e5j_1 | 0) & 255;
  }
  w57(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.f5j_1 | 0) & 255;
  }
  x57(v) {
    return 255;
  }
}
class Companion_8 extends RGB {
  constructor() {
    Companion_instance_18 = null;
    super(0, 8, 16);
    Companion_instance_18 = this;
  }
}
class Companion_9 {
  q51(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.g5j_1 = ints;
  }
  n1(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.g5j_1, fromIndex, toIndex);
  }
  h5j(element) {
    return RgbaArray__contains_impl_ofn00n(this.g5j_1, element);
  }
  f3(element) {
    return RgbaArray__contains_impl_ofn00n_0(this, element);
  }
  i5j(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.g5j_1, elements);
  }
  g3(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  j5j(element) {
    return RgbaArray__indexOf_impl_d6b5pl(this.g5j_1, element);
  }
  q1(element) {
    return RgbaArray__indexOf_impl_d6b5pl_0(this, element);
  }
  a1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.g5j_1);
  }
  f1() {
    return RgbaArray__iterator_impl_5wfwsm(this.g5j_1);
  }
  h3() {
    return RgbaArray__listIterator_impl_m4kjt0(this.g5j_1);
  }
  p1(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.g5j_1, index);
  }
  j1() {
    return _RgbaArray___get_size__impl__imxef8(this.g5j_1);
  }
  k5j(index) {
    return RgbaArray__get_impl_nzyo1o(this.g5j_1, index);
  }
  i1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.g5j_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.g5j_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.g5j_1, other);
  }
}
class Companion_10 extends ColorFormat32 {
  constructor() {
    Companion_instance_20 = null;
    super();
    Companion_instance_20 = this;
    this.c4x_1 = 0;
    this.d4x_1 = 8;
    this.e4x_1 = 16;
    this.f4x_1 = 24;
  }
  e53(r, g, b, a) {
    return this.n5j(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  n5j(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  a57(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  t59(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  o5j(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  p5j(rgba) {
    return rgba;
  }
  l57(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  v57(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  w57(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  x57(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  q5j(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.r5j(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  r5j(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  s5j(c1, c2, factor) {
    return this.q5j(c1, c2, numberToInt(Ratio__toFloat_impl_1ftup5(factor) * 256));
  }
  t5j(c1, c2, factor) {
    return Companion_getInstance_28().o5j(_RGBA___get_rgb__impl__tijaqt(this.s5j(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  g4x(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.t5j(c00, c10, factorX);
    var c2 = this.t5j(c01, c11, factorX);
    return this.t5j(c1, c2, factorY);
  }
  z56(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_28().o5j(_RGBA___get_rgb__impl__tijaqt(this.q5j(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  m5j(c1, c2) {
    return Companion_getInstance_28().a57(imul(_RGBA___get_r__impl__duz7mo(c1), _RGBA___get_r__impl__duz7mo(c2)) / 255 | 0, imul(_RGBA___get_g__impl__o8pukr(c1), _RGBA___get_g__impl__o8pukr(c2)) / 255 | 0, imul(_RGBA___get_b__impl__m6tl80(c1), _RGBA___get_b__impl__m6tl80(c2)) / 255 | 0, imul(_RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2)) / 255 | 0);
  }
  l5j(src, dst, ratio) {
    return Companion_getInstance_28().a57(interpolate_1(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate_1(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate_1(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate_1(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_28();
    this.v59_1 = value;
  }
  j13() {
    return RGBA__clone_impl_w007z0(this.v59_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.v59_1);
  }
  u5j(other) {
    return RGBA__compareTo_impl_lrfjc1(this.v59_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  v5j(ratio, other) {
    return RGBA__interpolateWith_impl_mw7p5y(this.v59_1, ratio, other);
  }
  d10(ratio, other) {
    return RGBA__interpolateWith_impl_mw7p5y_0(this, ratio, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.v59_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.v59_1, other);
  }
}
class Companion_11 {
  constructor() {
    this.l51_1 = 16711935;
    this.m51_1 = -16711936;
  }
  w5j(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
  n51(c1, c2, c3, c4) {
    var RB = (((((_RGBAPremultiplied___get_value__impl__bqfhud(c1) & 16711935) + (_RGBAPremultiplied___get_value__impl__bqfhud(c2) & 16711935) | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c3) & 16711935) | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c4) & 16711935) | 0) >>> 2 | 0) & 16711935;
    var G = (((((_RGBAPremultiplied___get_value__impl__bqfhud(c1) & 65280) + (_RGBAPremultiplied___get_value__impl__bqfhud(c2) & 65280) | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c3) & 65280) | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c4) & 65280) | 0) >>> 2 | 0) & 65280;
    var A = (((((_RGBAPremultiplied___get_value__impl__bqfhud(c1) >>> 24 | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c2) >>> 24 | 0) | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c3) >>> 24 | 0) | 0) + (_RGBAPremultiplied___get_value__impl__bqfhud(c4) >>> 24 | 0) | 0) >>> 2 | 0) & 255;
    return _RGBAPremultiplied___init__impl__uos02x(A << 24 | RB | G);
  }
}
class Companion_12 {
  x5j(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.y5j_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.y5j_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.y5j_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.y5j_1, other);
  }
}
class BGRA_5551 {
  constructor() {
    BGRA_5551_instance = this;
    this.z5j_1 = new Mixin_0(16, 10, 5, 5, 5, 0, 5, 15, 1);
  }
  l57(v) {
    return this.z5j_1.l57(v);
  }
  v57(v) {
    return this.z5j_1.v57(v);
  }
  w57(v) {
    return this.z5j_1.w57(v);
  }
  x57(v) {
    return this.z5j_1.x57(v);
  }
  t4q() {
    return this.z5j_1.m57_1;
  }
}
class Companion_13 {
  a5k(hex, color) {
    return RGBAf__setTo_impl_x4m1oi_0(color, Colors_getInstance().r59(hex));
  }
}
class RGBAf {
  constructor(data) {
    this.b5k_1 = data;
  }
  toString() {
    return RGBAf__toString_impl_98o9o1(this.b5k_1);
  }
  hashCode() {
    return RGBAf__hashCode_impl_uzu6gw(this.b5k_1);
  }
  equals(other) {
    return RGBAf__equals_impl_wa7r4s(this.b5k_1, other);
  }
}
class Companion_14 {
  c5k(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_15 {
  l5k(font, fontSize, chars, fontName, paint, mipmaps_0, effect) {
    var fontSizeD = numberToDouble(fontSize);
    var fmetrics = font.m5k(fontSizeD);
    // Inline function 'kotlin.collections.map' call
    var this_0 = chars.n5k_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = font.o5k(fontSizeD, item, VOID, null);
      destination.f(tmp$ret$0);
    }
    var glyphMetrics = destination;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(glyphMetrics, 10));
    var tmp0_iterator = glyphMetrics.f1();
    while (tmp0_iterator.g1()) {
      var item_0 = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.Companion.invoke.<anonymous>' call
      var tmp$ret$3 = (item_0.j2y() + 4) * (fmetrics.d5l() + 4);
      destination_0.f(tmp$ret$3);
    }
    var requiredArea = toIntCeil_0(sum(destination_0));
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$6 = Math.sqrt(requiredArea);
    var requiredAreaSide = toIntCeil(tmp$ret$6);
    var matlas = MutableAtlas.l4q(get_nextPowerOfTwo(requiredAreaSide), get_nextPowerOfTwo(requiredAreaSide));
    var border = 2;
    var indexedObject = chars.n5k_1;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var codePoint = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var result = renderGlyphToBitmap(font, fontSizeD, codePoint, paint, true, effect, 1);
      matlas.n4q(result.e5l_1.o4q().r4p(), result);
    }
    var fm = first(matlas.g4q_1).x4p_1.f5l_1;
    var atlas = mipmaps(matlas.e4q_1, mipmaps_0);
    // Inline function 'korlibs.image.font.Companion.invoke' call
    var lineHeight = fmetrics.d5l();
    var base = fmetrics.v5k_1;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = matlas.g4q_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_1 = LinkedHashMap.wc(capacity);
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element = tmp0_iterator_0.h1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.image.font.Companion.invoke.<anonymous>' call
      var slice = element.w4p_1;
      var g = first(element.x4p_1.h5l_1);
      var m = g.m5l_1;
      var pair = to(g.k5l_1, new Glyph(fontSizeD, g.k5l_1, slice, -border | 0, numberToInt(border - m.k2y() - m.r2i()) + numberToInt(fm.w5k_1) | 0, toIntCeil_0(m.t5k_1)));
      destination_1.r3(pair.im_1, pair.jm_1);
    }
    var glyphs = toIntMap(destination_1);
    var kernings = IntMap.t37();
    return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs, kernings, fontName, null);
  }
}
class Kerning {
  constructor(first, second, amount) {
    this.v5l_1 = first;
    this.w5l_1 = second;
    this.x5l_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.d5k_1 = fontSize;
    this.e5k_1 = id;
    this.f5k_1 = texture;
    this.g5k_1 = xoffset;
    this.h5k_1 = yoffset;
    this.i5k_1 = xadvance;
    var tmp = this;
    tmp.j5k_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.k5k_1 = new GlyphMetrics(this.d5k_1, true, -1, Companion_getInstance_2().d2t(this.g5k_1, this.h5k_1, this.f5k_1.o41_1, this.f5k_1.p41_1), this.i5k_1);
  }
  y5l() {
    return this.f5k_1.o41_1;
  }
  z5l() {
    return this.f5k_1.p41_1;
  }
  a5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j5k_1;
    bmp$factory();
    return this_0.b2();
  }
  toString() {
    return 'Glyph(fontSize=' + this.d5k_1 + ', id=' + this.e5k_1 + ', texture=' + this.f5k_1.toString() + ', xoffset=' + this.g5k_1 + ', yoffset=' + this.h5k_1 + ', xadvance=' + this.i5k_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.d5k_1);
    result = imul(result, 31) + this.e5k_1 | 0;
    result = imul(result, 31) + this.f5k_1.hashCode() | 0;
    result = imul(result, 31) + this.g5k_1 | 0;
    result = imul(result, 31) + this.h5k_1 | 0;
    result = imul(result, 31) + this.i5k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.d5k_1, tmp0_other_with_cast.d5k_1))
      return false;
    if (!(this.e5k_1 === tmp0_other_with_cast.e5k_1))
      return false;
    if (!this.f5k_1.equals(tmp0_other_with_cast.f5k_1))
      return false;
    if (!(this.g5k_1 === tmp0_other_with_cast.g5k_1))
      return false;
    if (!(this.h5k_1 === tmp0_other_with_cast.h5k_1))
      return false;
    if (!(this.i5k_1 === tmp0_other_with_cast.i5k_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.j5m(size, metrics) : $super.j5m.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.l5m(size, codePoint, metrics, reader) : $super.l5m.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.r5m(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.r5m.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.g5m().f5k_1);
}
function getFontMetrics(size, metrics) {
  return metrics.k5m(this.h5m(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.c35(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.k5k_1;
  return metrics.m5m(tmp0_elvis_lhs == null ? this.i5m() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.b5m();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.c35(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.c35(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.g5m() : tmp1_elvis_lhs;
}
function get_1(char) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(char);
  return this.i1(tmp$ret$0);
}
function getGlyph(char) {
  return this.p5m(char);
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.o5m(size);
  var tmp0_elvis_lhs = this.d5m().i1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.l5m(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.q5k_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.j2y() === 0.0 && metrics.k2y() === 0.0)
    return false;
  var texX = pos.i2h_1 + metrics.p2i();
  var texY = pos.j2h_1 + metrics.r2i();
  var swidth = metrics.j2y();
  var sheight = metrics.k2y();
  var tmp_1;
  if (equals(ctx.o5n(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.a5m();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.c4p(g.a5m().j2y(), g.a5m().k2y(), VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.i4p_1;
    if (true) {
      this_1.w1w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.y4x(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.d4y_1.s5m_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.n5n(1.0 / scale);
          ctx_0.p5n(ctx.o5n());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.j2y() * scale;
          var height = ctx_0.k2y() * scale;
          ctx_0.q5n(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.d4y_1.s5m_1 = t;
        }
      }finally {
        ctx_0.o18();
      }
    }finally {
      result = true ? this_1.q4q(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.h50(BitmapChannel_ALPHA_getInstance(), g.a5m(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.r5n(bmp, Vector2D.k2h(texX, texY - metrics.s2i()), Size2D.k2t(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.o5m(size);
  var tmp40_safe_receiver = this.n5m(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.x5l_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.u5n_1 = new Mixin();
    this.v5n_1 = fontSize;
    this.w5n_1 = lineHeight;
    this.x5n_1 = base;
    this.y5n_1 = glyphs;
    this.z5n_1 = kernings;
    this.a5o_1 = name;
    this.b5o_1 = distanceField;
    this.c5o_1 = this.w5n_1 - this.x5n_1;
    var tmp = this;
    tmp.d5o_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.e5o_1 = new GlyphMetrics(this.v5n_1, false, 0, Companion_getInstance_2().l2m(), 0.0);
    var tmp_0 = this;
    tmp_0.f5o_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.g5o_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  n13(_set____db54di) {
    this.u5n_1.n13(_set____db54di);
  }
  o13() {
    return this.u5n_1.o13();
  }
  b5m() {
    return this.v5n_1;
  }
  d5l() {
    return this.w5n_1;
  }
  o33() {
    return this.x5n_1;
  }
  d5m() {
    return this.y5n_1;
  }
  e5m() {
    return this.z5n_1;
  }
  w3() {
    return this.a5o_1;
  }
  c5m() {
    return this.b5o_1;
  }
  s14() {
    return this;
  }
  h5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d5o_1;
    naturalFontMetrics$factory();
    return this_0.b2();
  }
  i5m() {
    return this.e5o_1;
  }
  n5m(first, second) {
    return this.z5n_1.i1(Companion_instance_24.c5k(first, second));
  }
  c35(codePoint) {
    return this.y5n_1.i1(codePoint);
  }
  g5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f5o_1;
    anyGlyph$factory();
    return this_0.b2();
  }
  h5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g5o_1;
    invalidGlyph$factory();
    return this_0.b2();
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_26 = this;
    this.i5o_1 = CharacterSet.q5o(' ');
    this.j5o_1 = CharacterSet.q5o(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), ''));
    this.k5o_1 = CharacterSet.q5o(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), ''));
    this.l5o_1 = CharacterSet.q5o(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)), ''));
    this.m5o_1 = CharacterSet.q5o('!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}');
    this.n5o_1 = CharacterSet.q5o('\xE7\xC7 \xF1\xD1 \xE5\xC5 \xE6\xC6 \xFF \xA2\xA3\xA5P\xAA\xB0\xBF\xAC\xBD\xBC\xA1\xAB\xBB\xDF\xB5\xF8\xB1\xF7\xB0\xB7.\xB2 \xE1\xE9\xED\xF3\xFA\xE4\xEB\xEF\xF6\xFC\xE0\xE8\xEC\xF2\xF9\xE2\xEA\xEE\xF4\xFB \xC1\xC9\xCD\xD3\xDA\xC4\xCB\xCF\xD6\xDC\xC0\xC8\xCC\xD2\xD9\xC2\xCA\xCE\xD4\xDB');
    this.o5o_1 = CharacterSet.q5o('\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F');
    this.p5o_1 = this.i5o_1.r5o(this.j5o_1).r5o(this.k5o_1).r5o(this.l5o_1).r5o(this.m5o_1).r5o(this.n5o_1);
  }
}
class CharacterSet {
  static s5o(codePoints) {
    Companion_getInstance_34();
    var $this = createThis(this);
    $this.n5k_1 = codePoints;
    return $this;
  }
  static q5o(chars) {
    Companion_getInstance_34();
    // Inline function 'kotlin.text.map' call
    // Inline function 'kotlin.text.mapTo' call
    var destination = ArrayList.w(charSequenceLength(chars));
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(chars)) {
      var item = charSequenceGet(chars, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.CharacterSet.<init>.<anonymous>' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(item);
      destination.f(tmp$ret$0);
    }
    return this.s5o(toIntArray(destination));
  }
  r5o(other) {
    // Inline function 'kotlin.collections.plus' call
    var this_0 = this.n5k_1;
    var elements = other.n5k_1;
    var tmp$ret$0 = primitiveArrayConcat([this_0, elements]);
    return CharacterSet.s5o(tmp$ret$0);
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.e5l_1 = bmp;
    this.f5l_1 = fmetrics;
    this.g5l_1 = metrics;
    this.h5l_1 = glyphs;
    this.i5l_1 = glyphsPerLine;
    this.j5l_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString(this.e5l_1) + ', fmetrics=' + this.f5l_1.toString() + ', metrics=' + this.g5l_1.toString() + ', glyphs=' + toString(this.h5l_1) + ', glyphsPerLine=' + toString(this.i5l_1) + ', shape=' + toString_0(this.j5l_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.e5l_1);
    result = imul(result, 31) + this.f5l_1.hashCode() | 0;
    result = imul(result, 31) + this.g5l_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.h5l_1) | 0;
    result = imul(result, 31) + hashCode(this.i5l_1) | 0;
    result = imul(result, 31) + (this.j5l_1 == null ? 0 : hashCode(this.j5l_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.e5l_1, tmp0_other_with_cast.e5l_1))
      return false;
    if (!this.f5l_1.equals(tmp0_other_with_cast.f5l_1))
      return false;
    if (!this.g5l_1.equals(tmp0_other_with_cast.g5l_1))
      return false;
    if (!equals(this.h5l_1, tmp0_other_with_cast.h5l_1))
      return false;
    if (!equals(this.i5l_1, tmp0_other_with_cast.i5l_1))
      return false;
    if (!equals(this.j5l_1, tmp0_other_with_cast.j5l_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.k5l_1 = codePoint;
    this.l5l_1 = pos;
    this.m5l_1 = metrics;
    this.n5l_1 = fontMetrics;
    this.o5l_1 = transform;
    this.p5l_1 = index;
    this.q5l_1 = nline;
    var tmp = this;
    tmp.r5l_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.s5l_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t5l_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.u5l_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  q5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r5l_1;
    boundsPath$factory();
    return this_0.b2();
  }
  r5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s5l_1;
    boundsPathCurves$factory();
    return this_0.b2();
  }
  s5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5l_1;
    caretStart$factory();
    return this_0.b2();
  }
  t5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5l_1;
    caretEnd$factory();
    return this_0.b2();
  }
  u5r(x, y, startEnd) {
    if (this.q5r().l4b(x, y))
      return 0.0;
    var tmp;
    switch (startEnd) {
      case true:
        tmp = this.s5r().v3v(Companion_getInstance_11().h10_1);
        break;
      case false:
        tmp = this.t5r().v3v(Companion_getInstance_11().h10_1);
        break;
      case null:
        // Inline function 'korlibs.math.geom.Companion.middle' call

        Companion_getInstance_1();
        var a = this.s5r().v3v(Companion_getInstance_11().h10_1);
        // Inline function 'korlibs.math.geom.Vector2D.times' call

        // Inline function 'korlibs.math.geom.Vector2D.plus' call

        var that = this.t5r().v3v(Companion_getInstance_11().h10_1);
        var this_0 = Vector2D.k2h(a.i2h_1 + that.i2h_1, a.j2h_1 + that.j2h_1);
        tmp = Vector2D.k2h(this_0.i2h_1 * 0.5, this_0.j2h_1 * 0.5);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var middle = tmp;
    return Companion_getInstance_1().l2u(middle.i2h_1, middle.j2h_1, x, y);
  }
  v5r(p, startEnd) {
    return this.u5r(p.i2h_1, p.j2h_1, startEnd);
  }
  w5r(p, startEnd, $super) {
    startEnd = startEnd === VOID ? null : startEnd;
    return $super === VOID ? this.v5r(p, startEnd) : $super.v5r.call(this, p, startEnd);
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.k5l_1 + ', pos=' + this.l5l_1.toString() + ', metrics=' + this.m5l_1.toString() + ', fontMetrics=' + this.n5l_1.toString() + ', transform=' + this.o5l_1.toString() + ', index=' + this.p5l_1 + ', nline=' + this.q5l_1 + ')';
  }
  hashCode() {
    var result = this.k5l_1;
    result = imul(result, 31) + this.l5l_1.hashCode() | 0;
    result = imul(result, 31) + this.m5l_1.hashCode() | 0;
    result = imul(result, 31) + this.n5l_1.hashCode() | 0;
    result = imul(result, 31) + this.o5l_1.hashCode() | 0;
    result = imul(result, 31) + this.p5l_1 | 0;
    result = imul(result, 31) + this.q5l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.k5l_1 === tmp0_other_with_cast.k5l_1))
      return false;
    if (!this.l5l_1.equals(tmp0_other_with_cast.l5l_1))
      return false;
    if (!this.m5l_1.equals(tmp0_other_with_cast.m5l_1))
      return false;
    if (!this.n5l_1.equals(tmp0_other_with_cast.n5l_1))
      return false;
    if (!this.o5l_1.equals(tmp0_other_with_cast.o5l_1))
      return false;
    if (!(this.p5l_1 === tmp0_other_with_cast.p5l_1))
      return false;
    if (!(this.q5l_1 === tmp0_other_with_cast.q5l_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.x5r_1 = fmetrics;
    this.y5r_1 = metrics;
    this.z5r_1 = glyphs;
    this.a5s_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.x5r_1.toString() + ', metrics=' + this.y5r_1.toString() + ', glyphs=' + toString(this.z5r_1) + ', glyphsPerLine=' + toString(this.a5s_1) + ')';
  }
  hashCode() {
    var result = this.x5r_1.hashCode();
    result = imul(result, 31) + this.y5r_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.z5r_1) | 0;
    result = imul(result, 31) + hashCode(this.a5s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.x5r_1.equals(tmp0_other_with_cast.x5r_1))
      return false;
    if (!this.y5r_1.equals(tmp0_other_with_cast.y5r_1))
      return false;
    if (!equals(this.z5r_1, tmp0_other_with_cast.z5r_1))
      return false;
    if (!equals(this.a5s_1, tmp0_other_with_cast.a5s_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.c5t_1 = FastArrayList.g14();
    this.d5t_1 = FastArrayList.g14();
  }
  j1() {
    return this.c5t_1.j1();
  }
  i5u(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.c5t_1.f(glyph);
    while (this.d5t_1.j1() <= glyph.q5l_1) {
      this.d5t_1.f(FastArrayList.g14());
    }
    this.d5t_1.i1(glyph.q5l_1).f(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.s5w(Companion_getInstance_1().a2i_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.lz();
  var that = Vector2D.k2h(x, 0.0);
  var tmp$ret$0 = Vector2D.k2h(this_0.i2h_1 + that.i2h_1, this_0.j2h_1 + that.j2h_1);
  this.s5w(tmp$ret$0);
}
function newLine(y, end) {
  this.s5w(Vector2D.k2h(0.0, this.lz().j2h_1 + y));
  var _unary__edvuaz = this.k5w();
  this.q5w(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.a5w_1 = new GlyphPath();
    this.b5w_1 = new GlyphMetrics();
    this.c5w_1 = new FontMetrics();
    this.d5w_1 = 0;
    this.f5w_1 = 0.0;
    this.g5w_1 = Companion_getInstance_1().a2i_1;
    this.h5w_1 = Companion_getInstance_4().i2m_1;
    this.i5w_1 = null;
    this.j5w_1 = Colors_getInstance().g4r_1;
  }
  d5l() {
    return this.c5w_1.d5l();
  }
  q5w(_set____db54di) {
    this.d5w_1 = _set____db54di;
  }
  k5w() {
    return this.d5w_1;
  }
  p5w() {
    var tmp = this.e5w_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  r5w(font, size) {
    this.e5w_1 = font;
    this.f5w_1 = size;
    font.j5m(size, this.c5w_1);
  }
  s5w(_set____db54di) {
    this.g5w_1 = _set____db54di;
  }
  lz() {
    return this.g5w_1;
  }
  t5w(reader, codePoint) {
    return this.p5w().l5m(this.f5w_1, codePoint, this.b5w_1, reader);
  }
  u5w(_set____db54di) {
    this.h5w_1 = _set____db54di;
  }
  n5w() {
    return this.h5w_1;
  }
  n5m(leftCodePoint, rightCodePoint) {
    return this.p5w().t5n(this.f5w_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.p5v_1 = $size;
    $box.q5v_1 = $align;
    $box.r5v_1 = $pos;
    $box.s5v_1 = $ctx;
    $box.t5v_1 = $paint;
    $box.u5v_1 = $textRangeStart;
    $box.v5v_1 = $textRangeEnd;
    $box.w5v_1 = $doRender;
    $box.x5v_1 = $glyphs;
    $box.y5v_1 = $placed;
    super($box);
    this.n5v_1 = measure($renderer, $text, $size, $fnt);
    this.o5v_1 = 0;
  }
  z5v(reader, codePoint) {
    var nline = this.k5w();
    var dx = this.n5v_1.l5w(this.q5v_1.z5t_1, nline);
    var dy = this.n5v_1.c5u(this.q5v_1.a5u_1, this.c5w_1);
    var px = this.lz().i2h_1 + this.r5v_1.i2h_1 - dx;
    var py = this.lz().j2h_1 + this.r5v_1.j2h_1 + dy;
    var tmp71_safe_receiver = this.s5v_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.d4y_1.s5m_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.s5v_1.m5w(px, py);
        this.s5v_1.o5w(get_immutable(this.n5w()));
        var tmp0_elvis_lhs = this.i5w_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.t5v_1 : tmp0_elvis_lhs;
        this.s5v_1.p5n(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.u5v_1;
        var containsUpper = this.v5v_1;
        var containsArg = this.o5v_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.p5w().r5m(this.s5v_1, this.p5v_1, codePoint, Companion_getInstance_1().a2i_1, null, this.b5w_1, reader, this.w5v_1);
        }
        this.o5v_1 = this.o5v_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.d4y_1.s5m_1 = t;
      }
    }
    if (!(this.x5v_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.k2h(px, py), this.b5w_1.j13(), this.c5w_1.j13(), this.n5w(), this.x5v_1.j1(), nline);
      this.x5v_1.i5u(glyph);
    }
    var tmp72_safe_receiver = this.y5v_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.k2h(px, py), this.p5v_1, this.b5w_1, this.c5w_1, this.n5w());
    return this.b5w_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.k2l(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.i2v(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_4().l2m() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.x5w_1 = path;
    this.y5w_1 = colorShape;
    this.z5w_1 = bitmap;
    this.a5x_1 = bitmapOffset;
    this.b5x_1 = bitmapScale;
    this.c5x_1 = transform;
    this.d5x_1 = scale;
  }
  e5x() {
    return this.z5w_1 == null && this.y5w_1 == null;
  }
  f5x(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.d4y_1.s5m_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.o5w(this.c5x_1);
      if (!(this.z5w_1 == null)) {
        c.r5n(ensureNotNull(this.z5w_1), this.a5x_1, toFloat(ensureNotNull(this.z5w_1).j1()).x2v(this.b5x_1));
      } else if (!(this.y5w_1 == null)) {
        c.g5x(ensureNotNull(this.y5w_1));
        c.b5t();
      } else {
        draw_1(c, this.x5w_1);
      }
    }finally {
      c.d4y_1.s5m_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.x5w_1.toString() + ', colorShape=' + toString_0(this.y5w_1) + ', bitmap=' + toString_0(this.z5w_1) + ', bitmapOffset=' + this.a5x_1.toString() + ', bitmapScale=' + this.b5x_1.toString() + ', transform=' + this.c5x_1.toString() + ', scale=' + this.d5x_1 + ')';
  }
  hashCode() {
    var result = this.x5w_1.hashCode();
    result = imul(result, 31) + (this.y5w_1 == null ? 0 : hashCode(this.y5w_1)) | 0;
    result = imul(result, 31) + (this.z5w_1 == null ? 0 : hashCode(this.z5w_1)) | 0;
    result = imul(result, 31) + this.a5x_1.hashCode() | 0;
    result = imul(result, 31) + this.b5x_1.hashCode() | 0;
    result = imul(result, 31) + this.c5x_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.d5x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.x5w_1.equals(tmp0_other_with_cast.x5w_1))
      return false;
    if (!equals(this.y5w_1, tmp0_other_with_cast.y5w_1))
      return false;
    if (!equals(this.z5w_1, tmp0_other_with_cast.z5w_1))
      return false;
    if (!this.a5x_1.equals(tmp0_other_with_cast.a5x_1))
      return false;
    if (!this.b5x_1.equals(tmp0_other_with_cast.b5x_1))
      return false;
    if (!this.c5x_1.equals(tmp0_other_with_cast.c5x_1))
      return false;
    if (!equals(this.d5x_1, tmp0_other_with_cast.d5x_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_27 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.h5x_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_35();
    distanceField = distanceField === VOID ? null : distanceField;
    this.i5x_1 = new Mixin();
    this.j5x_1 = font;
    this.k5x_1 = fontSize;
    this.l5x_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.l4q(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.l5x_1 == null))
      this_0.e4q_1;
    else
      mipmaps(this_0.e4q_1);
    tmp.m5x_1 = this_0;
    this.n5x_1 = this.j5x_1.m5k(this.k5x_1);
    this.o5x_1 = this.n5x_1.d5l();
    this.p5x_1 = this.n5x_1.x5k_1;
    this.q5x_1 = IntMap.t37();
    this.r5x_1 = IntMap.t37();
    var tmp_0 = this;
    tmp_0.s5x_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t5x_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.u5x_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.v5x_1 = new GlyphMetrics(this.k5x_1, false, 0, Companion_getInstance_2().l2m(), 0.0);
  }
  n13(_set____db54di) {
    this.i5x_1.n13(_set____db54di);
  }
  o13() {
    return this.i5x_1.o13();
  }
  b5m() {
    return this.k5x_1;
  }
  c5m() {
    return this.l5x_1;
  }
  d5l() {
    return this.o5x_1;
  }
  o33() {
    return this.p5x_1;
  }
  d5m() {
    return this.q5x_1;
  }
  e5m() {
    return this.r5x_1;
  }
  g5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s5x_1;
    anyGlyph$factory_0();
    return this_0.b2();
  }
  h5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5x_1;
    invalidGlyph$factory_0();
    return this_0.b2();
  }
  w3() {
    return this.j5x_1.w3();
  }
  h5m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5x_1;
    naturalFontMetrics$factory_0();
    return this_0.b2();
  }
  i5m() {
    return this.v5x_1;
  }
  n5m(first, second) {
    var kerning = this.j5x_1.t5n(this.k5x_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.r5x_1;
      var key = Companion_instance_24.c5k(first, second);
      var res = this_0.i1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.n37(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.i1(key));
    }
    return tmp;
  }
  c35(codePoint) {
    if (this.q5x_1.i1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.w5x(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.w5x(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.w5x(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.x5x(tmp$ret$6);
    }
    return this.q5x_1.i1(codePoint);
  }
  w5x(codePoint, range) {
    var containsLower = range.k2_1;
    if (codePoint <= range.l2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.f31(coerceAtLeast(range.c1() - range.b1() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.b1();
      var last = range.c1();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.l31(v);
        }
         while (!(v === last));
      this.x5x(this_0.z31());
    }
  }
  x5x(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.m5x_1.e4q_1;
    var rect = this_0.i4p_1;
    if (true) {
      this_0.w1w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.q5x_1;
        var res = this_1.i1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.l5x_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.k5x_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.j5x_1;
          var tmp84_size = this.k5x_1;
          var tmp85_paint = Colors_getInstance().g4r_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.e5l_1.o4q();
          var rbmp;
          switch (this.l5x_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.j5l_1).y5x(), bmp.j2y(), bmp.k2y());
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.j5l_1).y5x(), bmp.j2y(), bmp.k2y());
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.m5x_1.n4q(rbmp, Unit_instance);
          var slice = entry.w4p_1.t42(border, border, entry.w4p_1.o41_1 - border | 0, entry.w4p_1.p41_1 - border | 0);
          var g = first(result_0.h5l_1);
          var m = g.m5l_1;
          var xadvance = m.t5k_1;
          var tmp$ret$1 = new Glyph(this.k5x_1, codePoint, slice, -toIntRound(g.l5l_1.i2h_1) | 0, -toIntRound(g.l5l_1.j2h_1) | 0, toIntRound(xadvance));
          this_1.n37(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.i1(codePoint));
      }
    }finally {
      result = true ? this_0.q4q(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.u5k_1 = size;
    this.v5k_1 = top;
    this.w5k_1 = ascent;
    this.x5k_1 = baseline;
    this.y5k_1 = descent;
    this.z5k_1 = bottom;
    this.a5l_1 = lineGap;
    this.b5l_1 = maxWidth;
    this.c5l_1 = unitsPerEm;
  }
  z5x() {
    // Inline function 'kotlin.math.max' call
    var a = this.w5k_1;
    var b = this.v5k_1;
    return Math.max(a, b);
  }
  a5y() {
    // Inline function 'kotlin.math.min' call
    var a = this.y5k_1;
    var b = this.z5k_1;
    return Math.min(a, b);
  }
  b5y() {
    return this.z5x() - this.a5y();
  }
  d5l() {
    return this.b5y() + this.a5l_1;
  }
  i5t(other) {
    return this.c5y(other, 1.0);
  }
  k5m(other, size) {
    return this.c5y(other, size / other.u5k_1);
  }
  c5y(other, scale) {
    this.u5k_1 = other.u5k_1 * scale;
    this.v5k_1 = other.v5k_1 * scale;
    this.w5k_1 = other.w5k_1 * scale;
    this.x5k_1 = other.x5k_1 * scale;
    this.y5k_1 = other.y5k_1 * scale;
    this.z5k_1 = other.z5k_1 * scale;
    this.a5l_1 = other.a5l_1 * scale;
    this.c5l_1 = other.c5l_1 * scale;
    this.b5l_1 = other.b5l_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.ic('FontMetrics(');
    this_0.ic('size=' + niceStr(this.u5k_1, 1) + ', ');
    this_0.ic('top=' + niceStr(this.v5k_1, 1) + ', ');
    this_0.ic('ascent=' + niceStr(this.w5k_1, 1) + ', ');
    this_0.ic('baseline=' + niceStr(this.x5k_1, 1) + ', ');
    this_0.ic('descent=' + niceStr(this.y5k_1, 1) + ', ');
    this_0.ic('bottom=' + niceStr(this.z5k_1, 1) + ', ');
    this_0.ic('lineGap=' + niceStr(this.a5l_1, 1) + ', ');
    this_0.ic('unitsPerEm=' + niceStr(this.c5l_1, 1) + ', ');
    this_0.ic('maxWidth=' + niceStr(this.b5l_1, 1) + ', ');
    this_0.ic('lineHeight=' + niceStr(this.d5l(), 1));
    this_0.ic(')');
    return this_0.toString();
  }
  j13() {
    return this.d5y();
  }
  e5y(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  d5y(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.u5k_1 : size;
    top = top === VOID ? this.v5k_1 : top;
    ascent = ascent === VOID ? this.w5k_1 : ascent;
    baseline = baseline === VOID ? this.x5k_1 : baseline;
    descent = descent === VOID ? this.y5k_1 : descent;
    bottom = bottom === VOID ? this.z5k_1 : bottom;
    lineGap = lineGap === VOID ? this.a5l_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.b5l_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.c5l_1 : unitsPerEm;
    return $super === VOID ? this.e5y(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.e5y.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.u5k_1);
    result = imul(result, 31) + getNumberHashCode(this.v5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a5l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b5l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c5l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.u5k_1, tmp0_other_with_cast.u5k_1))
      return false;
    if (!equals(this.v5k_1, tmp0_other_with_cast.v5k_1))
      return false;
    if (!equals(this.w5k_1, tmp0_other_with_cast.w5k_1))
      return false;
    if (!equals(this.x5k_1, tmp0_other_with_cast.x5k_1))
      return false;
    if (!equals(this.y5k_1, tmp0_other_with_cast.y5k_1))
      return false;
    if (!equals(this.z5k_1, tmp0_other_with_cast.z5k_1))
      return false;
    if (!equals(this.a5l_1, tmp0_other_with_cast.a5l_1))
      return false;
    if (!equals(this.b5l_1, tmp0_other_with_cast.b5l_1))
      return false;
    if (!equals(this.c5l_1, tmp0_other_with_cast.c5l_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_2().l2m() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.p5k_1 = size;
    this.q5k_1 = existing;
    this.r5k_1 = codePoint;
    this.s5k_1 = bounds;
    this.t5k_1 = xadvance;
  }
  s2i() {
    return this.s5k_1.s2i();
  }
  p2i() {
    return this.s5k_1.p2i();
  }
  r2i() {
    return this.s5k_1.r2i();
  }
  j2y() {
    return this.s5k_1.k2i_1;
  }
  k2y() {
    return this.s5k_1.l2i_1;
  }
  j13() {
    return this.f5y(VOID, VOID, VOID, this.s5k_1.j13());
  }
  m5m(other, size, codePoint) {
    return this.g5y(other, size / other.p5k_1, codePoint);
  }
  g5y(other, scale, codePoint) {
    this.p5k_1 = other.p5k_1;
    this.q5k_1 = other.q5k_1;
    this.r5k_1 = codePoint;
    this.s5k_1 = other.s5k_1.c2t(scale);
    this.t5k_1 = other.t5k_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.ic('GlyphMetrics(');
    this_0.ic('codePoint=' + this.r5k_1 + " ('" + toString_1(numberToChar(this.r5k_1)) + "'), ");
    this_0.ic('existing=' + this.q5k_1 + ', ');
    this_0.ic('xadvance=' + roundToInt(this.t5k_1) + ', ');
    this_0.ic('bounds=' + this.s5k_1.q2().toString());
    this_0.ic(')');
    return this_0.toString();
  }
  h5y(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  f5y(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.p5k_1 : size;
    existing = existing === VOID ? this.q5k_1 : existing;
    codePoint = codePoint === VOID ? this.r5k_1 : codePoint;
    bounds = bounds === VOID ? this.s5k_1 : bounds;
    xadvance = xadvance === VOID ? this.t5k_1 : xadvance;
    return $super === VOID ? this.h5y(size, existing, codePoint, bounds, xadvance) : $super.h5y.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.p5k_1);
    result = imul(result, 31) + getBooleanHashCode(this.q5k_1) | 0;
    result = imul(result, 31) + this.r5k_1 | 0;
    result = imul(result, 31) + this.s5k_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.t5k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.p5k_1, tmp0_other_with_cast.p5k_1))
      return false;
    if (!(this.q5k_1 === tmp0_other_with_cast.q5k_1))
      return false;
    if (!(this.r5k_1 === tmp0_other_with_cast.r5k_1))
      return false;
    if (!this.s5k_1.equals(tmp0_other_with_cast.s5k_1))
      return false;
    if (!equals(this.t5k_1, tmp0_other_with_cast.t5k_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_2().l2m() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.e5t_1 = bounds;
    this.f5t_1 = lineBounds;
    this.g5t_1 = fontMetrics;
    this.h5t_1 = nlines;
  }
  i5y() {
    var tmp0_elvis_lhs = firstOrNull_1(this.f5t_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_2().u2i_1 : tmp0_elvis_lhs;
  }
  p2i() {
    return this.e5t_1.p2i();
  }
  r2i() {
    return this.e5t_1.r2i();
  }
  j2y() {
    return this.e5t_1.k2i_1;
  }
  k2y() {
    return this.e5t_1.l2i_1;
  }
  j5y() {
    return -this.p2i();
  }
  k5y() {
    return this.i5y().l2i_1 + this.i5y().r2i();
  }
  h5u() {
    return this.g5t_1.w5k_1;
  }
  d5l() {
    return this.g5t_1.d5l();
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.p2i()) + ', ' + get_niceStr_0(this.r2i()) + ', ' + get_niceStr_0(this.j2y()) + ', ' + get_niceStr_0(this.k2y()) + '][' + get_niceStr_0(this.j5y()) + ', ' + get_niceStr_0(this.k5y()) + ']';
  }
  hashCode() {
    var result = this.e5t_1.hashCode();
    result = imul(result, 31) + hashCode(this.f5t_1) | 0;
    result = imul(result, 31) + this.g5t_1.hashCode() | 0;
    result = imul(result, 31) + this.h5t_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.e5t_1.equals(tmp0_other_with_cast.e5t_1))
      return false;
    if (!equals(this.f5t_1, tmp0_other_with_cast.f5t_1))
      return false;
    if (!this.g5t_1.equals(tmp0_other_with_cast.g5t_1))
      return false;
    if (!(this.h5t_1 === tmp0_other_with_cast.h5t_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_28 = this;
    this.l5y_1 = Companion_getInstance_16().ez('NativeSystemFontProvider');
  }
}
class NativeSystemFontProvider {
  constructor() {
    Companion_getInstance_36();
  }
  m5y(systemFont, size, codePoint, path, reader) {
    return null;
  }
  n5y(systemFont, size, metrics) {
    var ascentRatio = 0.8;
    metrics.u5k_1 = size;
    metrics.v5k_1 = size * ascentRatio;
    metrics.w5k_1 = metrics.v5k_1;
    metrics.x5k_1 = 0.0;
    metrics.y5k_1 = -size * (1.0 - ascentRatio);
    metrics.z5k_1 = metrics.y5k_1;
    metrics.b5l_1 = size;
  }
  o5y(systemFont, size, codePoint, metrics, reader) {
    metrics.q5k_1 = false;
    metrics.s5k_1 = new Rectangle(0.0, 0.0, size, size);
    metrics.t5k_1 = size;
  }
  p5y(systemFont, size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
}
class TtfNativeSystemFontProvider extends NativeSystemFontProvider {
  constructor() {
    super();
    this.g61_1 = LinkedHashMap.vc();
  }
  h61(_this__u8e3s4) {
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = _this__u8e3s4.toLowerCase();
    return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  i61(name) {
    var normalizedName = this.h61(name);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.g61_1;
    var value = this_0.k3(normalizedName);
    var tmp;
    if (value == null) {
      // Inline function 'korlibs.image.font.TtfNativeSystemFontProvider.locateFontByName.<anonymous>' call
      var answer = this.e61(name);
      this_0.r3(normalizedName, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  j61(systemFont) {
    var tmp0_elvis_lhs = this.i61(systemFont.e62_1);
    return tmp0_elvis_lhs == null ? this.f61() : tmp0_elvis_lhs;
  }
  m5y(systemFont, size, codePoint, path, reader) {
    return this.j61(systemFont).g62(size, codePoint, path, reader);
  }
  n5y(systemFont, size, metrics) {
    this.j61(systemFont).j5m(size, metrics);
  }
  o5y(systemFont, size, codePoint, metrics, reader) {
    this.j61(systemFont).l5m(size, codePoint, metrics, reader);
  }
  p5y(systemFont, size, leftCodePoint, rightCodePoint) {
    return this.j61(systemFont).t5n(size, leftCodePoint, rightCodePoint);
  }
}
class FallbackNativeSystemFontProvider extends TtfNativeSystemFontProvider {
  constructor(ttf) {
    super();
    this.r5y_1 = ttf;
    this.s5y_1 = VfsFileFromData(this.r5y_1.d61(), 'ttf');
  }
  e61(name) {
    return this.r5y_1;
  }
  f61() {
    return this.r5y_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_29 = this;
    this.k61_1 = Companion_getInstance_16().ez('FolderBasedNativeSystemFontProvider');
  }
}
class FolderBasedNativeSystemFontProvider$listFontNamesMap$slambda {
  constructor(this$0) {
    this.q61_1 = this$0;
  }
  o1s($this$runBlockingNoJs, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0(this, $this$runBlockingNoJs, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.o1s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class FolderBasedNativeSystemFontProvider$loadFontByName$slambda {
  constructor(this$0, $name) {
    this.z61_1 = this$0;
    this.a62_1 = $name;
  }
  o1s($this$runBlockingNoJs, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1(this, $this$runBlockingNoJs, $completion), $completion);
  }
  qe(p1, $completion) {
    return this.o1s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class FolderBasedNativeSystemFontProvider extends TtfNativeSystemFontProvider {
  constructor(context, folders, fontCacheFile) {
    Companion_getInstance_37();
    folders = folders === VOID ? distinct(plus_0(plus_0(plus_0(plus_0(get_linuxFolders(), get_windowsFolders()), get_macosFolders()), get_androidFolders()), get_iosFolders())) : folders;
    fontCacheFile = fontCacheFile === VOID ? userSharedCacheFile('korimFontCache') : fontCacheFile;
    super();
    this.m61_1 = context;
    this.n61_1 = folders;
    this.o61_1 = fontCacheFile;
    this.p61_1 = atomic$ref$1(null);
  }
  c62() {
    return runBlockingNoJs(this.m61_1, FolderBasedNativeSystemFontProvider$listFontNamesMap$slambda_0(this));
  }
  b62() {
    // Inline function 'kotlin.collections.mapKeys' call
    var this_0 = this.c62();
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap.wc(mapCapacity(this_0.j1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.z1().f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMapLC.<anonymous>' call
      var tmp = this.h61(element.a2());
      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
      var tmp$ret$1 = element.b2();
      destination.r3(tmp, tmp$ret$1);
    }
    return destination;
  }
  f61() {
    return get_DefaultTtfFont();
  }
  e61(name) {
    return runBlockingNoJs(VOID, FolderBasedNativeSystemFontProvider$loadFontByName$slambda_0(this, name));
  }
}
class Companion_20 {}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.g62(size, codePoint, path, reader) : $super.g62.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.ny_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.l5m(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.ny_1 = old;
      }
    }
  }
  var g = this.i62(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.b5t();
    }
    if (!g.e5x()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.d4y_1.s5m_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.m5w(pos.i2h_1, pos.j2h_1);
      g.f5x(ctx);
    }finally {
      ctx.d4y_1.s5m_1 = t;
    }
    switch (fill) {
      case true:
        ctx.k5u();
        break;
      case false:
        ctx.j5u();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.e5x();
  }
  return false;
}
class SystemFont {
  constructor(name, coroutineContext) {
    this.d62_1 = new Mixin();
    this.e62_1 = name;
    this.f62_1 = coroutineContext;
  }
  n13(_set____db54di) {
    this.d62_1.n13(_set____db54di);
  }
  o13() {
    return this.d62_1.o13();
  }
  w3() {
    return this.e62_1;
  }
  hashCode() {
    return getStringHashCode(this.e62_1);
  }
  equals(other) {
    var tmp;
    if (other instanceof SystemFont) {
      tmp = this.e62_1 === other.e62_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'SystemFont(name=' + this.e62_1 + ')';
  }
  h62() {
    return nativeSystemFontProvider(this.f62_1);
  }
  j5m(size, metrics) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SystemFont.getFontMetrics.<anonymous>' call
    this.h62().n5y(this, size, metrics);
    return metrics;
  }
  l5m(size, codePoint, metrics, reader) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SystemFont.getGlyphMetrics.<anonymous>' call
    this.h62().o5y(this, size, codePoint, metrics, reader);
    return metrics;
  }
  t5n(size, leftCodePoint, rightCodePoint) {
    return this.h62().p5y(this, size, leftCodePoint, rightCodePoint);
  }
  g62(size, codePoint, path, reader) {
    return this.h62().m5y(this, size, codePoint, path, reader);
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.l62_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.m62_1 = toIntMap(destination);
  }
  i1(id) {
    return this.m62_1.i1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.n62_1 = path;
    this.o62_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.n62_1.toString() + ', advanceWidth=' + this.o62_1 + ')';
  }
  hashCode() {
    var result = this.n62_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.o62_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.n62_1.equals(tmp0_other_with_cast.n62_1))
      return false;
    if (!equals(this.o62_1, tmp0_other_with_cast.o62_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.p62_1 = charstringsIndex;
    this.q62_1 = globalSubrIndex;
    this.r62_1 = localSubrsIndex;
    this.s62_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.s62_1.k3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_1(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.t62_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.s62_1.k3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_1(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.u62_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  v62(index, flipY) {
    var evalCtx = new EvalContext(this.q62_1, this.r62_1, this.t62_1, this.u62_1, index);
    var vp = new VectorPath();
    var bytes = this.p62_1.i1(index);
    CharStringType2_instance.y62(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.y4b(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.i63_1);
  }
  k63(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.v62(index, flipY) : $super.v62.call(this, index, flipY);
  }
}
class DataIndex {
  static l63(offsets, bytes) {
    var $this = createThis(this);
    $this.w62_1 = offsets;
    $this.x62_1 = bytes;
    return $this;
  }
  static m63() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.l63(tmp, tmp$ret$1);
  }
  j1() {
    return this.w62_1.length - 1 | 0;
  }
  n63(index) {
    return this.w62_1[index + 1 | 0] - this.w62_1[index] | 0;
  }
  i1(index) {
    return copyOfRange(this.x62_1, this.w62_1[index], this.w62_1[index + 1 | 0]);
  }
  o63() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.j1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
      var tmp$ret$0 = this.i1(item);
      destination.f(tmp$ret$0);
    }
    return destination;
  }
  f1() {
    return this.o63().f1();
  }
  toString() {
    var tmp = this.j1();
    var tmp_0 = toString(toList_0(this.w62_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.j1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
      var tmp$ret$0 = this.n63(item);
      destination.f(tmp$ret$0);
    }
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.l62_1 = id;
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.r63_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.s63_1 = toIntMap(destination);
  }
  i1(id) {
    var tmp0_elvis_lhs = this.s63_1.i1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.m5(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.m63() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.m63() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.z62_1 = globalSubrIndex;
    this.a63_1 = localSubrsIndex;
    this.b63_1 = defaultWidthX;
    this.c63_1 = nominalWidthX;
    this.d63_1 = index;
    this.e63_1 = heap;
    this.f63_1 = computeSubrBias(CharStringType2_instance, this.z62_1.j1());
    this.g63_1 = computeSubrBias(CharStringType2_instance, this.a63_1.j1());
    this.h63_1 = 0;
    this.i63_1 = this.b63_1;
    this.j63_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.r63_1 = id;
  }
}
class CFF {
  t63(_this__u8e3s4) {
    this.u63(_this__u8e3s4);
    var nameIndex = this.v63(_this__u8e3s4);
    var topDictIndex = this.v63(_this__u8e3s4);
    var topDictByte = topDictIndex.i1(0)[1];
    var topDict = this.w63(openFastStream(topDictIndex.i1(0)));
    var stringIndex = this.v63(_this__u8e3s4);
    var globalSubrIndex = this.v63(_this__u8e3s4);
    var privateSizeOffset = topDict.k3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.m63();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.f(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.i1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.i1(1);
      privateDict = this.w63(_this__u8e3s4.t1q(privateOffset, privateSize));
      var localSubrs = privateDict.k3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.v63(_this__u8e3s4.u1q(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.k3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.v63(_this__u8e3s4.u1q(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  u63(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.z1q();
    var versionMinor = _this__u8e3s4.z1q();
    var headerSize = _this__u8e3s4.z1q();
    var offsetSize = _this__u8e3s4.z1q();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.m5(toString(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().x63_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.v3g(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  y63(_this__u8e3s4) {
    return _this__u8e3s4.z1q();
  }
  z63(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.y63(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.z1q();
        break;
      case 2:
        tmp = _this__u8e3s4.b1r();
        break;
      case 3:
        tmp = _this__u8e3s4.d1r();
        break;
      case 4:
        tmp = _this__u8e3s4.f1r();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  v63(_this__u8e3s4) {
    var count = _this__u8e3s4.b1r();
    if (count === 0)
      return DataIndex.m63();
    var offSize = this.y63(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.f31((coerceAtLeast(this_0.c1() - this_0.b1() | 0, 0) / this_0.m2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.b1();
    var nestedLast = this_0.c1();
    var stepArg = this_0.m2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.z63(_this__u8e3s4, offSize) - 1 | 0;
        this_1.l31(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.x1q(offsets.v31());
    return DataIndex.l63(offsets.z31(), bytes);
  }
  w63(_this__u8e3s4) {
    var map = LinkedHashMap.vc();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.m1();
    while (_this__u8e3s4.uy()) {
      var item = this.a64(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.r3(item, value);
        values.o3();
      } else {
        if (isNumber(item)) {
          values.f(item);
        }
      }
    }
    return map;
  }
  a64(_this__u8e3s4) {
    var b0 = _this__u8e3s4.z1q();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_39();
      tmp = tmp_0.i1(b0 === 12 ? b0 << 8 | _this__u8e3s4.z1q() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.z1q() << 8 | _this__u8e3s4.z1q());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.z1q() << 24 | _this__u8e3s4.z1q() << 16 | _this__u8e3s4.z1q() << 8 | _this__u8e3s4.z1q();
    } else if (b0 === 30) {
      tmp = this.b64(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.z1q() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.z1q() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  c64(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.z1q() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.m5(toString(message));
      }
    }
    var str = StringBuilder.h();
    end: while (true) {
      var byte = _this__u8e3s4.z1q();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.ic('E-');
              break;
            default:
              str.jc((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  b64(_this__u8e3s4, readHeader) {
    return toDouble(this.c64(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  d64(_this__u8e3s4, value) {
    _this__u8e3s4.p32(_this__u8e3s4.j1() - 1 | 0, value);
  }
  e64(_this__u8e3s4) {
    return _this__u8e3s4.i1(_this__u8e3s4.j1() - 1 | 0);
  }
  f64(_this__u8e3s4) {
    return _this__u8e3s4.q3(_this__u8e3s4.j1() - 1 | 0);
  }
  g64(_this__u8e3s4, value) {
    _this__u8e3s4.t2d(value);
  }
  h64(_this__u8e3s4, value) {
    _this__u8e3s4.t2d(value);
  }
  i64(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.f3y();
    _this__u8e3s4.u6();
    _this__u8e3s4.e3y(lastPoint);
  }
  j64(_this__u8e3s4, x, y) {
    _this__u8e3s4.x4a(Vector2D.k2h(x, y));
  }
  k64(_this__u8e3s4, x, y) {
    _this__u8e3s4.y4a(Vector2D.k2h(x, y));
  }
  l64(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.j3y(Vector2D.k2h(fcx1, fcy1), Vector2D.k2h(fcx2, fcy2), Vector2D.k2h(fax, fay));
  }
  m64(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.f3y().i2h_1 + cx1;
    var fcy1 = _this__u8e3s4.f3y().j2h_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.l64(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  n64(_this__u8e3s4, v, horizontal) {
    return this.j64(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  o64(_this__u8e3s4, v, horizontal) {
    return this.k64(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  p64(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.z1q();
  }
  q64(ctx, s, evalCtx, stack, stackLevel) {
    while (s.uy()) {
      var v0 = this.p64(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_40();
        var op = tmp.i1(v0 === 12 ? v0 << 8 | this.p64(s) : v0);
        switch (op.v3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.a1()) {
              tmp_0 = !evalCtx.j63_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.i63_1 = stack.i1(0) + evalCtx.c63_1;
              evalCtx.j63_1 = true;
            }

            if (!(ctx.k4a() === 0)) {
              this.i64(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.f64(stack));
            var bytes = global ? evalCtx.z62_1.i1(evalCtx.f63_1 + funcOffset | 0) : evalCtx.a63_1.i1(evalCtx.g63_1 + funcOffset | 0);
            this.q64(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.f64(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.f64(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.h32(this_0, this_0);
            break;
          case 39:
            stack.x31(stack.j1() - 2 | 0, stack.j1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.oe();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.oe();
          case 25:
            var index = this.f64(stack);
            var value = this.f64(stack);
            evalCtx.e63_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.e64(stack);
            var tmp$ret$3 = evalCtx.e63_1[numberToInt(it)];
            this.d64(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.f64(stack);
            var l = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.g64(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.f64(stack);
            var l_0 = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.g64(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.e64(stack) === 0.0 ? 1 : 0;
            this.d64(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.f64(stack);
            var l_1 = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.g64(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.f64(stack);
            var v1 = this.f64(stack);
            var s2 = this.f64(stack);
            var s1 = this.f64(stack);
            this.g64(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.t2d(Default_getInstance().to());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.e64(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.d64(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.e64(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.d64(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.e64(stack);
            this.d64(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.f64(stack);
            var l_2 = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.g64(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.f64(stack);
            var l_3 = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.g64(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.f64(stack);
            var l_4 = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.g64(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.f64(stack);
            var l_5 = this.f64(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.g64(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.j1() > 2) {
              evalCtx.i63_1 = stack.i1(0) + evalCtx.c63_1;
              evalCtx.j63_1 = true;
            }

            if (!(ctx.k4a() === 0)) {
              this.i64(ctx);
            }

            this.j64(ctx, stack.i1(stack.j1() - 2 | 0), stack.i1(stack.j1() - 1 | 0));
            stack.o3();
            break;
          case 3:
          case 28:
            if (stack.j1() > 1) {
              evalCtx.i63_1 = stack.i1(0) + evalCtx.c63_1;
              evalCtx.j63_1 = true;
            }

            this.n64(ctx, this.f64(stack), op.equals(Op_hmoveto_getInstance()));
            stack.o3();
            break;
          case 5:
            var progression = step(until(0, stack.j1()), 2);
            var inductionVariable = progression.k2_1;
            var last = progression.l2_1;
            var step_0 = progression.m2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.k64(ctx, stack.i1(n), stack.i1(n + 1 | 0));
              }
               while (!(n === last));
            stack.o3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.j1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.o64(ctx, stack.i1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.o3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.j1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.i1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.k64(ctx, tmp_1, stack.i1(_unary__edvuaz_0));
              }
            }

            while ((stack.j1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.i1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.i1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.i1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.i1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.i1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.m64(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.i1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.j1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.i1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.k64(ctx, tmp_7, stack.i1(_unary__edvuaz_8));
              }
            }

            stack.o3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.j1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.i1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.j1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.m5(toString(message));
            }

            while (n_2 < stack.j1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.i1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.i1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.i1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.i1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.m64(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.o3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.a1()) {
                break $l$loop;
              }
              var vv_0 = this.f64(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.f64(stack);
              var y2_0 = this.f64(stack);
              var v1_1 = this.f64(stack);
              var v2_0 = stack.j1() === 1 ? this.f64(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.m64(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.o3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.oe();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.j1() % 2 | 0) === 0) && !evalCtx.j63_1) {
              var value_0 = stack.i1(0);
              evalCtx.i63_1 = value_0 + evalCtx.c63_1;
            }

            evalCtx.h63_1 = evalCtx.h63_1 + (stack.j1() >>> 1 | 0) | 0;
            evalCtx.j63_1 = true;
            stack.o3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.h63_1 + 7 | 0) >>> 3 | 0;
              s.zy(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.oe();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.oe();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.p64(s) << 8 | this.p64(s);
        var fractionPart = this.p64(s) << 8 | this.p64(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.g64(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.p64(s) << 8 | this.p64(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.p64(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.p64(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.h64(stack, value_2);
      }
    }
  }
  y62(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.c32(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.q64(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.q64.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.x63_1 = Companion_getInstance_16().ez('TtfCIDFont');
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_33 = this;
    this.r61_1 = Companion_getInstance_16().ez('TTF');
  }
  s61(s, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readNames__k160f6(this, s, $completion), $completion);
  }
  r64(s, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readNames__k160f6_0(this, s, $completion), $completion);
  }
}
class BaseTtfFont {
  static l6e(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.t5y_1 = new Mixin();
    $this.u5y_1 = s;
    $this.v5y_1 = extName;
    $this.w5y_1 = onlyReadMetadata;
    $this.x5y_1 = enableLigatures;
    $this.y5y_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.z5y_1 = tmp_1;
    $this.a5z_1 = 0;
    $this.b5z_1 = 0;
    $this.c5z_1 = 0;
    $this.d5z_1 = 0;
    $this.e5z_1 = 0;
    $this.f5z_1 = 0;
    $this.g5z_1 = 0;
    $this.h5z_1 = 0;
    $this.i5z_1 = 0;
    $this.j5z_1 = 0;
    $this.k5z_1 = 0;
    $this.l5z_1 = 0;
    $this.m5z_1 = 0;
    $this.n5z_1 = 0;
    $this.o5z_1 = Companion_instance_37.m6e(0, 0);
    $this.p5z_1 = 0;
    $this.q5z_1 = 0;
    $this.r5z_1 = 0;
    $this.s5z_1 = 0;
    $this.t5z_1 = 0;
    $this.u5z_1 = 0;
    $this.v5z_1 = 0;
    $this.w5z_1 = 0;
    $this.x5z_1 = 0;
    $this.y5z_1 = 0;
    $this.z5z_1 = 0;
    $this.a60_1 = 0;
    $this.b60_1 = new Int32Array(0);
    $this.c60_1 = Companion_instance_37.m6e(0, 0);
    $this.d60_1 = 128;
    $this.e60_1 = 0;
    $this.f60_1 = 0;
    $this.g60_1 = 0;
    $this.h60_1 = 0;
    $this.i60_1 = 0;
    $this.j60_1 = 0;
    $this.k60_1 = 0;
    $this.l60_1 = 0;
    $this.m60_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.n60_1 = emptyList();
    $this.o60_1 = LinkedHashMap.vc();
    $this.p60_1 = LinkedHashMap.vc();
    $this.q60_1 = IntMap.t37(512);
    $this.r60_1 = LinkedHashMap.vc();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.s60_1 = [];
    $this.t60_1 = IntMap.t37();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.u60_1 = emptyList();
    $this.v60_1 = new COLRv1();
    $this.w60_1 = false;
    $this.x60_1 = IntIntMap.m38();
    $this.y60_1 = IntMap.t37();
    $this.a61_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_2().l2m(), 0.0);
    $this.b61_1 = false;
    $this.c61_1 = null;
    return $this;
  }
  n13(_set____db54di) {
    this.t5y_1.n13(_set____db54di);
  }
  o13() {
    return this.t5y_1.o13();
  }
  static a65(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.l6e(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  d61() {
    return this.u5y_1.p1r();
  }
  j5m(size, metrics) {
    return metrics.k5m(this.h65(), size);
  }
  l5m(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.s66(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.r6b_1;
    return metrics.m5m(tmp0_elvis_lhs == null ? this.a61_1 : tmp0_elvis_lhs, size, codePoint);
  }
  t5n(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  g62(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.ny_1;
    var codePointPeek = reader == null ? null : reader.vy(0);
    var tmp0_elvis_lhs = this.r66(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.o5m(size);
    path.x5w_1 = g.v1z().u6b_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.e6c();
    tmp_0.y5w_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.w6b();
    var bitmapEntry = g.g6c();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.g69();
    path.z5w_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.d60_1 / bitmapEntry.q68_1.w67_1;
      var scaleY = this.d60_1 / bitmapEntry.q68_1.x67_1;
      path.a5x_1 = Vector2D.k2h(0.0, ((-bitmapEntry.r68_1 | 0) - bitmapEntry.b69() | 0) * scaleY);
      path.b5x_1 = Scale.s2r(scaleX, scaleY);
    }
    path.c5x_1 = Companion_getInstance_4().i2m_1.k2n(scale, scale);
    path.d5x_1 = scale;
    return path;
  }
  o5m(size) {
    return size / this.d60_1;
  }
  e65(key) {
    return this.o60_1.k3(key);
  }
  f65(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.o60_1.r3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.p60_1.r3(glyphID, codePoint);
  }
  g65(codePoint, glyphID) {
  }
  h65() {
    var tmp = this.z60_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  i65() {
    return this.y5y_1.i65();
  }
  w3() {
    var tmp0_elvis_lhs = this.v5y_1;
    return tmp0_elvis_lhs == null ? this.i65() : tmp0_elvis_lhs;
  }
  b65() {
    this.c65();
    this.o65();
    this.p65();
    this.q65();
    this.m65();
    if (!this.w5y_1) {
      if (!(this.d65('CFF ') == null) && this.d65('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.l65('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.c61_1 = CFF_instance.t63(tmp111_safe_receiver);
        }
      }
      this.n65();
      this.o66();
      this.r65();
      this.s65();
      this.n66();
      this.m66();
      this.u65();
      this.v65();
      this.w65();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.o5m(1.0);
    this_0.u5k_1 = 1.0;
    this_0.v5k_1 = this.h60_1 * scale;
    this_0.w5k_1 = this.p5z_1 * scale;
    this_0.x5k_1 = 0.0 * scale;
    this_0.y5k_1 = this.q5z_1 * scale;
    this_0.z5k_1 = this.f60_1 * scale;
    this_0.a5l_1 = this.r5z_1 * scale;
    this_0.b5l_1 = this.s5z_1 * scale;
    this_0.c5l_1 = this.d60_1 * scale;
    tmp.z60_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.w3() + ')';
  }
  j65(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.b1r());
  }
  k65(_this__u8e3s4) {
    return Companion_instance_37.m6e(_this__u8e3s4.a1r(), _this__u8e3s4.a1r());
  }
  l65(name) {
    var tmp109_safe_receiver = this.d65(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.l67();
  }
  m65() {
    var tmp111_safe_receiver = this.l65('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_36.z64(tmp111_safe_receiver, this.y5y_1);
    }
    return Unit_instance;
  }
  n65() {
    var tmp111_safe_receiver = this.l65('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.l60_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.x1q(imul(bytesPerEntry, this.a5z_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.l60_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.j1r(this.a5z_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.l1r(this.a5z_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.b60_1 = tmp_1;
    }
    return Unit_instance;
  }
  o65() {
    var tmp111_safe_receiver = this.l65('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.b1r() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.b1r() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.c60_1 = this.k65(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.f1r();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.f1r();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.b1r();
      this.d60_1 = tmp111_safe_receiver.b1r();
      var created = tmp111_safe_receiver.g1r().d4(new Long(1000, 0));
      var modified = tmp111_safe_receiver.g1r().d4(new Long(1000, 0));
      this.e60_1 = tmp111_safe_receiver.a1r();
      this.f60_1 = tmp111_safe_receiver.a1r();
      this.g60_1 = tmp111_safe_receiver.a1r();
      this.h60_1 = tmp111_safe_receiver.a1r();
      this.i60_1 = tmp111_safe_receiver.b1r();
      this.j60_1 = tmp111_safe_receiver.b1r();
      this.k60_1 = tmp111_safe_receiver.a1r();
      this.l60_1 = tmp111_safe_receiver.a1r();
      this.m60_1 = tmp111_safe_receiver.a1r();
    }
    return Unit_instance;
  }
  p65() {
    var tmp111_safe_receiver = this.l65('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.k65(tmp111_safe_receiver);
      this.a5z_1 = tmp111_safe_receiver.b1r();
      this.b5z_1 = tmp111_safe_receiver.b1r();
      this.c5z_1 = tmp111_safe_receiver.b1r();
      this.d5z_1 = tmp111_safe_receiver.b1r();
      this.e5z_1 = tmp111_safe_receiver.b1r();
      this.f5z_1 = tmp111_safe_receiver.b1r();
      this.g5z_1 = tmp111_safe_receiver.b1r();
      this.h5z_1 = tmp111_safe_receiver.b1r();
      this.i5z_1 = tmp111_safe_receiver.b1r();
      this.j5z_1 = tmp111_safe_receiver.b1r();
      this.k5z_1 = tmp111_safe_receiver.b1r();
      this.l5z_1 = tmp111_safe_receiver.b1r();
      this.m5z_1 = tmp111_safe_receiver.b1r();
      this.n5z_1 = tmp111_safe_receiver.b1r();
    }
    return Unit_instance;
  }
  q65() {
    var tmp111_safe_receiver = this.l65('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.o5z_1 = this.k65(tmp111_safe_receiver);
      this.p5z_1 = tmp111_safe_receiver.a1r();
      this.q5z_1 = tmp111_safe_receiver.a1r();
      this.r5z_1 = tmp111_safe_receiver.a1r();
      this.s5z_1 = tmp111_safe_receiver.b1r();
      this.t5z_1 = tmp111_safe_receiver.a1r();
      this.u5z_1 = tmp111_safe_receiver.a1r();
      this.v5z_1 = tmp111_safe_receiver.a1r();
      this.w5z_1 = tmp111_safe_receiver.a1r();
      this.x5z_1 = tmp111_safe_receiver.a1r();
      this.y5z_1 = tmp111_safe_receiver.a1r();
      tmp111_safe_receiver.a1r();
      tmp111_safe_receiver.a1r();
      tmp111_safe_receiver.a1r();
      tmp111_safe_receiver.a1r();
      this.z5z_1 = tmp111_safe_receiver.a1r();
      this.a60_1 = tmp111_safe_receiver.b1r();
    }
    return Unit_instance;
  }
  r65() {
    var tmp111_safe_receiver = this.l65('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.a60_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.b1r(), tmp111_safe_receiver.a1r());
        destination.f(tmp$ret$0);
      }
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).m67_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.a5z_1 - this.a60_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.f1();
      while (tmp0_iterator_0.g1()) {
        var item_0 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
        var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.a1r());
        destination_0.f(tmp$ret$3);
      }
      var compressedMetrics = destination_0;
      this.n60_1 = plus_0(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  s65() {
    var tmp111_safe_receiver = this.l65('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.b1r();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.b1r();
          var numPalettes = tmp111_safe_receiver.b1r();
          var numColorRecords = tmp111_safe_receiver.b1r();
          var colorRecordsArrayOffset = tmp111_safe_receiver.f1r();
          var colorRecordIndices = tmp111_safe_receiver.i1r(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.f1r() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.f1r() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.f1r() : -1;
          tmp111_safe_receiver.p1q(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.k1r(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_28().a57(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.f(tmp$ret$0);
          }

          tmp.u60_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  t65(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.z1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q(), _this__u8e3s4.y1q());
  }
  u65() {
    var tmp111_safe_receiver = this.l65('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.b1r();
      var minorVersion = tmp111_safe_receiver.b1r();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.f1r();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.f1r(), tmp111_safe_receiver.f1r(), tmp111_safe_receiver.f1r(), tmp111_safe_receiver.f1r(), this.t65(tmp111_safe_receiver), this.t65(tmp111_safe_receiver), tmp111_safe_receiver.b1r(), tmp111_safe_receiver.b1r(), tmp111_safe_receiver.z1q(), tmp111_safe_receiver.z1q(), tmp111_safe_receiver.z1q(), tmp111_safe_receiver.y1q());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.f1();
        while (_iterator__ex2g4s.g1()) {
          var cbi = _iterator__ex2g4s.h1();
          var glyphCount = cbi.v67_1 - cbi.u67_1 | 0;
          tmp111_safe_receiver.p1q(cbi.o67_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.q67_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$1$Subtable(tmp111_safe_receiver.b1r(), tmp111_safe_receiver.b1r(), tmp111_safe_receiver.f1r());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.p1q(cbi.o67_1 + subtable.y6d_1 | 0);
            var indexFormat = tmp111_safe_receiver.b1r();
            var imageFormat = tmp111_safe_receiver.b1r();
            var imageDataOffset = tmp111_safe_receiver.f1r();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.z6d() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.f1r() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.w6d_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.r60_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.r3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  v65() {
    var tmp111_safe_receiver = this.l65('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.b1r();
      var minorVersion = tmp111_safe_receiver.b1r();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.r60_1.m3().f1();
        while (_iterator__ex2g4s.g1()) {
          var i = _iterator__ex2g4s.h1();
          var format = i.n68_1;
          if (format === 17 || format === 18) {
            i.r68_1 = tmp111_safe_receiver.z1q();
            i.s68_1 = tmp111_safe_receiver.z1q();
            i.t68_1 = tmp111_safe_receiver.y1q();
            i.u68_1 = tmp111_safe_receiver.y1q();
            i.v68_1 = tmp111_safe_receiver.z1q();
            i.w68_1 = format === 18 ? tmp111_safe_receiver.y1q() : i.t68_1;
            i.x68_1 = format === 18 ? tmp111_safe_receiver.y1q() : i.u68_1;
            i.y68_1 = format === 18 ? tmp111_safe_receiver.y1q() : i.v68_1;
          }
          var dataLen = tmp111_safe_receiver.f1r();
          i.z68_1 = tmp111_safe_receiver.s1q(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  w65() {
    var tmp111_safe_receiver = this.l65('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.b1r();
      var flags = tmp111_safe_receiver.b1r();
      var numStrikes = tmp111_safe_receiver.f1r();
      var strikeOffsets = tmp111_safe_receiver.l1r(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.p1q(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$1$StrikeInfo(tmp111_safe_receiver.b1r(), tmp111_safe_receiver.b1r(), item, toIntArrayList(tmp111_safe_receiver.l1r(this.a5z_1 + 1 | 0)));
        destination.f(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.f1();
        if (!iterator.g1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.h1();
        if (!iterator.g1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.a6e_1;
        do {
          var e = iterator.h1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.a6e_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.g1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.a5z_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.d6e_1.i1(n);
          var len = strike.d6e_1.i1(n + 1 | 0) - offset | 0;
          var start = strike.c6e_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.p1q(start);
          var originOffsetX = tmp111_safe_receiver.a1r();
          var originOffsetY = tmp111_safe_receiver.a1r();
          var graphicType = tmp111_safe_receiver.o1r(4);
          var bytes = tmp111_safe_receiver.s1q(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.r60_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.a6e_1, strike.a6e_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.z68_1 = bytes;
          this_0.r3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  x65(_this__u8e3s4) {
    return _this__u8e3s4.f1r();
  }
  y65(_this__u8e3s4) {
    return _this__u8e3s4.b1r();
  }
  z65(_this__u8e3s4) {
    return _this__u8e3s4.a1r();
  }
  a66(_this__u8e3s4) {
    return _this__u8e3s4.b1r();
  }
  b66(_this__u8e3s4) {
    return _this__u8e3s4.d1r();
  }
  c66(_this__u8e3s4) {
    return _this__u8e3s4.f1r();
  }
  d66(_this__u8e3s4, isVar) {
    var xx = this.y66(_this__u8e3s4);
    var yx = this.y66(_this__u8e3s4);
    var xy = this.y66(_this__u8e3s4);
    var yy = this.y66(_this__u8e3s4);
    var dx = this.y66(_this__u8e3s4);
    var dy = this.y66(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  e66(_this__u8e3s4, out) {
    out.k69_1 = this.x66(_this__u8e3s4);
    out.l69_1 = _this__u8e3s4.b1r();
    out.m69_1 = this.x66(_this__u8e3s4);
    return out;
  }
  f66(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.e66(_this__u8e3s4, out) : $super.e66.call(this, _this__u8e3s4, out);
  }
  g66(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.z1q();
    var xMin = this.z65(_this__u8e3s4);
    var yMin = this.z65(_this__u8e3s4);
    var xMax = this.z65(_this__u8e3s4);
    var yMax = this.z65(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.x65(_this__u8e3s4);
    }
    return Companion_getInstance_2().h2t(xMin, yMin, xMax, yMax);
  }
  h66(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.g66(_this__u8e3s4, doVar) : $super.g66.call(this, _this__u8e3s4, doVar);
  }
  i66(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.z1q()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.b1r();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.f66(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  j66(glyphID, s, c, pal, level) {
    var nodeFormat = s.z1q();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString_0(getOrNull(Companion_getInstance_43().c67_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.z1q();
        var firstLayerIndex = s.f1r();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.v60_1.p6a_1[firstLayerIndex + n | 0];
            this.j66(glyphID, this.v60_1.s6a_1.u1q(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.b1r();
        var alpha = this.x66(s);
        if (isVar) {
          var varIndexBase = this.x65(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.oe();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.u60_1.i1(pal).n56_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.n5u(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.b66(s);
        var x0 = this.z65(s);
        var y0 = this.z65(s);
        var x1 = this.z65(s);
        var y1 = this.z65(s);
        var x2 = this.z65(s);
        var y2 = this.z65(s);
        var colorLine = this.i66(s.u1q(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.x65(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.h69_1;
        var transform = Companion_getInstance_4().i2m_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.j69(paint_0, this.u60_1.i1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.n5u(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.b66(s);
        var x0_0 = this.z65(s);
        var y0_1 = this.z65(s);
        var radius0 = this.y65(s);
        var x1_0 = this.z65(s);
        var y1_1 = this.z65(s);
        var radius1 = this.y65(s);
        var colorLine_0 = this.i66(s.u1q(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.x65(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.h69_1;
        var transform_0 = Companion_getInstance_4().i2m_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.j69(paint_1, this.u60_1.i1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.n5u(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.b66(s);
        var centerX = this.z65(s);
        var centerY = this.z65(s);
        var startAngle = this.x66(s);
        var endAngle = this.x66(s);
        if (isVar) {
          var varIndexBase_2 = this.x65(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
      case 10:
        var paint_2 = this.b66(s);
        var glyphID_0 = s.b1r();
        var colr = this.t60_1.i1(glyphID_0);
        var glyph = this.w66(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.u5u();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.v1z().u6b_1), '\n'));
            }
            c.n6e(glyph.v1z().u6b_1);
            this.j66(glyphID_0, s.u1q(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.c5v();
        }

        break;
      case 11:
        var glyphID_1 = s.b1r();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
      case 12:
      case 13:
        var paint_3 = this.b66(s);
        var transform_1 = this.b66(s);
        var affine = this.d66(s.u1q(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.u5u();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.o5w(affine);
          this.j66(glyphID, s.u1q(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.c5v();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.b66(s);
        var dx = FWord__toDouble_impl_53j5qp(this.j65(s));
        var dy = FWord__toDouble_impl_53j5qp(this.j65(s));
        if (isVar) {
          var varIndexBase_3 = this.x65(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.u5u();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.m5w(dx, -dy);
          this.j66(glyphID, s.u1q(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.c5v();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.b66(s);
        var scaleX = this.x66(s);
        var scaleY = this.x66(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.z65(s);
          var centerY_0 = this.z65(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.oe();
        }

        if (isVar) {
          var varIndexBase_4 = this.x65(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.u5u();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.o6e(numberToDouble(scaleX), numberToDouble(scaleY));
          this.j66(glyphID, s.u1q(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.c5v();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.b66(s);
        var scale = this.x66(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.z65(s);
          var centerY_1 = this.z65(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.x65(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.b66(s);
        var angle = this.x66(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.z65(s);
          var centerY_2 = this.z65(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.x65(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.b66(s);
        var xSkewAngle = this.x66(s);
        var ySkewAngle = this.x66(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.z65(s);
          var centerY_3 = this.z65(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.x65(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
      case 32:
        var sourcePaint = this.b66(s);
        var compositeMode = s.z1q();
        var backdropPaint = this.b66(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.oe();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.oe('An operation is not implemented: ' + reason);
    }
  }
  k66(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.b1r();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.b1r();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.j1r(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.b1r();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var tmp0_iterator = this_3.f1();
        while (tmp0_iterator.g1()) {
          var item = tmp0_iterator.h1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r());
          destination.f(tmp$ret$4);
        }

        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.f1();
        if (!iterator.g1())
          throw NoSuchElementException.c7();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.h1();
        var maxValue = it.g6e_1 + it.h6e_1 | 0;
        while (iterator.g1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.h1();
          var v = it_0.g6e_1 + it_0.h6e_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.f1();
        while (_iterator__ex2g4s.g1()) {
          var range = _iterator__ex2g4s.h1();
          var inductionVariable_0 = range.e6e_1;
          var last_0 = range.f6e_1;
          if (inductionVariable_0 <= last_0)
            do {
              var glyphID = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var offset = glyphID - range.e6e_1 | 0;
              glyphArray[range.g6e_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_0));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.oe('An operation is not implemented: ' + reason);
    }
  }
  l66(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.k66(_this__u8e3s4, hintedCount) : $super.k66.call(this, _this__u8e3s4, hintedCount);
  }
  m66() {
    var tmp111_safe_receiver = this.l65('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.b1r();
      var minorVersion = tmp111_safe_receiver.b1r();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.m5(toString(message));
      }
      var scriptListOffset = this.a66(tmp111_safe_receiver);
      var featureListOffset = this.a66(tmp111_safe_receiver);
      var lookupListOffset = this.a66(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.c66(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.u1q(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.b1r();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.o1r(4);
          var scriptOffset = this.a66(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.u1q(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.b1r();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.o1r(4);
          var featureOffset = this.a66(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.u1q(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.b1r();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.f31((coerceAtLeast(this_3.c1() - this_3.b1() | 0, 0) / this_3.m2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.b1();
      var nestedLast = this_3.c1();
      var stepArg = this_3.m2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.a66(this_2);
          this_4.l31(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.f1();
      while (_iterator__ex2g4s.g1()) {
        var lookupOffset = _iterator__ex2g4s.h1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.u1q(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.b1r();
        var lookupFlag = this_5.b1r();
        var subTableCount = this_5.b1r();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.i1r(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.b1r();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.u1q(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.b1r();
              var coverageOffset = this.a66(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.a1r();
                  var coverageTable = this.l66(this_8.u1q(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.x60_1.l38(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.b1r();
                  var coverageTable_0 = this.l66(this_8.u1q(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.j1r(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.x60_1.l38(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.m5(toString(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.b1r();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.m5(toString(message_1));
              }

              var coverageOffset_0 = this.a66(this_8);
              var ligatureSetCount = this_8.b1r();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.j1r(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.k66(this_8.u1q(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.vc();
                  var codePoint = this.q66(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.u1q(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.b1r();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.j1r(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.u1q(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.b1r();
                    var componentCount = this_19.b1r();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.j1r(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.q66(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_14();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.cz(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.r3(ligature, value);
                  }
                  this.y60_1.n37(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_41().r61_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.u3g(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.v3g(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  n66() {
    var tmp111_safe_receiver = this.l65('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.b1r();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.b1r();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.f1r();
          var layerRecordsOffset = tmp111_safe_receiver.f1r();
          var numLayerRecords = tmp111_safe_receiver.b1r();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.u1q(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.b1r(), this_0.b1r());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.s60_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.u1q(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.b1r(), this_1.b1r(), this_1.b1r());
              this.t60_1.n37(info.a6c_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.c66(tmp111_safe_receiver);
            var layerListOffset = this.c66(tmp111_safe_receiver);
            var clipListOffset = this.c66(tmp111_safe_receiver);
            var varIdxMapOffset = this.c66(tmp111_safe_receiver);
            var varStoreOffset = this.c66(tmp111_safe_receiver);
            this.v60_1.u6a_1.o3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.u1q(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.u1q(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.f1r();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.c66(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray_0(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.u1q(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.u1q(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.u1q(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.v60_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.u1q(clipListOffset);
              var format = s.z1q();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.f1r();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.b1r();
                var endGlyphID = s.b1r();
                var clipBoxOffset = this.b66(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.v60_1.u6a_1.l38(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.u1q(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.f1r();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.b1r();
              var paint = this.c66(this_3);
              this.t60_1.n37(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  o66() {
    var tmp111_safe_receiver = this.l65('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.b1r();
      var numTables = tmp111_safe_receiver.b1r();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new BaseTtfFont$readCmap$1$EncodingRecord(tmp111_safe_receiver.b1r(), tmp111_safe_receiver.b1r(), tmp111_safe_receiver.f1r());
        destination.f(tmp$ret$0);
      }
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.f1();
      while (_iterator__ex2g4s.g1()) {
        var table = _iterator__ex2g4s.h1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.u1q(table.k6e_1);
        var format = $this$run.b1r();
        try {
          switch (format) {
            case 0:
              var length = $this$run.b1r();
              var language = $this$run.b1r();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.x1q(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable = 0;
              var last = this_1.length;
              if (inductionVariable < last)
                do {
                  var n = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable < last);
              var glyphIdArray = this_2;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < 256)
                do {
                  var n_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  this.g65(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_0 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.b1r();
              var language_0 = $this$run.b1r();
              var segCount = $this$run.b1r() / 2 | 0;
              var searchRangeS = $this$run.b1r();
              var entrySelector = $this$run.b1r();
              var rangeShift = $this$run.b1r();
              var endCount = $this$run.j1r(segCount);
              $this$run.b1r();
              var startCount = $this$run.j1r(segCount);
              var idDelta = $this$run.i1r(segCount);
              var rangeOffsetPos = $this$run.q1q();
              var idRangeOffset = $this$run.j1r(segCount);
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < segCount)
                do {
                  var n_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_2 = sc;
                  if (inductionVariable_2 <= ec)
                    do {
                      var c = inductionVariable_2;
                      inductionVariable_2 = inductionVariable_2 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.u1q(glyphIndexOffset).b1r();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.f65(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_1 < segCount);
              break;
            case 6:
              var length_1 = $this$run.b1r();
              var language_1 = $this$run.b1r();
              var firstCode = $this$run.b1r();
              var entryCount = $this$run.b1r();
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < entryCount)
                do {
                  var n_2 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.f65(codePoint, $this$run.b1r());
                }
                 while (inductionVariable_3 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.b1r();
              var length_2 = $this$run.f1r();
              var language_2 = $this$run.f1r();
              var numGroups = $this$run.f1r();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < numGroups)
                do {
                  var n_3 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var startCharCode = $this$run.f1r();
                  var endCharCode = $this$run.f1r();
                  var startGlyphId = $this$run.f1r();
                  var inductionVariable_5 = startCharCode;
                  if (inductionVariable_5 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.f65(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_4 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  p66(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.p60_1.k3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  q66(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.p66(charIndex, default_0) : $super.p66.call(this, charIndex, default_0);
  }
  r66(reader, codePoint, cache) {
    var g = this.u66(codePoint);
    var skipCount = 1;
    if (this.x5y_1 && !(g == null)) {
      var subs = this.y60_1.i1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.oy();
        var b = subs.j67_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.az(0, count);
            var replacement = subs.k67_1.k3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.w66(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.zy(skipCount);
    }
    return g;
  }
  s66(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.r66(reader, codePoint, cache) : $super.r66.call(this, reader, codePoint, cache);
  }
  t66(codePoint, cache) {
    var tmp134_safe_receiver = this.e65(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.v66(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  u66(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.t66(codePoint, cache) : $super.t66.call(this, codePoint, cache);
  }
  v66(index, cache, codePoint) {
    var cff = this.c61_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.q60_1;
      var res = this_0.i1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.k63(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.o62_1), new GlyphGraphicsPath(index, gvector.n62_1));
        this_0.n37(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.i1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.b60_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.b60_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.q60_1.i1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.d65('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.l67();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.a67($this$runTable.u1q(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.n60_1.i1(index).m67_1, true);
    }
    var glyph = tmp;
    if (cache && !this.w60_1) {
      this.q60_1.n37(index, glyph);
    }
    return glyph;
  }
  w66(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.v66(index, cache, codePoint) : $super.v66.call(this, index, cache, codePoint);
  }
  x66(_this__u8e3s4) {
    var v = _this__u8e3s4.a1r();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  y66(_this__u8e3s4) {
    var v = _this__u8e3s4.f1r();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  z66(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.y1q();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.z1q();
    } else if (word && signed) {
      tmp = _this__u8e3s4.a1r();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.b1r();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  a67(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.a1r();
    var xMin = _this__u8e3s4.a1r();
    var yMin = _this__u8e3s4.a1r();
    var xMax = _this__u8e3s4.a1r();
    var yMax = _this__u8e3s4.a1r();
    var advanceWidth = this.n60_1.i1(index).m67_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.m1();
      do {
        var flags = _this__u8e3s4.b1r();
        var glyphIndex = _this__u8e3s4.b1r();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.z66(_this__u8e3s4, signed, words);
        var y = this.z66(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.x66(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.x66(_this__u8e3s4);
          scaleY = this.x66(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.x66(_this__u8e3s4);
          scale01 = this.x66(_this__u8e3s4);
          scale10 = this.x66(_this__u8e3s4);
          scaleY = this.x66(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.w66(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.f(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.b1r();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.b1r();
      var instructions = _this__u8e3s4.x1q(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.f31();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.z1q();
        flags_0.l31(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.z1q();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.l31(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.h13(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.z1q();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.a1r() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.z31(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static e5r(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_41();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.a65(d, extName, onlyReadMetadata, enableLigatures);
    $this.d5r_1 = LinkedHashMap.vc();
    $this.b65();
    return $this;
  }
  c65() {
    this.d5r_1.t3(Companion_instance_36.s64(this.u5y_1.v1q()));
  }
  d65(name) {
    return this.d5r_1.k3(name);
  }
}
class Companion_24 {
  constructor() {
    this.b67_1 = 26;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c67_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.t61_1 = fillArrayVal(Array(26), null);
    this.u61_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.v61_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.w61_1 = tmp_5;
    this.x61_1 = null;
  }
  i65() {
    var tmp0_elvis_lhs = this.d67(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.d67(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  y61() {
    var tmp0_elvis_lhs = this.d67(NameId_COMPLETE_NAME_getInstance());
    return tmp0_elvis_lhs == null ? this.i65() : tmp0_elvis_lhs;
  }
  e67(nameId) {
    if (this.t61_1[nameId] == null) {
      var nameLength = this.v61_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.x61_1).m1r(this.u61_1[nameId], nameLength, this.w61_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.h();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.jc(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.t61_1[nameId] = tmp;
    }
    return this.t61_1[nameId];
  }
  d67(nameId) {
    return this.e67(nameId.h67_1);
  }
  i67() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.wc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.d67(element);
      result.r3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString(this.i67()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.j67_1 = maxSequence;
    this.k67_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.t64_1 = id;
    this.u64_1 = checksum;
    this.v64_1 = offset;
    this.w64_1 = length;
    this.x64_1 = null;
    var tmp = this;
    tmp.y64_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  l67() {
    return _get_ss__ndcawb(this).j13();
  }
  toString() {
    return 'Table(id=' + this.t64_1 + ', checksum=' + this.u64_1 + ', offset=' + this.v64_1 + ', length=' + this.w64_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.t64_1);
    result = imul(result, 31) + this.u64_1 | 0;
    result = imul(result, 31) + this.v64_1 | 0;
    result = imul(result, 31) + this.w64_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.t64_1 === tmp0_other_with_cast.t64_1))
      return false;
    if (!(this.u64_1 === tmp0_other_with_cast.u64_1))
      return false;
    if (!(this.v64_1 === tmp0_other_with_cast.v64_1))
      return false;
    if (!(this.w64_1 === tmp0_other_with_cast.w64_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.m67_1 = advanceWidth;
    this.n67_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.m67_1 + ', lsb=' + this.n67_1 + ')';
  }
  hashCode() {
    var result = this.m67_1;
    result = imul(result, 31) + this.n67_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.m67_1 === tmp0_other_with_cast.m67_1))
      return false;
    if (!(this.n67_1 === tmp0_other_with_cast.n67_1))
      return false;
    return true;
  }
}
class Companion_26 {
  z64(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.b1r();
    var count = s.b1r();
    var stringOffset = s.b1r();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.b1r();
        var encodingId = s.b1r();
        var languageId = s.b1r();
        var nameId = s.b1r();
        var length = s.b1r();
        var offset = s.b1r();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.v61_1[nameId] === -1) {
          info.u61_1[nameId] = stringOffset + offset | 0;
          info.v61_1[nameId] = length;
          info.w61_1[nameId] = charset;
          info.x61_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  s64(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.f1r() === 1953784678) {
      var majorVersion = s.b1r();
      var minorVersion = s.b1r();
      var numFonts = s.f1r();
      var tableDirectoryOffsets = s.l1r(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.f1r();
        var dsigLength = s.f1r();
        var dsigOffset = s.f1r();
      }
      s.p1q(tableDirectoryOffsets[0]);
    } else {
      s.w1q(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.b1r();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.b1r();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.b1r();
    var searchRange = s.b1r();
    var entrySelector = s.b1r();
    var rangeShift = s.b1r();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
      var tmp$ret$2 = new Table(s.o1r(4), s.f1r(), s.f1r(), s.f1r());
      destination.f(tmp$ret$2);
    }
    var tables = destination;
    var tablesByName = LinkedHashMap.vc();
    var _iterator__ex2g4s = tables.f1();
    while (_iterator__ex2g4s.g1()) {
      var table = _iterator__ex2g4s.h1();
      var tmp = table;
      tmp.x64_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.t64_1;
      tablesByName.r3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.h67_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.o67_1 = indexSubTableArrayOffset;
    this.p67_1 = indexTablesSize;
    this.q67_1 = numberofIndexSubTables;
    this.r67_1 = colorRef;
    this.s67_1 = hori;
    this.t67_1 = vert;
    this.u67_1 = startGlyphIndex;
    this.v67_1 = endGlyphIndex;
    this.w67_1 = ppemX;
    this.x67_1 = ppemY;
    this.y67_1 = bitDepth;
    this.z67_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.o67_1 + ', indexTablesSize=' + this.p67_1 + ', numberofIndexSubTables=' + this.q67_1 + ', colorRef=' + this.r67_1 + ', hori=' + this.s67_1.toString() + ', vert=' + this.t67_1.toString() + ', startGlyphIndex=' + this.u67_1 + ', endGlyphIndex=' + this.v67_1 + ', ppemX=' + this.w67_1 + ', ppemY=' + this.x67_1 + ', bitDepth=' + this.y67_1 + ', flags=' + this.z67_1 + ')';
  }
  hashCode() {
    var result = this.o67_1;
    result = imul(result, 31) + this.p67_1 | 0;
    result = imul(result, 31) + this.q67_1 | 0;
    result = imul(result, 31) + this.r67_1 | 0;
    result = imul(result, 31) + this.s67_1.hashCode() | 0;
    result = imul(result, 31) + this.t67_1.hashCode() | 0;
    result = imul(result, 31) + this.u67_1 | 0;
    result = imul(result, 31) + this.v67_1 | 0;
    result = imul(result, 31) + this.w67_1 | 0;
    result = imul(result, 31) + this.x67_1 | 0;
    result = imul(result, 31) + this.y67_1 | 0;
    result = imul(result, 31) + this.z67_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.o67_1 === tmp0_other_with_cast.o67_1))
      return false;
    if (!(this.p67_1 === tmp0_other_with_cast.p67_1))
      return false;
    if (!(this.q67_1 === tmp0_other_with_cast.q67_1))
      return false;
    if (!(this.r67_1 === tmp0_other_with_cast.r67_1))
      return false;
    if (!this.s67_1.equals(tmp0_other_with_cast.s67_1))
      return false;
    if (!this.t67_1.equals(tmp0_other_with_cast.t67_1))
      return false;
    if (!(this.u67_1 === tmp0_other_with_cast.u67_1))
      return false;
    if (!(this.v67_1 === tmp0_other_with_cast.v67_1))
      return false;
    if (!(this.w67_1 === tmp0_other_with_cast.w67_1))
      return false;
    if (!(this.x67_1 === tmp0_other_with_cast.x67_1))
      return false;
    if (!(this.y67_1 === tmp0_other_with_cast.y67_1))
      return false;
    if (!(this.z67_1 === tmp0_other_with_cast.z67_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.a68_1 = ascender;
    this.b68_1 = descender;
    this.c68_1 = widthMax;
    this.d68_1 = caretSlopeNumerator;
    this.e68_1 = caretSlopeDenominator;
    this.f68_1 = caretOffset;
    this.g68_1 = minOriginSB;
    this.h68_1 = minAdvanceSB;
    this.i68_1 = maxBeforeBL;
    this.j68_1 = minAfterBL;
    this.k68_1 = pad1;
    this.l68_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.a68_1 + ', descender=' + this.b68_1 + ', widthMax=' + this.c68_1 + ', caretSlopeNumerator=' + this.d68_1 + ', caretSlopeDenominator=' + this.e68_1 + ', caretOffset=' + this.f68_1 + ', minOriginSB=' + this.g68_1 + ', minAdvanceSB=' + this.h68_1 + ', maxBeforeBL=' + this.i68_1 + ', minAfterBL=' + this.j68_1 + ', pad1=' + this.k68_1 + ', pad2=' + this.l68_1 + ')';
  }
  hashCode() {
    var result = this.a68_1;
    result = imul(result, 31) + this.b68_1 | 0;
    result = imul(result, 31) + this.c68_1 | 0;
    result = imul(result, 31) + this.d68_1 | 0;
    result = imul(result, 31) + this.e68_1 | 0;
    result = imul(result, 31) + this.f68_1 | 0;
    result = imul(result, 31) + this.g68_1 | 0;
    result = imul(result, 31) + this.h68_1 | 0;
    result = imul(result, 31) + this.i68_1 | 0;
    result = imul(result, 31) + this.j68_1 | 0;
    result = imul(result, 31) + this.k68_1 | 0;
    result = imul(result, 31) + this.l68_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.a68_1 === tmp0_other_with_cast.a68_1))
      return false;
    if (!(this.b68_1 === tmp0_other_with_cast.b68_1))
      return false;
    if (!(this.c68_1 === tmp0_other_with_cast.c68_1))
      return false;
    if (!(this.d68_1 === tmp0_other_with_cast.d68_1))
      return false;
    if (!(this.e68_1 === tmp0_other_with_cast.e68_1))
      return false;
    if (!(this.f68_1 === tmp0_other_with_cast.f68_1))
      return false;
    if (!(this.g68_1 === tmp0_other_with_cast.g68_1))
      return false;
    if (!(this.h68_1 === tmp0_other_with_cast.h68_1))
      return false;
    if (!(this.i68_1 === tmp0_other_with_cast.i68_1))
      return false;
    if (!(this.j68_1 === tmp0_other_with_cast.j68_1))
      return false;
    if (!(this.k68_1 === tmp0_other_with_cast.k68_1))
      return false;
    if (!(this.l68_1 === tmp0_other_with_cast.l68_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.m68_1 = glyphID;
    this.n68_1 = imageFormat;
    this.o68_1 = offset;
    this.p68_1 = size;
    this.q68_1 = info;
    this.r68_1 = height;
    this.s68_1 = width;
    this.t68_1 = horiBearingX;
    this.u68_1 = horiBearingY;
    this.v68_1 = horiAdvance;
    this.w68_1 = vertBearingX;
    this.x68_1 = vertBearingY;
    this.y68_1 = vertAdvance;
    this.z68_1 = null;
    this.a69_1 = null;
  }
  b69() {
    return this.q68_1.s67_1.b68_1;
  }
  c69(cache) {
    var tmp0_elvis_lhs = this.a69_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().f69(toSyncStream(ensureNotNull(this.z68_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.a69_1 = bmp;
    return bmp;
  }
  g69(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.c69(cache) : $super.c69.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.m68_1 + ', imageFormat=' + this.n68_1 + ', offset=' + this.o68_1 + ', size=' + this.p68_1 + ', info=' + this.q68_1.toString() + ', height=' + this.r68_1 + ', width=' + this.s68_1 + ', horiBearingX=' + this.t68_1 + ', horiBearingY=' + this.u68_1 + ', horiAdvance=' + this.v68_1 + ', vertBearingX=' + this.w68_1 + ', vertBearingY=' + this.x68_1 + ', vertAdvance=' + this.y68_1 + ')';
  }
  hashCode() {
    var result = this.m68_1;
    result = imul(result, 31) + this.n68_1 | 0;
    result = imul(result, 31) + this.o68_1 | 0;
    result = imul(result, 31) + this.p68_1 | 0;
    result = imul(result, 31) + this.q68_1.hashCode() | 0;
    result = imul(result, 31) + this.r68_1 | 0;
    result = imul(result, 31) + this.s68_1 | 0;
    result = imul(result, 31) + this.t68_1 | 0;
    result = imul(result, 31) + this.u68_1 | 0;
    result = imul(result, 31) + this.v68_1 | 0;
    result = imul(result, 31) + this.w68_1 | 0;
    result = imul(result, 31) + this.x68_1 | 0;
    result = imul(result, 31) + this.y68_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.m68_1 === tmp0_other_with_cast.m68_1))
      return false;
    if (!(this.n68_1 === tmp0_other_with_cast.n68_1))
      return false;
    if (!(this.o68_1 === tmp0_other_with_cast.o68_1))
      return false;
    if (!(this.p68_1 === tmp0_other_with_cast.p68_1))
      return false;
    if (!this.q68_1.equals(tmp0_other_with_cast.q68_1))
      return false;
    if (!(this.r68_1 === tmp0_other_with_cast.r68_1))
      return false;
    if (!(this.s68_1 === tmp0_other_with_cast.s68_1))
      return false;
    if (!(this.t68_1 === tmp0_other_with_cast.t68_1))
      return false;
    if (!(this.u68_1 === tmp0_other_with_cast.u68_1))
      return false;
    if (!(this.v68_1 === tmp0_other_with_cast.v68_1))
      return false;
    if (!(this.w68_1 === tmp0_other_with_cast.w68_1))
      return false;
    if (!(this.x68_1 === tmp0_other_with_cast.x68_1))
      return false;
    if (!(this.y68_1 === tmp0_other_with_cast.y68_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.h69_1 = cycle;
    this.i69_1 = stops;
  }
  j69(paint, palette) {
    var _iterator__ex2g4s = this.i69_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var stop = _iterator__ex2g4s.h1();
      paint.l6a(stop.k69_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.n56_1, stop.l69_1), stop.m69_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.h69_1.toString() + ', stops=' + toString(this.i69_1) + ')';
  }
  hashCode() {
    var result = this.h69_1.hashCode();
    result = imul(result, 31) + hashCode(this.i69_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.h69_1.equals(tmp0_other_with_cast.h69_1))
      return false;
    if (!equals(this.i69_1, tmp0_other_with_cast.i69_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.k69_1 = stopOffset;
    this.l69_1 = paletteIndex;
    this.m69_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.o6a_1 = this.v3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.p6a_1 = layerList;
    this.q6a_1 = s;
    this.r6a_1 = sBaseOffset;
    this.s6a_1 = sLayerOffset;
    this.t6a_1 = sClipOffset;
    this.u6a_1 = IntIntMap.m38();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.v6a_1 = x;
    this.w6a_1 = y;
    this.x6a_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.v6a_1 + ', y=' + this.w6a_1 + ', onCurve=' + this.x6a_1 + ')';
  }
  hashCode() {
    var result = this.v6a_1;
    result = imul(result, 31) + this.w6a_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x6a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.v6a_1 === tmp0_other_with_cast.v6a_1))
      return false;
    if (!(this.w6a_1 === tmp0_other_with_cast.w6a_1))
      return false;
    if (!(this.x6a_1 === tmp0_other_with_cast.x6a_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.y6a_1 = glyph;
    this.z6a_1 = x;
    this.a6b_1 = y;
    this.b6b_1 = scaleX;
    this.c6b_1 = scale01;
    this.d6b_1 = scale10;
    this.e6b_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString(this.y6a_1) + ', x=' + this.z6a_1 + ', y=' + this.a6b_1 + ', scaleX=' + this.b6b_1 + ', scale01=' + this.c6b_1 + ', scale10=' + this.d6b_1 + ', scaleY=' + this.e6b_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y6a_1);
    result = imul(result, 31) + this.z6a_1 | 0;
    result = imul(result, 31) + this.a6b_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.b6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e6b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.y6a_1, tmp0_other_with_cast.y6a_1))
      return false;
    if (!(this.z6a_1 === tmp0_other_with_cast.z6a_1))
      return false;
    if (!(this.a6b_1 === tmp0_other_with_cast.a6b_1))
      return false;
    if (!equals(this.b6b_1, tmp0_other_with_cast.b6b_1))
      return false;
    if (!equals(this.c6b_1, tmp0_other_with_cast.c6b_1))
      return false;
    if (!equals(this.d6b_1, tmp0_other_with_cast.d6b_1))
      return false;
    if (!equals(this.e6b_1, tmp0_other_with_cast.e6b_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.h6b_1 = $outer;
    this.f6b_1 = glyphID;
    this.g6b_1 = paletteIndex;
  }
  i6b(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.h6b_1.u60_1, pal).n56_1);
    var index = this.g6b_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.j1() : false) {
      tmp = this_0.i1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().i4t_1);
    }
    return tmp.v59_1;
  }
  j6b() {
    return this.i6b(0);
  }
  k6b(pal) {
    var tmp135_safe_receiver = this.h6b_1.w66(this.f6b_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.v1z();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.u6b_1, null, new RGBA(this.i6b(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.f6b_1 + ', ' + this.g6b_1 + ', ' + RGBA__toString_impl_4lw6dp(this.j6b()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.v6b(pal) : $super.v6b.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.z6b_1 = $outer;
    this.x6b_1 = glyphID;
    this.y6b_1 = paint;
  }
  v6b(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.z6b_1.v60_1.r6a_1.u1q(this.y6b_1);
    try {
      this.z6b_1.j66(this.x6b_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.p5r();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.x6b_1 + '][' + this.y6b_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.d6c_1 = $outer;
    this.a6c_1 = glyphID;
    this.b6c_1 = firstLayerIndex;
    this.c6c_1 = numLayers;
  }
  i1(index) {
    return this.d6c_1.s60_1[this.b6c_1 + index | 0];
  }
  o63() {
    var tmp = 0;
    var tmp_0 = this.c6c_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.i1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  v6b(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.o63();
    var destination = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.k6b(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.f(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.a6c_1 + '][' + this.c6c_1 + '](' + toString(this.o63()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.t6b_1 = glpyhIndex;
    this.u6b_1 = path;
  }
  e3y(p) {
    this.u6b_1.e3y(p);
  }
  g3y(p) {
    this.u6b_1.g3y(p);
  }
  h3y(c, a) {
    this.u6b_1.h3y(c, a);
  }
  j3y(c1, c2, a) {
    this.u6b_1.j3y(c1, c2, a);
  }
  u6() {
    this.u6b_1.u6();
  }
  l4a(p0, p1) {
    this.u6b_1.l4a(p0, p1);
  }
  m4a(a, c, r) {
    this.u6b_1.m4a(a, c, r);
  }
  a1() {
    return this.u6b_1.a1();
  }
  n4a(rect) {
    this.u6b_1.n4a(rect);
  }
  o4a(pos, size) {
    this.u6b_1.o4a(pos, size);
  }
  p4a(x, y, width, height) {
    this.u6b_1.p4a(x, y, width, height);
  }
  q4a(x, y, w, h, rtl, rtr, rbr, rbl) {
    this.u6b_1.q4a(x, y, w, h, rtl, rtr, rbr, rbl);
  }
  r4a(center, r, start, end, counterclockwise) {
    this.u6b_1.r4a(center, r, start, end, counterclockwise);
  }
  m3s(center, radius) {
    this.u6b_1.m3s(center, radius);
  }
  t4a(x) {
    this.u6b_1.t4a(x);
  }
  u4a(y) {
    this.u6b_1.u4a(y);
  }
  v4a(x) {
    this.u6b_1.v4a(x);
  }
  w4a(y) {
    this.u6b_1.w4a(y);
  }
  x4a(delta) {
    this.u6b_1.x4a(delta);
  }
  y4a(delta) {
    this.u6b_1.y4a(delta);
  }
  j2u(m) {
    return this.u6b_1.j2u(m);
  }
  k4a() {
    return this.u6b_1.k4a();
  }
  f3y() {
    return this.u6b_1.s3y_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.t6b_1 + ', "' + toSvgPathString(this.u6b_1) + '")';
  }
  hashCode() {
    var result = this.t6b_1;
    result = imul(result, 31) + this.u6b_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.t6b_1 === tmp0_other_with_cast.t6b_1))
      return false;
    if (!this.u6b_1.equals(tmp0_other_with_cast.u6b_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.s6b_1 = $outer;
    this.l6b_1 = index;
    this.m6b_1 = xMin;
    this.n6b_1 = yMin;
    this.o6b_1 = xMax;
    this.p6b_1 = yMax;
    this.q6b_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.m6b_1;
    var yMin_0 = this.n6b_1;
    var xMax_0 = this.o6b_1;
    var yMax_0 = this.p6b_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.s6b_1.v60_1.t6a_1;
      var glyphIDToClipOffset = this.s6b_1.v60_1.u6a_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.dp(this.l6b_1)) {
        var clipOffset = glyphIDToClipOffset.i1(this.l6b_1);
        tmp_0 = this.s6b_1.h66(sClipOffset.u1q(clipOffset));
      } else {
        var tmp137_safe_receiver = this.e6c();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.w6b();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.f6c();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.p2i());
        xMax_0 = numberToInt(bounds.q2i());
        yMin_0 = numberToInt(bounds.r2i());
        yMax_0 = numberToInt(bounds.s2i());
      }
    }
    var size = this.s6b_1.d60_1;
    var scale = this.s6b_1.o5m(size);
    tmp.r6b_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_2().g2t(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.q6b_1 * scale);
  }
  e6c() {
    return this.s6b_1.t60_1.i1(this.l6b_1);
  }
  g6c() {
    return this.s6b_1.r60_1.k3(this.l6b_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.s6c_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.p6c_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.p6c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.y6a_1.v1z().u6b_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.y6a_1.l6b_1, new VectorPath(IntArrayList.f31(gpath.m3y_1.j1()), DoubleArrayList.c32(gpath.n3y_1.j1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_4().l2m().j2n(item.b6b_1, item.e6b_1).p2n(item.z6a_1, -item.a6b_1 | 0);
      this_1.u6b_1.v4b(item.y6a_1.v1z().u6b_1, m);
      destination.f(this_1);
    }
    tmp.q6c_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.q6c_1;
    var n = 0;
    while (n < this_2.j1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.i1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.u6b_1.m3y_1.j1() | 0;
      dataSize = dataSize + gpath_0.u6b_1.n3y_1.j1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.f31(commandsSize), DoubleArrayList.c32(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.q6c_1;
    var n_0 = 0;
    while (n_0 < this_4.j1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.i1(_unary__edvuaz_0);
      this_3.u6b_1.w4b(it.u6b_1);
    }
    tmp_0.r6c_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.q6b_1 + '](' + toString(this.p6c_1) + ')';
  }
  v1z() {
    return this.r6c_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.d6d_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.b6d_1 = path;
    this.c6d_1 = listOf(this.b6d_1);
  }
  v1z() {
    return this.b6d_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.t6d_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.m6d_1 = contoursIndices;
    this.n6d_1 = flags;
    this.o6d_1 = xPos;
    this.p6d_1 = yPos;
    this.q6d_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.t6d_1;
    var inductionVariable = 0;
    var last = this.m6d_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.m6d_1[n] + 1 | 0;
        var cend = this.m6d_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.f31(commandSize), DoubleArrayList.c32(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.t6d_1;
    var inductionVariable_0 = 0;
    var last_0 = this.m6d_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.m6d_1[n_0] + 1 | 0;
        var cend_0 = this.m6d_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.u6d(cend_0, this_1.z5y_1[0]);
        var next = this.u6d(cstart_0, this_1.z5y_1[1]);
        if (curr.x6a_1) {
          this_0.e3y(Vector2D.k2l(curr.v6a_1, -curr.w6a_1 | 0));
        } else if (next.x6a_1) {
          this_0.e3y(Vector2D.k2l(next.v6a_1, -next.w6a_1 | 0));
        } else {
          this_0.e3y(Vector2D.k2l(imul(curr.v6a_1 + next.v6a_1 | 0, numberToInt(0.5)), -numberToInt((curr.w6a_1 + next.w6a_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.u6d(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.z5y_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.x6a_1) {
              this_0.g3y(Vector2D.k2l(curr.v6a_1, -curr.w6a_1 | 0));
            } else {
              var prev2X = prev.v6a_1;
              var prev2Y = prev.w6a_1;
              var next2X = next.v6a_1;
              var next2Y = next.w6a_1;
              if (!prev.x6a_1) {
                prev2X = numberToInt((curr.v6a_1 + prev.v6a_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.w6a_1 + prev.w6a_1 | 0) * 0.5);
                this_0.g3y(Vector2D.k2l(prev2X, -prev2Y | 0));
              }
              if (!next.x6a_1) {
                next2X = numberToInt((curr.v6a_1 + next.v6a_1 | 0) * 0.5);
                next2Y = numberToInt((curr.w6a_1 + next.w6a_1 | 0) * 0.5);
              }
              this_0.g3y(Vector2D.k2l(prev2X, -prev2Y | 0));
              this_0.h3y(Vector2D.k2l(curr.v6a_1, -curr.w6a_1 | 0), Vector2D.k2l(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.u6();
      }
       while (inductionVariable_0 < last_0);
    tmp.r6d_1 = this_0;
    this.s6d_1 = listOf(this.r6d_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.q6d_1 ? 'Dummy' : '') + '[' + this.l6b_1 + '](advance=' + this.q6b_1 + ') : ' + this.r6d_1.toString();
  }
  v6d(n) {
    return !((this.n6d_1[n] & 1) === 0);
  }
  u6d(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.v6a_1 = this.o6d_1[n];
    out.w6a_1 = this.p6d_1[n];
    out.x6a_1 = this.v6d(n);
    return out;
  }
  v1z() {
    return this.r6d_1;
  }
}
class BaseTtfFont$readCblc$1$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.w6d_1 = firstGlyphIndex;
    this.x6d_1 = lastGlyphIndex;
    this.y6d_1 = additionalOffsetToIndexSubtable;
  }
  z6d() {
    return this.x6d_1 - this.w6d_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.w6d_1 + ', lastGlyphIndex=' + this.x6d_1 + ', additionalOffsetToIndexSubtable=' + this.y6d_1 + ')';
  }
  hashCode() {
    var result = this.w6d_1;
    result = imul(result, 31) + this.x6d_1 | 0;
    result = imul(result, 31) + this.y6d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$1$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$1$Subtable ? other : THROW_CCE();
    if (!(this.w6d_1 === tmp0_other_with_cast.w6d_1))
      return false;
    if (!(this.x6d_1 === tmp0_other_with_cast.x6d_1))
      return false;
    if (!(this.y6d_1 === tmp0_other_with_cast.y6d_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$1$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.a6e_1 = ppem;
    this.b6e_1 = ppi;
    this.c6e_1 = strikeOffset;
    this.d6e_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.a6e_1 + ', ppi=' + this.b6e_1 + ', strikeOffset=' + this.c6e_1 + ', offsets=' + this.d6e_1.toString() + ')';
  }
  hashCode() {
    var result = this.a6e_1;
    result = imul(result, 31) + this.b6e_1 | 0;
    result = imul(result, 31) + this.c6e_1 | 0;
    result = imul(result, 31) + this.d6e_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$1$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$1$StrikeInfo ? other : THROW_CCE();
    if (!(this.a6e_1 === tmp0_other_with_cast.a6e_1))
      return false;
    if (!(this.b6e_1 === tmp0_other_with_cast.b6e_1))
      return false;
    if (!(this.c6e_1 === tmp0_other_with_cast.c6e_1))
      return false;
    if (!this.d6e_1.equals(tmp0_other_with_cast.d6e_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.e6e_1 = start;
    this.f6e_1 = endInclusive;
    this.g6e_1 = index;
    this.h6e_1 = (this.f6e_1 - this.e6e_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.e6e_1 + ', endInclusive=' + this.f6e_1 + ', index=' + this.g6e_1 + ')';
  }
  hashCode() {
    var result = this.e6e_1;
    result = imul(result, 31) + this.f6e_1 | 0;
    result = imul(result, 31) + this.g6e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.e6e_1 === tmp0_other_with_cast.e6e_1))
      return false;
    if (!(this.f6e_1 === tmp0_other_with_cast.f6e_1))
      return false;
    if (!(this.g6e_1 === tmp0_other_with_cast.g6e_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$1$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.i6e_1 = platformId;
    this.j6e_1 = encodingId;
    this.k6e_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.i6e_1 + ', encodingId=' + this.j6e_1 + ', offset=' + this.k6e_1 + ')';
  }
  hashCode() {
    var result = this.i6e_1;
    result = imul(result, 31) + this.j6e_1 | 0;
    result = imul(result, 31) + this.k6e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$1$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$1$EncodingRecord ? other : THROW_CCE();
    if (!(this.i6e_1 === tmp0_other_with_cast.i6e_1))
      return false;
    if (!(this.j6e_1 === tmp0_other_with_cast.j6e_1))
      return false;
    if (!(this.k6e_1 === tmp0_other_with_cast.k6e_1))
      return false;
    return true;
  }
}
class Companion_27 {
  m6e(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_28 {
  l2m() {
    return new Mixin_1();
  }
}
class Mixin_1 {
  constructor() {
    this.p6e_1 = null;
    this.q6e_1 = Colors_getInstance().l4r_1;
  }
  r6e(_set____db54di) {
    this.p6e_1 = _set____db54di;
  }
  s6e(_set____db54di) {
    this.q6e_1 = _set____db54di;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.t6e_1 = function_0;
  }
  rj(a, b) {
    return this.t6e_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class AseCell {}
function resolve() {
  return this;
}
class AseBitmapCell {
  constructor(bmp, x, y, opacity) {
    this.h6f_1 = Companion_instance_38.l2m();
    this.i6f_1 = bmp;
    this.j6f_1 = x;
    this.k6f_1 = y;
    this.l6f_1 = opacity;
  }
  r6e(_set____db54di) {
    this.h6f_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.h6f_1.s6e(_set____db54di);
  }
  a5m() {
    return this.i6f_1;
  }
  n4f() {
    return this.j6f_1;
  }
  p4f() {
    return this.k6f_1;
  }
}
class AseLinkedCell {
  constructor(linkedCell, x, y, opacity) {
    this.m6f_1 = Companion_instance_38.l2m();
    this.n6f_1 = linkedCell;
    this.o6f_1 = x;
    this.p6f_1 = y;
    this.q6f_1 = opacity;
  }
  r6e(_set____db54di) {
    this.m6f_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.m6f_1.s6e(_set____db54di);
  }
  n4f() {
    return this.o6f_1;
  }
  p4f() {
    return this.p6f_1;
  }
  a5m() {
    return this.n6f_1.a5m();
  }
  g6f() {
    return this.n6f_1.g6f();
  }
}
class AseTilemapCell {
  constructor(data, tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity) {
    this.r6f_1 = Companion_instance_38.l2m();
    this.s6f_1 = data;
    this.t6f_1 = tileBitmask;
    this.u6f_1 = bitmaskXFlip;
    this.v6f_1 = bitmaskYFlip;
    this.w6f_1 = bitmask90CWFlip;
    this.x6f_1 = x;
    this.y6f_1 = y;
    this.z6f_1 = opacity;
    this.a6g_1 = Bitmap32.c4p(1, 1, VOID, true);
  }
  r6e(_set____db54di) {
    this.r6f_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.r6f_1.s6e(_set____db54di);
  }
  n4f() {
    return this.x6f_1;
  }
  p4f() {
    return this.y6f_1;
  }
  a5m() {
    return this.a6g_1;
  }
}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.n6j_1 = index;
    this.o6j_1 = name;
    this.p6j_1 = type;
  }
}
class AseLayer extends ImageLayer {
  constructor(originalAseIndex, index, name, flags, type, childLevel, blendModeInt, opacity, tilesetIndex) {
    super(index, name, type);
    this.e6g_1 = Companion_instance_38.l2m();
    this.f6g_1 = originalAseIndex;
    this.g6g_1 = flags;
    this.h6g_1 = childLevel;
    this.i6g_1 = blendModeInt;
    this.j6g_1 = opacity;
    this.k6g_1 = tilesetIndex;
    this.l6g_1 = hasBitSet(this.g6g_1, 0);
    this.m6g_1 = hasBitSet(this.g6g_1, 1);
    this.n6g_1 = hasBitSet(this.g6g_1, 2);
    this.o6g_1 = hasBitSet(this.g6g_1, 3);
    this.p6g_1 = hasBitSet(this.g6g_1, 4);
    this.q6g_1 = hasBitSet(this.g6g_1, 5);
    this.r6g_1 = hasBitSet(this.g6g_1, 6);
    var tmp = this;
    switch (this.i6g_1) {
      case 0:
        tmp.s6g_1 = BlendMode_NORMAL_getInstance();
        break;
      case 1:
        tmp.s6g_1 = BlendMode_MULTIPLY_getInstance();
        break;
      case 2:
        tmp.s6g_1 = BlendMode_SCREEN_getInstance();
        break;
      case 3:
        tmp.s6g_1 = BlendMode_OVERLAY_getInstance();
        break;
      case 4:
        tmp.s6g_1 = BlendMode_DARKEN_getInstance();
        break;
      case 5:
        tmp.s6g_1 = BlendMode_LIGHTEN_getInstance();
        break;
      case 6:
        tmp.s6g_1 = BlendMode_COLOR_DODGE_getInstance();
        break;
      case 7:
        tmp.s6g_1 = BlendMode_COLOR_BURN_getInstance();
        break;
      case 8:
        tmp.s6g_1 = BlendMode_HARD_LIGHT_getInstance();
        break;
      case 9:
        tmp.s6g_1 = BlendMode_SOFT_LIGHT_getInstance();
        break;
      case 10:
        tmp.s6g_1 = BlendMode_DIFFERENCE_getInstance();
        break;
      case 11:
        tmp.s6g_1 = BlendMode_EXCLUSION_getInstance();
        break;
      case 12:
        tmp.s6g_1 = BlendMode_HUE_getInstance();
        break;
      case 13:
        tmp.s6g_1 = BlendMode_SATURATION_getInstance();
        break;
      case 14:
        tmp.s6g_1 = BlendMode_COLOR_getInstance();
        break;
      case 15:
        tmp.s6g_1 = BlendMode_LUMINOSITY_getInstance();
        break;
      case 16:
        tmp.s6g_1 = BlendMode_ADDITION_getInstance();
        break;
      case 17:
        tmp.s6g_1 = BlendMode_SUBTRACT_getInstance();
        break;
      case 18:
        tmp.s6g_1 = BlendMode_DIVIDE_getInstance();
        break;
      default:
        tmp.s6g_1 = BlendMode_NORMAL_getInstance();
        break;
    }
  }
  r6e(_set____db54di) {
    this.e6g_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.e6g_1.s6e(_set____db54di);
  }
}
class AseFrame {
  constructor(index) {
    this.t6g_1 = Companion_instance_38.l2m();
    this.u6g_1 = index;
    this.v6g_1 = 0;
    this.w6g_1 = FastIntMap();
  }
  r6e(_set____db54di) {
    this.t6g_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.t6g_1.s6e(_set____db54di);
  }
}
class AsePalette extends Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    super(colors, names, changeStart, changeEnd);
    this.b6h_1 = Companion_instance_38.l2m();
  }
  r6e(_set____db54di) {
    this.b6h_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.b6h_1.s6e(_set____db54di);
  }
}
class AseTileset {
  constructor(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles) {
    this.c6h_1 = tilesetId;
    this.d6h_1 = ntiles;
    this.e6h_1 = tileWidth;
    this.f6h_1 = tileHeight;
    this.g6h_1 = baseIndex;
    this.h6h_1 = tilesetName;
    this.i6h_1 = tiles;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = IntMap.t37();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.AseTileset.tileSet.<anonymous>' call
    var inductionVariable = 0;
    var last = this.i6h_1.j1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var id = n;
        this_0.n37(id, new TileSetTileInfo(id, this.i6h_1.i1(n)));
      }
       while (inductionVariable <= last);
    tmp.j6h_1 = new TileSet(this_0);
  }
  toString() {
    return 'AseTileset(tilesetId=' + this.c6h_1 + ', ntiles=' + this.d6h_1 + ', tileWidth=' + this.e6h_1 + ', tileHeight=' + this.f6h_1 + ', baseIndex=' + this.g6h_1 + ', tilesetName=' + this.h6h_1 + ', tiles=' + toString(this.i6h_1) + ')';
  }
  hashCode() {
    var result = this.c6h_1;
    result = imul(result, 31) + this.d6h_1 | 0;
    result = imul(result, 31) + this.e6h_1 | 0;
    result = imul(result, 31) + this.f6h_1 | 0;
    result = imul(result, 31) + this.g6h_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.h6h_1) | 0;
    result = imul(result, 31) + hashCode(this.i6h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AseTileset))
      return false;
    var tmp0_other_with_cast = other instanceof AseTileset ? other : THROW_CCE();
    if (!(this.c6h_1 === tmp0_other_with_cast.c6h_1))
      return false;
    if (!(this.d6h_1 === tmp0_other_with_cast.d6h_1))
      return false;
    if (!(this.e6h_1 === tmp0_other_with_cast.e6h_1))
      return false;
    if (!(this.f6h_1 === tmp0_other_with_cast.f6h_1))
      return false;
    if (!(this.g6h_1 === tmp0_other_with_cast.g6h_1))
      return false;
    if (!(this.h6h_1 === tmp0_other_with_cast.h6h_1))
      return false;
    if (!equals(this.i6h_1, tmp0_other_with_cast.i6h_1))
      return false;
    return true;
  }
}
class AseSliceKey {
  constructor(frameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY) {
    this.u6e_1 = frameIndex;
    this.v6e_1 = sliceXOrigin;
    this.w6e_1 = sliceYOrigin;
    this.x6e_1 = sliceWidth;
    this.y6e_1 = sliceHeight;
    this.z6e_1 = centerXPos;
    this.a6f_1 = centerYPos;
    this.b6f_1 = centerWidth;
    this.c6f_1 = centerHeight;
    this.d6f_1 = pivotX;
    this.e6f_1 = pivotY;
    this.f6f_1 = RectangleInt.d2u(this.v6e_1, this.w6e_1, this.x6e_1, this.y6e_1);
  }
}
class AseSlice {
  constructor(name, hasNinePatch, hasPivotInfo) {
    this.k6h_1 = Companion_instance_38.l2m();
    this.l6h_1 = name;
    this.m6h_1 = hasNinePatch;
    this.n6h_1 = hasPivotInfo;
    this.o6h_1 = FastArrayList.g14();
  }
  r6e(_set____db54di) {
    this.k6h_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.k6h_1.s6e(_set____db54di);
  }
  p6h() {
    // Inline function 'kotlin.collections.sortBy' call
    var this_0 = this.o6h_1;
    if (this_0.j1() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = ASE$AseSlice$sortKeys$lambda;
      var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
      sortWith(this_0, tmp$ret$0);
    }
  }
  q6h(index) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
    var this_0 = this.o6h_1;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this_0.e14_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.image.format.AseSlice.getSliceForFrame.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[(this_0.j1() - n | 0) - 1 | 0];
      if (index >= it.u6e_1)
        return it;
      n = n + 1 | 0;
    }
    var tmp0_elvis_lhs = firstOrNull_1(this.o6h_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'No frames key frames for slice!';
      throw IllegalStateException.m5(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class AseTag {
  constructor(fromFrame, toFrame, directionByte, tagColor, tagName) {
    this.r6h_1 = Companion_instance_38.l2m();
    this.s6h_1 = fromFrame;
    this.t6h_1 = toFrame;
    this.u6h_1 = directionByte;
    this.v6h_1 = tagColor;
    this.w6h_1 = tagName;
    var tmp = this;
    switch (this.u6h_1) {
      case 0:
        tmp.x6h_1 = Direction_FORWARD_getInstance();
        break;
      case 1:
        tmp.x6h_1 = Direction_REVERSE_getInstance();
        break;
      case 2:
        tmp.x6h_1 = Direction_PING_PONG_getInstance();
        break;
      default:
        tmp.x6h_1 = Direction_FORWARD_getInstance();
        break;
    }
  }
  r6e(_set____db54di) {
    this.r6h_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.r6h_1.s6e(_set____db54di);
  }
}
class AseImage {
  constructor() {
    this.y6h_1 = Companion_instance_38.l2m();
    this.z6h_1 = null;
    this.a6i_1 = FastArrayList.g14();
    this.b6i_1 = FastArrayList.g14();
    this.c6i_1 = FastArrayList.g14();
    this.d6i_1 = FastArrayList.g14();
    this.e6i_1 = IntMap.t37();
    this.f6i_1 = IntMap.t37();
  }
  r6e(_set____db54di) {
    this.y6h_1.r6e(_set____db54di);
  }
  s6e(_set____db54di) {
    this.y6h_1.s6e(_set____db54di);
  }
}
class ImageFormatDecoder {}
function decode$default(file, props, $completion, $super) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  return $super === VOID ? this.p6k(file, props, $completion) : $super.p6k.call(this, file, props, $completion);
}
class ImageFormat {
  static i6m(exts) {
    var $this = createThis(this);
    var tmp = $this;
    tmp.d69_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.f(tmp$ret$3);
    }
    tmp_0.e69_1 = toSet(destination);
    return $this;
  }
  j6k() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d69_1;
    decodingProps$factory();
    return this_0.b2();
  }
  s6i(s, props) {
    return new ImageDataContainer(listOf(this.i6k(s, props)));
  }
  i6k(s, props) {
    throw NotImplementedError.oe();
  }
  n6i(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.k6k(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.p6i_1 = bmp.j2y();
      this_0.q6i_1 = bmp.k2y();
      this_0.r6i_1 = bmp.t4q();
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  k6k(s, props) {
    return this.i6k(s, props).x6l();
  }
  l6k(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.n6i(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  m6k(s, props) {
    return this.k6k(s, props);
  }
  f69(s, props, $super) {
    props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
    return $super === VOID ? this.m6k(s, props) : $super.m6k.call(this, s, props);
  }
  n6k(data, props) {
    return this.k6k(openSync(data), props);
  }
  o6k(data, props, $super) {
    props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
    return $super === VOID ? this.n6k(data, props) : $super.n6k.call(this, data, props);
  }
  r6k(data, props, $completion) {
    return this.n6k(data, props);
  }
  p6k(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq(this, file, props, $completion), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString(this.e69_1) + ')';
  }
}
class ImageFormatWithContainer extends ImageFormat {
  static m6i(exts) {
    return this.i6m(exts.slice());
  }
  s6i(s, props) {
    throw NotImplementedError.oe();
  }
  i6k(s, props) {
    return first(this.s6i(s, props).y6l_1);
  }
}
class ASE extends ImageFormatWithContainer {
  static j6i() {
    ASE_instance = null;
    var $this = this.m6i(['ase']);
    ASE_instance = $this;
    return $this;
  }
  n6i(s, props) {
    var ss = s.j13();
    readBytesExact(ss, 4);
    if (!(readU16LE(ss) === 42464))
      return null;
    var frames = readU16LE(ss);
    var width = readU16LE(ss);
    var height = readU16LE(ss);
    var bitsPerPixel = readU16LE(ss);
    // Inline function 'kotlin.also' call
    var this_0 = new ImageInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.ASE.decodeHeader.<anonymous>' call
    this_0.r6i_1 = bitsPerPixel;
    this_0.p6i_1 = width;
    this_0.q6i_1 = height;
    return this_0;
  }
  s6i(s, props) {
    var fileSize = readS32LE(s);
    if (s.a().g2(toLong(fileSize)) < 0) {
      // Inline function 'kotlin.error' call
      var message = 'File too short';
      throw IllegalStateException.m5(toString(message));
    }
    if (!(readU16LE(s) === 42464)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Not an Aseprite file';
      throw IllegalStateException.m5(toString(message_0));
    }
    var numFrames = readU16LE(s);
    var imageWidth = readU16LE(s);
    var imageHeight = readU16LE(s);
    var bitsPerPixel = readU16LE(s);
    var bytesPerPixel = bitsPerPixel / 8 | 0;
    var flags = readU32LE(s);
    var speed = readU16LE(s);
    s.zy(4);
    s.zy(4);
    var transparentIndex = readU8(s);
    s.zy(3);
    var numColors = readU16LE(s);
    var pixelWidth = readU8(s);
    var pixelHeight = readU8(s);
    var gridX = readS16LE(s);
    var gridY = readS16LE(s);
    var gridWidth = readU16LE(s);
    var gridHeight = readU16LE(s);
    s.zy(84);
    var image = new AseImage();
    var inductionVariable = 0;
    if (inductionVariable < numFrames)
      do {
        var frameIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var bytesInFrame = readS32LE(s);
        var fs = readStream(s, bytesInFrame - 4 | 0);
        if (!(readU16LE(fs) === 61946)) {
          // Inline function 'kotlin.error' call
          var message_1 = 'Invalid ASE sprite file or error parsing';
          throw IllegalStateException.m5(toString(message_1));
        }
        readU16LE(fs);
        var frameDuration = readU16LE(fs);
        fs.zy(2);
        var numChunks = readS32LE(fs);
        var currentFrame = new AseFrame(frameIndex);
        image.b6i_1.f(currentFrame);
        currentFrame.v6g_1 = frameDuration;
        var lastEntity = null;
        var lastCell = null;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < numChunks)
          do {
            var nc = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var chunkSize = readS32LE(fs);
            var chunkType = readU16LE(fs);
            var cs = readStream(fs, chunkSize - 6 | 0);
            switch (chunkType) {
              case 4:
                image.z6h_1;
                break;
              case 17:
                image.z6h_1;
                break;
              case 8196:
                var flags_0 = readU16LE(cs);
                var type = Companion_getInstance_52().t6i_1[readU16LE(cs)];
                var childLevel = readU16LE(cs);
                var defaultLayerWidth = readU16LE(cs);
                var defaultLayerHeight = readU16LE(cs);
                var blendModeInt = readU16LE(cs);
                var opacity = readU8(cs);
                cs.zy(3);
                var name = this.u6i(cs);
                var tilesetIndex = type.x6i() ? readS32LE(cs) : 0;
                var layer = new AseLayer(image.a6i_1.j1(), image.a6i_1.j1(), name, flags_0, type, childLevel, blendModeInt, opacity, tilesetIndex);
                image.a6i_1.f(layer);
                lastEntity = layer;
                break;
              case 8197:
                var layerIndex = readU16LE(cs);
                var x = readS16LE(cs);
                var y = readS16LE(cs);
                var opacity_0 = readU8(cs);
                var celType = readU16LE(cs);
                cs.zy(7);
                var tmp;
                switch (celType) {
                  case 0:
                  case 2:
                    var width = readU16LE(cs);
                    var height = readU16LE(cs);
                    var data = readAvailable(cs);
                    var udata = celType === 2 ? uncompress(data, Companion_getInstance_15(), imul(imul(width, height), bytesPerPixel)) : data;
                    var tmp_0;
                    switch (bitsPerPixel) {
                      case 32:
                        // Inline function 'kotlin.also' call

                        var this_0 = Bitmap32.q4z(width, height, _RgbaArray___init__impl__oib4y4(getS32Array(udata, 0, imul(width, height), true)));
                        // Inline function 'kotlin.contracts.contract' call

                        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call

                        if (props.k6j()) {
                          this_0.i51();
                        }

                        tmp_0 = this_0;
                        break;
                      case 8:
                        tmp_0 = Bitmap8.f51(width, height, udata, ensureNotNull(image.z6h_1).n56_1);
                        break;
                      default:
                        var message_2 = 'Unsupported ASE mode';
                        throw IllegalStateException.m5(toString(message_2));
                    }

                    var bmp = tmp_0;
                    tmp = new AseBitmapCell(bmp, x, y, opacity_0);
                    break;
                  case 1:
                    var linkFrame = readU16LE(cs);
                    // Inline function 'korlibs.datastructure.get' call

                    // Inline function 'kotlin.js.asDynamic' call

                    var tmp$ret$2 = image.b6i_1.i1(linkFrame).w6g_1.get(layerIndex);
                    var aseCell = ensureNotNull(tmp$ret$2);
                    tmp = new AseLinkedCell(aseCell, x, y, opacity_0);
                    break;
                  case 3:
                    var tilesWidth = readU16LE(cs);
                    var tilesHeight = readU16LE(cs);
                    var bitsPerTile = readU16LE(cs);
                    var tileBitmask = readS32LE(cs);
                    var bitmaskXFlip = readS32LE(cs);
                    var bitmaskYFlip = readS32LE(cs);
                    var bitmask90CWFlip = readS32LE(cs);
                    var bytesPerTile = bitsPerTile / 8 | 0;
                    cs.zy(10);
                    var compressedData = uncompress(readAvailable(cs), Companion_getInstance_15(), imul(imul(tilesWidth, tilesHeight), bytesPerTile));
                    var tmp_1;
                    if (bitsPerTile === 32) {
                      tmp_1 = getS32ArrayLE(compressedData, 0, imul(tilesWidth, tilesHeight));
                    } else {
                      var reason = 'Only supported 32-bits per tile';
                      throw NotImplementedError.oe('An operation is not implemented: ' + reason);
                    }

                    var data_0 = tmp_1;
                    tmp = new AseTilemapCell(new IntArray2(tilesWidth, tilesHeight, data_0), tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity_0);
                    break;
                  default:
                    var message_3 = 'Aseprite: Unknown celType=' + celType;
                    throw IllegalStateException.m5(toString(message_3));
                }

                var cel = tmp;
                lastEntity = cel;
                lastCell = cel;
                if (!(cel == null)) {
                  // Inline function 'korlibs.datastructure.set' call
                  // Inline function 'kotlin.js.asDynamic' call
                  currentFrame.w6g_1.set(layerIndex, cel);
                }

                break;
              case 8198:
                var flags_1 = readS32LE(cs);
                var x_0 = _Fixed32___get_double__impl__wjoyf6(this.l6j(cs));
                var y_0 = _Fixed32___get_double__impl__wjoyf6(this.l6j(cs));
                var width_0 = _Fixed32___get_double__impl__wjoyf6(this.l6j(cs));
                var height_0 = _Fixed32___get_double__impl__wjoyf6(this.l6j(cs));
                cs.zy(16);
                break;
              case 8199:
                var type_0 = readU16LE(cs);
                var flags_2 = readU16LE(cs);
                var gamma = this.l6j(cs);
                cs.zy(8);
                break;
              case 8200:
                var nentries = readS32LE(cs);
                cs.zy(8);
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < nentries)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var entryId = readS32LE(cs);
                    cs.zy(8);
                    var externalFileName = this.u6i(cs);
                    image.e6i_1.n37(entryId, externalFileName);
                  }
                   while (inductionVariable_1 < nentries);
                break;
              case 8214:
                break;
              case 8215:
                break;
              case 8216:
                var numTags = readU16LE(cs);
                cs.zy(8);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < numTags)
                  do {
                    var tag = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var fromFrame = readU16LE(cs);
                    var toFrame = readU16LE(cs);
                    var direction = readU8(cs);
                    cs.zy(8);
                    var tagColor = RGBA__withA_impl_vogscm(this.m6j(cs), 255);
                    var tagName = this.u6i(cs);
                    var tag_0 = new AseTag(fromFrame, toFrame, direction, tagColor, tagName);
                    image.c6i_1.f(tag_0);
                  }
                   while (inductionVariable_2 < numTags);
                break;
              case 8217:
                var numEntries = readS32LE(cs);
                var changeStart = readS32LE(cs);
                var changeEnd = readS32LE(cs);
                var colors = Companion_instance_19.q51(numEntries);
                // Inline function 'kotlin.arrayOfNulls' call

                var colorNames = fillArrayVal(Array(numEntries), null);
                cs.zy(8);
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < numEntries)
                  do {
                    var ncol = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var flags_3 = readU16LE(cs);
                    var rgba = this.m6j(cs);
                    var name_0 = hasBitSet(flags_3, 0) ? this.u6i(cs) : null;
                    RgbaArray__set_impl_epw2wg(colors, ncol, rgba);
                    colorNames[ncol] = name_0;
                  }
                   while (inductionVariable_3 < numEntries);
                image.z6h_1 = new AsePalette(colors, colorNames, changeStart, changeEnd);
                lastEntity = image.z6h_1;
                break;
              case 8224:
                var flags_4 = readS32LE(cs);
                if (hasBitSet(flags_4, 0)) {
                  var tmp149_safe_receiver = lastEntity;
                  if (tmp149_safe_receiver == null)
                    null;
                  else {
                    tmp149_safe_receiver.r6e(this.u6i(cs));
                  }
                }

                if (hasBitSet(flags_4, 1)) {
                  var tmp150_safe_receiver = lastEntity;
                  if (tmp150_safe_receiver == null)
                    null;
                  else {
                    tmp150_safe_receiver.s6e(this.m6j(cs));
                  }
                }

                break;
              case 8226:
                var numSliceKeys = readS32LE(cs);
                var sliceFlags = readS32LE(cs);
                cs.zy(4);
                var sliceName = this.u6i(cs);
                var hasNinePatch = hasBitSet(sliceFlags, 0);
                var hasPivotInfo = hasBitSet(sliceFlags, 1);
                var slice_1 = new AseSlice(sliceName, hasNinePatch, hasPivotInfo);
                image.d6i_1.f(slice_1);
                lastEntity = slice_1;
                var inductionVariable_4 = 0;
                if (inductionVariable_4 < numSliceKeys)
                  do {
                    var nsk = inductionVariable_4;
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    var sliceFrameIndex = readS32LE(cs);
                    var sliceXOrigin = readS32LE(cs);
                    var sliceYOrigin = readS32LE(cs);
                    var sliceWidth = readS32LE(cs);
                    var sliceHeight = readS32LE(cs);
                    var centerXPos = hasNinePatch ? readS32LE(cs) : 0;
                    var centerYPos = hasNinePatch ? readS32LE(cs) : 0;
                    var centerWidth = hasNinePatch ? readS32LE(cs) : sliceWidth;
                    var centerHeight = hasNinePatch ? readS32LE(cs) : sliceHeight;
                    var pivotX = hasPivotInfo ? readS32LE(cs) : 0;
                    var pivotY = hasPivotInfo ? readS32LE(cs) : 0;
                    slice_1.o6h_1.f(new AseSliceKey(sliceFrameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY));
                  }
                   while (inductionVariable_4 < numSliceKeys);
                break;
              case 8227:
                var tilesetId = readS32LE(cs);
                var tilesetFlags = readS32LE(cs);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeLinkToExternalFile = !(((tilesetFlags >>> 0 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeTilesInsideThisFile = !(((tilesetFlags >>> 1 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var tile0IsEmpty = !(((tilesetFlags >>> 2 | 0) & 1) === 0);
                var ntiles = readS32LE(cs);
                var tileWidth = readU16LE(cs);
                var tileHeight = readU16LE(cs);
                var baseIndex = readS16LE(cs);
                cs.zy(14);
                var tilesetName = this.u6i(cs);
                // Inline function 'kotlin.collections.listOf' call

                var tiles = emptyList();
                if (includeLinkToExternalFile) {
                  var externalFileId = readS32LE(cs);
                  var externalTilesetId = readS32LE(cs);
                }

                if (includeTilesInsideThisFile) {
                  var compressedDataLength = readS32LE(cs);
                  var compressedData_0 = readBytesExact(cs, compressedDataLength);
                  var data_1 = uncompress(compressedData_0, Companion_getInstance_15());
                  var ints = getS32ArrayLE(data_1, 0, imul(imul(tileWidth, tileHeight), ntiles));
                  // Inline function 'kotlin.also' call
                  var this_1 = Bitmap32.q4z(tileWidth, imul(tileHeight, ntiles), _RgbaArray___init__impl__oib4y4(ints));
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
                  if (props.k6j()) {
                    this_1.i51();
                  }
                  var bitmap = this_1;
                  tiles = splitInRows(slice_0(bitmap), tileWidth, tileHeight);
                }

                image.f6i_1.n37(tilesetId, new AseTileset(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles));
                break;
              default:
                println('WARNING: Aseprite: Not implemented chunkType=' + get_hex(chunkType));
                break;
            }
          }
           while (inductionVariable_0 < numChunks);
      }
       while (inductionVariable < numFrames);
    var imageLayers = image.a6i_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.m1();
    var tmp0_iterator = imageLayers.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var shouldProcess = get_onlyReadVisibleLayers(props) ? element.l6g_1 : true;
      var tmp_2;
      if (shouldProcess) {
        var tmp_3 = ASE_getInstance();
        var tmp_4 = element.o6j_1;
        tmp_2 = takeLayersByName(props, tmp_3, (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        destination.f(element);
      }
    }
    var imageLayersToProcess = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_2 = image.b6i_1;
    var destination_0 = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this_2.f1();
    while (tmp0_iterator_0.g1()) {
      var element_0 = tmp0_iterator_0.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_3 = toLinkedMap(element_0.w6g_1);
      var destination_1 = LinkedHashMap.vc();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = this_3.z1().f1();
      while (tmp0_iterator_1.g1()) {
        var element_1 = tmp0_iterator_1.h1();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var shouldProcess_0 = get_onlyReadVisibleLayers(props) ? imageLayers.i1(element_1.a2()).l6g_1 : true;
        var tmp_5;
        if (shouldProcess_0) {
          var tmp_6 = ASE_getInstance();
          var tmp_7 = imageLayers.i1(element_1.a2()).o6j_1;
          tmp_5 = takeLayersByName(props, tmp_6, (!(tmp_7 == null) ? typeof tmp_7 === 'string' : false) ? tmp_7 : THROW_CCE());
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          destination_1.r3(element_1.a2(), element_1.b2());
        }
      }
      var cells = destination_1;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList.w(cells.j1());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = cells.z1().f1();
      while (tmp0_iterator_2.g1()) {
        var item = tmp0_iterator_2.h1();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = item.a2();
        // Inline function 'kotlin.collections.component2' call
        var value = item.b2();
        var tmp$ret$23 = readImageContainer$createImageFrameLayer(imageLayers, image, key, value);
        destination_2.f(tmp$ret$23);
      }
      var layerData = destination_2;
      var tmp_8;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!layerData.a1()) {
        // Inline function 'korlibs.time.milliseconds' call
        var this_4 = element_0.v6g_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$28 = toDuration(this_4, DurationUnit_MILLISECONDS_getInstance());
        tmp_8 = ImageFrame.w6j(element_0.u6g_1, tmp$ret$28, layerData);
      } else {
        tmp_8 = ImageFrame.v6j(element_0.u6g_1);
      }
      var tmp0_safe_receiver = tmp_8;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.f(tmp0_safe_receiver);
      }
    }
    var frames = destination_0;
    // Inline function 'kotlin.collections.map' call
    var this_5 = image.c6i_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_3 = this_5.f1();
    while (tmp0_iterator_3.g1()) {
      var item_0 = tmp0_iterator_3.h1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var framesRange = slice(frames, numberRangeToNumber(clamp(item_0.s6h_1, 0, frames.j1()), clamp(item_0.t6h_1, 0, frames.j1() - 1 | 0)));
      var tmp$ret$33 = new ImageAnimation(framesRange, item_0.x6h_1, item_0.w6h_1);
      destination_3.f(tmp$ret$33);
    }
    var animations = destination_3;
    var defaultData = new ImageData(frames, VOID, imageWidth, imageHeight, imageLayersToProcess, animations);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_6 = image.d6i_1;
    var destination_4 = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_4 = this_6.f1();
    while (tmp0_iterator_4.g1()) {
      var element_2 = tmp0_iterator_4.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      element_2.p6h();
      var tmp$ret$36;
      $l$block: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator = element_2.o6h_1.f1();
        if (!iterator.g1()) {
          tmp$ret$36 = null;
          break $l$block;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue = iterator.h1().x6e_1;
        while (iterator.g1()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v = iterator.h1().x6e_1;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
        tmp$ret$36 = maxValue;
      }
      var tmp0_elvis_lhs = tmp$ret$36;
      var maxWidth = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var tmp$ret$39;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator_0 = element_2.o6h_1.f1();
        if (!iterator_0.g1()) {
          tmp$ret$39 = null;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue_0 = iterator_0.h1().y6e_1;
        while (iterator_0.g1()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v_0 = iterator_0.h1().y6e_1;
          if (compareTo(maxValue_0, v_0) < 0) {
            maxValue_0 = v_0;
          }
        }
        tmp$ret$39 = maxValue_0;
      }
      var tmp1_elvis_lhs = tmp$ret$39;
      var maxHeight = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_7 = image.b6i_1;
      var destination_5 = ArrayList.m1();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_5 = this_7.f1();
      while (tmp0_iterator_5.g1()) {
        var element_3 = tmp0_iterator_5.h1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var sliceKey = element_2.q6h(element_3.u6g_1);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_8 = toLinkedMap(element_3.w6g_1);
        var destination_6 = LinkedHashMap.vc();
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_6 = this_8.z1().f1();
        while (tmp0_iterator_6.g1()) {
          var element_4 = tmp0_iterator_6.h1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var shouldProcess_1 = get_onlyReadVisibleLayers(props) ? imageLayers.i1(element_4.a2()).l6g_1 : true;
          var tmp_9;
          if (shouldProcess_1) {
            var tmp_10 = ASE_getInstance();
            var tmp_11 = imageLayers.i1(element_4.a2()).o6j_1;
            tmp_9 = takeLayersByName(props, tmp_10, (!(tmp_11 == null) ? typeof tmp_11 === 'string' : false) ? tmp_11 : THROW_CCE());
          } else {
            tmp_9 = false;
          }
          if (tmp_9) {
            destination_6.r3(element_4.a2(), element_4.b2());
          }
        }
        var cells_0 = destination_6;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_7 = ArrayList.w(cells_0.j1());
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_7 = cells_0.z1().f1();
        while (tmp0_iterator_7.g1()) {
          var item_1 = tmp0_iterator_7.h1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.component1' call
          var key_0 = item_1.a2();
          // Inline function 'kotlin.collections.component2' call
          var value_0 = item_1.b2();
          var tmp$ret$49 = readImageContainer$createImageFrameLayer(imageLayers, image, key_0, value_0);
          destination_7.f(tmp$ret$49);
        }
        // Inline function 'kotlin.collections.mapTo' call
        var destination_8 = ArrayList.w(collectionSizeOrDefault(destination_7, 10));
        var tmp0_iterator_8 = destination_7.f1();
        while (tmp0_iterator_8.g1()) {
          var item_2 = tmp0_iterator_8.h1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var sliceKeyFrame = sliceKey.f6f_1;
          var sliceFrame = RectangleInt.d2u(sliceKeyFrame.z2t_1 - item_2.y6j_1 | 0, sliceKeyFrame.a2u_1 - item_2.z6j_1 | 0, sliceKeyFrame.b2u_1, sliceKeyFrame.c2u_1);
          var sslice = item_2.g6k_1.x42(sliceFrame, item_2.g6k_1.j41_1);
          var ninePatchSlice = element_2.m6h_1 ? asNinePatchSimple(sslice, sliceKey.z6e_1, sliceKey.a6f_1, sliceKey.z6e_1 + sliceKey.b6f_1 | 0, sliceKey.a6f_1 + sliceKey.c6f_1 | 0) : null;
          var tmp$ret$52 = new ImageFrameLayer(item_2.x6j_1, sslice, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.z2t_1 : item_2.y6j_1) - sliceKey.d6f_1 | 0, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.a2u_1 : item_2.z6j_1) - sliceKey.e6f_1 | 0, item_2.a6k_1, item_2.b6k_1, VOID, ninePatchSlice);
          destination_8.f(tmp$ret$52);
        }
        var layerData_0 = destination_8;
        var tmp_12;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!layerData_0.a1()) {
          // Inline function 'korlibs.time.milliseconds' call
          var this_9 = element_3.v6g_1;
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$57 = toDuration(this_9, DurationUnit_MILLISECONDS_getInstance());
          tmp_12 = ImageFrame.w6j(element_3.u6g_1, tmp$ret$57, layerData_0);
        } else {
          tmp_12 = null;
        }
        var tmp0_safe_receiver_0 = tmp_12;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_5.f(tmp0_safe_receiver_0);
        }
      }
      var frames_0 = destination_5;
      var tmp_13;
      var tmp_14;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!frames_0.a1()) {
        tmp_14 = slicingEnabled(props, ASE_getInstance());
      } else {
        tmp_14 = false;
      }
      if (tmp_14) {
        // Inline function 'kotlin.collections.map' call
        var this_10 = image.c6i_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_9 = ArrayList.w(collectionSizeOrDefault(this_10, 10));
        var tmp0_iterator_9 = this_10.f1();
        while (tmp0_iterator_9.g1()) {
          var item_3 = tmp0_iterator_9.h1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var framesRange_0 = slice(frames_0, numberRangeToNumber(clamp(item_3.s6h_1, 0, frames_0.j1()), clamp(item_3.t6h_1, 0, frames_0.j1() - 1 | 0)));
          var tmp$ret$63 = new ImageAnimation(framesRange_0, item_3.x6h_1, item_3.w6h_1);
          destination_9.f(tmp$ret$63);
        }
        var animations_0 = destination_9;
        tmp_13 = new ImageData(frames_0, VOID, maxWidth, maxHeight, imageLayersToProcess, animations_0, element_2.l6h_1);
      } else {
        tmp_13 = null;
      }
      var tmp0_safe_receiver_1 = tmp_13;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_4.f(tmp0_safe_receiver_1);
      }
    }
    var datas = destination_4;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_10 = imageLayersToProcess.f1();
    while (tmp0_iterator_10.g1()) {
      var item_4 = tmp0_iterator_10.h1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      item_4.n6j_1 = checkIndexOverflow(tmp1);
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_15;
    if (datas.a1()) {
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      tmp_15 = listOf(defaultData);
    } else {
      tmp_15 = datas;
    }
    var tmp$ret$71 = tmp_15;
    return new ImageDataContainer(tmp$ret$71);
  }
  m6j(_this__u8e3s4) {
    return _RGBA___init__impl__lqpay5(readS32LE(_this__u8e3s4));
  }
  l6j(_this__u8e3s4) {
    return Companion_instance_39.h6k(readS32LE(_this__u8e3s4));
  }
  u6i(_this__u8e3s4) {
    return readString(_this__u8e3s4, readU16LE(_this__u8e3s4));
  }
}
class Companion_29 {
  h6k(raw) {
    return _Fixed32___init__impl__8jizkq(raw);
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_40 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.u6k_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.w6k_1 = destination;
  }
  i1(index) {
    var tmp0_elvis_lhs = this.w6k_1.k3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.u6k_1 = id;
    this.v6k_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.x6k_1 = Companion_getInstance_16().ez('EXIF');
  }
  y6k(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx(this, ss, info, debug, $completion), $completion);
  }
  z6k(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.y6k(ss, info, debug, $completion) : $super.y6k.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.a6l_1 = function_0;
  }
  rj(a, b) {
    return this.a6l_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.m1();
      var tmp0_iterator = frames.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.t6j_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.f1();
      while (tmp0_iterator_0.g1()) {
        var item = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.x6j_1;
        destination_0.f(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.b6l_1 = frames;
    this.c6l_1 = direction;
    this.d6l_1 = name;
    this.e6l_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_1(this.b6l_1);
    tmp_1.f6l_1 = tmp0_elvis_lhs == null ? ImageFrame.v6j(0) : tmp0_elvis_lhs;
  }
}
class Companion_31 {
  g6l(simple) {
    return new ImageData(listOf(Companion_instance_43.h6l(simple)));
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.i6l_1 = function_0;
  }
  rj(a, b) {
    return this.i6l_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp170_safe_receiver = firstOrNull_1(frames);
      var tmp0_elvis_lhs = tmp170_safe_receiver == null ? null : tmp170_safe_receiver.j2y();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp171_safe_receiver = firstOrNull_1(frames);
      var tmp1_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.k2y();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.l6l_1 = new Mixin();
    this.m6l_1 = frames;
    this.n6l_1 = loopCount;
    this.o6l_1 = width;
    this.p6l_1 = height;
    this.q6l_1 = layers;
    this.r6l_1 = animations;
    this.s6l_1 = name;
    this.t6l_1 = new ImageAnimation(this.m6l_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.r6l_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.d6l_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp_1.u6l_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.m6l_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.wc(capacity_0);
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var element_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.w3();
      destination_0.r3(tmp$ret$3, element_0);
    }
    tmp_2.v6l_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.m6l_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_4);
    tmp_3.w6l_1 = sortedWith(this_2, tmp$ret$6);
  }
  n13(_set____db54di) {
    this.l6l_1.n13(_set____db54di);
  }
  o13() {
    return this.l6l_1.o13();
  }
  x6l() {
    var tmp172_safe_receiver = firstOrNull_1(this.w6l_1);
    var tmp0_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.j6l();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString(this.m6l_1) + ')';
  }
}
class sam$kotlin_Comparator$0_2 {
  constructor(function_0) {
    this.c6m_1 = function_0;
  }
  rj(a, b) {
    return this.c6m_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.y6l_1 = imageDatas;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.y6l_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName.<anonymous>' call
      var tmp$ret$0 = element.s6l_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.z6l_1 = destination;
    var tmp_0 = this;
    var tmp0_elvis_lhs = this.z6l_1.k3(null);
    tmp_0.a6m_1 = tmp0_elvis_lhs == null ? first(this.y6l_1) : tmp0_elvis_lhs;
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_42 = this;
    this.s4m_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.t4m_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.u4m_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_50();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.y6i_1 = filename;
    this.z6i_1 = width;
    this.a6j_1 = height;
    this.b6j_1 = premultiplied;
    this.c6j_1 = asumePremultiplied;
    this.d6j_1 = requestedMaxSize;
    this.e6j_1 = debug;
    this.f6j_1 = preferKotlinDecoder;
    this.g6j_1 = tryNativeDecode;
    this.h6j_1 = format;
    this.i6j_1 = out;
    this.j6j_1 = extra;
  }
  n13(_set____db54di) {
    this.j6j_1 = _set____db54di;
  }
  o13() {
    return this.j6j_1;
  }
  j6k() {
    return this;
  }
  k6j() {
    var tmp0_elvis_lhs = this.b6j_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  d6m() {
    var tmp0_elvis_lhs = this.h6j_1;
    return tmp0_elvis_lhs == null ? get_RegisteredImageFormats() : tmp0_elvis_lhs;
  }
  e6m(filename) {
    return this.f6m(filename);
  }
  g6m(file) {
    return this.e6m(get_baseName(file));
  }
  h6m(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  f6m(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.y6i_1 : filename;
    width = width === VOID ? this.z6i_1 : width;
    height = height === VOID ? this.a6j_1 : height;
    premultiplied = premultiplied === VOID ? this.b6j_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.c6j_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.d6j_1 : requestedMaxSize;
    debug = debug === VOID ? this.e6j_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.f6j_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.g6j_1 : tryNativeDecode;
    format = format === VOID ? this.h6j_1 : format;
    out = out === VOID ? this.i6j_1 : out;
    extra = extra === VOID ? this.j6j_1 : extra;
    return $super === VOID ? this.h6m(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.h6m.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.y6i_1 + ', width=' + this.z6i_1 + ', height=' + this.a6j_1 + ', premultiplied=' + this.b6j_1 + ', asumePremultiplied=' + this.c6j_1 + ', requestedMaxSize=' + this.d6j_1 + ', debug=' + this.e6j_1 + ', preferKotlinDecoder=' + this.f6j_1 + ', tryNativeDecode=' + this.g6j_1 + ', format=' + toString_0(this.h6j_1) + ', out=' + toString_0(this.i6j_1) + ', extra=' + toString_0(this.j6j_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.y6i_1);
    result = imul(result, 31) + (this.z6i_1 == null ? 0 : this.z6i_1) | 0;
    result = imul(result, 31) + (this.a6j_1 == null ? 0 : this.a6j_1) | 0;
    result = imul(result, 31) + (this.b6j_1 == null ? 0 : getBooleanHashCode(this.b6j_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c6j_1) | 0;
    result = imul(result, 31) + (this.d6j_1 == null ? 0 : this.d6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6j_1) | 0;
    result = imul(result, 31) + (this.h6j_1 == null ? 0 : hashCode(this.h6j_1)) | 0;
    result = imul(result, 31) + (this.i6j_1 == null ? 0 : hashCode(this.i6j_1)) | 0;
    result = imul(result, 31) + (this.j6j_1 == null ? 0 : hashCode(this.j6j_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.y6i_1 === tmp0_other_with_cast.y6i_1))
      return false;
    if (!(this.z6i_1 == tmp0_other_with_cast.z6i_1))
      return false;
    if (!(this.a6j_1 == tmp0_other_with_cast.a6j_1))
      return false;
    if (!(this.b6j_1 == tmp0_other_with_cast.b6j_1))
      return false;
    if (!(this.c6j_1 === tmp0_other_with_cast.c6j_1))
      return false;
    if (!(this.d6j_1 == tmp0_other_with_cast.d6j_1))
      return false;
    if (!(this.e6j_1 === tmp0_other_with_cast.e6j_1))
      return false;
    if (!(this.f6j_1 === tmp0_other_with_cast.f6j_1))
      return false;
    if (!(this.g6j_1 === tmp0_other_with_cast.g6j_1))
      return false;
    if (!equals(this.h6j_1, tmp0_other_with_cast.h6j_1))
      return false;
    if (!equals(this.i6j_1, tmp0_other_with_cast.i6j_1))
      return false;
    if (!equals(this.j6j_1, tmp0_other_with_cast.j6j_1))
      return false;
    return true;
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static n6m(formats) {
    var $this = this.i6m(['']);
    $this.l6m_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static o6m(formats) {
    return this.n6m(toList_1(formats));
  }
  p6m(_set____db54di) {
    var this_0 = this.l6m_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  q6m() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.l6m_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  m6m() {
    return this.q6m();
  }
  r6m(ext) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.m6m().f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExtOrNull.<anonymous>' call
        if (element.e69_1.f3(ext)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  s6m(ext) {
    var tmp0_elvis_lhs = this.r6m(ext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.m6m();
      var destination = ArrayList.m1();
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExt.<anonymous>' call
        var list = element.e69_1;
        addAll(destination, list);
      }
      throw UnsupportedOperationException.ua("Don't know how to generate file for extension '" + ext + "' (supported extensions " + toString(destination) + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageFormats(' + this.m6m().j1() + ')' + toString(this.m6m());
  }
  n6i(s, props) {
    if (this.m6m().a1())
      return null;
    var _iterator__ex2g4s = this.m6m().f1();
    $l$loop_0: while (_iterator__ex2g4s.g1()) {
      var format = _iterator__ex2g4s.h1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.n6i(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  i6k(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.m6m().f1();
      while (_iterator__ex2g4s.g1()) {
        var format = _iterator__ex2g4s.h1();
        if (format.l6k(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImage.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.i6k(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.ua('No suitable image format : MAGIC:' + readString_1(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
  s6i(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.m6m().f1();
      while (_iterator__ex2g4s.g1()) {
        var format = _iterator__ex2g4s.h1();
        if (format.l6k(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.s6i(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.ua('No suitable image format : MAGIC:' + readString_1(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
  r6k(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme(this, data, props, $completion), $completion);
  }
  p6k(file, props, $completion) {
    return this.s6m(get_extensionLC(file)).p6k(file, props, $completion);
  }
}
class ImageFormatsMutable extends ImageFormats {
  static x6m() {
    var $this = this.o6m([]);
    $this.w6m_1 = new NonRecursiveLock();
    return $this;
  }
  y6m(formats) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.w6m_1;
      this_0.w1w();
      try {
        this.p6m(minus(plus_1(this.q6m(), formats), this));
        break $l$block;
      }finally {
        this_0.z1w();
      }
    }
  }
}
class Companion_33 {
  z6m(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.w6j(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice_0(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  h6l(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.z6m(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.z6m.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static v6j(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.q6j_1 = new Mixin();
    $this.r6j_1 = index;
    $this.s6j_1 = fastTime;
    $this.t6j_1 = layerData;
    $this.u6j_1 = firstOrNull_1($this.t6j_1);
    return $this;
  }
  n13(_set____db54di) {
    this.q6j_1.n13(_set____db54di);
  }
  o13() {
    return this.q6j_1.o13();
  }
  a6n() {
    return toDuration_0(this.s6j_1);
  }
  static w6j(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.v6j(index, get_fast(time), layerData);
  }
  b6n() {
    var tmp176_safe_receiver = this.u6j_1;
    var tmp0_elvis_lhs = tmp176_safe_receiver == null ? null : tmp176_safe_receiver.g6k_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  c6n() {
    var tmp177_safe_receiver = this.u6j_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.y6j_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  d6n() {
    var tmp178_safe_receiver = this.u6j_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.z6j_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  k6l() {
    var tmp179_safe_receiver = this.u6j_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.a6k_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  e6n() {
    return this.a6n();
  }
  j2y() {
    return this.b6n().o41_1;
  }
  k2y() {
    return this.b6n().p41_1;
  }
  j6l() {
    var tmp181_safe_receiver = this.u6j_1;
    var tmp0_elvis_lhs = tmp181_safe_receiver == null ? null : tmp181_safe_receiver.j6l();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  w3() {
    return this.b6n().j41_1;
  }
  toString() {
    return 'ImageFrame(' + this.b6n().toString() + ', time=' + Duration__toString_impl_8d916b(this.a6n()) + ', targetX=' + this.c6n() + ', targetY=' + this.d6n() + ', main=' + this.k6l() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.x6j_1 = layer;
    this.y6j_1 = targetX;
    this.z6j_1 = targetY;
    this.a6k_1 = main;
    this.b6k_1 = includeInAtlas;
    this.c6k_1 = tilemap;
    this.d6k_1 = ninePatchSlice;
    this.e6k_1 = null;
    this.f6k_1 = null;
    this.g6k_1 = slice;
  }
  b6m(value) {
    this.g6k_1 = value;
    this.e6k_1 = null;
    this.f6k_1 = null;
  }
  j2y() {
    return this.g6k_1.o41_1;
  }
  k2y() {
    return this.g6k_1.p41_1;
  }
  x2u() {
    return this.g6k_1.x2u();
  }
  j6l() {
    if (get_bmp(this.g6k_1).j2y() === this.j2y() && get_bmp(this.g6k_1).k2y() === this.k2y())
      return get_bmp(this.g6k_1);
    if (this.e6k_1 == null)
      this.e6k_1 = extract_0(this.g6k_1);
    return ensureNotNull(this.e6k_1);
  }
}
class ImageInfo {
  constructor() {
    this.o6i_1 = new Mixin();
    this.p6i_1 = 0;
    this.q6i_1 = 0;
    this.r6i_1 = 8;
  }
  n13(_set____db54di) {
    this.o6i_1.n13(_set____db54di);
  }
  o13() {
    return this.o6i_1.o13();
  }
  toString() {
    var tmp = this.p6i_1;
    var tmp_0 = this.q6i_1;
    var tmp_1 = this.r6i_1;
    var tmp182_safe_receiver = this.o13();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString_0(tmp182_safe_receiver == null ? null : toMap_0(tmp182_safe_receiver)) + ')';
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_44 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t6i_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {
  x6i() {
    return this.equals(Type_TILEMAP_getInstance());
  }
}
class NativeImageFormatProvider {
  z6n(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt(this, vfs, path, props, $completion), $completion);
  }
  r6k(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme_0(this, data, props, $completion), $completion);
  }
  a6o(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0(this, file, props, $completion), $completion);
  }
  p6k(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1(this, file, props, $completion), $completion);
  }
  j54(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.k54(bmp.j2y(), bmp.k2y(), bmp.v4q());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.i4p_1;
    if (true) {
      this_0.w1w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.y4x(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.f6o(bmp, Companion_getInstance_1().a2i_1);
      }finally {
        ctx.o18();
      }
    }finally {
      result = true ? this_0.q4q(rect) : 0;
    }
    return this_0;
  }
  i54(bmp, levels) {
    return ensureNative(bmp.o4q().k51(levels));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  m6m() {
    return get_RegisteredImageFormats();
  }
  f6n(data, props, $completion) {
    return this.g6n(this.m6m().n6k(data, props), props);
  }
  h6n(bmp) {
    return BitmapNativeImage.y6n(bmp);
  }
  g6n(bmp, props) {
    var bmp32 = bmp.q4p();
    return new NativeImageResult(this.h6n(props.c6j_1 ? asumePremultiplied(bmp32) : props.k6j() ? bmp32.r4p() : bmp32.g51()));
  }
  k54(width, height, premultiplied) {
    return this.h6n(Bitmap32.c4p(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  j54(bmp) {
    return this.h6n(bmp);
  }
  i54(bmp, levels) {
    return this.h6n(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.j2y() : originalWidth;
    originalHeight = originalHeight === VOID ? image.k2y() : originalHeight;
    this.b6o_1 = image;
    this.c6o_1 = originalWidth;
    this.d6o_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.b6o_1.toString() + ', originalWidth=' + this.c6o_1 + ', originalHeight=' + this.d6o_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b6o_1);
    result = imul(result, 31) + this.c6o_1 | 0;
    result = imul(result, 31) + this.d6o_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.b6o_1, tmp0_other_with_cast.b6o_1))
      return false;
    if (!(this.c6o_1 === tmp0_other_with_cast.c6o_1))
      return false;
    if (!(this.d6o_1 === tmp0_other_with_cast.d6o_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static e6o(bitmap) {
    var $this = this.h54(bitmap.j2y(), bitmap.k2y(), bitmap, bitmap.v4q());
    $this.w6n_1 = bitmap;
    $this.x6n_1 = $this.w6n_1.z4o_1;
    return $this;
  }
  w3() {
    return 'BitmapNativeImage';
  }
  static y6n(bitmap) {
    return this.e6o(bitmap.q4p());
  }
  y4x(antialiasing) {
    return this.w6n_1.y4x(antialiasing);
  }
  o4q() {
    return this.w6n_1;
  }
  b4r(x, y, width, height, out, offset) {
    return this.w6n_1.b4r(x, y, width, height, out, offset);
  }
  d4r(x, y, width, height, out, offset) {
    return this.w6n_1.d4r(x, y, width, height, out, offset);
  }
  e4r(x, y, v) {
    return this.w6n_1.e4r(x, y, v);
  }
  c4r(x, y) {
    return this.w6n_1.c4r(x, y);
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_45 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.wc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.i6o_1;
      destination.r3(tmp$ret$0, element);
    }
    tmp.k6o_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.l6o_1 = startingRow;
    this.m6o_1 = startingCol;
    this.n6o_1 = rowIncrement;
    this.o6o_1 = colIncrement;
    this.p6o_1 = blockHeight;
    this.q6o_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.o6o_1;
    var tmp$ret$0 = log2(x);
    tmp.r6o_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.l6o_1 + ', startingCol=' + this.m6o_1 + ', rowIncrement=' + this.n6o_1 + ', colIncrement=' + this.o6o_1 + ', blockHeight=' + this.p6o_1 + ', blockWidth=' + this.q6o_1 + ')';
  }
  hashCode() {
    var result = this.l6o_1;
    result = imul(result, 31) + this.m6o_1 | 0;
    result = imul(result, 31) + this.n6o_1 | 0;
    result = imul(result, 31) + this.o6o_1 | 0;
    result = imul(result, 31) + this.p6o_1 | 0;
    result = imul(result, 31) + this.q6o_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.l6o_1 === tmp0_other_with_cast.l6o_1))
      return false;
    if (!(this.m6o_1 === tmp0_other_with_cast.m6o_1))
      return false;
    if (!(this.n6o_1 === tmp0_other_with_cast.n6o_1))
      return false;
    if (!(this.o6o_1 === tmp0_other_with_cast.o6o_1))
      return false;
    if (!(this.p6o_1 === tmp0_other_with_cast.p6o_1))
      return false;
    if (!(this.q6o_1 === tmp0_other_with_cast.q6o_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.i6o_1 = id;
    this.j6o_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.s6o_1 = width;
    this.t6o_1 = height;
    this.u6o_1 = bitsPerChannel;
    this.v6o_1 = colorspace;
    this.w6o_1 = compressionmethod;
    this.x6o_1 = filtermethod;
    this.y6o_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.v6o_1.v3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.z6o_1 = tmp_0;
    this.a6p_1 = imul(imul(this.s6o_1, this.z6o_1), this.u6o_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.b6p_1 = header;
    this.c6p_1 = _UByteArrayInt___init__impl__xif7bu_0(this.b6p_1.a6p_1);
    this.d6p_1 = _UByteArrayInt___init__impl__xif7bu_0(this.b6p_1.a6p_1);
    this.e6p_1 = Companion_instance_19.q51(this.b6p_1.s6o_1);
  }
  n6p() {
    var temp = this.d6p_1;
    this.d6p_1 = this.c6p_1;
    this.c6p_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.o6p_1 = $data;
    this.p6p_1 = $info;
  }
  pe($completion) {
    return EXIF_getInstance().z6k(openAsync(readAll_0(this.o6p_1)), this.p6p_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static q6p() {
    PNG_instance = null;
    var $this = this.i6m(['png']);
    PNG_instance = $this;
    $this.h6p_1 = -1991225785;
    $this.i6p_1 = 218765834;
    $this.j6p_1 = listOf_0([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.k6p_1 = listOf(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  n6i(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  i6k(s, props) {
    var tmp = Companion_instance_41;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.g6l(tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE());
  }
  r6p(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  l6p(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.r6p(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.oe('An operation is not implemented: ' + reason);
    }
  }
  m6p(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.l6p(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.l6p.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  v6p(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.u6p(n, yFloat));
      }
       while (!(n === x1));
  }
  w6p(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.z4o_1);
    var inductionVariable = rect.r2i();
    var last = rect.s2i();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.j2y());
        this.v6p(cols, offset, rect.p2i(), rect.q2i() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  x6p(bmp, rect, $super) {
    rect = rect === VOID ? bmp.b4p_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.w6p(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.w6p.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.s6p_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().i4r_1);
  }
  t6p(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.s6p_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  u6p(x, y) {
    return this.s6p_1;
  }
  v6p(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.s6p_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_36 {
  constructor() {
    this.y6p_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.z6p_1 = Companion_instance_22.x5j(256);
  }
  b6q(fill, state) {
    fill.c6q(this.z6p_1);
    this.a6q_1 = fill.d6q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_4().i2m_1.e2o(fill.x69_1).e2o(state.s5m_1));
    return this;
  }
  e6q(x, y) {
    return _get_fill__d6ivc8(this).f6q(Vector2D.u2n(x, y));
  }
  u6p(x, y) {
    return color(this, this.e6q(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.g6q_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.h6q_1 = 0.0;
    this.i6q_1 = 0.0;
    this.j6q_1 = 0.0;
    this.k6q_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.l6q_1 = get_bmp(tmp$ret$0);
    this.m6q_1 = Companion_getInstance_4().i2m_1;
    this.n6q_1 = true;
    this.o6q_1 = Companion_getInstance_4().i2m_1;
  }
  p6q(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.g6q_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.s6q_1, fill.t6q_1);
    _set_texture__qu271y(this, fill.w6q_1);
    this.m6q_1 = fill.r6q_1;
    this.n6q_1 = fill.u6q_1;
    this.o6q_1 = Companion_getInstance_4().i2m_1.x2n(state.s5m_1).x2n(fill.r6q_1).y2n();
    return this;
  }
  x6q(x, y) {
    return this.l6q_1.a4x(x, y);
  }
  y6q(x, y) {
    return this.l6q_1.t4z(numberToInt(x), numberToInt(y));
  }
  u6p(x, y) {
    var mat = this.o6q_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.u2n(x, y);
      if (mat.n2i()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2h(mat.d2n(p.i2h_1, p.j2h_1), mat.g2n(p.i2h_1, p.j2h_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.u2n(this.j6q_1, this.k6q_1);
    var p_0 = Vector2D.k2h(this_0.i2h_1 * that.i2h_1, this_0.j2h_1 * that.j2h_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.g6q_1, p_0);
    var that_0 = Vector2D.u2n(this.h6q_1, this.i6q_1);
    var t = Vector2D.k2h(this_1.i2h_1 * that_0.i2h_1, this_1.j2h_1 * that_0.j2h_1);
    return this.n6q_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.x6q(t.i2h_1, t.j2h_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.y6q(t.i2h_1, t.j2h_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  u6p(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  v6p(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_37 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.c32() : stops;
    colors = colors === VOID ? IntArrayList.f31() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_6().r2h_1 : startAngle;
    this.n69_1 = kind;
    this.o69_1 = x0;
    this.p69_1 = y0;
    this.q69_1 = r0;
    this.r69_1 = x1;
    this.s69_1 = y1;
    this.t69_1 = r1;
    this.u69_1 = stops;
    this.v69_1 = colors;
    this.w69_1 = cycle;
    this.x69_1 = transform;
    this.y69_1 = interpolationMethod;
    this.z69_1 = units;
    this.a6a_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_4().i2m_1.q2n(-this.o69_1, -this.p69_1).l2n(1.0 / clamp_1(Companion_getInstance_1().l2u(this.o69_1, this.p69_1, this.r69_1, this.s69_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_6();
    var x0_0 = this.o69_1;
    var y0_0 = this.p69_1;
    var x1_0 = this.r69_1;
    var y1_0 = this.s69_1;
    var up = Companion_getInstance_1().e2i_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.b6a_1 = tmp_0.v2m(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.c6a_1 = this.x69_1.y2n();
    this.d6a_1 = Companion_getInstance_4().i2m_1.x2n(this.b6a_1).x2n(this.c6a_1);
    this.e6a_1 = 2 * this.q69_1 * this.t69_1;
    this.f6a_1 = this.z6q(this.q69_1);
    this.g6a_1 = this.z6q(this.t69_1);
    this.h6a_1 = this.p69_1 - this.s69_1;
    this.i6a_1 = this.q69_1 - this.t69_1;
    this.j6a_1 = this.o69_1 - this.r69_1;
    this.k6a_1 = 1.0 / (this.z6q(this.q69_1 - this.t69_1) - this.z6q(this.o69_1 - this.r69_1) - this.z6q(this.p69_1 - this.s69_1));
  }
  n5w() {
    return this.x69_1;
  }
  a6r() {
    return this.z69_1;
  }
  c6q(out) {
    return _fillColors(Companion_instance_47, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.u69_1, this.v69_1, true);
  }
  b6r(stop, color) {
    return this.l6a(Ratio__toDouble_impl_o7epze(stop), color);
  }
  l6a(stop, color) {
    return this.c6r(stop, color);
  }
  c6r(stop, color) {
    this.u69_1.l32(stop);
    this.v69_1.o31(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  f6q(p) {
    var tmp;
    switch (this.n69_1.v3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.c6a_1;
          if (this_0.n2i()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.k2h(this_0.d2n(p.i2h_1, p.j2h_1), this_0.g2n(p.i2h_1, p.j2h_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_1().h2w(Vector2D.k2h(this.o69_1, this.p69_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.c6a_1;
          if (this_1.n2i()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.k2h(this_1.d2n(p.i2h_1, p.j2h_1), this_1.g2n(p.i2h_1, p.j2h_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.km();
        var y = _destruct__k2r9zo.lm();
        var tmp_0 = -this.t69_1 * this.i6a_1 + this.j6a_1 * (this.r69_1 - x) + this.h6a_1 * (this.s69_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.g6a_1 * (this.z6q(this.o69_1 - x) + this.z6q(this.p69_1 - y)) - this.e6a_1 * ((this.o69_1 - x) * (this.r69_1 - x) + (this.p69_1 - y) * (this.s69_1 - y)) + this.f6a_1 * (this.z6q(this.r69_1 - x) + this.z6q(this.s69_1 - y)) - this.z6q(this.r69_1 * this.p69_1 - x * this.p69_1 - this.o69_1 * this.s69_1 + x * this.s69_1 + this.o69_1 * y - this.r69_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.k6a_1;
        break;
      default:
        tmp = this.d6a_1.c2n(p);
        break;
    }
    return this.w69_1.f6r(tmp);
  }
  z6q(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  g6r(m) {
    return this.d6q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, m);
  }
  j13() {
    return this.d6q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.x69_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.n69_1.v3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.o69_1 + ', ' + this.p69_1 + '], [' + this.r69_1 + ', ' + this.s69_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.o69_1 + ', ' + this.p69_1 + ', ' + this.q69_1 + '], [' + this.r69_1 + ', ' + this.s69_1 + ', ' + this.t69_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.o69_1 + ', ' + this.p69_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.ic(tmp);
    this_0.ic(', stops=' + this.u69_1.toString() + ', colors=' + colorsToString_0(this, this.v69_1) + ', cycle=' + this.w69_1.toString() + ', transform=' + this.x69_1.toString() + ', interpolationMethod=' + this.y69_1.toString() + ', units=' + this.z69_1.toString() + ')');
    return this_0.toString();
  }
  h6r(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  d6q(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.n69_1 : kind;
    x0 = x0 === VOID ? this.o69_1 : x0;
    y0 = y0 === VOID ? this.p69_1 : y0;
    r0 = r0 === VOID ? this.q69_1 : r0;
    x1 = x1 === VOID ? this.r69_1 : x1;
    y1 = y1 === VOID ? this.s69_1 : y1;
    r1 = r1 === VOID ? this.t69_1 : r1;
    stops = stops === VOID ? this.u69_1 : stops;
    colors = colors === VOID ? this.v69_1 : colors;
    cycle = cycle === VOID ? this.w69_1 : cycle;
    transform = transform === VOID ? this.x69_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.y69_1 : interpolationMethod;
    units = units === VOID ? this.z69_1 : units;
    startAngle = startAngle === VOID ? this.a6a_1 : startAngle;
    return $super === VOID ? this.h6r(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.h6r.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.n69_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.o69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t69_1) | 0;
    result = imul(result, 31) + this.u69_1.hashCode() | 0;
    result = imul(result, 31) + this.v69_1.hashCode() | 0;
    result = imul(result, 31) + this.w69_1.hashCode() | 0;
    result = imul(result, 31) + this.x69_1.hashCode() | 0;
    result = imul(result, 31) + this.y69_1.hashCode() | 0;
    result = imul(result, 31) + this.z69_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.a6a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.n69_1.equals(tmp0_other_with_cast.n69_1))
      return false;
    if (!equals(this.o69_1, tmp0_other_with_cast.o69_1))
      return false;
    if (!equals(this.p69_1, tmp0_other_with_cast.p69_1))
      return false;
    if (!equals(this.q69_1, tmp0_other_with_cast.q69_1))
      return false;
    if (!equals(this.r69_1, tmp0_other_with_cast.r69_1))
      return false;
    if (!equals(this.s69_1, tmp0_other_with_cast.s69_1))
      return false;
    if (!equals(this.t69_1, tmp0_other_with_cast.t69_1))
      return false;
    if (!this.u69_1.equals(tmp0_other_with_cast.u69_1))
      return false;
    if (!this.v69_1.equals(tmp0_other_with_cast.v69_1))
      return false;
    if (!this.w69_1.equals(tmp0_other_with_cast.w69_1))
      return false;
    if (!this.x69_1.equals(tmp0_other_with_cast.x69_1))
      return false;
    if (!this.y69_1.equals(tmp0_other_with_cast.y69_1))
      return false;
    if (!this.z69_1.equals(tmp0_other_with_cast.z69_1))
      return false;
    if (!equals(this.a6a_1, tmp0_other_with_cast.a6a_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  j13() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.q6q_1 = bitmap;
    this.r6q_1 = transform;
    this.s6q_1 = cycleX;
    this.t6q_1 = cycleY;
    this.u6q_1 = smooth;
    this.v6q_1 = units;
    this.w6q_1 = this.q6q_1.o4q();
  }
  n5w() {
    return this.r6q_1;
  }
  a6r() {
    return this.v6q_1;
  }
  i6r() {
    return this.s6q_1.j6r();
  }
  k6r() {
    return this.t6q_1.j6r();
  }
  j13() {
    return this.l6r(VOID, this.r6q_1);
  }
  g6r(m) {
    return this.l6r(VOID, m);
  }
  toString() {
    return 'BitmapPaint(' + toString(this.q6q_1) + ', cycle=(' + this.s6q_1.toString() + ', ' + this.t6q_1.toString() + '), smooth=' + this.u6q_1 + ', transform=' + this.r6q_1.toString() + ')';
  }
  m6r(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  l6r(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.q6q_1 : bitmap;
    transform = transform === VOID ? this.r6q_1 : transform;
    cycleX = cycleX === VOID ? this.s6q_1 : cycleX;
    cycleY = cycleY === VOID ? this.t6q_1 : cycleY;
    smooth = smooth === VOID ? this.u6q_1 : smooth;
    units = units === VOID ? this.v6q_1 : units;
    return $super === VOID ? this.m6r(bitmap, transform, cycleX, cycleY, smooth, units) : $super.m6r.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.q6q_1);
    result = imul(result, 31) + this.r6q_1.hashCode() | 0;
    result = imul(result, 31) + this.s6q_1.hashCode() | 0;
    result = imul(result, 31) + this.t6q_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u6q_1) | 0;
    result = imul(result, 31) + this.v6q_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.q6q_1, tmp0_other_with_cast.q6q_1))
      return false;
    if (!this.r6q_1.equals(tmp0_other_with_cast.r6q_1))
      return false;
    if (!this.s6q_1.equals(tmp0_other_with_cast.s6q_1))
      return false;
    if (!this.t6q_1.equals(tmp0_other_with_cast.t6q_1))
      return false;
    if (!(this.u6q_1 === tmp0_other_with_cast.u6q_1))
      return false;
    if (!this.v6q_1.equals(tmp0_other_with_cast.v6q_1))
      return false;
    return true;
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_48 = this;
    this.o6r_1 = new KeyFrame(Companion_getInstance_11().f10_1, new Declarations(emptyList()));
  }
}
class Companion_39 {
  p6r(selector) {
    var str = selector.g3o();
    if (str === 'from')
      return Companion_getInstance_11().f10_1;
    if (str === 'to')
      return Companion_getInstance_11().i10_1;
    if (!endsWith(str, '%')) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid keyframe selector ' + toString(selector);
      throw IllegalStateException.m5(toString(message));
    }
    return Companion_instance_50.q6r(str);
  }
  r6r(rules) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.m1();
    var tmp0_iterator = rules.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      if (element instanceof RuleSet) {
        destination.f(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.f1();
    while (tmp0_iterator_0.g1()) {
      var item = tmp0_iterator_0.h1();
      // Inline function 'korlibs.image.style.Companion.ruleSetToKeyFrame.<anonymous>' call
      var tmp$ret$2 = new KeyFrame(Companion_instance_49.p6r(item.s6r_1), item.t6r_1);
      destination_0.f(tmp$ret$2);
    }
    return destination_0;
  }
}
class Token {
  constructor(str) {
    this.n6r_1 = str;
  }
  toString() {
    return 'Token(str=' + this.n6r_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.n6r_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Token))
      return false;
    var tmp0_other_with_cast = other instanceof Token ? other : THROW_CCE();
    if (!(this.n6r_1 === tmp0_other_with_cast.n6r_1))
      return false;
    return true;
  }
}
class sam$korlibs_math_interpolation_Easing$0 {
  constructor(function_0) {
    this.u6r_1 = function_0;
  }
  xz(it) {
    return this.u6r_1(it);
  }
}
class IdSelector {
  constructor(token) {
    this.x6r_1 = token;
    this.y6r_1 = substr(this.g3o(), 1);
  }
  g3o() {
    return this.x6r_1.n6r_1;
  }
  toString() {
    return 'IdSelector(token=' + this.x6r_1.toString() + ')';
  }
  hashCode() {
    return this.x6r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IdSelector))
      return false;
    var tmp0_other_with_cast = other instanceof IdSelector ? other : THROW_CCE();
    if (!this.x6r_1.equals(tmp0_other_with_cast.x6r_1))
      return false;
    return true;
  }
}
class ClassSelector {
  constructor(token) {
    this.z6r_1 = token;
    this.a6s_1 = substr(this.g3o(), 1);
  }
  g3o() {
    return this.z6r_1.n6r_1;
  }
  toString() {
    return 'ClassSelector(token=' + this.z6r_1.toString() + ')';
  }
  hashCode() {
    return this.z6r_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClassSelector))
      return false;
    var tmp0_other_with_cast = other instanceof ClassSelector ? other : THROW_CCE();
    if (!this.z6r_1.equals(tmp0_other_with_cast.z6r_1))
      return false;
    return true;
  }
}
class UnknownSelector {
  constructor(token) {
    this.b6s_1 = token;
  }
  g3o() {
    return this.b6s_1.n6r_1;
  }
  toString() {
    return 'UnknownSelector(token=' + this.b6s_1.toString() + ')';
  }
  hashCode() {
    return this.b6s_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnknownSelector))
      return false;
    var tmp0_other_with_cast = other instanceof UnknownSelector ? other : THROW_CCE();
    if (!this.b6s_1.equals(tmp0_other_with_cast.b6s_1))
      return false;
    return true;
  }
}
class Expression {
  constructor(expr) {
    this.c6s_1 = new Mixin();
    this.d6s_1 = expr;
    var tmp = this;
    tmp.e6s_1 = joinToString(this.d6s_1, ' ', VOID, VOID, VOID, VOID, CSS$Expression$exprStr$lambda);
  }
  n13(_set____db54di) {
    this.c6s_1.n13(_set____db54di);
  }
  o13() {
    return this.c6s_1.o13();
  }
  toString() {
    return 'Expression(expr=' + toString(this.d6s_1) + ')';
  }
  hashCode() {
    return hashCode(this.d6s_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Expression))
      return false;
    var tmp0_other_with_cast = other instanceof Expression ? other : THROW_CCE();
    if (!equals(this.d6s_1, tmp0_other_with_cast.d6s_1))
      return false;
    return true;
  }
}
class Declaration {
  constructor(property, expr) {
    this.f6s_1 = property;
    this.g6s_1 = expr;
  }
  toString() {
    return 'Declaration(property=' + this.f6s_1 + ', expr=' + toString_0(this.g6s_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.f6s_1);
    result = imul(result, 31) + (this.g6s_1 == null ? 0 : this.g6s_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Declaration))
      return false;
    var tmp0_other_with_cast = other instanceof Declaration ? other : THROW_CCE();
    if (!(this.f6s_1 === tmp0_other_with_cast.f6s_1))
      return false;
    if (!equals(this.g6s_1, tmp0_other_with_cast.g6s_1))
      return false;
    return true;
  }
}
class Declarations {
  constructor(declarations) {
    this.h6s_1 = new Mixin();
    this.i6s_1 = declarations;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.i6s_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap.wc(capacity);
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.image.style.Declarations.declarationsMap.<anonymous>' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = element.f6s_1.toLowerCase();
      var pair = to(tmp$ret$1, element.g6s_1);
      destination.r3(pair.im_1, pair.jm_1);
    }
    tmp.j6s_1 = destination;
  }
  n13(_set____db54di) {
    this.h6s_1.n13(_set____db54di);
  }
  o13() {
    return this.h6s_1.o13();
  }
  bj(prop) {
    return this.j6s_1.k3(prop);
  }
  toString() {
    return 'Declarations(declarations=' + toString(this.i6s_1) + ')';
  }
  hashCode() {
    return hashCode(this.i6s_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Declarations))
      return false;
    var tmp0_other_with_cast = other instanceof Declarations ? other : THROW_CCE();
    if (!equals(this.i6s_1, tmp0_other_with_cast.i6s_1))
      return false;
    return true;
  }
}
class RuleSet {
  constructor(selector, declarations) {
    this.s6r_1 = selector;
    this.t6r_1 = declarations;
  }
  toString() {
    return 'RuleSet(selector=' + toString(this.s6r_1) + ', declarations=' + this.t6r_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.s6r_1);
    result = imul(result, 31) + this.t6r_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuleSet))
      return false;
    var tmp0_other_with_cast = other instanceof RuleSet ? other : THROW_CCE();
    if (!equals(this.s6r_1, tmp0_other_with_cast.s6r_1))
      return false;
    if (!this.t6r_1.equals(tmp0_other_with_cast.t6r_1))
      return false;
    return true;
  }
}
class KeyFrame {
  constructor(ratio, declarations) {
    Companion_getInstance_56();
    this.k6s_1 = ratio;
    this.l6s_1 = declarations;
    var tmp = this;
    var tmp226_safe_receiver = this.bj('animation-timing-function');
    var tmp0_elvis_lhs = tmp226_safe_receiver == null ? null : get_easing(tmp226_safe_receiver);
    tmp.m6s_1 = tmp0_elvis_lhs == null ? Companion_getInstance_12().b10_1 : tmp0_elvis_lhs;
  }
  bj(key) {
    return this.l6s_1.j6s_1.k3(key);
  }
  toString() {
    return 'KeyFrame(ratio=' + Ratio__toString_impl_mfgt3e(this.k6s_1) + ', declarations=' + this.l6s_1.toString() + ')';
  }
  hashCode() {
    var result = Ratio__hashCode_impl_quhc2v(this.k6s_1);
    result = imul(result, 31) + this.l6s_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyFrame))
      return false;
    var tmp0_other_with_cast = other instanceof KeyFrame ? other : THROW_CCE();
    if (!equals(this.k6s_1, tmp0_other_with_cast.k6s_1))
      return false;
    if (!this.l6s_1.equals(tmp0_other_with_cast.l6s_1))
      return false;
    return true;
  }
}
class InterpolationResult {
  constructor(ratio, k0, k1) {
    ratio = ratio === VOID ? 0.0 : ratio;
    k0 = k0 === VOID ? Companion_getInstance_56().o6r_1 : k0;
    k1 = k1 === VOID ? Companion_getInstance_56().o6r_1 : k1;
    this.n6s_1 = ratio;
    this.o6s_1 = k0;
    this.p6s_1 = k1;
  }
  q6s() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.o6s_1.l6s_1.i6s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.style.InterpolationResult.<get-properties>.<anonymous>' call
      var tmp$ret$0 = item.f6s_1;
      destination.f(tmp$ret$0);
    }
    return destination;
  }
  toString() {
    return 'InterpolationResult(ratio=' + this.n6s_1 + ', k0=' + this.o6s_1.toString() + ', k1=' + this.p6s_1.toString() + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.n6s_1);
    result = imul(result, 31) + this.o6s_1.hashCode() | 0;
    result = imul(result, 31) + this.p6s_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterpolationResult))
      return false;
    var tmp0_other_with_cast = other instanceof InterpolationResult ? other : THROW_CCE();
    if (!equals(this.n6s_1, tmp0_other_with_cast.n6s_1))
      return false;
    if (!this.o6s_1.equals(tmp0_other_with_cast.o6s_1))
      return false;
    if (!this.p6s_1.equals(tmp0_other_with_cast.p6s_1))
      return false;
    return true;
  }
}
class Animation {
  constructor(name, duration, delay, iterationCount, direction, easing) {
    var tmp;
    if (delay === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = delay;
    }
    delay = tmp;
    iterationCount = iterationCount === VOID ? -1 : iterationCount;
    direction = direction === VOID ? true : direction;
    easing = easing === VOID ? Companion_getInstance_12().b10_1 : easing;
    this.r6s_1 = name;
    this.s6s_1 = duration;
    this.t6s_1 = delay;
    this.u6s_1 = iterationCount;
    this.v6s_1 = direction;
    this.w6s_1 = easing;
  }
  toString() {
    return 'Animation(name=' + this.r6s_1 + ', duration=' + Duration__toString_impl_8d916b(this.s6s_1) + ', delay=' + Duration__toString_impl_8d916b(this.t6s_1) + ', iterationCount=' + this.u6s_1 + ', direction=' + this.v6s_1 + ', easing=' + toString(this.w6s_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.r6s_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.s6s_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.t6s_1) | 0;
    result = imul(result, 31) + this.u6s_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6s_1) | 0;
    result = imul(result, 31) + hashCode(this.w6s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Animation))
      return false;
    var tmp0_other_with_cast = other instanceof Animation ? other : THROW_CCE();
    if (!(this.r6s_1 === tmp0_other_with_cast.r6s_1))
      return false;
    if (!equals(this.s6s_1, tmp0_other_with_cast.s6s_1))
      return false;
    if (!equals(this.t6s_1, tmp0_other_with_cast.t6s_1))
      return false;
    if (!(this.u6s_1 === tmp0_other_with_cast.u6s_1))
      return false;
    if (!(this.v6s_1 === tmp0_other_with_cast.v6s_1))
      return false;
    if (!equals(this.w6s_1, tmp0_other_with_cast.w6s_1))
      return false;
    return true;
  }
}
class KeyFrames {
  constructor(id, partialKeyFrames) {
    this.x6s_1 = id;
    this.y6s_1 = partialKeyFrames;
    var tmp = this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.y6s_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.style.KeyFrames.propertyNames.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = element.l6s_1.i6s_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.f1();
      while (tmp0_iterator_0.g1()) {
        var item = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.style.KeyFrames.propertyNames.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.f6s_1;
        destination_0.f(tmp$ret$0);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    tmp.z6s_1 = distinct(destination);
    this.a6t_1 = FastArrayList.g14();
    // Inline function 'kotlin.collections.associateWith' call
    var this_2 = this.z6s_1;
    var result = LinkedHashMap.wc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator_1 = this_2.f1();
    while (tmp0_iterator_1.g1()) {
      var element_0 = tmp0_iterator_1.h1();
      // Inline function 'korlibs.image.style.KeyFrames.<anonymous>' call
      var tmp$ret$6 = (null == null ? true : null instanceof Expression) ? null : THROW_CCE();
      result.r3(element_0, tmp$ret$6);
    }
    var currentMap = toMutableMap(result);
    var _iterator__ex2g4s = this.y6s_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var frame = _iterator__ex2g4s.h1();
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = frame.l6s_1.j6s_1.z1().f1();
      while (_iterator__ex2g4s_0.g1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.h1();
        // Inline function 'kotlin.collections.component1' call
        var key = _destruct__k2r9zo.a2();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.b2();
        // Inline function 'kotlin.collections.set' call
        currentMap.r3(key, value);
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(currentMap.j1());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = currentMap.z1().f1();
      while (tmp0_iterator_2.g1()) {
        var item_0 = tmp0_iterator_2.h1();
        // Inline function 'korlibs.image.style.KeyFrames.<anonymous>' call
        var tmp$ret$13 = new Declaration(item_0.a2(), item_0.b2());
        destination_1.f(tmp$ret$13);
      }
      this.a6t_1.f(new KeyFrame(frame.k6s_1, new Declarations(destination_1)));
    }
  }
  b6t(ratio, out) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var tmp0_iterator = this.a6t_1.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.style.KeyFrames.getAt.<anonymous>' call
        if (Ratio__compareTo_impl_z2ienc(item.k6s_1, ratio) >= 0) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    var firstFrameIndex = tmp$ret$1;
    if (firstFrameIndex >= 0) {
      var firstFrame = this.a6t_1.i1(firstFrameIndex);
      var tmp = out;
      var tmp227_subject = firstFrame.k6s_1;
      var tmp_0;
      if (equals(tmp227_subject, ratio)) {
        tmp_0 = firstFrame;
      } else {
        var tmp0_elvis_lhs = getOrNull_1(this.a6t_1, firstFrameIndex - 1 | 0);
        tmp_0 = tmp0_elvis_lhs == null ? firstFrame : tmp0_elvis_lhs;
      }
      tmp.o6s_1 = tmp_0;
      out.p6s_1 = firstFrame;
      var tmp_1 = out;
      var tmp_2;
      if (equals(out.o6s_1.k6s_1, out.p6s_1.k6s_1)) {
        tmp_2 = 0.0;
      } else {
        var easing = out.o6s_1.m6s_1;
        tmp_2 = easing.yz(Ratio__toDouble_impl_o7epze(convertRange_0(ratio, out.o6s_1.k6s_1, out.p6s_1.k6s_1, Companion_getInstance_11().f10_1, Companion_getInstance_11().i10_1)));
      }
      tmp_1.n6s_1 = tmp_2;
    } else {
      out.o6s_1 = Companion_getInstance_56().o6r_1;
      out.p6s_1 = Companion_getInstance_56().o6r_1;
      out.n6s_1 = 0.0;
    }
    return out;
  }
  c6t(ratio, out, $super) {
    out = out === VOID ? new InterpolationResult() : out;
    return $super === VOID ? this.b6t(ratio, out) : $super.b6t.call(this, new Ratio(ratio), out);
  }
  toString() {
    return 'KeyFrames(id=' + this.x6s_1.toString() + ', partialKeyFrames=' + toString(this.y6s_1) + ')';
  }
  hashCode() {
    var result = this.x6s_1.hashCode();
    result = imul(result, 31) + hashCode(this.y6s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyFrames))
      return false;
    var tmp0_other_with_cast = other instanceof KeyFrames ? other : THROW_CCE();
    if (!this.x6s_1.equals(tmp0_other_with_cast.x6s_1))
      return false;
    if (!equals(this.y6s_1, tmp0_other_with_cast.y6s_1))
      return false;
    return true;
  }
}
class Companion_40 {
  d6t(str) {
    return (new CSSReader(reader(this.e6t(Companion_instance_8.sz(str))))).g6t();
  }
  h6t(str) {
    return this.e6t(Companion_instance_8.sz(str));
  }
  e6t(ss) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.m1();
    var buffer = StringBuilder.h();
    while (ss.uy()) {
      var c = ss.kz();
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(9) || (c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13))) {
        tokenize$flush(buffer, out);
      } else if (c === _Char___init__impl__6a9atx(47)) {
        if (ss.jz() === _Char___init__impl__6a9atx(42)) {
          tokenize$flush(buffer, out);
          ss.pz();
          var prev = {_v: new Char(_Char___init__impl__6a9atx(0))};
          skipWhile(ss, CSS$Companion$tokenize$lambda(prev));
          ss.oz(1);
        } else {
          tokenize$flush(buffer, out);
          out.f(new Token(toString_1(c)));
        }
      } else if (c === _Char___init__impl__6a9atx(44) || c === _Char___init__impl__6a9atx(58) || (c === _Char___init__impl__6a9atx(59) || c === _Char___init__impl__6a9atx(40)) || (c === _Char___init__impl__6a9atx(91) || c === _Char___init__impl__6a9atx(41) || (c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(123) || c === _Char___init__impl__6a9atx(125))))) {
        tokenize$flush(buffer, out);
        out.f(new Token(toString_1(c)));
      } else if (c === _Char___init__impl__6a9atx(45)) {
        var tmp;
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(buffer) > 0) {
          tmp = !(toDoubleOrNull(buffer.toString()) == null);
        } else {
          tmp = false;
        }
        if (tmp) {
          tokenize$flush(buffer, out);
          buffer.jc(c);
        } else {
          buffer.jc(c);
        }
      } else {
        buffer.jc(c);
      }
    }
    tokenize$flush(buffer, out);
    return out;
  }
  i6t(str) {
    // Inline function 'kotlin.text.trimEnd' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.trimEnd' call
      var this_0 = isCharSequence(str) ? str : THROW_CCE();
      var inductionVariable = charSequenceLength(this_0) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'korlibs.image.style.Companion.parseNumberDropSuffix.<anonymous>' call
          var it = charSequenceGet(this_0, index);
          if (!(!(it === _Char___init__impl__6a9atx(46)) && !(_Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false))) {
            tmp$ret$1 = charSequenceSubSequence(this_0, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    var tmp$ret$2 = toString(tmp$ret$1);
    return toDoubleOrNull(tmp$ret$2);
  }
  j6t(str) {
    if (endsWith(str, 'ms')) {
      var tmp229_safe_receiver = toDoubleOrNull(removeSuffix(str, 'ms'));
      var tmp;
      if (tmp229_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'korlibs.time.milliseconds' call
        tmp = toDuration(tmp229_safe_receiver, DurationUnit_MILLISECONDS_getInstance());
      }
      return tmp;
    }
    if (endsWith(str, 's')) {
      var tmp230_safe_receiver = toDoubleOrNull(removeSuffix(str, 's'));
      var tmp_0;
      if (tmp230_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.time.seconds' call
        tmp_0 = toDuration(tmp230_safe_receiver, DurationUnit_SECONDS_getInstance());
      }
      return tmp_0;
    }
    var tmp231_safe_receiver = this.i6t(str);
    var tmp_1;
    if (tmp231_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'korlibs.time.milliseconds' call
      tmp_1 = toDuration(tmp231_safe_receiver, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp_1;
  }
  k6t(str) {
    if (endsWith(str, 'deg')) {
      var tmp232_safe_receiver = toDoubleOrNull(removeSuffix(str, 'deg'));
      return tmp232_safe_receiver == null ? null : get_degrees_0(tmp232_safe_receiver);
    }
    if (endsWith(str, 'rad')) {
      var tmp233_safe_receiver = toDoubleOrNull(removeSuffix(str, 'rad'));
      return tmp233_safe_receiver == null ? null : get_radians(tmp233_safe_receiver);
    }
    var tmp234_safe_receiver = this.i6t(str);
    return tmp234_safe_receiver == null ? null : get_degrees_0(tmp234_safe_receiver);
  }
  w6r(str) {
    if (endsWith(str, '%')) {
      var tmp235_safe_receiver = toDoubleOrNull(removeSuffix(str, '%'));
      return tmp235_safe_receiver == null ? null : tmp235_safe_receiver / 100.0;
    }
    if (endsWith(str, 'px'))
      return toDoubleOrNull(removeSuffix(str, 'px'));
    if (endsWith(str, 'pt'))
      return toDoubleOrNull(removeSuffix(str, 'pt'));
    var tmp236_safe_receiver = this.i6t(str);
    return tmp236_safe_receiver == null ? null : tmp236_safe_receiver;
  }
  v6r(tr) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var args = ArrayList.m1();
    expect(tr, '(');
    $l$loop_0: while (true) {
      if (tr.v38() === ')') {
        tr.p1v();
        break $l$loop_0;
      }
      if (tr.v38() === ',') {
        tr.p1v();
        continue $l$loop_0;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var element = tr.p1v();
      args.f(element);
    }
    return args;
  }
  l6t(str) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.h6t(str);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.style.Companion.parseTransform.<anonymous>' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.n6r_1.toLowerCase();
      destination.f(tmp$ret$2);
    }
    var tokens = destination;
    var tr = new ListReader(tokens);
    var out = Companion_getInstance_4().l2m();
    while (tr.uy()) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var id = tr.p1v().toLowerCase();
      // Inline function 'kotlin.collections.arrayListOf' call
      var args = ArrayList.m1();
      if (tr.v38() === '(') {
        // Inline function 'kotlin.collections.plusAssign' call
        var elements = this.v6r(tr);
        addAll(args, elements);
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(args, 10));
      var tmp0_iterator_0 = args.f1();
      while (tmp0_iterator_0.g1()) {
        var item_0 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.style.Companion.parseTransform.<anonymous>' call
        var tmp0_elvis_lhs = Companion_instance_50.w6r(item_0);
        var tmp$ret$8 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        destination_0.f(tmp$ret$8);
      }
      var doubleArgs = destination_0;
      switch (id) {
        case 'translate3d':
          println('Warning. CSS. translate3d not implemented');
          out = out.v2n(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1));
          break;
        case 'translatey':
          out = out.v2n(0.0, parseTransform$double(doubleArgs, 0));
          break;
        case 'translatex':
          out = out.v2n(parseTransform$double(doubleArgs, 0), 0.0);
          break;
        case 'translatez':
          println('Warning. CSS. translatez not implemented');
          out = out.v2n(0.0, 0.0);
          break;
        case 'translate':
          out = out.v2n(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1));
          break;
        case 'scale':
          out = out.m2n(parseTransform$double(doubleArgs, 0), doubleArgs.j1() >= 2 ? parseTransform$double(doubleArgs, 1) : parseTransform$double(doubleArgs, 0));
          break;
        case 'matrix':
          out = out.x2n(new Matrix(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1), parseTransform$double(doubleArgs, 2), parseTransform$double(doubleArgs, 3), parseTransform$double(doubleArgs, 4), parseTransform$double(doubleArgs, 5)));
          break;
        case 'rotate':
          if (doubleArgs.j1() >= 3)
            out = out.v2n(parseTransform$double(doubleArgs, 1), parseTransform$double(doubleArgs, 2));
          var tmp0_elvis_lhs_0 = this.k6t(args.i1(0));
          var tmp;
          var tmp_0 = tmp0_elvis_lhs_0;
          if ((tmp_0 == null ? null : new Angle(tmp_0)) == null) {
            tmp = get_degrees(0);
          } else {
            tmp = tmp0_elvis_lhs_0;
          }

          var angle = tmp;
          out = out.w2n(angle);
          if (doubleArgs.j1() >= 3)
            out = out.v2n(-parseTransform$double(doubleArgs, 1), -parseTransform$double(doubleArgs, 2));
          break;
        default:
          invalidOp('Unsupported transform ' + id + ' : ' + args.toString() + ' : ' + toString(doubleArgs) + ' (' + str + ')');
          break;
      }
    }
    return out;
  }
  m6t(str, default_0) {
    if (endsWith(str, '%')) {
      var tmp0_elvis_lhs = this.i6t(str);
      return _Ratio___init__impl__9mwvn2_0((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) / 100.0);
    }
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp;
    switch (str.toLowerCase()) {
      case 'from':
        tmp = Companion_getInstance_11().f10_1;
        break;
      case 'to':
        tmp = Companion_getInstance_11().i10_1;
        break;
      default:
        var tmp1_elvis_lhs = this.i6t(str);
        tmp = _Ratio___init__impl__9mwvn2_0(tmp1_elvis_lhs == null ? Ratio__toDouble_impl_o7epze(default_0) : tmp1_elvis_lhs);
        break;
    }
    return tmp;
  }
  q6r(str, default_0, $super) {
    default_0 = default_0 === VOID ? Companion_getInstance_11().f10_1 : default_0;
    return $super === VOID ? this.m6t(str, default_0) : $super.m6t.call(this, str, new Ratio(default_0)).e10_1;
  }
  n6t(str) {
    return Colors_getInstance().s59(str, Colors_getInstance().i4t_1);
  }
  o6t(str) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.h6t(str);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.style.Companion.parseEasing.<anonymous>' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.n6r_1.toLowerCase();
      destination.f(tmp$ret$2);
    }
    return parseEasing$parseEasing(reader(destination));
  }
  p6t(size) {
    // Inline function 'kotlin.text.filter' call
    // Inline function 'kotlin.text.filterTo' call
    var destination = StringBuilder.h();
    var inductionVariable = 0;
    var last = charSequenceLength(size);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = charSequenceGet(size, index);
        // Inline function 'korlibs.image.style.Companion.parseSizeAsDouble.<anonymous>' call
        if (!(_Char___init__impl__6a9atx(97) <= element ? element <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= element ? element <= _Char___init__impl__6a9atx(90) : false)) {
          destination.jc(element);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$2 = destination.toString();
    var tmp0_elvis_lhs = toDoubleOrNull(tmp$ret$2);
    return tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  }
  q6t(str) {
    var tokens = reader(this.h6t(str));
    var id = tokens.p1v().n6r_1;
    var tmp0_elvis_lhs = this.j6t(tokens.p1v().n6r_1);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(1, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var duration = tmp;
    return new Animation(id, duration);
  }
}
class CSS {
  static w6t(allRules, unit) {
    unit = unit === VOID ? Unit_instance : unit;
    var $this = createThis(this);
    $this.r6t_1 = allRules;
    var tmp = $this;
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = $this.r6t_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      if (element instanceof KeyFrames) {
        destination.f(element);
      }
    }
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.wc(capacity);
    var tmp0_iterator_0 = destination.f1();
    while (tmp0_iterator_0.g1()) {
      var element_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.image.style.CSS.animationsById.<anonymous>' call
      var tmp$ret$2 = element_0.x6s_1.n6r_1;
      destination_0.r3(tmp$ret$2, element_0);
    }
    tmp.s6t_1 = destination_0;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_1 = $this.r6t_1;
    var destination_1 = ArrayList.m1();
    var tmp0_iterator_1 = this_1.f1();
    while (tmp0_iterator_1.g1()) {
      var element_1 = tmp0_iterator_1.h1();
      if (element_1 instanceof RuleSet) {
        destination_1.f(element_1);
      }
    }
    tmp_0.t6t_1 = destination_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = $this.t6t_1;
    var destination_2 = ArrayList.m1();
    var tmp0_iterator_2 = this_2.f1();
    while (tmp0_iterator_2.g1()) {
      var element_2 = tmp0_iterator_2.h1();
      // Inline function 'korlibs.image.style.CSS.rulesForIds.<anonymous>' call
      var tmp_2 = element_2.s6r_1;
      if (tmp_2 instanceof IdSelector) {
        destination_2.f(element_2);
      }
    }
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_3 = LinkedHashMap.wc(capacity_0);
    var tmp0_iterator_3 = destination_2.f1();
    while (tmp0_iterator_3.g1()) {
      var element_3 = tmp0_iterator_3.h1();
      // Inline function 'korlibs.image.style.CSS.rulesForIds.<anonymous>' call
      var tmp_3 = element_3.s6r_1;
      var tmp$ret$10 = (tmp_3 instanceof IdSelector ? tmp_3 : THROW_CCE()).y6r_1;
      destination_3.r3(tmp$ret$10, element_3);
    }
    tmp_1.u6t_1 = destination_3;
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_3 = $this.t6t_1;
    var destination_4 = ArrayList.m1();
    var tmp0_iterator_4 = this_3.f1();
    while (tmp0_iterator_4.g1()) {
      var element_4 = tmp0_iterator_4.h1();
      // Inline function 'korlibs.image.style.CSS.rulesForClassNames.<anonymous>' call
      var tmp_5 = element_4.s6r_1;
      if (tmp_5 instanceof ClassSelector) {
        destination_4.f(element_4);
      }
    }
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_4, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_5 = LinkedHashMap.wc(capacity_1);
    var tmp0_iterator_5 = destination_4.f1();
    while (tmp0_iterator_5.g1()) {
      var element_5 = tmp0_iterator_5.h1();
      // Inline function 'korlibs.image.style.CSS.rulesForClassNames.<anonymous>' call
      var tmp_6 = element_5.s6r_1;
      var tmp$ret$16 = (tmp_6 instanceof ClassSelector ? tmp_6 : THROW_CCE()).a6s_1;
      destination_5.r3(tmp$ret$16, element_5);
    }
    tmp_4.v6t_1 = destination_5;
    return $this;
  }
  static x6t(cssList) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.m1();
    var tmp0_iterator = cssList.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.style.CSS.<init>.<anonymous>' call
      var list = element.r6t_1;
      addAll(destination, list);
    }
    return this.w6t(destination);
  }
  toString() {
    return 'CSS(rules = ' + this.t6t_1.j1() + ', animations = ' + this.s6t_1.j1() + ')';
  }
}
class sam$kotlin_Comparator$0_3 {
  constructor(function_0) {
    this.y6t_1 = function_0;
  }
  rj(a, b) {
    return this.y6t_1(a, b);
  }
  compare(a, b) {
    return this.rj(a, b);
  }
}
class CSSReader {
  constructor(tokens) {
    this.f6t_1 = tokens;
  }
  g6t() {
    return CSS.w6t(this.z6t());
  }
  z6t() {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.m1();
    while (this.f6t_1.uy()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var elements = this.a6u();
      addAll(out, elements);
    }
    return out;
  }
  b6u(token) {
    if (startsWith(token.n6r_1, '#'))
      return new IdSelector(token);
    if (startsWith(token.n6r_1, '.'))
      return new ClassSelector(token);
    return new UnknownSelector(token);
  }
  a6u() {
    var token = this.f6t_1.v38();
    if (startsWith(token.n6r_1, '@')) {
      this.f6t_1.p1v();
      switch (token.n6r_1) {
        case '@keyframes':
        case '@-webkit-keyframes':
          var keyframesName = this.f6t_1.p1v();
          // Inline function 'kotlin.collections.arrayListOf' call

          var sets = ArrayList.m1();
          expect(this.f6t_1, new Token('{'));
          while (!this.f6t_1.v38().equals(new Token('}'))) {
            var frame = Companion_instance_49.r6r(this.a6u());
            if (!(frame == null)) {
              // Inline function 'kotlin.collections.plusAssign' call
              addAll(sets, frame);
            }
          }

          expect(this.f6t_1, new Token('}'));
          // Inline function 'kotlin.collections.sortedBy' call

          // Inline function 'kotlin.comparisons.compareBy' call

          var tmp = CSSReader$parseRuleset$lambda;
          var tmp$ret$1 = new sam$kotlin_Comparator$0_3(tmp);
          var tmp$ret$2 = sortedWith(sets, tmp$ret$1);
          return listOf(new KeyFrames(keyframesName, tmp$ret$2));
        default:
          // Inline function 'kotlin.TODO' call

          var reason = "Unknown at rule: '" + token.toString() + "'";
          throw NotImplementedError.oe('An operation is not implemented: ' + reason);
      }
    } else {
      // Inline function 'kotlin.collections.arrayListOf' call
      var selectors = ArrayList.m1();
      $l$loop_0: while (this.f6t_1.uy()) {
        var token_0 = this.f6t_1.p1v();
        // Inline function 'kotlin.collections.plusAssign' call
        var element = this.b6u(token_0);
        selectors.f(element);
        if (this.f6t_1.v38().n6r_1 === ',') {
          this.f6t_1.w38();
          continue $l$loop_0;
        }
        if (this.f6t_1.v38().n6r_1 === '{') {
          break $l$loop_0;
        }
      }
      // Inline function 'kotlin.collections.arrayListOf' call
      var decls = ArrayList.m1();
      expect(this.f6t_1, new Token('{'));
      while (!this.f6t_1.v38().equals(new Token('}'))) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = this.c6u();
        decls.f(element_0);
      }
      expect(this.f6t_1, new Token('}'));
      var declsd = new Declarations(decls);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(selectors, 10));
      var tmp0_iterator = selectors.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.style.CSSReader.parseRuleset.<anonymous>' call
        var tmp$ret$5 = new RuleSet(item, declsd);
        destination.f(tmp$ret$5);
      }
      return destination;
    }
  }
  c6u() {
    var property = removePrefix(this.f6t_1.p1v().n6r_1, '-webkit-');
    expect(this.f6t_1, new Token(':'));
    var expression = this.d6u();
    return new Declaration(property, expression);
  }
  d6u() {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.m1();
    $l$loop_0: while (true) {
      var token = this.f6t_1.p1v();
      if (token.n6r_1 === ';') {
        break $l$loop_0;
      }
      if (token.n6r_1 === '}') {
        this.f6t_1.oz(-1);
        break $l$loop_0;
      }
      out.f(token);
    }
    return new Expression(out);
  }
}
class RatioMapping {
  constructor(name, property) {
    this.e6u_1 = name;
    this.f6u_1 = property;
  }
  g6u(element, prop, value) {
    this.f6u_1.set(element, Ratio__toDouble_impl_o7epze(Companion_instance_51.h6u(prop, value)));
  }
}
class MatrixMapping {
  constructor(name, property) {
    this.i6u_1 = name;
    this.j6u_1 = property;
  }
  g6u(element, prop, value) {
    this.j6u_1.set(element, Companion_instance_51.k6u(prop, value));
  }
}
class DomPropertyMapping {
  constructor() {
    this.v6u_1 = HashMap.c9();
  }
  w6u(name, property) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.DomPropertyMapping.add.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.v6u_1;
    var value = new RatioMapping(name, isInterface(property, KMutableProperty1) ? property : THROW_CCE());
    this_0.r3(name, value);
    return this;
  }
  x6u(name, property) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.DomPropertyMapping.add.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.v6u_1;
    var value = new MatrixMapping(name, isInterface(property, KMutableProperty1) ? property : THROW_CCE());
    this_0.r3(name, value);
    return this;
  }
}
class DomElement {
  constructor(dom, mappings, $box) {
    mappings = mappings === VOID ? null : mappings;
    boxApply(this, $box);
    this.r6u_1 = dom;
    this.s6u_1 = mappings;
    this.t6u_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.u6u_1 = LinkedHashSet.l1();
  }
  y6u(value) {
    if (!(this.t6u_1 == null)) {
      _get_listener__4cngyf(this).a6v(this, ensureNotNull(this.t6u_1));
    }
    this.t6u_1 = value;
    if (!(this.t6u_1 == null)) {
      _get_listener__4cngyf(this).b6v(this, ensureNotNull(this.t6u_1));
    }
  }
  c6v() {
    return this.u6u_1;
  }
  d6v(prop, value) {
    var tmp252_safe_receiver = this.s6u_1;
    var tmp253_safe_receiver = tmp252_safe_receiver == null ? null : tmp252_safe_receiver.v6u_1;
    var tmp254_safe_receiver = tmp253_safe_receiver == null ? null : tmp253_safe_receiver.k3(prop);
    if (tmp254_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp254_safe_receiver.g6u(this, prop, value);
    }
  }
  e6v(result) {
    var properties = result.q6s();
    var _iterator__ex2g4s = properties.f1();
    while (_iterator__ex2g4s.g1()) {
      var prop = _iterator__ex2g4s.h1();
      this.d6v(prop, result);
    }
  }
}
class DomListener {}
function removedId(element, id) {
  return this.f6v(element);
}
function addedId(element, id) {
  return this.f6v(element);
}
function updatedElement(element) {
  return Unit_instance;
}
class ComposedDomListener {
  constructor(list) {
    this.z6u_1 = list;
  }
  a6v(element, id) {
    var this_0 = this.z6u_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.image.style.ComposedDomListener.removedId.<anonymous>' call
      this_0.i1((this_0.j1() - n | 0) - 1 | 0).a6v(element, id);
      n = n + 1 | 0;
    }
    return Unit_instance;
  }
  b6v(element, id) {
    var this_0 = this.z6u_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.image.style.ComposedDomListener.addedId.<anonymous>' call
      this_0.i1((this_0.j1() - n | 0) - 1 | 0).b6v(element, id);
      n = n + 1 | 0;
    }
    return Unit_instance;
  }
  f6v(element) {
    var this_0 = this.z6u_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.image.style.ComposedDomListener.updatedElement.<anonymous>' call
      this_0.i1((this_0.j1() - n | 0) - 1 | 0).f6v(element);
      n = n + 1 | 0;
    }
    return Unit_instance;
  }
}
class Companion_41 {
  k6u(prop, value) {
    var tmp;
    if (value instanceof Matrix) {
      tmp = value;
    } else {
      if (value instanceof InterpolationResult) {
        tmp = getMatrix(value, prop);
      } else {
        if (value instanceof Expression) {
          tmp = get_matrix(value);
        } else {
          tmp = Companion_getInstance_4().i2m_1;
        }
      }
    }
    return tmp;
  }
  h6u(prop, value) {
    var tmp;
    if (!(value == null) ? typeof value === 'number' : false) {
      tmp = toRatio(value);
    } else {
      if (!(value == null) ? typeof value === 'number' : false) {
        tmp = toRatio_0(value);
      } else {
        if (value instanceof InterpolationResult) {
          tmp = getRatio(value, prop);
        } else {
          if (value instanceof Expression) {
            tmp = get_ratio(value);
          } else {
            tmp = Companion_getInstance_11().f10_1;
          }
        }
      }
    }
    return tmp;
  }
}
class DOM$internalListener$1 {
  constructor(this$0) {
    this.g6v_1 = this$0;
  }
  a6v(element, id) {
    this.g6v_1.m6u_1.s3(id);
  }
  b6v(element, id) {
    // Inline function 'kotlin.collections.set' call
    this.g6v_1.m6u_1.r3(id, element);
  }
}
class DOM {
  constructor(css) {
    this.l6u_1 = css;
    this.m6u_1 = HashMap.c9();
    this.n6u_1 = HashMap.c9();
    var tmp = this;
    tmp.o6u_1 = new DOM$internalListener$1(this);
    this.p6u_1 = arrayListOf([this.o6u_1]);
    this.q6u_1 = new ComposedDomListener(this.p6u_1);
  }
}
class DOMAnimator$1 {
  constructor(this$0) {
    this.h6v_1 = this$0;
  }
  f6v(element) {
    this.h6v_1.k6v(element instanceof SvgElement ? element : THROW_CCE());
  }
}
class DOMAnimator {
  constructor(dom) {
    this.i6v_1 = dom;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.j6v_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.i6v_1.p6u_1.f(new DOMAnimator$1(this));
  }
  l6v() {
    return this.i6v_1.l6u_1;
  }
  k6v(element) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.l6v().u6t_1;
    var key = element.t6u_1;
    var tmp$ret$0 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).k3(key);
    var tmp = listOf(tmp$ret$0);
    // Inline function 'kotlin.collections.map' call
    var this_1 = element.c6v();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.style.DOMAnimator.updateElement.<anonymous>' call
      var tmp$ret$1 = this.l6v().v6t_1.k3(item);
      destination.f(tmp$ret$1);
    }
    var rules = filterNotNull(plus_0(tmp, destination));
    var _iterator__ex2g4s = rules.f1();
    while (_iterator__ex2g4s.g1()) {
      var rule = _iterator__ex2g4s.h1();
      var decls = rule.t6r_1;
      var tmp258_safe_receiver = get_animation(decls);
      if (tmp258_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $l$block: {
          // Inline function 'korlibs.image.style.DOMAnimator.updateElement.<anonymous>' call
          var tmp0_elvis_lhs = this.l6v().s6t_1.k3(tmp258_safe_receiver.r6s_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var animation = tmp_0;
          // Inline function 'korlibs.time.rem' call
          var this_2 = this.j6v_1;
          var other = tmp258_safe_receiver.s6s_1;
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var this_3 = get_milliseconds(this_2) % get_milliseconds(other);
          var tmp$ret$6 = toDuration(this_3, DurationUnit_MILLISECONDS_getInstance());
          var ratio = Duration__div_impl_dknbf4(tmp$ret$6, tmp258_safe_receiver.s6s_1);
          var results = animation.c6t(toRatio_0(ratio));
          element.e6v(results);
        }
      }
      var _iterator__ex2g4s_0 = decls.i6s_1.f1();
      while (_iterator__ex2g4s_0.g1()) {
        var decl = _iterator__ex2g4s_0.h1();
        element.d6v(decl.f6s_1, decl.g6s_1);
      }
    }
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    var tmp262_font = get_DefaultTtfFont();
    tmp.a6w_1 = new Style(tmp262_font, 16.0);
  }
}
class Line {
  static j6w(nodes, defaultLineStyle) {
    defaultLineStyle = defaultLineStyle === VOID ? null : defaultLineStyle;
    var $this = createThis(this);
    $this.m6v_1 = new Mixin();
    $this.n6v_1 = nodes;
    $this.o6v_1 = defaultLineStyle;
    var tmp = $this;
    tmp.p6v_1 = lazy(RichTextData$Line$defaultStyle$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.q6v_1 = lazy(RichTextData$Line$defaultLastStyle$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.r6v_1 = lazy(RichTextData$Line$text$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.s6v_1 = lazy(RichTextData$Line$width$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.t6v_1 = lazy(RichTextData$Line$maxLineHeight$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.u6v_1 = lazy(RichTextData$Line$maxHeight$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.v6v_1 = lazy(RichTextData$Line$allFonts$delegate$lambda($this));
    return $this;
  }
  n13(_set____db54di) {
    this.m6v_1.n13(_set____db54di);
  }
  o13() {
    return this.m6v_1.o13();
  }
  static k6w(nodes) {
    return this.j6w(toList_1(nodes));
  }
  b6w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p6v_1;
    defaultStyle$factory();
    return this_0.b2();
  }
  l6w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q6v_1;
    defaultLastStyle$factory();
    return this_0.b2();
  }
  o2f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r6v_1;
    text$factory_0();
    return this_0.b2();
  }
  j2y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s6v_1;
    width$factory_0();
    return this_0.b2();
  }
  m6w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t6v_1;
    maxLineHeight$factory();
    return this_0.b2();
  }
  n6w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u6v_1;
    maxHeight$factory();
    return this_0.b2();
  }
  o6w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v6v_1;
    allFonts$factory_0();
    return this_0.b2();
  }
  p6w() {
    var out = toDeque(this.n6v_1);
    $l$loop_2: while (true) {
      var first = firstOrNull_0(out);
      var last = lastOrNull_1(out);
      if (first instanceof TextNode) {
        if (isBlank(first.x6v_1)) {
          out.nl();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimStart' call
        var this_0 = first.x6v_1;
        var trimmed = toString(trimStart(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        if (!(trimmed === first.x6v_1)) {
          out.nl();
          out.r34(first.q6w(trimmed));
          continue $l$loop_2;
        }
      }
      if (last instanceof TextNode) {
        if (isBlank(last.x6v_1)) {
          out.pl();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimEnd' call
        var this_1 = last.x6v_1;
        var trimmed_0 = toString(trimEnd(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (!(trimmed_0 === last.x6v_1)) {
          out.pl();
          out.q34(last.q6w(trimmed_0));
          continue $l$loop_2;
        }
      }
      break $l$loop_2;
    }
    return Line.j6w(toList(out));
  }
  r6w(style) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.n6v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.text.Line.withStyle.<anonymous>' call
      var tmp$ret$0 = item.r6w(style);
      destination.f(tmp$ret$0);
    }
    return Line.j6w(destination, style);
  }
  toString() {
    return 'Line(nodes=' + toString(this.n6v_1) + ', defaultLineStyle=' + toString_0(this.o6v_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.n6v_1);
    result = imul(result, 31) + (this.o6v_1 == null ? 0 : this.o6v_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!equals(this.n6v_1, tmp0_other_with_cast.n6v_1))
      return false;
    if (!equals(this.o6v_1, tmp0_other_with_cast.o6v_1))
      return false;
    return true;
  }
}
class Node {}
function withStyle(style) {
  return this;
}
function get_lineHeight() {
  return this.k2y();
}
class Style {
  constructor(font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_60();
    textSize = textSize === VOID ? 16.0 : textSize;
    italic = italic === VOID ? false : italic;
    bold = bold === VOID ? false : bold;
    underline = underline === VOID ? false : underline;
    color = color === VOID ? null : color;
    canBreak = canBreak === VOID ? true : canBreak;
    this.c6w_1 = font;
    this.d6w_1 = textSize;
    this.e6w_1 = italic;
    this.f6w_1 = bold;
    this.g6w_1 = underline;
    this.h6w_1 = color;
    this.i6w_1 = canBreak;
  }
  s6w(text) {
    return RichTextData.a6x(text, this);
  }
  b6x(font, textSize, italic, bold, underline, color, canBreak) {
    return new Style(font, textSize, italic, bold, underline, color, canBreak);
  }
  c6x(font, textSize, italic, bold, underline, color, canBreak, $super) {
    font = font === VOID ? this.c6w_1 : font;
    textSize = textSize === VOID ? this.d6w_1 : textSize;
    italic = italic === VOID ? this.e6w_1 : italic;
    bold = bold === VOID ? this.f6w_1 : bold;
    underline = underline === VOID ? this.g6w_1 : underline;
    color = color === VOID ? this.h6w_1 : color;
    canBreak = canBreak === VOID ? this.i6w_1 : canBreak;
    var tmp;
    if ($super === VOID) {
      tmp = this.b6x(font, textSize, italic, bold, underline, color, canBreak);
    } else {
      var tmp_0 = $super.b6x;
      var tmp_1 = color;
      tmp = tmp_0.call(this, font, textSize, italic, bold, underline, tmp_1 == null ? null : new RGBA(tmp_1), canBreak);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.c6w_1);
    var tmp_0 = this.h6w_1;
    return 'Style(font=' + tmp + ', textSize=' + this.d6w_1 + ', italic=' + this.e6w_1 + ', bold=' + this.f6w_1 + ', underline=' + this.g6w_1 + ', color=' + toString_0(tmp_0 == null ? null : new RGBA(tmp_0)) + ', canBreak=' + this.i6w_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.c6w_1);
    result = imul(result, 31) + getNumberHashCode(this.d6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6w_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.h6w_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.h6w_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i6w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Style))
      return false;
    var tmp0_other_with_cast = other instanceof Style ? other : THROW_CCE();
    if (!equals(this.c6w_1, tmp0_other_with_cast.c6w_1))
      return false;
    if (!equals(this.d6w_1, tmp0_other_with_cast.d6w_1))
      return false;
    if (!(this.e6w_1 === tmp0_other_with_cast.e6w_1))
      return false;
    if (!(this.f6w_1 === tmp0_other_with_cast.f6w_1))
      return false;
    if (!(this.g6w_1 === tmp0_other_with_cast.g6w_1))
      return false;
    var tmp = this.h6w_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.h6w_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!(this.i6w_1 === tmp0_other_with_cast.i6w_1))
      return false;
    return true;
  }
}
class TextNode {
  constructor(text, style) {
    style = style === VOID ? Companion_getInstance_60().a6w_1 : style;
    this.w6v_1 = new Mixin();
    this.x6v_1 = text;
    this.y6v_1 = style;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!contains(this.x6v_1, _Char___init__impl__6a9atx(10))) {
      // Inline function 'korlibs.image.text.TextNode.<anonymous>' call
      var message = 'Single RichTextData nodes cannot have line breaks';
      throw IllegalArgumentException.l(toString(message));
    }
    var tmp = this;
    tmp.z6v_1 = lazy(RichTextData$TextNode$bounds$delegate$lambda(this));
  }
  n13(_set____db54di) {
    this.w6v_1.n13(_set____db54di);
  }
  o13() {
    return this.w6v_1.o13();
  }
  o2f() {
    return this.x6v_1;
  }
  r6w(style) {
    return new TextNode(this.x6v_1, style);
  }
  f6c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z6v_1;
    bounds$factory();
    return this_0.b2();
  }
  j2y() {
    return this.f6c().j2y();
  }
  d5l() {
    return this.f6c().d5l();
  }
  k2y() {
    return this.f6c().h5u();
  }
  d6x(text, style) {
    return new TextNode(text, style);
  }
  q6w(text, style, $super) {
    text = text === VOID ? this.x6v_1 : text;
    style = style === VOID ? this.y6v_1 : style;
    return $super === VOID ? this.d6x(text, style) : $super.d6x.call(this, text, style);
  }
  toString() {
    return 'TextNode(text=' + this.x6v_1 + ', style=' + this.y6v_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x6v_1);
    result = imul(result, 31) + this.y6v_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextNode))
      return false;
    var tmp0_other_with_cast = other instanceof TextNode ? other : THROW_CCE();
    if (!(this.x6v_1 === tmp0_other_with_cast.x6v_1))
      return false;
    if (!this.y6v_1.equals(tmp0_other_with_cast.y6v_1))
      return false;
    return true;
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_53 = this;
    this.e6x_1 = Regex.ni('\\W+');
  }
  f6x(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextNode) {
      tmp = _this__u8e3s4.q6w(VOID, _this__u8e3s4.y6v_1.c6x(VOID, VOID, VOID, VOID, VOID, VOID, false));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  g6x(maxLineWidth, line, addNode) {
    var chunk = RichTextData.h6x([Line.j6w(plus_0(listOf(this.f6x(addNode)), line.n6v_1))]).i6x(maxLineWidth, true);
    var nodes = first(chunk.u6w_1).n6v_1;
    return Line.j6w(plus_2(drop(nodes, 1), first(nodes)));
  }
  j6x(text) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return emptyList();
    var parts = this.h6t(text);
    if (parts.j1() === 1) {
      return splitInChunks(text, 1);
    } else {
      return parts;
    }
  }
  h6t(text) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = splitKeep(text, this.e6x_1);
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>' call
      var tmp;
      // Inline function 'kotlin.text.matches' call
      if (Companion_getInstance_61().e6x_1.oi(element)) {
        // Inline function 'kotlin.text.map' call
        // Inline function 'kotlin.text.mapTo' call
        var destination_0 = ArrayList.w(charSequenceLength(element));
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(element)) {
          var item = charSequenceGet(element, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>.<anonymous>' call
          var tmp$ret$1 = toString_1(item);
          destination_0.f(tmp$ret$1);
        }
        tmp = destination_0;
      } else {
        tmp = listOf(element);
      }
      var list = tmp;
      addAll(destination, list);
    }
    return destination;
  }
}
class RichTextData {
  static k6x(lines, defaultStyle) {
    Companion_getInstance_61();
    var tmp;
    if (defaultStyle === VOID) {
      var tmp259_safe_receiver = firstOrNull_1(lines);
      var tmp0_elvis_lhs = tmp259_safe_receiver == null ? null : tmp259_safe_receiver.b6w();
      tmp = tmp0_elvis_lhs == null ? Companion_getInstance_60().a6w_1 : tmp0_elvis_lhs;
    } else {
      tmp = defaultStyle;
    }
    defaultStyle = tmp;
    var $this = createThis(this);
    $this.t6w_1 = new Mixin();
    $this.u6w_1 = lines;
    $this.v6w_1 = defaultStyle;
    var tmp_0 = $this;
    tmp_0.w6w_1 = lazy(RichTextData$text$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.x6w_1 = lazy(RichTextData$width$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.y6w_1 = lazy(RichTextData$height$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.z6w_1 = lazy(RichTextData$allFonts$delegate$lambda($this));
    return $this;
  }
  n13(_set____db54di) {
    this.t6w_1.n13(_set____db54di);
  }
  o13() {
    return this.t6w_1.o13();
  }
  l6x(element) {
    return this.u6w_1.f3(element);
  }
  f3(element) {
    if (!(element instanceof Line))
      return false;
    return this.l6x(element instanceof Line ? element : THROW_CCE());
  }
  m6x(elements) {
    return this.u6w_1.g3(elements);
  }
  g3(elements) {
    return this.m6x(elements);
  }
  i1(index) {
    return this.u6w_1.i1(index);
  }
  n6x(element) {
    return this.u6w_1.q1(element);
  }
  q1(element) {
    if (!(element instanceof Line))
      return -1;
    return this.n6x(element instanceof Line ? element : THROW_CCE());
  }
  a1() {
    return this.u6w_1.a1();
  }
  f1() {
    return this.u6w_1.f1();
  }
  h3() {
    return this.u6w_1.h3();
  }
  p1(index) {
    return this.u6w_1.p1(index);
  }
  n1(fromIndex, toIndex) {
    return this.u6w_1.n1(fromIndex, toIndex);
  }
  j1() {
    return this.u6w_1.j1();
  }
  static h6x(lines) {
    Companion_getInstance_61();
    return this.k6x(toList_1(lines));
  }
  static a6x(text, style) {
    Companion_getInstance_61();
    // Inline function 'kotlin.collections.map' call
    var this_0 = split_0(text, ['\n']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.text.RichTextData.<init>.<anonymous>' call
      var tmp$ret$0 = Line.k6w([new TextNode(item, style)]);
      destination.f(tmp$ret$0);
    }
    return this.k6x(destination);
  }
  static o6x(text, font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_61();
    font = font === VOID ? Companion_getInstance_60().a6w_1.c6w_1 : font;
    textSize = textSize === VOID ? Companion_getInstance_60().a6w_1.d6w_1 : textSize;
    italic = italic === VOID ? Companion_getInstance_60().a6w_1.e6w_1 : italic;
    bold = bold === VOID ? Companion_getInstance_60().a6w_1.f6w_1 : bold;
    underline = underline === VOID ? Companion_getInstance_60().a6w_1.g6w_1 : underline;
    color = color === VOID ? Companion_getInstance_60().a6w_1.h6w_1 : color;
    canBreak = canBreak === VOID ? Companion_getInstance_60().a6w_1.i6w_1 : canBreak;
    return this.a6x(text, new Style(font, textSize, italic, bold, underline, color, canBreak));
  }
  o2f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w6w_1;
    text$factory();
    return this_0.b2();
  }
  j2y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x6w_1;
    width$factory();
    return this_0.b2();
  }
  k2y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y6w_1;
    height$factory();
    return this_0.b2();
  }
  o6w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z6w_1;
    allFonts$factory();
    return this_0.b2();
  }
  p6w() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.u6w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.text.RichTextData.trimSpaces.<anonymous>' call
      var tmp$ret$0 = item.p6w();
      destination.f(tmp$ret$0);
    }
    return RichTextData.k6x(destination);
  }
  p6x(maxLineWidth, maxHeight, includePartialLines, ellipsis, trimSpaces, includeFirstLineAlways) {
    var out = this;
    var removedWords = false;
    if (!(maxLineWidth === Infinity)) {
      out = out.q6x(maxLineWidth);
    }
    if (!(maxHeight === Infinity)) {
      // Inline function 'kotlin.also' call
      var this_0 = out.r6x(maxHeight, includePartialLines, includeFirstLineAlways);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.limit.<anonymous>' call
      if (!this_0.equals(out))
        removedWords = true;
      out = this_0;
    }
    var tmp;
    if (!(maxLineWidth === Infinity) && !(ellipsis == null) && removedWords) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !out.u6w_1.a1();
    } else {
      tmp = false;
    }
    if (tmp) {
      var line = last(out.u6w_1);
      var lastLine = Companion_getInstance_61().g6x(maxLineWidth, last(out.u6w_1), new TextNode(ellipsis, line.l6w()));
      out = RichTextData.k6x(plus_2(dropLast(out, 1), lastLine));
    }
    if (trimSpaces) {
      out = out.p6w();
    }
    return out;
  }
  r6x(maxHeight, includePartialLines, includeFirstLineAlways) {
    var currentHeight = 0.0;
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.m1();
    var _iterator__ex2g4s = this.u6w_1.f1();
    $l$loop: while (_iterator__ex2g4s.g1()) {
      var line = _iterator__ex2g4s.h1();
      currentHeight = currentHeight + line.m6w();
      if (currentHeight >= maxHeight) {
        if (includePartialLines || (includeFirstLineAlways && outLines.a1())) {
          // Inline function 'kotlin.collections.plusAssign' call
          outLines.f(line);
        }
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      outLines.f(line);
    }
    return RichTextData.k6x(outLines);
  }
  i6x(maxLineWidth, splitLetters) {
    var maxLineWidth_0 = coerceAtLeast_0(maxLineWidth, 0.1);
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.m1();
    var currentLineWidth = {_v: 0.0};
    // Inline function 'kotlin.collections.arrayListOf' call
    var currentLine = ArrayList.m1();
    var _iterator__ex2g4s = this.u6w_1.f1();
    done: while (_iterator__ex2g4s.g1()) {
      var line = _iterator__ex2g4s.h1();
      // Inline function 'kotlin.also' call
      var this_0 = TGenDeque.p34();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
      this_0.s34(line.n6v_1);
      var deque = this_0;
      $l$loop: while (true) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!!deque.a1()) {
          break $l$loop;
        }
        var node = deque.nl();
        var width = node.j2y();
        if (currentLineWidth._v >= maxLineWidth_0) {
          wordWrap$finishLine(currentLine, outLines, currentLineWidth);
        }
        var fullyFitsInLine = width <= maxLineWidth_0;
        var fitsInRemainingLine = currentLineWidth._v + width <= maxLineWidth_0;
        var tmp;
        if (node instanceof TextNode) {
          tmp = (node.y6v_1.i6w_1 && (!fullyFitsInLine || splitLetters));
        } else {
          tmp = false;
        }
        if (tmp) {
          var division = Companion_getInstance_61().j6x(node.x6v_1);
          if (division.j1() === 1) {
            if (!fitsInRemainingLine) {
              wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            }
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList.w(collectionSizeOrDefault(division, 10));
            var tmp0_iterator = division.f1();
            while (tmp0_iterator.g1()) {
              var item = tmp0_iterator.h1();
              // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
              var tmp$ret$4 = node.q6w(item);
              destination.f(tmp$ret$4);
            }
            deque.u34(destination);
          }
        } else {
          if (!fitsInRemainingLine) {
            wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            wordWrap$addNode(currentLine, currentLineWidth, node);
          }
        }
      }
      wordWrap$finishLine(currentLine, outLines, currentLineWidth);
    }
    return RichTextData.k6x(outLines);
  }
  q6x(maxLineWidth, splitLetters, $super) {
    splitLetters = splitLetters === VOID ? false : splitLetters;
    return $super === VOID ? this.i6x(maxLineWidth, splitLetters) : $super.i6x.call(this, maxLineWidth, splitLetters);
  }
  r6w(style) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.u6w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.text.RichTextData.withStyle.<anonymous>' call
      var tmp$ret$0 = item.r6w(style);
      destination.f(tmp$ret$0);
    }
    return RichTextData.k6x(destination);
  }
  s6w(text) {
    return RichTextData.a6x(text, this.v6w_1);
  }
  toString() {
    return 'RichTextData(lines=' + toString(this.u6w_1) + ', defaultStyle=' + this.v6w_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.u6w_1);
    result = imul(result, 31) + this.v6w_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextData))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextData ? other : THROW_CCE();
    if (!equals(this.u6w_1, tmp0_other_with_cast.u6w_1))
      return false;
    if (!this.v6w_1.equals(tmp0_other_with_cast.v6w_1))
      return false;
    return true;
  }
}
class Placement {
  constructor(text, pos, size, font, fillStyle, stroke) {
    this.t6x_1 = text;
    this.u6x_1 = pos;
    this.v6x_1 = size;
    this.w6x_1 = font;
    this.x6x_1 = fillStyle;
    this.y6x_1 = stroke;
  }
  toString() {
    return 'Placement(text=' + this.t6x_1 + ', pos=' + this.u6x_1.toString() + ', size=' + this.v6x_1 + ', font=' + toString(this.w6x_1) + ', fillStyle=' + toString_0(this.x6x_1) + ', stroke=' + toString_0(this.y6x_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.t6x_1);
    result = imul(result, 31) + this.u6x_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v6x_1) | 0;
    result = imul(result, 31) + hashCode(this.w6x_1) | 0;
    result = imul(result, 31) + (this.x6x_1 == null ? 0 : hashCode(this.x6x_1)) | 0;
    result = imul(result, 31) + (this.y6x_1 == null ? 0 : this.y6x_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Placement))
      return false;
    var tmp0_other_with_cast = other instanceof Placement ? other : THROW_CCE();
    if (!(this.t6x_1 === tmp0_other_with_cast.t6x_1))
      return false;
    if (!this.u6x_1.equals(tmp0_other_with_cast.u6x_1))
      return false;
    if (!equals(this.v6x_1, tmp0_other_with_cast.v6x_1))
      return false;
    if (!equals(this.w6x_1, tmp0_other_with_cast.w6x_1))
      return false;
    if (!equals(this.x6x_1, tmp0_other_with_cast.x6x_1))
      return false;
    if (!equals(this.y6x_1, tmp0_other_with_cast.y6x_1))
      return false;
    return true;
  }
}
class RichTextDataPlacements {
  constructor(placements) {
    placements = placements === VOID ? fastArrayListOf([]) : placements;
    this.s6x_1 = placements;
  }
  a6y(element) {
    return this.s6x_1.f3(element);
  }
  f3(element) {
    if (!(element instanceof Placement))
      return false;
    return this.a6y(element instanceof Placement ? element : THROW_CCE());
  }
  b6y(elements) {
    return this.s6x_1.g3(elements);
  }
  g3(elements) {
    return this.b6y(elements);
  }
  i1(index) {
    return this.s6x_1.i1(index);
  }
  c6y(element) {
    return this.s6x_1.q1(element);
  }
  q1(element) {
    if (!(element instanceof Placement))
      return -1;
    return this.c6y(element instanceof Placement ? element : THROW_CCE());
  }
  a1() {
    return this.s6x_1.a1();
  }
  f1() {
    return this.s6x_1.f1();
  }
  h3() {
    return this.s6x_1.h3();
  }
  p1(index) {
    return this.s6x_1.p1(index);
  }
  n1(fromIndex, toIndex) {
    return this.s6x_1.n1(fromIndex, toIndex);
  }
  j1() {
    return this.s6x_1.j1();
  }
  toString() {
    return 'RichTextDataPlacements(placements=' + this.s6x_1.toString() + ')';
  }
  hashCode() {
    return this.s6x_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextDataPlacements))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextDataPlacements ? other : THROW_CCE();
    if (!this.s6x_1.equals(tmp0_other_with_cast.s6x_1))
      return false;
    return true;
  }
}
class Companion_44 {
  constructor() {
    Companion_instance_54 = this;
    this.j6y_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.k6y_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.l6y_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.m6y_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n6y_1 = [new VerticalAlign(this.j6y_1), new VerticalAlign(this.k6y_1), new VerticalAlign(this.m6y_1), new VerticalAlign(this.l6y_1)];
    this.o6y_1 = toList_1(this.n6y_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_62();
    this.p6y_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.p6y_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.p6y_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.p6y_1, other);
  }
}
class Companion_45 {
  constructor() {
    Companion_instance_55 = this;
    this.d6y_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.e6y_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.f6y_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.g6y_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h6y_1 = [new HorizontalAlign(this.e6y_1), new HorizontalAlign(this.f6y_1), new HorizontalAlign(this.g6y_1), new HorizontalAlign(this.d6y_1)];
    this.i6y_1 = toList_1(this.h6y_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_63();
    this.q6y_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.q6y_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.q6y_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.q6y_1, other);
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_56 = this;
    this.b5s_1 = listOf_0([new HorizontalAlign(Companion_getInstance_63().e6y_1), new HorizontalAlign(Companion_getInstance_63().f6y_1), new HorizontalAlign(Companion_getInstance_63().g6y_1), new HorizontalAlign(Companion_getInstance_63().d6y_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.b5s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.q6y_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_62().j6y_1);
      destination.f(tmp$ret$0);
    }
    tmp.c5s_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.b5s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.f1();
    while (tmp0_iterator_0.g1()) {
      var item_0 = tmp0_iterator_0.h1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.q6y_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_62().m6y_1);
      destination_0.f(tmp$ret$3);
    }
    tmp_0.d5s_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.b5s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.f1();
    while (tmp0_iterator_1.g1()) {
      var item_1 = tmp0_iterator_1.h1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.q6y_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_62().k6y_1);
      destination_1.f(tmp$ret$6);
    }
    tmp_1.e5s_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.b5s_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.f1();
    while (tmp0_iterator_2.g1()) {
      var item_2 = tmp0_iterator_2.h1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.q6y_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_62().l6y_1);
      destination_2.f(tmp$ret$9);
    }
    tmp_2.f5s_1 = destination_2;
    this.g5s_1 = plus_0(plus_0(plus_0(this.c5s_1, this.d5s_1), this.e5s_1), this.f5s_1);
    this.h5s_1 = this.c5s_1.i1(0);
    this.i5s_1 = this.c5s_1.i1(1);
    this.j5s_1 = this.c5s_1.i1(2);
    this.k5s_1 = this.c5s_1.i1(3);
    this.l5s_1 = this.d5s_1.i1(0);
    this.m5s_1 = this.d5s_1.i1(1);
    this.n5s_1 = this.d5s_1.i1(2);
    this.o5s_1 = this.d5s_1.i1(3);
    this.p5s_1 = this.c5s_1.i1(0);
    this.q5s_1 = this.c5s_1.i1(1);
    this.r5s_1 = this.c5s_1.i1(2);
    this.s5s_1 = this.c5s_1.i1(3);
    this.t5s_1 = this.e5s_1.i1(0);
    this.u5s_1 = this.e5s_1.i1(1);
    this.v5s_1 = this.e5s_1.i1(2);
    this.w5s_1 = this.e5s_1.i1(3);
    this.x5s_1 = this.f5s_1.i1(0);
    this.y5s_1 = this.f5s_1.i1(1);
    this.z5s_1 = this.f5s_1.i1(2);
    this.a5t_1 = this.f5s_1.i1(3);
  }
  r6y(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_63().e6y_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_63().f6y_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_63().g6y_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_63().d6y_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_62().j6y_1) ? this.c5s_1.i1(horizontalIndex) : equals(vertical, Companion_getInstance_62().m6y_1) ? this.d5s_1.i1(horizontalIndex) : equals(vertical, Companion_getInstance_62().k6y_1) ? this.e5s_1.i1(horizontalIndex) : equals(vertical, Companion_getInstance_62().l6y_1) ? this.f5s_1.i1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_64();
    this.z5t_1 = horizontal;
    this.a5u_1 = vertical;
    this.b5u_1 = Anchor2D.g2h(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.z5t_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.a5u_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.a5u_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.z5t_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.z5t_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.a5u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.z5t_1, tmp0_other_with_cast.z5t_1))
      return false;
    if (!equals(this.a5u_1, tmp0_other_with_cast.a5u_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_5().y2i() : bounds;
    this.d5u_1 = maxLineHeight;
    this.e5u_1 = maxX;
    this.f5u_1 = bounds;
  }
  g5u(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.e5u_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.f5u_1, 0.0);
  }
  v5w(dx) {
    this.e5u_1 = this.e5u_1 + dx;
  }
  u6y(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.d5u_1;
    var b = fontMetrics.d5l();
    tmp.d5u_1 = Math.max(a, b);
  }
  v6y() {
  }
  z33() {
    this.e5u_1 = 0.0;
    this.f5u_1 = Companion_getInstance_5().t2i_1;
    this.d5u_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.d5u_1 + ', maxX=' + this.e5u_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.f5u_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.d5u_1);
    result = imul(result, 31) + getNumberHashCode(this.e5u_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.f5u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.d5u_1, tmp0_other_with_cast.d5u_1))
      return false;
    if (!equals(this.e5u_1, tmp0_other_with_cast.e5u_1))
      return false;
    if (!equals(this.f5u_1, tmp0_other_with_cast.f5u_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.t5t_1 = Companion_getInstance_5().y2i();
    this.u5t_1 = Companion_getInstance_5().y2i();
    this.v5t_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.w5t_1 = ArrayList.m1();
    this.x5t_1 = new LineStats();
  }
  y5t() {
    return this.v5t_1;
  }
  w6y() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.w5t_1.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.d5u_1;
    }
    return sum;
  }
  l5w(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.w5t_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.e5u_1);
  }
  c5u(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.w6y());
  }
  z33() {
    super.z33();
    this.v5t_1 = 0;
    this.u5t_1 = Companion_getInstance_5().t2i_1;
    this.t5t_1 = Companion_getInstance_5().t2i_1;
    this.x5t_1.z33();
    this.w5t_1.o3();
  }
  z5v(reader, codePoint) {
    var g = this.t5w(reader, codePoint);
    add_1(this, g.s5k_1);
    this.x5t_1.u6y(this.c5w_1);
    return g;
  }
  v5w(x) {
    super.v5w(x);
    this.x5t_1.v5w(x);
  }
  w5w(y, end) {
    super.w5w(y, end);
    this.v5t_1 = this.v5t_1 + 1 | 0;
    this.x5t_1.u6y(this.c5w_1);
    this.x5t_1.v6y();
    this.w5t_1.f(this.x5t_1);
    this.x5t_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.x6y_1 = maxTop;
    this.y6y_1 = minBottom;
    this.z6y_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.x6y_1 + ', minBottom=' + this.y6y_1 + ', maxLineHeight=' + this.z6y_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.x6y_1);
    result = imul(result, 31) + getNumberHashCode(this.y6y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z6y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.x6y_1, tmp0_other_with_cast.x6y_1))
      return false;
    if (!equals(this.y6y_1, tmp0_other_with_cast.y6y_1))
      return false;
    if (!equals(this.z6y_1, tmp0_other_with_cast.z6y_1))
      return false;
    return true;
  }
}
class Entry_2 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians_0(0) : rot;
    this.a6z_1 = tex;
    this.b6z_1 = x;
    this.c6z_1 = y;
    this.d6z_1 = sx;
    this.e6z_1 = sy;
    this.f6z_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.ic('Entry(');
    this_0.ic("'" + this.a6z_1.j41_1 + "', " + numberToInt(this.b6z_1) + ', ' + numberToInt(this.c6z_1) + ', ' + this.a6z_1.o41_1 + ', ' + this.a6z_1.p41_1);
    if (!(this.d6z_1 === 1.0)) {
      this_0.ic(', sx=' + get_niceStr_0(this.d6z_1));
    }
    if (!(this.e6z_1 === 1.0)) {
      this_0.ic(', sy=' + get_niceStr_0(this.e6z_1));
    }
    if (!equals(this.f6z_1, get_radians_0(0))) {
      this_0.ic(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.f6z_1)));
    }
    this_0.ic(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.a6z_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b6z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d6z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e6z_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.f6z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_2))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_2 ? other : THROW_CCE();
    if (!this.a6z_1.equals(tmp0_other_with_cast.a6z_1))
      return false;
    if (!equals(this.b6z_1, tmp0_other_with_cast.b6z_1))
      return false;
    if (!equals(this.c6z_1, tmp0_other_with_cast.c6z_1))
      return false;
    if (!equals(this.d6z_1, tmp0_other_with_cast.d6z_1))
      return false;
    if (!equals(this.e6z_1, tmp0_other_with_cast.e6z_1))
      return false;
    if (!equals(this.f6z_1, tmp0_other_with_cast.f6z_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.q6z_1 = Companion_getInstance_64().h5s_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r6z_1 = ArrayList.m1();
    this.s6z_1 = doubleArrayListOf(new Float64Array([]));
    this.t6z_1 = doubleArrayListOf(new Float64Array([]));
    this.u6z_1 = doubleArrayListOf(new Float64Array([]));
    this.v6z_1 = doubleArrayListOf(new Float64Array([]));
    this.w6z_1 = doubleArrayListOf(new Float64Array([]));
    this.x6z_1 = new DoubleVectorArrayList(4);
    this.y6z_1 = MatrixTransform.v2o();
  }
  z6z() {
    return this.q6z_1.a5u_1;
  }
  j1() {
    return this.s6z_1.j1();
  }
  a70() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.x6z_1;
    var inductionVariable = 0;
    var last = this_0.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.z2k(n, 0));
        while (out.j1() <= line) {
          out.f(new LineInfo());
        }
        var lineInfo = out.i1(line);
        var top = this_0.z2k(n, 1);
        var bottom = this_0.z2k(n, 2);
        var lineHeight = this_0.z2k(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.x6y_1;
        tmp.x6y_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.y6y_1;
        tmp_0.y6y_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.z6y_1;
        tmp_1.z6y_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  b70(n) {
    return n >= this.j1() ? Companion_getInstance_2().u2i_1 : Companion_getInstance_2().g2t(this.s6z_1.i1(n), this.t6z_1.i1(n), this.s6z_1.i1(n) + this.r6z_1.i1(n).o41_1 * this.u6z_1.i1(n), this.t6z_1.i1(n) + this.r6z_1.i1(n).p41_1 * this.v6z_1.i1(n));
  }
  v3u() {
    if (this.j1() === 0) {
      return Companion_getInstance_2().u2i_1;
    }
    var bb = Companion_getInstance_5().y2i();
    var inductionVariable = 0;
    var last = this.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.b70(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  c70(n, out) {
    out.a6z_1 = this.r6z_1.i1(n);
    out.b6z_1 = this.s6z_1.i1(n);
    out.c6z_1 = this.t6z_1.i1(n);
    out.d6z_1 = this.u6z_1.i1(n);
    out.e6z_1 = this.v6z_1.i1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_6();
    var ratio = this.w6z_1.i1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.f6z_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  d70() {
    this.s5w(Companion_getInstance_1().a2i_1);
    this.r6z_1.o3();
    this.s6z_1.o3();
    this.t6z_1.o3();
    this.u6z_1.o3();
    this.v6z_1.o3();
    this.w6z_1.o3();
    this.x6z_1.o3();
    this.q5w(0);
  }
  z5v(reader, codePoint) {
    var tmp = this.p5w();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.ny_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.t5w(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.ny_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.i1(codePoint);
    var x = g.g5k_1;
    var tmp_0 = g.h5k_1;
    var tmp294_subject = this.z6z();
    var y = tmp_0 - (equals(tmp294_subject, Companion_getInstance_62().m6y_1) ? bf.o33() : bf.d5l() * _VerticalAlign___get_ratio__impl__b3ilr8(this.z6z()));
    var fontScale = this.f5w_1 / bf.b5m();
    this.y6z_1 = get_immutable(this.n5w()).z2n();
    this.r6z_1.f(g.f5k_1);
    this.s6z_1.t2d(this.lz().i2h_1 + this.n5w().d2n(x, y) * fontScale);
    this.t6z_1.t2d(this.lz().j2h_1 + this.n5w().g2n(x, y) * fontScale);
    this.u6z_1.t2d(this.y6z_1.n2o_1 * fontScale);
    this.v6z_1.t2d(this.y6z_1.o2o_1 * fontScale);
    this.w6z_1.t2d(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.y6z_1.r2o_1)));
    this.x6z_1.j32(this.k5w(), this.c5w_1.v5k_1, this.c5w_1.z5k_1, this.c5w_1.d5l());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.e70_1 = $getVersion;
    this.f70_1 = $handler;
  }
  s6y() {
    return this.e70_1();
  }
  g70(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.z33();
    _this__u8e3s4.r5w(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.uy()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.xy());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.vy(1));
      var startPos = reader.ny_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.w5w(_this__u8e3s4.d5l(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.ny_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.t5w(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.ny_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.u5w(Companion_getInstance_4().i2m_1);
        this.f70_1(_this__u8e3s4, reader, c, g, g.t5k_1 + _this__u8e3s4.n5m(c, c1));
      }
      if (reader.ny_1 <= startPos) {
        reader.zy(1);
      }
    }
    _this__u8e3s4.w5w(_this__u8e3s4.d5l(), true);
  }
  t6y(_this__u8e3s4, text, size, defaultFont) {
    return this.g70(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.h70_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  s6y() {
    return this.h70_1.s6y();
  }
  i70(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.h70_1.t6y(_this__u8e3s4, Companion_getInstance_14().ez(text), size, defaultFont);
  }
  t6y(_this__u8e3s4, text, size, defaultFont) {
    return this.i70(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_57 = this;
    this.j70_1 = new Long(-1, -1);
    this.k70_1 = _Tile___init__impl__tdix77(new Long(0, 0));
    this.l70_1 = _Tile___init__impl__tdix77(new Long(-1, -1));
  }
  m70(raw) {
    return _Tile___init__impl__tdix77(raw);
  }
  n70(low, high) {
    return _Tile___init__impl__tdix77(fromLowHigh(Companion_getInstance_0(), low, high));
  }
  o70(tile, offsetX, offsetY, flipX, flipY, rotate) {
    return this.n70(insert_0(insert_0(insert_0(insert(0, tile, 0, 26), rotate, 29), flipY, 30), flipX, 31), insert16(insert16(0, offsetX, 0), offsetY, 16));
  }
  p70(tile, offsetX, offsetY, flipX, flipY, rotate, $super) {
    offsetX = offsetX === VOID ? 0 : offsetX;
    offsetY = offsetY === VOID ? 0 : offsetY;
    flipX = flipX === VOID ? false : flipX;
    flipY = flipY === VOID ? false : flipY;
    rotate = rotate === VOID ? false : rotate;
    return $super === VOID ? this.o70(tile, offsetX, offsetY, flipX, flipY, rotate) : $super.o70.call(this, tile, offsetX, offsetY, flipX, flipY, rotate).q70_1;
  }
}
class Companion_48 {
  r70(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale) {
    var tmp297_width = data.j2y();
    var tmp298_height = data.k2y();
    var tmp299_tileSet = tileSet == null ? Companion_getInstance_67().s70_1 : tileSet;
    var map = TileMapData.z70(tmp297_width, tmp298_height, tmp299_tileSet, VOID, repeatX, repeatY, offsetScale);
    var offsetXRange = Companion_instance_6.m10(maskOffsetX);
    var offsetYRange = Companion_instance_6.m10(maskOffsetY);
    // Inline function 'korlibs.datastructure.each' call
    var inductionVariable = 0;
    var last = data.k2y();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = data.j2y();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.tiles.Companion.invoke.<anonymous>' call
            var v = data.u2y(x, y);
            var offsetX = IntMaskRange__extractSigned_impl_s8qphq(offsetXRange, v, offsetSigned);
            var offsetY = IntMaskRange__extractSigned_impl_s8qphq(offsetYRange, v, offsetSigned);
            map.a71(x, y, Companion_getInstance_65().o70(v & maskData, offsetX, offsetY, !((v & maskFlipX) === 0), !((v & maskFlipY) === 0), !((v & maskRotate) === 0)));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    return map;
  }
  g6i(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale, $super) {
    tileSet = tileSet === VOID ? null : tileSet;
    maskData = maskData === VOID ? 268435455 : maskData;
    maskFlipX = maskFlipX === VOID ? mask(1, 31) : maskFlipX;
    maskFlipY = maskFlipY === VOID ? mask(1, 30) : maskFlipY;
    maskRotate = maskRotate === VOID ? mask(1, 29) : maskRotate;
    maskOffsetX = maskOffsetX === VOID ? 0 : maskOffsetX;
    maskOffsetY = maskOffsetY === VOID ? 0 : maskOffsetY;
    offsetSigned = offsetSigned === VOID ? true : offsetSigned;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    return $super === VOID ? this.r70(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale) : $super.r70.call(this, data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale);
  }
}
class TileMapData extends BaseDelegatedStackedArray2 {
  static b71(data, tileSet, repeatX, repeatY, offsetScale) {
    tileSet = tileSet === VOID ? Companion_getInstance_67().s70_1 : tileSet;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    var $this = this.b3b(data);
    $this.u70_1 = data;
    $this.v70_1 = tileSet;
    $this.w70_1 = repeatX;
    $this.x70_1 = repeatY;
    $this.y70_1 = offsetScale;
    return $this;
  }
  static z70(width, height, tileSet, empty, repeatX, repeatY, offsetScale) {
    tileSet = tileSet === VOID ? Companion_getInstance_67().s70_1 : tileSet;
    empty = empty === VOID ? Tile(0) : empty;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    return this.b71(new StackedLongArray2(width, height, _Tile___get_raw__impl__kp6cq8(empty)), tileSet, repeatX, repeatY, offsetScale);
  }
  a71(x, y, data) {
    return this.c71(x, y, data);
  }
  d71(x, y, level, data) {
    if (this.v2y(x, y)) {
      this.u70_1.f3b(x, y, level, _Tile___get_raw__impl__kp6cq8(data));
    }
  }
  e71(x, y, level) {
    return Companion_getInstance_65().m70(this.u70_1.h3b(x, y, level));
  }
  y3a(x, y) {
    return this.u70_1.y3a(x, y);
  }
  f71(x, y, value) {
    this.u70_1.i3b(x, y, _Tile___get_raw__impl__kp6cq8(value));
  }
  c71(x, y, value) {
    if (!this.v2y(x, y))
      return Unit_instance;
    var level = coerceAtLeast(this.y3a(x, y) - 1 | 0, 0);
    this.d71(x, y, level, value);
  }
  toString() {
    return 'TileMapData(data=' + toString(this.u70_1) + ', tileSet=' + this.v70_1.toString() + ', repeatX=' + this.w70_1.toString() + ', repeatY=' + this.x70_1.toString() + ', offsetScale=' + this.y70_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u70_1);
    result = imul(result, 31) + hashCode(this.v70_1) | 0;
    result = imul(result, 31) + this.w70_1.hashCode() | 0;
    result = imul(result, 31) + this.x70_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.y70_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileMapData))
      return false;
    var tmp0_other_with_cast = other instanceof TileMapData ? other : THROW_CCE();
    if (!equals(this.u70_1, tmp0_other_with_cast.u70_1))
      return false;
    if (!equals(this.v70_1, tmp0_other_with_cast.v70_1))
      return false;
    if (!this.w70_1.equals(tmp0_other_with_cast.w70_1))
      return false;
    if (!this.x70_1.equals(tmp0_other_with_cast.x70_1))
      return false;
    if (!equals(this.y70_1, tmp0_other_with_cast.y70_1))
      return false;
    return true;
  }
}
class TileMapRepeat extends Enum {
  constructor(name, ordinal, get) {
    super(name, ordinal);
    this.i71_1 = get;
  }
}
class Companion_49 {
  constructor() {
    Companion_instance_59 = this;
    this.s70_1 = new TileSet(IntMap.t37());
  }
  j71(tiles, width, height) {
    var map = IntMap.t37();
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var n = 0;
    while (n < tiles.j1()) {
      // Inline function 'korlibs.image.tiles.Companion.invoke.<anonymous>' call
      var index = n;
      var value = tiles.i1(n);
      map.n37(index, value);
      n = n + 1 | 0;
    }
    return new TileSet(map, width, height);
  }
  k71(tiles, width, height, $super) {
    width = width === VOID ? first(tiles).n71_1.o41_1 : width;
    height = height === VOID ? first(tiles).n71_1.p41_1 : height;
    return $super === VOID ? this.j71(tiles, width, height) : $super.j71.call(this, tiles, width, height);
  }
  q71(base, tileWidth, tileHeight, columns, totalTiles) {
    var out = IntMap.t37();
    var rows = base.p41_1 / tileHeight | 0;
    var actualColumns = columns < 0 ? base.o41_1 / tileWidth | 0 : columns;
    var actualTotalTiles = totalTiles < 0 ? imul(rows, actualColumns) : totalTiles;
    var n = 0;
    var inductionVariable = 0;
    if (inductionVariable < rows)
      complete: do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < actualColumns)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.n37(n, new TileSetTileInfo(n + 1 | 0, base.v42(imul(x, tileWidth), imul(y, tileHeight), tileWidth, tileHeight)));
            n = n + 1 | 0;
            if (out.g37_1 >= actualTotalTiles)
              break complete;
          }
           while (inductionVariable_0 < actualColumns);
      }
       while (inductionVariable < rows);
    return new TileSet(out, tileWidth, tileHeight);
  }
  r71(base, tileWidth, tileHeight, columns, totalTiles, $super) {
    tileWidth = tileWidth === VOID ? base.o41_1 : tileWidth;
    tileHeight = tileHeight === VOID ? base.p41_1 : tileHeight;
    columns = columns === VOID ? -1 : columns;
    totalTiles = totalTiles === VOID ? -1 : totalTiles;
    return $super === VOID ? this.q71(base, tileWidth, tileHeight, columns, totalTiles) : $super.q71.call(this, base, tileWidth, tileHeight, columns, totalTiles);
  }
  s71(tilewidth, tileheight, bitmaps, border, mipmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.tiles.Companion.fromBitmaps.<anonymous>' call
      var tmp$ret$0 = slice_0(item);
      destination.f(tmp$ret$0);
    }
    return this.t71(tilewidth, tileheight, destination, border, mipmaps);
  }
  t71(tilewidth, tileheight, bmpSlices, border, mipmaps_0) {
    // Inline function 'kotlin.check' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(bmpSlices, Collection)) {
        tmp = bmpSlices.a1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = bmpSlices.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
        if (!(element.o41_1 === tilewidth && element.p41_1 === tileheight)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp$ret$0) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.m5(toString(message));
    }
    if (bmpSlices.a1())
      return new TileSet(IntMap.t37(), tilewidth, tileheight);
    var border2 = imul(border, 2);
    var btilewidth = tilewidth + border2 | 0;
    var btileheight = tileheight + border2 | 0;
    // Inline function 'kotlin.math.sqrt' call
    var x = bmpSlices.j1();
    var tmp$ret$3 = Math.sqrt(x);
    var columns = toIntCeil_0(tmp$ret$3);
    var rows = toIntCeil_0(bmpSlices.j1() / columns);
    var minWidth = imul(columns, tilewidth + border | 0) + border | 0;
    var minHeight = imul(rows, tileheight + border | 0) + border | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = get_nextPowerOfTwo(minWidth);
    var b = get_nextPowerOfTwo(minHeight);
    var potSize = Math.max(a, b);
    var tmp$ret$5;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(bmpSlices, Collection)) {
        tmp_0 = bmpSlices.a1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$5 = false;
        break $l$block_2;
      }
      var tmp0_iterator_0 = bmpSlices.f1();
      while (tmp0_iterator_0.g1()) {
        var element_0 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
        if (element_0.f41_1.v4q()) {
          tmp$ret$5 = true;
          break $l$block_2;
        }
      }
      tmp$ret$5 = false;
    }
    var premultiplied = tmp$ret$5;
    var out = mipmaps(Bitmap32.c4p(potSize, potSize, VOID, premultiplied), mipmaps_0);
    var texs = IntMap.t37();
    var inductionVariable = 0;
    var last = bmpSlices.j1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = n / columns | 0;
        var x_0 = n % columns | 0;
        var px = imul(x_0, btilewidth) + border | 0;
        var py = imul(y, btileheight) + border | 0;
        out.f50(bmpSlices.i1(n), px, py);
        var tileInfo = new TileSetTileInfo(n, sliceWithSize(out, px, py, tilewidth, tileheight, bmpSlices.i1(n).j41_1));
        texs.n37(n, tileInfo);
      }
       while (inductionVariable <= last);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < columns)
      do {
        var x_1 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var px_0 = imul(x_1, btilewidth) + border | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < border)
          do {
            var b_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            Companion_getInstance_19().u4p(out, px_0, 0, out, (px_0 - 1 | 0) - b_0 | 0, 0, 1, out.k2y());
            Companion_getInstance_19().u4p(out, (px_0 + tilewidth | 0) - 1 | 0, 0, out, (px_0 + tilewidth | 0) + b_0 | 0, 0, 1, out.k2y());
          }
           while (inductionVariable_1 < border);
      }
       while (inductionVariable_0 < columns);
    var inductionVariable_2 = 0;
    if (inductionVariable_2 < rows)
      do {
        var y_0 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var py_0 = imul(y_0, btileheight) + border | 0;
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < border)
          do {
            var b_1 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            Companion_getInstance_19().u4p(out, 0, py_0, out, 0, (py_0 - 1 | 0) - b_1 | 0, out.j2y(), 1);
            Companion_getInstance_19().u4p(out, 0, (py_0 + tileheight | 0) - 1 | 0, out, 0, (py_0 + tileheight | 0) + b_1 | 0, out.j2y(), 1);
          }
           while (inductionVariable_3 < border);
      }
       while (inductionVariable_2 < rows);
    return new TileSet(texs, tilewidth, tileheight);
  }
  u71(tilewidth, tileheight, bmpSlices, border, mipmaps, $super) {
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    return $super === VOID ? this.t71(tilewidth, tileheight, bmpSlices, border, mipmaps) : $super.t71.call(this, tilewidth, tileheight, bmpSlices, border, mipmaps);
  }
}
class TileSet {
  constructor(tilesMap, width, height) {
    Companion_getInstance_67();
    width = width === VOID ? tilesMap.g37_1 === 0 ? 0 : tilesMap.v37().n71_1.o41_1 : width;
    height = height === VOID ? tilesMap.g37_1 === 0 ? 0 : tilesMap.v37().n71_1.p41_1 : height;
    this.v71_1 = tilesMap;
    this.w71_1 = width;
    this.x71_1 = height;
    var tmp = this;
    tmp.y71_1 = lazy(TileSet$base$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.z71_1 = lazy(TileSet$hasMultipleBaseBitmaps$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.a72_1 = lazy(TileSet$infos$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.b72_1 = lazy(TileSet$textures$delegate$lambda(this));
  }
  c72() {
    return SizeInt.c2v(this.w71_1, this.x71_1);
  }
  toString() {
    return 'TileSet(size=' + this.w71_1 + 'x' + this.x71_1 + ', tiles=' + toString(toList(this.v71_1.l3())) + ')';
  }
  o33() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y71_1;
    base$factory();
    return this_0.b2();
  }
  w3u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a72_1;
    infos$factory();
    return this_0.b2();
  }
  d72() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b72_1;
    textures$factory();
    return this_0.b2();
  }
}
class TileSetTileInfo {
  constructor(id, slice, frames, collision) {
    frames = frames === VOID ? emptyList() : frames;
    collision = collision === VOID ? null : collision;
    this.l71_1 = new Mixin();
    this.m71_1 = id;
    this.n71_1 = slice;
    this.o71_1 = frames;
    this.p71_1 = collision;
  }
  n13(_set____db54di) {
    this.l71_1.n13(_set____db54di);
  }
  o13() {
    return this.l71_1.o13();
  }
  toString() {
    return 'TileSetTileInfo(id=' + this.m71_1 + ', slice=' + this.n71_1.toString() + ', frames=' + toString(this.o71_1) + ', collision=' + toString_0(this.p71_1) + ')';
  }
  hashCode() {
    var result = this.m71_1;
    result = imul(result, 31) + this.n71_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.o71_1) | 0;
    result = imul(result, 31) + (this.p71_1 == null ? 0 : hashCode(this.p71_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetTileInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TileSetTileInfo ? other : THROW_CCE();
    if (!(this.m71_1 === tmp0_other_with_cast.m71_1))
      return false;
    if (!this.n71_1.equals(tmp0_other_with_cast.n71_1))
      return false;
    if (!equals(this.o71_1, tmp0_other_with_cast.o71_1))
      return false;
    if (!equals(this.p71_1, tmp0_other_with_cast.p71_1))
      return false;
    return true;
  }
}
class SegmentHandler {
  constructor() {
    this.e72_1 = intArrayListOf(new Int32Array([]));
    this.f72_1 = intArrayListOf(new Int32Array([]));
    this.z33();
  }
  j1() {
    return this.e72_1.j1();
  }
  z33() {
    this.e72_1.o3();
    this.f72_1.o3();
  }
  x47(x0, x1) {
    var inductionVariable = 0;
    var last = this.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.e72_1.h13(n);
        var xmax = this.f72_1.h13(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.e72_1.t31(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.f72_1.t31(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.e72_1.l31(x0);
    this.f72_1.l31(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.r72_1 = $outer;
    this.g72_1 = get_DEFAULT(Companion_getInstance_68());
    this.h72_1 = NoneFiller_getInstance();
    this.i72_1 = -1;
    this.j72_1 = -1;
    this.k72_1 = new Float32Array(this.j1());
    this.l72_1 = new Int32Array(this.j1());
    this.m72_1 = Companion_instance_22.x5j(this.j1());
    this.n72_1 = Companion_instance_22.x5j(this.j1());
    this.o72_1 = new SegmentHandler();
    this.p72_1 = 0;
    this.q72_1 = 1.0;
  }
  j1() {
    return this.r72_1.u72_1.j2y();
  }
  e73() {
    return this.r72_1.u72_1.j2y() - 1 | 0;
  }
  z33() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.o72_1;
    var inductionVariable = 0;
    var last = this_0.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.e72_1.h13(n);
        var xmax = this_0.f72_1.h13(n);
        fill_0(this.k72_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.l72_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.p72_1 = 0;
    this.o72_1.z33();
  }
  f73(x0, x1, y0) {
    if (this.e73() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.e73(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.e73(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.e73());
    var i1 = coerceIn(b, 0, this.e73());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.j72_1 === y)) {
      if (y >= 0) {
        this.fd();
      }
      this.j72_1 = y;
      this.z33();
    }
    if (!(this.i72_1 === y0)) {
      this.i72_1 = y0;
      this.p72_1 = this.p72_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.o72_1.x47(i0, i1);
      this.g73(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.g73(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.g73(i1, i1m / 20);
      }
    }
  }
  g73(x, ratio) {
    var mask = 1 << this.p72_1;
    if ((this.l72_1[x] & mask) === 0) {
      this.l72_1[x] = this.l72_1[x] | mask;
      var _array__4zh2yp = this.k72_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  fd() {
    var containsUpper = this.r72_1.u72_1.k2y();
    var containsArg = this.j72_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.q72_1);
    var scale_0 = 1.0 / this.p72_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.o72_1;
    var inductionVariable = 0;
    var last = this_0.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.e72_1.h13(n);
        var xmax = this_0.f72_1.h13(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.h72_1.v6p(this.n72_1, 0, xmin, xmax, this.j72_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.k72_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.n72_1, xmin, this.k72_1, xmin, count);
        var index = this.r72_1.u72_1.z4q(0, this.j72_1) + x | 0;
        if (this.r72_1.u72_1.v4q()) {
          arraycopy(this.r72_1.u72_1.z4o_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.m72_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.r72_1.u72_1.z4o_1), index, this.m72_1, x, count);
        }
        this.g72_1.h73(this.m72_1, x, this.n72_1, x, count);
        if (this.r72_1.u72_1.v4q()) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.m72_1), x, this.r72_1.u72_1.z4o_1, index, count);
        } else {
          depremultiply(this.m72_1, x, _RgbaArray___init__impl__oib4y4(this.r72_1.u72_1.z4o_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.t73_1 = false;
    this.u73_1 = 0;
  }
  fd() {
    return Unit_instance;
  }
  w73() {
    var _unary__edvuaz = this.u73_1;
    this.u73_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  x73() {
    this.u73_1 = this.u73_1 - 1 | 0;
    if (this.u73_1 === 0) {
      this.fd();
    }
  }
  y73(state, fill, winding) {
    var rstate = state;
    if (fill && !this.a74(state.c5n_1)) {
      rstate = state.j13();
      rstate.c5n_1 = toBitmapPaint(rstate.c5n_1, state);
    }
    this.s73(rstate, fill, winding);
  }
  z73(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.y73(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.y73.call(this, state, fill, winding);
    }
    return tmp;
  }
  s73(state, fill, winding) {
    return Unit_instance;
  }
  a74(_this__u8e3s4) {
    return true;
  }
  b74(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.b2n().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.o4a(pos, size);
    } else {
      this_0.h4b(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.z73(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_4().i2m_1, size.j2v(toFloat(image.j1()))).o2n(pos))), true);
  }
  c74(image, pos, size, transform, $super) {
    size = size === VOID ? toFloat(image.j1()) : size;
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.b74(image, pos, size, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.b74.call(this, image, pos, size, transform);
    }
    return tmp;
  }
  o18() {
    this.fd();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.u72_1 = bmp;
    this.v72_1 = antialiasing;
    this.w72_1 = this.u72_1.b4p_1.z2u();
    this.x72_1 = new Rasterizer();
    this.y72_1 = new ColorFiller();
    this.z72_1 = new GradientFiller();
    this.a73_1 = new BitmapFiller();
    this.b73_1 = new ScanlineWriter(this);
    this.c73_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.d73_1 = new StrokeToFill();
  }
  j2y() {
    return this.u72_1.j2y();
  }
  k2y() {
    return this.u72_1.k2y();
  }
  s73(state, fill, winding) {
    var style = fill ? state.c5n_1 : state.b5n_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.y72_1.t6p(style.v59_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.z72_1.b6q(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.a73_1.p6q(style, state);
          } else {
            throw NotImplementedError.oe();
          }
        }
      }
    }
    var filler = tmp;
    this.b73_1.g72_1 = state.j5n_1;
    this.x72_1.z33();
    this.x72_1.i73_1 = this.t73_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.u5m_1;
    } else {
      this.c73_1.o3();
      var tmp305_$receiver = state.u5m_1;
      var tmp306_lineWidth = state.v73();
      var tmp307_joins = state.z5m_1;
      var tmp308_startCap = state.x5m_1;
      var tmp309_endCap = state.y5m_1;
      var tmp310_miterLimit = state.a5n_1;
      var tmp311_temp = this.d73_1;
      var tmp312_outFill = this.c73_1;
      var tmp313_lineDash = state.k5n_1;
      var tmp314_lineDashOffset = state.l5n_1;
      tmp_0 = strokeToFill(tmp305_$receiver, tmp306_lineWidth, tmp307_joins, tmp308_startCap, tmp309_endCap, tmp310_miterLimit, tmp313_lineDash, tmp314_lineDashOffset, tmp311_temp, tmp312_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.t5m_1 == null)) {
      this.x72_1.m73_1.c47_1 = ensureNotNull(state.t5m_1).o3y_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.t5m_1);
      var i = Vector2D.i2l();
      var l = Vector2D.i2l();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.x72_1.m73_1.u6();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.m3y_1;
      var n_0 = 0;
      while (n_0 < this_1.j1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.h13(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.n3y_1.i1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.k2h(tmp_1, this_0.n3y_1.i1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.km();
            var y = it.lm();
            this.x72_1.m73_1.f48(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.n3y_1.i1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.k2h(tmp_2, this_0.n3y_1.i1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.km();
            var y_0 = it_0.lm();
            this.x72_1.m73_1.f48(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.n3y_1.i1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.k2h(tmp_3, this_0.n3y_1.i1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.n3y_1.i1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.k2h(tmp_4, this_0.n3y_1.i1(_unary__edvuaz_7));
            var sum = Companion_getInstance_1().n2w(l, c) + Companion_getInstance_1().n2w(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.i2l()};
            var prevPos = {_v: Vector2D.i2l()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_11().f10_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_8().e3w(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_1(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_8().e3w(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.km();
                var y_1 = it_1.lm();
                this.x72_1.m73_1.f48(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.n3y_1.i1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.k2h(tmp_5, this_0.n3y_1.i1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.n3y_1.i1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.k2h(tmp_6, this_0.n3y_1.i1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.n3y_1.i1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.k2h(tmp_7, this_0.n3y_1.i1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_1().n2w(l, c0) + Companion_getInstance_1().n2w(c0, c1) + Companion_getInstance_1().n2w(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.i2l()};
            var prevPos_0 = {_v: Vector2D.i2l()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_11().f10_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_8().d3w(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_1(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_8().d3w(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.km();
                var y_2 = it_2.lm();
                this.x72_1.m73_1.f48(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.km();
            var y_3 = destruct.lm();
            this.x72_1.m73_1.f48(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.x72_1.m73_1.u6();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.x72_1.m73_1.u6();
      }
    }
    var tmp_8 = this.x72_1.l73_1;
    tmp_8.c47_1 = winding == null ? ensureNotNull(state.u5m_1).o3y_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.i2l();
    var l_0 = Vector2D.i2l();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.x72_1.l73_1.u6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.m3y_1;
    var n_4 = 0;
    while (n_4 < this_2.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.h13(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.n3y_1.i1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.k2h(tmp_9, fillPath.n3y_1.i1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.km();
          var y_4 = it_3.lm();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.x72_1.l73_1.f48(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.n3y_1.i1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.k2h(tmp_10, fillPath.n3y_1.i1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.km();
          var y_5 = it_4.lm();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.x72_1.l73_1.f48(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.n3y_1.i1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.k2h(tmp_11, fillPath.n3y_1.i1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.n3y_1.i1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.k2h(tmp_12, fillPath.n3y_1.i1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_1().n2w(l_0, c_0) + Companion_getInstance_1().n2w(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.i2l()};
          var prevPos_1 = {_v: Vector2D.i2l()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_11().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_8().e3w(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_1(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_8().e3w(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.km();
              var y_6 = it_5.lm();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.x72_1.l73_1.f48(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.n3y_1.i1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.k2h(tmp_13, fillPath.n3y_1.i1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.n3y_1.i1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.k2h(tmp_14, fillPath.n3y_1.i1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.n3y_1.i1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.k2h(tmp_15, fillPath.n3y_1.i1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_1().n2w(l_0, c0_0) + Companion_getInstance_1().n2w(c0_0, c1_0) + Companion_getInstance_1().n2w(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.i2l()};
          var prevPos_2 = {_v: Vector2D.i2l()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_11().f10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_8().d3w(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_1(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_8().d3w(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.km();
              var y_7 = it_6.lm();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.x72_1.l73_1.f48(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.km();
          var y_8 = destruct_0.lm();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.x72_1.l73_1.f48(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.x72_1.l73_1.u6();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.x72_1.l73_1.u6();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class BitmapVector extends Bitmap {
  static c75(shape, bounds, scale, rasterizerMethod, antialiasing, width, height, premultiplied, native) {
    bounds = bounds === VOID ? shape.f6c() : bounds;
    scale = scale === VOID ? 1.0 : scale;
    rasterizerMethod = rasterizerMethod === VOID ? ShapeRasterizerMethod_X4_getInstance() : rasterizerMethod;
    antialiasing = antialiasing === VOID ? true : antialiasing;
    width = width === VOID ? numberToInt(bounds.k2i_1 * scale) : width;
    height = height === VOID ? numberToInt(bounds.l2i_1 * scale) : height;
    native = native === VOID ? true : native;
    var $this = this.s4q(width, height, 32, premultiplied, null);
    $this.q74_1 = shape;
    $this.r74_1 = bounds;
    $this.s74_1 = scale;
    $this.t74_1 = rasterizerMethod;
    $this.u74_1 = antialiasing;
    $this.v74_1 = native;
    $this.w74_1 = $this.r74_1.i2i_1;
    $this.x74_1 = $this.r74_1.j2i_1;
    if (width >= 4096 || height >= 4096) {
      // Inline function 'kotlin.error' call
      var message = 'Bitmap is too big';
      throw IllegalStateException.m5(toString(message));
    }
    var tmp = $this;
    tmp.y74_1 = lazy(BitmapVector$nativeImage$delegate$lambda(width, height, $this, premultiplied));
    var tmp_0 = $this;
    tmp_0.z74_1 = lazy(BitmapVector$bmp32$delegate$lambda($this));
    return $this;
  }
  b75() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y74_1;
    nativeImage$factory();
    return this_0.b2();
  }
  w1w() {
    return this.b75().w1w();
  }
  q4q(rect) {
    return this.b75().q4q(rect);
  }
  b4r(x, y, width, height, out, offset) {
    return this.b75().b4r(x, y, width, height, out, offset);
  }
  d4r(x, y, width, height, out, offset) {
    return this.b75().d4r(x, y, width, height, out, offset);
  }
  e4r(x, y, v) {
    return this.b75().e4r(x, y, v);
  }
  c4r(x, y) {
    return this.b75().c4r(x, y);
  }
  y4w(x, y, color) {
    return this.b75().y4w(x, y, color);
  }
  z4w(x, y) {
    return this.b75().z4w(x, y);
  }
  k4x(srcX, srcY, dst, dstX, dstY, width, height) {
    return this.b75().k4x(srcX, srcY, dst, dstX, dstY, width, height);
  }
  r4x(y0, y1) {
    return this.b75().r4x(y0, y1);
  }
  t4x(x0, x1) {
    return this.b75().t4x(x0, x1);
  }
  x4x(width, height) {
    return this.b75().x4x(width, height);
  }
  o4q() {
    return _get_bmp32__jeda37(this);
  }
  j13() {
    return BitmapVector.c75(this.q74_1, this.r74_1, this.s74_1, this.t74_1, this.u74_1, this.j2y(), this.k2y(), this.v4q());
  }
  y4x(antialiasing) {
    return this.b75().z4x();
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.d75_1 = $func;
  }
  h73(dst, dstN, src, srcN, count) {
    return this.d75_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_50 {
  constructor() {
    Companion_instance_60 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_68();
    tmp.e75_1 = tmp_0.f75(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  f75(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_51 {
  i4b() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.i75_1 = op;
  }
  h73(dst, dstN, src, srcN, count) {
    this.i75_1.h73(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.l75_1 = op;
  }
  h73(dst, dstN, src, srcN, count) {
    this.l75_1.h73(dst, dstN, src, srcN, count);
  }
}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_62().m6y_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_63().e6y_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.s5m_1 = transform;
    this.t5m_1 = clip;
    this.u5m_1 = path;
    this.v5m_1 = lineScaleMode;
    this.w5m_1 = lineWidth;
    this.x5m_1 = startLineCap;
    this.y5m_1 = endLineCap;
    this.z5m_1 = lineJoin;
    this.a5n_1 = miterLimit;
    this.b5n_1 = strokeStyle;
    this.c5n_1 = fillStyle;
    this.d5n_1 = fontRegistry;
    this.e5n_1 = font;
    this.f5n_1 = fontSize;
    this.g5n_1 = verticalAlign;
    this.h5n_1 = horizontalAlign;
    this.i5n_1 = globalAlpha;
    this.j5n_1 = globalCompositeOperation;
    this.k5n_1 = lineDash;
    this.l5n_1 = lineDashOffset;
    var tmp = this;
    tmp.m5n_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  m75() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m5n_1;
    transformTransform$factory();
    return this_0.b2();
  }
  v73() {
    var tmp = this.w5m_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.m75().x2o();
    return tmp * Math.abs(this_0);
  }
  n75() {
    return Companion_getInstance_64().r6y(this.h5n_1, this.g5n_1);
  }
  w5u(value) {
    this.x5m_1 = value;
    this.y5m_1 = value;
  }
  p5u() {
    return this.x5m_1;
  }
  j13() {
    var tmp = this.s5m_1;
    var tmp318_safe_receiver = this.t5m_1;
    var tmp_0 = tmp318_safe_receiver == null ? null : tmp318_safe_receiver.j13();
    var tmp_1 = this.u5m_1.j13();
    var tmp319_safe_receiver = this.k5n_1;
    return this.o75(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp319_safe_receiver == null ? null : tmp319_safe_receiver.j13());
  }
  p75(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  o75(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.s5m_1 : transform;
    clip = clip === VOID ? this.t5m_1 : clip;
    path = path === VOID ? this.u5m_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.v5m_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.w5m_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.x5m_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.y5m_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.z5m_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.a5n_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.b5n_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.c5n_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.d5n_1 : fontRegistry;
    font = font === VOID ? this.e5n_1 : font;
    fontSize = fontSize === VOID ? this.f5n_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.g5n_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.h5n_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.i5n_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.j5n_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.k5n_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.l5n_1 : lineDashOffset;
    return $super === VOID ? this.p75(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.p75.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.s5m_1.toString() + ', clip=' + toString_0(this.t5m_1) + ', path=' + this.u5m_1.toString() + ', lineScaleMode=' + this.v5m_1.toString() + ', lineWidth=' + this.w5m_1 + ', startLineCap=' + this.x5m_1.toString() + ', endLineCap=' + this.y5m_1.toString() + ', lineJoin=' + this.z5m_1.toString() + ', miterLimit=' + this.a5n_1 + ', strokeStyle=' + toString(this.b5n_1) + ', fillStyle=' + toString(this.c5n_1) + ', fontRegistry=' + toString_0(this.d5n_1) + ', font=' + toString_0(this.e5n_1) + ', fontSize=' + this.f5n_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.g5n_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.h5n_1) + ', globalAlpha=' + this.i5n_1 + ', globalCompositeOperation=' + toString(this.j5n_1) + ', lineDash=' + toString_0(this.k5n_1) + ', lineDashOffset=' + this.l5n_1 + ')';
  }
  hashCode() {
    var result = this.s5m_1.hashCode();
    result = imul(result, 31) + (this.t5m_1 == null ? 0 : this.t5m_1.hashCode()) | 0;
    result = imul(result, 31) + this.u5m_1.hashCode() | 0;
    result = imul(result, 31) + this.v5m_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.w5m_1) | 0;
    result = imul(result, 31) + this.x5m_1.hashCode() | 0;
    result = imul(result, 31) + this.y5m_1.hashCode() | 0;
    result = imul(result, 31) + this.z5m_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.a5n_1) | 0;
    result = imul(result, 31) + hashCode(this.b5n_1) | 0;
    result = imul(result, 31) + hashCode(this.c5n_1) | 0;
    result = imul(result, 31) + (this.d5n_1 == null ? 0 : hashCode(this.d5n_1)) | 0;
    result = imul(result, 31) + (this.e5n_1 == null ? 0 : hashCode(this.e5n_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f5n_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.g5n_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.h5n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i5n_1) | 0;
    result = imul(result, 31) + hashCode(this.j5n_1) | 0;
    result = imul(result, 31) + (this.k5n_1 == null ? 0 : hashCode(this.k5n_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l5n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.s5m_1.equals(tmp0_other_with_cast.s5m_1))
      return false;
    if (!equals(this.t5m_1, tmp0_other_with_cast.t5m_1))
      return false;
    if (!this.u5m_1.equals(tmp0_other_with_cast.u5m_1))
      return false;
    if (!this.v5m_1.equals(tmp0_other_with_cast.v5m_1))
      return false;
    if (!equals(this.w5m_1, tmp0_other_with_cast.w5m_1))
      return false;
    if (!this.x5m_1.equals(tmp0_other_with_cast.x5m_1))
      return false;
    if (!this.y5m_1.equals(tmp0_other_with_cast.y5m_1))
      return false;
    if (!this.z5m_1.equals(tmp0_other_with_cast.z5m_1))
      return false;
    if (!equals(this.a5n_1, tmp0_other_with_cast.a5n_1))
      return false;
    if (!equals(this.b5n_1, tmp0_other_with_cast.b5n_1))
      return false;
    if (!equals(this.c5n_1, tmp0_other_with_cast.c5n_1))
      return false;
    if (!equals(this.d5n_1, tmp0_other_with_cast.d5n_1))
      return false;
    if (!equals(this.e5n_1, tmp0_other_with_cast.e5n_1))
      return false;
    if (!equals(this.f5n_1, tmp0_other_with_cast.f5n_1))
      return false;
    if (!equals(this.g5n_1, tmp0_other_with_cast.g5n_1))
      return false;
    if (!equals(this.h5n_1, tmp0_other_with_cast.h5n_1))
      return false;
    if (!equals(this.i5n_1, tmp0_other_with_cast.i5n_1))
      return false;
    if (!equals(this.j5n_1, tmp0_other_with_cast.j5n_1))
      return false;
    if (!equals(this.k5n_1, tmp0_other_with_cast.k5n_1))
      return false;
    if (!equals(this.l5n_1, tmp0_other_with_cast.l5n_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.a4y_1 = renderer;
    this.b4y_1 = defaultFontRegistry;
    this.c4y_1 = defaultFont;
    this.d4y_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.b4y_1, this.c4y_1);
    this.e4y_1 = _TGenStack___init__impl__yynjgt();
    this.f4y_1 = Vector2D.i2l();
    this.g4y_1 = Vector2D.i2l();
  }
  q75() {
    return this.a4y_1.j2y();
  }
  r75() {
    return this.a4y_1.k2y();
  }
  s75(state, fill, winding) {
    return this.a4y_1.y73(state, fill, winding);
  }
  t75(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.s75(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.s75.call(this, state, fill, winding);
    }
    return tmp;
  }
  u75(image, pos, size, transform) {
    return this.a4y_1.b74(image, pos, size, transform);
  }
  v75(image, pos, size, transform, $super) {
    size = size === VOID ? toFloat(image.j1()) : size;
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.u75(image, pos, size, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.u75.call(this, image, pos, size, transform);
    }
    return tmp;
  }
  w75() {
    return this.a4y_1.o18();
  }
  x75() {
    return this.a4y_1.w73();
  }
  y75() {
    return this.a4y_1.x73();
  }
  z75(state, font, fontSize, text, pos, fill) {
    if (font == null)
      null;
    else
      drawText(font, this, fontSize, text, fill ? state.c5n_1 : state.b5n_1, pos, fill);
  }
  a76(text, pos) {
    return this.z75(this.d4y_1, this.p5w(), this.b5m(), text, pos, true);
  }
  b76(text, pos) {
    return this.z75(this.d4y_1, this.p5w(), this.b5m(), text, pos, false);
  }
  j2y() {
    return this.q75();
  }
  k2y() {
    return this.r75();
  }
  o18() {
    this.w75();
  }
  c76() {
    return this.x75();
  }
  d76() {
    return this.y75();
  }
  e76(value) {
    this.d4y_1.v5m_1 = value;
  }
  v5u(value) {
    this.d4y_1.w5m_1 = value;
  }
  o5u() {
    return this.d4y_1.w5m_1;
  }
  w5u(value) {
    this.d4y_1.w5u(value);
  }
  p5u() {
    return this.d4y_1.p5u();
  }
  y5u(value) {
    this.d4y_1.a5n_1 = value;
  }
  r5u() {
    return this.d4y_1.a5n_1;
  }
  f76(value) {
    this.d4y_1.x5m_1 = value;
  }
  g76(value) {
    this.d4y_1.y5m_1 = value;
  }
  x5u(value) {
    this.d4y_1.z5m_1 = value;
  }
  q5u() {
    return this.d4y_1.z5m_1;
  }
  h76(value) {
    this.d4y_1.b5n_1 = value;
  }
  i76() {
    return this.d4y_1.b5n_1;
  }
  p5n(value) {
    this.d4y_1.c5n_1 = value;
  }
  o5n() {
    return this.d4y_1.c5n_1;
  }
  j76() {
    return this.d4y_1.d5n_1;
  }
  k76(value) {
    this.d4y_1.e5n_1 = value;
  }
  p5w() {
    return this.d4y_1.e5n_1;
  }
  l76(value) {
    this.d4y_1.f5n_1 = value;
  }
  b5m() {
    return this.d4y_1.f5n_1;
  }
  m76(value) {
    this.d4y_1.g5n_1 = value;
  }
  z6z() {
    return this.d4y_1.g5n_1;
  }
  n76(value) {
    this.d4y_1.h5n_1 = value;
  }
  o76() {
    return this.d4y_1.h5n_1;
  }
  p76(value) {
    this.n76(value.z5t_1);
    this.m76(value.a5u_1);
  }
  n75() {
    return Companion_getInstance_64().r6y(this.o76(), this.z6z());
  }
  q76(value) {
    this.d4y_1.i5n_1 = value;
  }
  r76() {
    return this.d4y_1.i5n_1;
  }
  z5u(value) {
    this.d4y_1.k5n_1 = value;
  }
  s5u() {
    return this.d4y_1.k5n_1;
  }
  a5v(value) {
    this.d4y_1.l5n_1 = value;
  }
  t5u() {
    return this.d4y_1.l5n_1;
  }
  u5u() {
    TGenStack__push_impl_9yh33t(this.e4y_1, this.d4y_1.j13());
  }
  c5v() {
    this.d4y_1 = TGenStack__pop_impl_qisxa0(this.e4y_1);
  }
  o6e(sx, sy) {
    this.d4y_1.s5m_1 = this.d4y_1.s5m_1.m2n(sx, sy);
  }
  n5n(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.o6e(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.o6e.call(this, sx, sy);
    }
    return tmp;
  }
  m5w(tx, ty) {
    this.d4y_1.s5m_1 = this.d4y_1.s5m_1.v2n(tx, ty);
  }
  o5w(m) {
    this.d4y_1.s5m_1 = this.d4y_1.s5m_1.x2n(m);
  }
  s76(m) {
    this.d4y_1.s5m_1 = m;
  }
  t76(_set____db54di) {
    this.f4y_1 = _set____db54di;
  }
  u76() {
    return this.f4y_1;
  }
  v76(_set____db54di) {
    this.g4y_1 = _set____db54di;
  }
  f3y() {
    return this.g4y_1;
  }
  k4a() {
    return this.d4y_1.u5m_1.k4a();
  }
  u6() {
    this.d4y_1.u5m_1.u6();
    this.v76(this.u76());
  }
  e3y(p) {
    this.d4y_1.u5m_1.e3y(trans(this, p));
    this.v76(p);
    this.t76(p);
  }
  g3y(p) {
    this.d4y_1.u5m_1.g3y(trans(this, p));
    this.v76(p);
  }
  h3y(c, a) {
    this.d4y_1.u5m_1.h3y(trans(this, c), trans(this, a));
    this.v76(a);
  }
  j3y(c1, c2, a) {
    this.d4y_1.u5m_1.j3y(trans(this, c1), trans(this, c2), trans(this, a));
    this.v76(a);
  }
  n6e(path) {
    if (this.a1())
      this.d4y_1.u5m_1.o3y_1 = path.o3y_1;
    write_0(this, path);
  }
  g5x(d) {
    d.f5x(this);
  }
  q5n(x, y, width, height) {
    this.b5t();
    this.p4a(x, y, width, height);
    this.k5u();
  }
  b5t() {
    this.d4y_1.u5m_1 = new VectorPath();
  }
  j5u() {
    if (!equals(this.d4y_1.b5n_1, NonePaint_instance)) {
      this.t75(this.d4y_1, false);
    }
  }
  w76(winding) {
    if (!equals(this.d4y_1.c5n_1, NonePaint_instance)) {
      this.s75(this.d4y_1, true, winding);
    }
  }
  k5u(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.w76(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.w76.call(this, winding);
    }
    return tmp;
  }
  x76(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.o5n();
    this.p5n(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.w76(winding);
    }finally {
      this.p5n(oldStyle);
    }
  }
  n5u(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.x76(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.x76.call(this, paint, winding);
    }
    return tmp;
  }
  b5v(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.i76();
    this.h76(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.j5u();
    }finally {
      this.h76(oldStyle);
    }
  }
  y76() {
    this.k5u();
    this.j5u();
  }
  z76(path, winding) {
    if (!(path == null)) {
      if (this.d4y_1.t5m_1 == null) {
        this.d4y_1.t5m_1 = new VectorPath();
      }
      ensureNotNull(this.d4y_1.t5m_1).o3();
      ensureNotNull(this.d4y_1.t5m_1).o3y_1 = winding;
      ensureNotNull(this.d4y_1.t5m_1).w4b(path);
      if (path === this.d4y_1.u5m_1) {
        path.o3();
      }
    } else {
      this.d4y_1.t5m_1 = null;
    }
  }
  a77(path, winding, $super) {
    path = path === VOID ? this.d4y_1.u5m_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.z76(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.z76.call(this, path, winding);
    }
    return tmp;
  }
  a75(shape, rasterizerMethod, native) {
    switch (rasterizerMethod.v3_1) {
      case 0:
        shape.f5x(this);
        break;
      case 1:
      case 2:
      case 3:
        var scale = rasterizerMethod.d77_1;
        var oldState = this.d4y_1;
        // Inline function 'korlibs.image.bitmap.context2d' call

        // Inline function 'kotlin.math.ceil' call

        var x = this.q75() * scale;
        var tmp$ret$0 = Math.ceil(x);
        var tmp327_width = numberToInt(tmp$ret$0);
        // Inline function 'kotlin.math.ceil' call

        var x_0 = this.r75() * scale;
        var tmp$ret$1 = Math.ceil(x_0);
        var tmp328_height = numberToInt(tmp$ret$1);
        var this_0 = NativeImageOrBitmap32(tmp327_width, tmp328_height, native, false);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call

        var rect = this_0.i4p_1;
        if (true) {
          this_0.w1w();
        }

        var result;
        try {
          // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
          var ctx = this_0.y4x(false);
          try {
            // Inline function 'korlibs.image.vector.Context2d.drawShape.<anonymous>' call
            ctx.n5n(scale);
            ctx.o5w(oldState.s5m_1);
            ctx.g5x(shape);
          }finally {
            ctx.o18();
          }
        }finally {
          result = true ? this_0.q4q(rect) : 0;
        }

        var newBi = this_0;
        var renderBi;
        switch (rasterizerMethod.v3_1) {
          case 1:
            renderBi = newBi;
            break;
          case 2:
            renderBi = mipmap(newBi, 1);
            break;
          case 3:
            renderBi = mipmap(newBi, 2);
            break;
          default:
            renderBi = newBi;
            break;
        }

        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call

        var t = this.d4y_1.s5m_1;
        try {
          // Inline function 'korlibs.image.vector.Context2d.drawShape.<anonymous>' call
          this.s76(Companion_getInstance_4().i2m_1);
          this.v75(renderBi, Companion_getInstance_1().a2i_1);
        }finally {
          this.d4y_1.s5m_1 = t;
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  e77(color) {
    return color;
  }
  f77(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.o5n() : this.i76() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  z6x(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_1().a2i_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.p5w() : font;
    size = size === VOID ? this.b5m() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.n75() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.f77(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.f77.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  r5n(image, pos, size) {
    return this.u75(image, pos, size, this.d4y_1.s5m_1);
  }
  f6o(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.j1()) : size;
    var tmp;
    if ($super === VOID) {
      this.r5n(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.r5n.call(this, image, pos, size);
    }
    return tmp;
  }
}
class scaled$1 {
  constructor($this_scaled, $sx, $sy) {
    this.j77_1 = $this_scaled;
    this.k77_1 = $sx;
    this.l77_1 = $sy;
    this.g77_1 = $this_scaled;
    var tmp = this;
    // Inline function 'kotlin.math.abs' call
    var x = $this_scaled.j2y() * numberToDouble($sx);
    var tmp$ret$0 = Math.abs(x);
    tmp.h77_1 = numberToInt(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'kotlin.math.abs' call
    var x_0 = $this_scaled.k2y() * numberToDouble($sy);
    var tmp$ret$1 = Math.abs(x_0);
    tmp_0.i77_1 = numberToInt(tmp$ret$1);
  }
  j2y() {
    return this.h77_1;
  }
  k2y() {
    return this.i77_1;
  }
  f5x(c) {
    c.o6e(numberToDouble(this.k77_1), numberToDouble(this.l77_1));
    this.j77_1.f5x(c);
  }
}
class Companion_52 {
  constructor() {
    Companion_instance_62 = this;
    this.m77_1 = values_6();
  }
  n77(repeat) {
    return repeat ? CycleMethod_REPEAT_getInstance() : CycleMethod_NO_CYCLE_getInstance();
  }
}
class CycleMethod extends Enum {
  j6r() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  f6r(ratio) {
    var tmp;
    switch (this.v3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod_0(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  o77(ratio) {
    return this.f6r(ratio);
  }
}
class BoundsDrawable {}
function get_width() {
  return numberToInt(this.f6c().k2i_1);
}
function get_height() {
  return numberToInt(this.f6c().l2i_1);
}
class ColorizedBeziers {
  constructor(beziers) {
    this.p77_1 = beziers;
    var tmp = this;
    tmp.q77_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r77_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.s77_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.t77_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.u77_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.v77_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.w77_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  h78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q77_1;
    red$factory();
    return this_0.b2();
  }
  i78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r77_1;
    green$factory();
    return this_0.b2();
  }
  j78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s77_1;
    blue$factory();
    return this_0.b2();
  }
  x77() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t77_1;
    allProjected$factory();
    return this_0.b2();
  }
  c78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u77_1;
    redProjected$factory();
    return this_0.b2();
  }
  d78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v77_1;
    greenProjected$factory();
    return this_0.b2();
  }
  e78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w77_1;
    blueProjected$factory();
    return this_0.b2();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.f78_1 = bezier;
    this.g78_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.f78_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.g78_1) + ')';
  }
  hashCode() {
    var result = this.f78_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.g78_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.f78_1.equals(tmp0_other_with_cast.f78_1))
      return false;
    if (!(this.g78_1 === tmp0_other_with_cast.g78_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.y77_1 = beziers;
    this.z77_1 = new ProjectedPoint();
    this.a78_1 = Companion_getInstance_9().l2m();
  }
  b78(point) {
    return Companion_getInstance_1().n2w(point, this.k3x(point));
  }
  k3x(point) {
    if (this.y77_1.a1())
      return Vector2D.k2l(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.y77_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.i1(_unary__edvuaz).v3w().s2j(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.i2l();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.y77_1;
    var n_0 = 0;
    while (n_0 < this_1.j1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.i1(_unary__edvuaz_0);
        if (it.v3w().r2j(point) > minDistSq) {
          break $l$block;
        }
        it.i3x(point, this.z77_1);
        if (this.z77_1.y3v_1 < bminDistSq) {
          bminDistSq = this.z77_1.y3v_1;
          out = this.z77_1.w3v_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.k78(path) : getPath(path);
}
function get_bounds() {
  return this.l78(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp344_safe_receiver = this.v1z();
  var tmp;
  if (tmp344_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_3(Companion_getInstance_5().y2i(), tmp344_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_2().x2i() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp346_safe_receiver = this.v1z();
  if (tmp346_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.w4b(tmp346_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.d4y_1.s5m_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.b5t();
    var tmp347_safe_receiver = this.v1z();
    if (tmp347_safe_receiver == null)
      null;
    else {
      draw_0(tmp347_safe_receiver, c);
    }
    if (!(this.t78() == null)) {
      draw_0(ensureNotNull(this.t78()), c);
      c.a77();
    }
    c.o5w(get_immutable(this.n5w()));
    this.x78(c);
  }finally {
    c.d4y_1.s5m_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.m78_1 = path;
    this.n78_1 = clip;
    this.o78_1 = paint;
    this.p78_1 = transform;
    this.q78_1 = globalAlpha;
    var tmp = this;
    tmp.r78_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.s78_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  v1z() {
    return this.m78_1;
  }
  t78() {
    return this.n78_1;
  }
  n5w() {
    return this.p78_1;
  }
  u78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r78_1;
    pathCurvesList$factory();
    return this_0.b2();
  }
  v78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s78_1;
    clipCurvesList$factory();
    return this_0.b2();
  }
  w78() {
    return this.u78().j1() === 1 && get_isConvex(first(this.u78())) && this.v78() == null;
  }
  x78(c) {
    c.x76(this.o78_1, this.m78_1.o3y_1);
  }
  toString() {
    return 'FillShape(path=' + this.m78_1.toString() + ', clip=' + toString_0(this.n78_1) + ', paint=' + toString(this.o78_1) + ', transform=' + this.p78_1.toString() + ', globalAlpha=' + this.q78_1 + ')';
  }
  hashCode() {
    var result = this.m78_1.hashCode();
    result = imul(result, 31) + (this.n78_1 == null ? 0 : this.n78_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.o78_1) | 0;
    result = imul(result, 31) + this.p78_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.q78_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.m78_1.equals(tmp0_other_with_cast.m78_1))
      return false;
    if (!equals(this.n78_1, tmp0_other_with_cast.n78_1))
      return false;
    if (!equals(this.o78_1, tmp0_other_with_cast.o78_1))
      return false;
    if (!this.p78_1.equals(tmp0_other_with_cast.p78_1))
      return false;
    if (!equals(this.q78_1, tmp0_other_with_cast.q78_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.y78_1 = components;
  }
  l78(includeStrokes) {
    var bb = Companion_getInstance_5().y2i();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.y78_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.i1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.l78(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  f5x(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.c76();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.y78_1;
        var n = 0;
        while (n < this_0.j1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.i1(_unary__edvuaz).f5x(c);
        }
        break $l$block;
      }finally {
        c.d76();
      }
    }
    return Unit_instance;
  }
  k78(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.y78_1;
    var n = 0;
    while (n < this_0.j1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.i1(_unary__edvuaz).k78(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.y78_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.a79_1 = path;
    this.b79_1 = clip;
    this.c79_1 = paint;
    this.d79_1 = transform;
    this.e79_1 = strokeInfo;
    this.f79_1 = globalAlpha;
    this.g79_1 = thickness$factory(this.e79_1);
    this.h79_1 = scaleMode$factory(this.e79_1);
    this.i79_1 = startCap$factory(this.e79_1);
    this.j79_1 = endCap$factory(this.e79_1);
    this.k79_1 = join$factory(this.e79_1);
    this.l79_1 = miterLimit$factory(this.e79_1);
    this.m79_1 = dash$factory(this.e79_1);
    this.n79_1 = dashOffset$factory(this.e79_1);
    var tmp = this;
    tmp.o79_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  v1z() {
    return this.a79_1;
  }
  t78() {
    return this.b79_1;
  }
  n5w() {
    return this.d79_1;
  }
  l78(includeStrokes) {
    var tmp351_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_3(Companion_getInstance_5().y2i(), this.a79_1));
    var bounds = tmp351_safe_receiver == null ? null : get_mutable(tmp351_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.e79_1.n3s_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.y4e(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.j2t();
    return tmp0_elvis_lhs == null ? Companion_getInstance_2().u2i_1 : tmp0_elvis_lhs;
  }
  p79(c) {
    c.e76(this.e79_1.p3s_1);
    c.v5u(this.e79_1.n3s_1);
    c.f76(this.e79_1.q3s_1);
    c.g76(this.e79_1.r3s_1);
    c.x5u(this.e79_1.s3s_1);
    c.y5u(this.e79_1.t3s_1);
    c.z5u(this.e79_1.u3s_1);
    c.a5v(this.e79_1.v3s_1);
  }
  x78(c) {
    this.p79(c);
    c.b5v(this.c79_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.a79_1.toString() + ', clip=' + toString_0(this.b79_1) + ', paint=' + toString(this.c79_1) + ', transform=' + this.d79_1.toString() + ', strokeInfo=' + this.e79_1.toString() + ', globalAlpha=' + this.f79_1 + ')';
  }
  hashCode() {
    var result = this.a79_1.hashCode();
    result = imul(result, 31) + (this.b79_1 == null ? 0 : this.b79_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.c79_1) | 0;
    result = imul(result, 31) + this.d79_1.hashCode() | 0;
    result = imul(result, 31) + this.e79_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.f79_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.a79_1.equals(tmp0_other_with_cast.a79_1))
      return false;
    if (!equals(this.b79_1, tmp0_other_with_cast.b79_1))
      return false;
    if (!equals(this.c79_1, tmp0_other_with_cast.c79_1))
      return false;
    if (!this.d79_1.equals(tmp0_other_with_cast.d79_1))
      return false;
    if (!this.e79_1.equals(tmp0_other_with_cast.e79_1))
      return false;
    if (!equals(this.f79_1, tmp0_other_with_cast.f79_1))
      return false;
    return true;
  }
}
class TextShape {
  constructor(text, pos, font, fontSize, clip, fill, stroke, align, transform, globalAlpha) {
    align = align === VOID ? Companion_getInstance_64().h5s_1 : align;
    transform = transform === VOID ? Companion_getInstance_4().i2m_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.q79_1 = text;
    this.r79_1 = pos;
    this.s79_1 = font;
    this.t79_1 = fontSize;
    this.u79_1 = clip;
    this.v79_1 = fill;
    this.w79_1 = stroke;
    this.x79_1 = align;
    this.y79_1 = transform;
    this.z79_1 = globalAlpha;
    var tmp = this;
    tmp.a7a_1 = lazy(TextShape$primitiveShapes$delegate$lambda(this));
  }
  t78() {
    return this.u79_1;
  }
  n5w() {
    return this.y79_1;
  }
  l78(includeStrokes) {
    return Companion_getInstance_2().c2j(this.r79_1, Vector2D.k2h(this.r79_1.i2h_1 + this.t79_1 * this.q79_1.length, this.r79_1.j2h_1 + this.t79_1));
  }
  x78(c) {
    // Inline function 'korlibs.image.vector.Context2d.font' call
    var font = this.s79_1;
    var align = this.x79_1;
    var size = c.b5m();
    var oldFont = c.p5w();
    var oldFontSize = c.b5m();
    var oldAlign = c.n75();
    try {
      c.k76(font);
      c.l76(size);
      c.p76(align);
      // Inline function 'korlibs.image.vector.TextShape.drawInternal.<anonymous>' call
      if (!(this.v79_1 == null)) {
        c.a76(this.q79_1, this.r79_1);
      }
      if (!(this.w79_1 == null)) {
        c.b76(this.q79_1, this.r79_1);
      }
    }finally {
      c.k76(oldFont);
      c.l76(oldFontSize);
      c.p76(oldAlign);
    }
  }
  b7a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a7a_1;
    primitiveShapes$factory();
    return this_0.b2();
  }
}
class EmptyShape {
  l78(includeStrokes) {
    return Companion_getInstance_2().x2i();
  }
  f5x(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_73());
    var tmp = this;
    tmp.m5r_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.n5r_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.o5r_1 = ArrayList.m1();
  }
  q75() {
    return this.m5r_1;
  }
  r75() {
    return this.n5r_1;
  }
  s75(state, fill, winding) {
    if (state.u5m_1.a1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.u5m_1.j13();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.o3y_1 = winding == null ? this_0.o3y_1 : winding;
    var path = this_0;
    var tmp366_safe_receiver = state.t5m_1;
    var tmp367_safe_receiver = tmp366_safe_receiver == null ? null : tmp366_safe_receiver.j13();
    var tmp_0;
    if (tmp367_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp367_safe_receiver;
      tmp_1.o3y_1 = winding == null ? tmp367_safe_receiver.o3y_1 : winding;
      tmp_0 = tmp367_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.s5m_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.o5r_1;
      var element = new FillShape(path, clip, state.c5n_1.j13(), transform, state.i5n_1);
      this_1.f(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.o5r_1;
      var tmp_2 = state.b5n_1.j13();
      var tmp368_thickness = state.w5m_1;
      var tmp369_scaleMode = state.v5m_1;
      var tmp370_startCap = state.x5m_1;
      var tmp371_endCap = state.y5m_1;
      var tmp372_join = state.z5m_1;
      var tmp373_dash = state.k5n_1;
      var tmp374_dashOffset = state.l5n_1;
      var tmp375_miterLimit = state.a5n_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp368_thickness, true, tmp369_scaleMode, tmp370_startCap, tmp371_endCap, tmp372_join, tmp375_miterLimit, tmp373_dash, tmp374_dashOffset), state.i5n_1);
      this_2.f(element_0);
    }
  }
  z75(state, font, fontSize, text, pos, fill) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.o5r_1;
    var tmp376_safe_receiver = state.t5m_1;
    var element = new TextShape(text, pos, font, fontSize, tmp376_safe_receiver == null ? null : tmp376_safe_receiver.j13(), fill ? state.c5n_1 : null, fill ? null : state.b5n_1, state.n75(), state.s5m_1);
    this_0.f(element);
  }
  u75(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.o4a(pos, size);
    this.t75(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_4().i2m_1, size.j2v(toFloat(image.j1()))).o2n(pos))), true);
  }
  w75() {
  }
  x75() {
    return 0;
  }
  y75() {
  }
  p5r() {
    return this.o5r_1.j1() === 1 ? first(this.o5r_1) : new CompoundShape(toList(this.o5r_1));
  }
  f5x(c) {
    c.g5x(this.p5r());
  }
}
class ShapeRasterizerMethod extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.d77_1 = scale;
  }
}
class Companion_53 {
  q7a(str) {
    return (new CSSDeclarations()).i2d(str).r7a_1;
  }
}
class SvgDef {
  constructor(def) {
    this.i7b_1 = def;
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j7b_1 = this.i7b_1.y2f('id').toLowerCase();
    this.k7b_1 = this.i7b_1.s2e_1;
    this.l7b_1 = this.s7b(this.i7b_1);
    var tmp_0 = this;
    var tmp0_elvis_lhs = this.i7b_1.j1d('gradientUnits');
    tmp_0.m7b_1 = (tmp0_elvis_lhs == null ? 'objectBoundingBox' : tmp0_elvis_lhs) === 'userSpaceOnUse' ? GradientUnits_USER_SPACE_ON_USE_getInstance() : GradientUnits_OBJECT_BOUNDING_BOX_getInstance();
    var tmp_1 = this;
    var tmp379_safe_receiver = this.i7b_1.j1d('gradientTransform');
    var tmp_2;
    if (tmp379_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.format.SvgDef.gradientTransform.<anonymous>' call
      tmp_2 = Companion_instance_50.l6t(tmp379_safe_receiver);
    }
    var tmp0_elvis_lhs_0 = tmp_2;
    tmp_1.n7b_1 = tmp0_elvis_lhs_0 == null ? Companion_getInstance_4().i2m_1 : tmp0_elvis_lhs_0;
    var tmp_3 = this;
    // Inline function 'kotlin.text.lowercase' call
    var tmp0_elvis_lhs_1 = this.i7b_1.j1d('spreadMethod');
    // Inline function 'kotlin.js.asDynamic' call
    switch ((tmp0_elvis_lhs_1 == null ? 'pad' : tmp0_elvis_lhs_1).toLowerCase()) {
      case 'pad':
        tmp_3.o7b_1 = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 'repeat':
        tmp_3.o7b_1 = CycleMethod_REPEAT_getInstance();
        break;
      case 'reflect':
        tmp_3.o7b_1 = CycleMethod_REFLECT_getInstance();
        break;
      default:
        tmp_3.o7b_1 = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    var tmp_4 = this;
    var tmp_5;
    if (this.k7b_1 === 'lineargradient') {
      var x0 = this.i7b_1.u2f('x1', 0.0);
      var y0 = this.i7b_1.u2f('y1', 0.0);
      var x1 = this.i7b_1.u2f('x2', 1.0);
      var y1 = this.i7b_1.u2f('y2', 1.0);
      tmp_5 = new GradientPaint(GradientKind_LINEAR_getInstance(), x0, y0, 0.0, x1, y1, 0.0, VOID, VOID, this.o7b_1, this.n7b_1, VOID, this.m7b_1);
    } else {
      var cx = this.i7b_1.u2f('cx', 0.0);
      var cy = this.i7b_1.u2f('cy', 0.0);
      var r = this.i7b_1.u2f('r', 16.0);
      var fx = this.i7b_1.u2f('fx', cx);
      var fy = this.i7b_1.u2f('fy', cy);
      tmp_5 = new GradientPaint(GradientKind_RADIAL_getInstance(), cx, cy, 0.0, fx, fy, r, VOID, VOID, this.o7b_1, this.n7b_1, VOID, this.m7b_1);
    }
    tmp_4.p7b_1 = tmp_5;
    this.q7b_1 = this.i7b_1.g2g('xlink:href');
    var _iterator__ex2g4s = this.l7b_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.h1();
      var offset = _destruct__k2r9zo.km().e10_1;
      var color = _destruct__k2r9zo.lm().v59_1;
      this.p7b_1.b6r(offset, color);
    }
    this.r7b_1 = this.p7b_1;
  }
  s7b(xml) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.m1();
    var _iterator__ex2g4s = xml.t2f('stop').f1();
    while (_iterator__ex2g4s.g1()) {
      var stop = _iterator__ex2g4s.h1();
      var info = Companion_getInstance_72().v7b(stop);
      var offset = Companion_getInstance_11().f10_1;
      var colorStop = Companion_getInstance_72().u7b_1.q59_1;
      var alphaStop = 1.0;
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = info.z1().f1();
      while (_iterator__ex2g4s_0.g1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.h1();
        // Inline function 'kotlin.collections.component1' call
        var key = _destruct__k2r9zo.a2();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.b2();
        switch (key) {
          case 'offset':
            offset = Companion_instance_50.q6r(value);
            break;
          case 'stop-color':
            colorStop = Companion_getInstance_72().u7b_1.r59(value);
            break;
          case 'stop-opacity':
            // Inline function 'kotlin.text.toFloatOrNull' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp0_elvis_lhs = toDoubleOrNull(value);
            alphaStop = tmp0_elvis_lhs == null ? 1.0 : tmp0_elvis_lhs;
            break;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new Pair(new Ratio(offset), new RGBA(Companion_getInstance_28().o5j(_RGBA___get_rgb__impl__tijaqt(colorStop), numberToInt(_RGBA___get_ad__impl__pt5rdj(colorStop) * alphaStop * 255))));
      out.f(element);
    }
    return out;
  }
}
class Mappings {
  constructor() {
    Mappings_instance = this;
    this.w7b_1 = (new DomPropertyMapping()).x6u('transform', transform$factory()).w6u('opacity', opacity$factory());
  }
}
class SvgElement extends DomElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.g7c_1 = $outer;
    super(_get__dom__d2l6i0($outer), Mappings_getInstance().w7b_1, $box);
    this.b7c_1 = xml;
    this.y6u(this.b7c_1.j1d('id'));
    this.c7c_1 = Companion_getInstance_72().v7b(this.b7c_1);
    var tmp = this;
    var tmp385_safe_receiver = this.c7c_1.k3('transform');
    var tmp_0;
    if (tmp385_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.format.SvgElement.transform.<anonymous>' call
      tmp_0 = Companion_instance_50.l6t(tmp385_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp_0;
    tmp.d7c_1 = tmp0_elvis_lhs == null ? Companion_getInstance_4().i2m_1 : tmp0_elvis_lhs;
    var tmp_1 = this;
    var tmp386_safe_receiver = this.c7c_1.k3('opacity');
    var tmp0_elvis_lhs_0 = tmp386_safe_receiver == null ? null : toDoubleOrNull(tmp386_safe_receiver);
    tmp_1.e7c_1 = tmp0_elvis_lhs_0 == null ? 1.0 : tmp0_elvis_lhs_0;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.b7c_1.r2f();
    var destination = ArrayList.m1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.vector.format.SvgElement.children.<anonymous>' call
      var tmp0_safe_receiver = this.g7c_1.h7c(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.f(tmp0_safe_receiver);
      }
    }
    tmp_2.f7c_1 = destination;
  }
  toString() {
    return 'SvgElement(' + this.t6u_1 + ', ' + this.b7c_1.s2e_1 + ', children=' + this.f7c_1.j1() + ')';
  }
  f5x(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepApply' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.Context2d.keepApply.<anonymous>' call
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    c.u5u();
    try {
      // Inline function 'korlibs.image.vector.Context2d.keepApply.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.image.vector.format.SvgElement.draw.<anonymous>' call
      var tmp387_safe_receiver = this.d7c_1;
      if (tmp387_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        c.d4y_1.s5m_1 = c.d4y_1.s5m_1.x2n(get_immutable(tmp387_safe_receiver));
      }
      this.i7c(c);
      this.j7c(c);
      this.x78(c);
      this.k7c(c);
    }finally {
      c.c5v();
    }
  }
  j7c(c) {
    var _iterator__ex2g4s = this.f7c_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var child = _iterator__ex2g4s.h1();
      child.f5x(c);
    }
  }
  x78(c) {
  }
  k7c(c) {
    if (c.d4y_1.u5m_1.y2k()) {
      // Inline function 'korlibs.image.vector.Context2d.keep' call
      c.u5u();
      try {
        // Inline function 'korlibs.image.vector.format.SvgElement.fillStrokeInternal.<anonymous>' call
        c.p5n(getPaintWithUnits(c.o5n(), c.d4y_1.s5m_1, c.d4y_1.u5m_1));
        c.h76(getPaintWithUnits(c.i76(), c.d4y_1.s5m_1, c.d4y_1.u5m_1));
        c.y76();
      }finally {
        c.c5v();
      }
    }
  }
  l7c(_this__u8e3s4, default_0) {
    // Inline function 'kotlin.text.trim' call
    var str = toString(trim(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE()));
    var scale = endsWith(str, 'px') ? 1.0 : endsWith(str, 'pt') ? 1.0 : endsWith(str, 'em') ? 10.0 : endsWith(str, '%') ? 0.01 : 1.0;
    // Inline function 'kotlin.text.toFloatOrNull' call
    var this_0 = removeSuffix(removeSuffix(removeSuffix(removeSuffix(str, 'px'), 'pt'), 'em'), '%');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp388_safe_receiver = toDoubleOrNull(this_0);
    var tmp0_elvis_lhs = tmp388_safe_receiver == null ? null : tmp388_safe_receiver * scale;
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  i7c(c) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.c7c_1.z1().f1();
    while (_iterator__ex2g4s.g1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.h1();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.a2();
      // Inline function 'kotlin.collections.component2' call
      var it = _destruct__k2r9zo.b2();
      switch (key) {
        case 'stroke-width':
          c.v5u(this.l7c(it, 1.0));
          break;
        case 'stroke-linejoin':
          c.x5u(Companion_instance_2.g4c(it));
          break;
        case 'stroke-linecap':
          c.w5u(Companion_instance_3.g4c(it));
          break;
        case 'stroke':
          c.h76(this.m7c(c, it));
          break;
        case 'opacity':
          c.q76(c.r76() * this.e7c_1);
          break;
        case 'fill-opacity':
          c.q76(c.r76() * this.l7c(it, 1.0));
          break;
        case 'stroke-opacity':
          c.q76(c.r76() * this.l7c(it, 1.0));
          break;
        case 'fill':
          c.p5n(this.m7c(c, it));
          break;
        case 'font-size':
          c.l76(Companion_instance_50.p6t(it));
          break;
        case 'font-family':
          var tmp390_safe_receiver = c.j76();
          c.k76(tmp390_safe_receiver == null ? null : tmp390_safe_receiver.g4c(it));
          break;
        case 'text-anchor':
          // Inline function 'kotlin.text.trim' call

          // Inline function 'kotlin.text.lowercase' call

          // Inline function 'kotlin.js.asDynamic' call

          var this_0 = it.toLowerCase();
          var tmp391_subject = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
          c.n76(tmp391_subject === 'left' ? Companion_getInstance_63().e6y_1 : tmp391_subject === 'center' || tmp391_subject === 'middle' ? Companion_getInstance_63().f6y_1 : tmp391_subject === 'right' || tmp391_subject === 'end' ? Companion_getInstance_63().g6y_1 : c.o76());
          break;
        case 'alignment-baseline':
          // Inline function 'kotlin.text.trim' call

          // Inline function 'kotlin.text.lowercase' call

          // Inline function 'kotlin.js.asDynamic' call

          var this_1 = it.toLowerCase();
          var tmp392_subject = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
          c.m76(tmp392_subject === 'hanging' ? Companion_getInstance_62().j6y_1 : tmp392_subject === 'center' || tmp392_subject === 'middle' ? Companion_getInstance_62().k6y_1 : tmp392_subject === 'baseline' ? Companion_getInstance_62().m6y_1 : tmp392_subject === 'bottom' ? Companion_getInstance_62().l6y_1 : c.z6z());
          break;
        case 'fill-rule':
          break;
      }
    }
  }
  m7c(c, str2) {
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = str2.toLowerCase();
    var str = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp;
    if (startsWith(str, 'url(')) {
      var urlPattern = substringBefore(substr_0(str, 4, -1), _Char___init__impl__6a9atx(41));
      var extra = substringAfter(str, _Char___init__impl__6a9atx(41));
      var tmp_0;
      if (startsWith(urlPattern, '#')) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var idName = urlPattern.substring(1).toLowerCase();
        var def = this.g7c_1.n7c().k3(idName);
        if (def == null) {
          // Inline function 'korlibs.logger.Logger.info' call
          var this_1 = Companion_getInstance_72().t7b_1;
          var level = Level_INFO_getInstance();
          var tmp_1;
          if (this_1.u3g(level)) {
            // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
            var tmp$ret$7 = this.g7c_1.n7c();
            this_1.v3g(level, tmp$ret$7);
            tmp_1 = Unit_instance;
          }
          // Inline function 'korlibs.logger.Logger.info' call
          var this_2 = Companion_getInstance_72().t7b_1;
          var level_0 = Level_INFO_getInstance();
          var tmp_2;
          if (this_2.u3g(level_0)) {
            // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
            var tmp$ret$9 = "Can't find svg definition '" + idName + "'";
            this_2.v3g(level_0, tmp$ret$9);
            tmp_2 = Unit_instance;
          }
        }
        var tmp0_elvis_lhs = def == null ? null : def.r7b_1;
        tmp_0 = tmp0_elvis_lhs == null ? NonePaint_instance : tmp0_elvis_lhs;
      } else {
        // Inline function 'korlibs.logger.Logger.info' call
        var this_3 = Companion_getInstance_72().t7b_1;
        var level_1 = Level_INFO_getInstance();
        var tmp_3;
        if (this_3.u3g(level_1)) {
          // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
          var tmp$ret$11 = 'Unsupported ' + str;
          this_3.v3g(level_1, tmp$ret$11);
          tmp_3 = Unit_instance;
        }
        tmp_0 = NonePaint_instance;
      }
      tmp = tmp_0;
    } else if (startsWith(str, 'rgba(')) {
      // Inline function 'kotlin.collections.map' call
      var this_4 = split_0(removeSuffix(removePrefix(str, 'rgba('), ')'), [',']);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_4, 10));
      var tmp0_iterator = this_4.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$13 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
        var tmp0_elvis_lhs_0 = toDoubleOrNull(tmp$ret$13);
        var tmp$ret$14 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
        destination.f(tmp$ret$14);
      }
      var components = destination;
      tmp = new RGBA(Companion_getInstance_28().p5j(Companion_getInstance_28().a57(numberToInt(components.i1(0)), numberToInt(components.i1(1)), numberToInt(components.i1(2)), numberToInt(components.i1(3) * 255))));
    } else if (startsWith(str, 'rgb(')) {
      // Inline function 'kotlin.collections.map' call
      var this_5 = split_0(removeSuffix(removePrefix(str, 'rgb('), ')'), [',']);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
      var tmp0_iterator_0 = this_5.f1();
      while (tmp0_iterator_0.g1()) {
        var item_0 = tmp0_iterator_0.h1();
        // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$17 = toString(trim(isCharSequence(item_0) ? item_0 : THROW_CCE()));
        var tmp0_elvis_lhs_1 = toDoubleOrNull(tmp$ret$17);
        var tmp$ret$18 = tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1;
        destination_0.f(tmp$ret$18);
      }
      var components_0 = destination_0;
      tmp = new RGBA(Companion_getInstance_28().p5j(Companion_getInstance_28().a57(numberToInt(components_0.i1(0)), numberToInt(components_0.i1(1)), numberToInt(components_0.i1(2)), 255)));
    } else {
      tmp = str === 'none' ? NonePaint_instance : new RGBA(c.e77(Companion_getInstance_72().u7b_1.r59(str)));
    }
    var res = tmp;
    return res;
  }
}
class RectSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.e7d_1 = $outer;
    super($outer, xml, $box);
    this.y7c_1 = xml.v2f('x');
    this.z7c_1 = xml.v2f('y');
    this.a7d_1 = xml.v2f('width');
    this.b7d_1 = xml.v2f('height');
    this.c7d_1 = xml.u2f('ry', xml.v2f('rx'));
    this.d7d_1 = xml.u2f('rx', xml.v2f('ry'));
  }
  x78(c) {
    c.b4b(this.y7c_1, this.z7c_1, this.a7d_1, this.b7d_1, this.d7d_1, this.c7d_1);
  }
}
class CircleSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.s7d_1 = $outer;
    super($outer, xml, $box);
    this.p7d_1 = xml.v2f('cx');
    this.q7d_1 = xml.v2f('cy');
    this.r7d_1 = xml.v2f('r');
  }
  x78(c) {
    c.m3s(Vector2D.k2h(this.p7d_1, this.q7d_1), this.r7d_1);
  }
}
class EllipseSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.h7e_1 = $outer;
    super($outer, xml, $box);
    this.d7e_1 = xml.v2f('cx');
    this.e7e_1 = xml.v2f('cy');
    this.f7e_1 = xml.v2f('rx');
    this.g7e_1 = xml.v2f('ry');
  }
  x78(c) {
    c.c4b(Vector2D.k2h(this.d7e_1 - this.f7e_1, this.e7e_1 - this.g7e_1), Size2D.k2t(this.f7e_1 * 2, this.g7e_1 * 2));
  }
}
class PolySvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.v7e_1 = $outer;
    super($outer, xml, $box);
    this.s7e_1 = Companion_instance_8.sz(xml.y2f('points'));
    var tmp = this;
    // Inline function 'korlibs.datastructure.mapWhile' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.m1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapWhile.<anonymous>' call
    $l$loop: while (true) {
      // Inline function 'korlibs.image.vector.format.PolySvgElement.pps.<anonymous>' call
      this_0.j1();
      if (!this.s7e_1.uy()) {
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.image.vector.format.PolySvgElement.pps.<anonymous>' call
      this_0.j1();
      skipWhile(this.s7e_1, SVG$PolySvgElement$pps$lambda);
      // Inline function 'korlibs.util.readWhileBuilder' call
      var this_1 = this.s7e_1;
      // Inline function 'korlibs.util.readUntilBuilder' call
      var out = StringBuilder.h();
      $l$loop_0: while (this_1.uy()) {
        var c = this_1.jz();
        // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
        // Inline function 'korlibs.image.vector.format.PolySvgElement.pps.<anonymous>.<anonymous>' call
        if (!get_isNumeric(c)) {
          if (false) {
            this_1.kz();
            out.jc(c);
          }
          break $l$loop_0;
        }
        this_1.kz();
        out.jc(c);
      }
      var out_0 = toDouble(out.toString());
      skipWhile(this.s7e_1, SVG$PolySvgElement$pps$lambda_0);
      this_0.f(out_0);
    }
    tmp.t7e_1 = new ListReader(toList(this_0));
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_2 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.format.PolySvgElement.path.<anonymous>' call
    var edges = 0;
    this_2.e3y(Vector2D.k2h(this.t7e_1.p1v(), this.t7e_1.p1v()));
    while (this.t7e_1.uy()) {
      var x = this.t7e_1.p1v();
      var y = this.t7e_1.p1v();
      this_2.g3y(Vector2D.k2h(x, y));
      edges = edges + 1 | 0;
    }
    if (xml.s2e_1 === 'polygon') {
      this_2.u6();
    }
    tmp_0.u7e_1 = this_2;
  }
  x78(c) {
    c.b5t();
    c.n6e(this.u7e_1);
  }
}
class LineSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.k7f_1 = $outer;
    super($outer, xml, $box);
    this.g7f_1 = xml.v2f('x1');
    this.h7f_1 = xml.v2f('y1');
    this.i7f_1 = xml.v2f('x2');
    this.j7f_1 = xml.v2f('y2');
  }
  x78(c) {
    c.b5t();
    c.e3y(Vector2D.k2h(this.g7f_1, this.h7f_1));
    c.g3y(Vector2D.k2h(this.i7f_1, this.j7f_1));
  }
}
class TextSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.a7g_1 = $outer;
    super($outer, xml, $box);
    var tmp = this;
    // Inline function 'kotlin.text.trim' call
    var this_0 = xml.o2f();
    tmp.v7f_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    this.w7f_1 = xml.a2g('x');
    this.x7f_1 = xml.a2g('dx');
    this.y7f_1 = xml.a2g('y');
    this.z7f_1 = xml.a2g('dy');
  }
  x78(c) {
  }
  k7c(c) {
    c.a76(this.v7f_1, Vector2D.u2n(this.w7f_1 + this.x7f_1, this.y7f_1 + this.z7f_1));
  }
}
class PathSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.o7a_1 = $outer;
    super($outer, xml, $box);
    this.m7a_1 = xml.y2f('d');
    var tmp = this;
    tmp.n7a_1 = lazy(SVG$PathSvgElement$path$delegate$lambda(this));
    var tmp395_safe_receiver = this.o7a_1.t7a_1;
    if (tmp395_safe_receiver == null)
      null;
    else
      tmp395_safe_receiver("Parsed SVG Path: '" + toSvgPathString_0(this.v1z()) + "'");
    var tmp396_safe_receiver = this.o7a_1.t7a_1;
    if (tmp396_safe_receiver == null)
      null;
    else
      tmp396_safe_receiver("Original SVG Path: '" + this.m7a_1 + "'");
    var tmp397_safe_receiver = this.o7a_1.t7a_1;
    if (tmp397_safe_receiver == null)
      null;
    else
      tmp397_safe_receiver('Points: ' + toString(get_cachedPoints(this.v1z())));
  }
  v1z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n7a_1;
    path$factory();
    return this_0.b2();
  }
  x78(c) {
    c.b5t();
    write(c, this.v1z());
  }
}
class CSSDeclarations {
  constructor() {
    this.r7a_1 = LinkedHashMap.vc();
  }
  i2d(str) {
    return this.b7g(Companion_instance_8.sz(str));
  }
  b7g(_this__u8e3s4) {
    while (!get_eof(_this__u8e3s4)) {
      this.c7g(_this__u8e3s4);
    }
    return this;
  }
  c7g(_this__u8e3s4) {
    skipSpaces(_this__u8e3s4);
    var id = this.d7g(_this__u8e3s4);
    skipSpaces(_this__u8e3s4);
    skipExpect(_this__u8e3s4, _Char___init__impl__6a9atx(58));
    skipSpaces(_this__u8e3s4);
    // Inline function 'kotlin.text.trim' call
    // Inline function 'korlibs.util.readUntilBuilder' call
    var out = StringBuilder.h();
    $l$loop: while (_this__u8e3s4.uy()) {
      var c = _this__u8e3s4.jz();
      // Inline function 'korlibs.image.vector.format.CSSDeclarations.parseCssDecl.<anonymous>' call
      if (c === _Char___init__impl__6a9atx(59)) {
        if (false) {
          _this__u8e3s4.kz();
          out.jc(c);
        }
        break $l$loop;
      }
      _this__u8e3s4.kz();
      out.jc(c);
    }
    var this_0 = out.toString();
    var value = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.collections.set' call
    this.r7a_1.r3(id, value);
    if (!get_eof(_this__u8e3s4)) {
      skipExpect(_this__u8e3s4, _Char___init__impl__6a9atx(59));
    }
  }
  d7g(_this__u8e3s4) {
    // Inline function 'korlibs.util.readWhileBuilder' call
    // Inline function 'korlibs.util.readUntilBuilder' call
    var out = StringBuilder.h();
    $l$loop: while (_this__u8e3s4.uy()) {
      var c = _this__u8e3s4.jz();
      // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
      // Inline function 'korlibs.image.vector.format.CSSDeclarations.readCssId.<anonymous>' call
      if (!(isLetterOrDigit(c) || c === _Char___init__impl__6a9atx(45))) {
        if (false) {
          _this__u8e3s4.kz();
          out.jc(c);
        }
        break $l$loop;
      }
      _this__u8e3s4.kz();
      out.jc(c);
    }
    return out.toString();
  }
}
class Companion_54 {
  constructor() {
    Companion_instance_64 = this;
    this.t7b_1 = Companion_getInstance_16().ez('SVG');
    this.u7b_1 = new WithDefault(Colors_getInstance().h4r_1);
  }
  v7b(node) {
    var out = toMutableMap(node.o2e_1);
    var tmp398_safe_receiver = node.j1d('style');
    if (tmp398_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      out.t3(Companion_instance_63.q7a(tmp398_safe_receiver));
    }
    return out;
  }
}
class PathTokenNumber {
  constructor(value) {
    this.e7g_1 = value;
  }
  toString() {
    return 'PathTokenNumber(value=' + this.e7g_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.e7g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PathTokenNumber))
      return false;
    var tmp0_other_with_cast = other instanceof PathTokenNumber ? other : THROW_CCE();
    if (!equals(this.e7g_1, tmp0_other_with_cast.e7g_1))
      return false;
    return true;
  }
}
class PathTokenCmd {
  constructor(id) {
    this.f7g_1 = id;
  }
  toString() {
    return 'PathTokenCmd(id=' + toString_1(this.f7g_1) + ')';
  }
  hashCode() {
    return Char__hashCode_impl_otmys(this.f7g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PathTokenCmd))
      return false;
    var tmp0_other_with_cast = other instanceof PathTokenCmd ? other : THROW_CCE();
    if (!(this.f7g_1 === tmp0_other_with_cast.f7g_1))
      return false;
    return true;
  }
}
class SVG {
  static k7g(root, warningProcessor) {
    Companion_getInstance_72();
    warningProcessor = warningProcessor === VOID ? null : warningProcessor;
    var $this = createThis(this);
    $this.s7a_1 = root;
    $this.t7a_1 = warningProcessor;
    $this.u7a_1 = $this.s7a_1.b2g('x', 0);
    $this.v7a_1 = $this.s7a_1.b2g('y', 0);
    $this.w7a_1 = $this.s7a_1.u2f('width', 128.0);
    $this.x7a_1 = $this.s7a_1.u2f('height', 128.0);
    var tmp = $this;
    var tmp0_elvis_lhs = $this.s7a_1.j1d('viewBox');
    tmp.y7a_1 = tmp0_elvis_lhs == null ? '0 0 ' + $this.w7a_1 + ' ' + $this.x7a_1 : tmp0_elvis_lhs;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = split($this.y7a_1, charArrayOf([_Char___init__impl__6a9atx(32)]));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxNumbers.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$0 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
      var tmp0_elvis_lhs_0 = toDoubleOrNull(tmp$ret$0);
      var tmp$ret$1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
      destination.f(tmp$ret$1);
    }
    tmp_0.z7a_1 = destination;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_1 = $this.z7a_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (0 <= 0 ? 0 < this_1.j1() : false) {
      tmp_2 = this_1.i1(0);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_2 = 0.0;
    }
    var tmp_3 = tmp_2;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_2 = $this.z7a_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_4;
    if (0 <= 1 ? 1 < this_2.j1() : false) {
      tmp_4 = this_2.i1(1);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_4 = 0.0;
    }
    var tmp_5 = tmp_4;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_3 = $this.z7a_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_6;
    if (0 <= 2 ? 2 < this_3.j1() : false) {
      tmp_6 = this_3.i1(2);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_6 = $this.w7a_1;
    }
    var tmp_7 = tmp_6;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_4 = $this.z7a_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_8;
    if (0 <= 3 ? 3 < this_4.j1() : false) {
      tmp_8 = this_4.i1(3);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_8 = $this.x7a_1;
    }
    var tmp$ret$11 = tmp_8;
    tmp_1.a7b_1 = new Rectangle(tmp_3, tmp_5, tmp_7, tmp$ret$11);
    var tmp_9 = $this;
    tmp_9.b7b_1 = lazy(SVG$defs$delegate$lambda($this));
    var tmp_10 = $this;
    tmp_10.c7b_1 = lazy(SVG$cssList$delegate$lambda($this));
    var tmp_11 = $this;
    tmp_11.d7b_1 = lazy(SVG$cssCombined$delegate$lambda($this));
    var tmp_12 = $this;
    tmp_12.e7b_1 = lazy(SVG$_dom$delegate$lambda($this));
    var tmp_13 = $this;
    tmp_13.f7b_1 = lazy(SVG$dom$delegate$lambda($this));
    var tmp_14 = $this;
    tmp_14.g7b_1 = lazy(SVG$renderElement$delegate$lambda($this));
    var tmp_15 = $this;
    tmp_15.h7b_1 = lazy(SVG$animator$delegate$lambda($this));
    return $this;
  }
  static l7g(str) {
    Companion_getInstance_72();
    return this.k7g(Xml(str));
  }
  toString() {
    return 'SVG(' + this.j2y() + ', ' + this.k2y() + ')';
  }
  j2y() {
    return numberToInt(this.a7b_1.k2i_1);
  }
  k2y() {
    return numberToInt(this.a7b_1.l2i_1);
  }
  n7c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b7b_1;
    defs$factory();
    return this_0.b2();
  }
  g7g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c7b_1;
    cssList$factory();
    return this_0.b2();
  }
  h7g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d7b_1;
    cssCombined$factory();
    return this_0.b2();
  }
  j7g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f7b_1;
    dom$factory();
    return this_0.b2();
  }
  i7g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g7b_1;
    renderElement$factory();
    return this_0.b2();
  }
  h7c(xml) {
    var nodeName = xml.s2e_1;
    var tmp;
    switch (nodeName) {
      case 'g':
      case 'a':
      case 'svg':
        tmp = new SvgElement(this, xml);
        break;
      case 'defs':
        tmp = null;
        break;
      case '_text_':
        tmp = null;
        break;
      case '_comment_':
        tmp = null;
        break;
      case 'title':
        tmp = null;
        break;
      case 'rect':
        tmp = new RectSvgElement(this, xml);
        break;
      case 'circle':
        tmp = new CircleSvgElement(this, xml);
        break;
      case 'ellipse':
        tmp = new EllipseSvgElement(this, xml);
        break;
      case 'polyline':
      case 'polygon':
        tmp = new PolySvgElement(this, xml);
        break;
      case 'line':
        tmp = new LineSvgElement(this, xml);
        break;
      case 'text':
        tmp = new TextSvgElement(this, xml);
        break;
      case 'path':
        tmp = new PathSvgElement(this, xml);
        break;
      default:
        var tmp384_safe_receiver = this.t7a_1;
        if (tmp384_safe_receiver == null)
          null;
        else
          tmp384_safe_receiver("Unhandled SVG node '" + nodeName + "'");
        tmp = null;
        break;
    }
    return tmp;
  }
  f5x(c) {
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    c.u5u();
    try {
      // Inline function 'korlibs.image.vector.format.SVG.draw.<anonymous>' call
      c.h76(NonePaint_instance);
      c.p5n(new RGBA(Colors_getInstance().h4r_1));
      this.i7g().f5x(c);
    }finally {
      c.c5v();
    }
  }
}
class SvgPath {
  m7g(d, warningProcessor) {
    var t = new Float64Array(6);
    var out = new VectorPath();
    var tokens = this.n7g(d);
    var tl = new ListReader(tokens);
    out.e3y(Vector2D.k2h(0.0, 0.0));
    var lastCX = 0.0;
    var lastCY = 0.0;
    var lastCmd = _Char___init__impl__6a9atx(45);
    $l$loop_0: while (tl.uy()) {
      var tmp0_elvis_lhs = parse$readNextTokenCmd(tl, warningProcessor, tokens);
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
        break $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var cmd = tmp;
      if (cmd === _Char___init__impl__6a9atx(0) || isWhitespaceFast(cmd))
        continue $l$loop_0;
      var relative = _Char___init__impl__6a9atx(97) <= cmd ? cmd <= _Char___init__impl__6a9atx(122) : false;
      var tmp402_subject = lastCmd;
      var lastCurve = tmp402_subject === _Char___init__impl__6a9atx(83) || tmp402_subject === _Char___init__impl__6a9atx(67) || (tmp402_subject === _Char___init__impl__6a9atx(84) || tmp402_subject === _Char___init__impl__6a9atx(81)) || (tmp402_subject === _Char___init__impl__6a9atx(115) || tmp402_subject === _Char___init__impl__6a9atx(99) || (tmp402_subject === _Char___init__impl__6a9atx(116) || tmp402_subject === _Char___init__impl__6a9atx(113))) ? true : false;
      if (cmd === _Char___init__impl__6a9atx(77) || cmd === _Char___init__impl__6a9atx(109)) {
        out.e4b(Vector2D.k2h(parse$n(tl, warningProcessor, tokens), parse$n(tl, warningProcessor, tokens)), relative);
        while (parse$isNextNumber(tl))
          out.d4b(Vector2D.k2h(parse$n(tl, warningProcessor, tokens), parse$n(tl, warningProcessor, tokens)), relative);
      } else if (cmd === _Char___init__impl__6a9atx(76) || cmd === _Char___init__impl__6a9atx(108))
        while (parse$isNextNumber(tl))
          out.d4b(Vector2D.k2h(parse$n(tl, warningProcessor, tokens), parse$n(tl, warningProcessor, tokens)), relative);
      else if (cmd === _Char___init__impl__6a9atx(72) || cmd === _Char___init__impl__6a9atx(104))
        while (parse$isNextNumber(tl))
          out.f4b(parse$n(tl, warningProcessor, tokens), relative);
      else if (cmd === _Char___init__impl__6a9atx(86) || cmd === _Char___init__impl__6a9atx(118))
        while (parse$isNextNumber(tl))
          out.g4b(parse$n(tl, warningProcessor, tokens), relative);
      else if (cmd === _Char___init__impl__6a9atx(81) || cmd === _Char___init__impl__6a9atx(113))
        while (parse$isNextNumber(tl)) {
          var cx = parse$nX(out, tl, warningProcessor, tokens, relative);
          var cy = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x2 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2 = parse$nY(out, tl, warningProcessor, tokens, relative);
          lastCX = cx;
          lastCY = cy;
          out.h3y(Vector2D.k2h(cx, cy), Vector2D.k2h(x2, y2));
        }
       else if (cmd === _Char___init__impl__6a9atx(67) || cmd === _Char___init__impl__6a9atx(99))
        while (parse$isNextNumber(tl)) {
          var x1 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y1 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x2_0 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2_0 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y = parse$nY(out, tl, warningProcessor, tokens, relative);
          lastCX = x2_0;
          lastCY = y2_0;
          out.j3y(Vector2D.k2h(x1, y1), Vector2D.k2h(x2_0, y2_0), Vector2D.k2h(x, y));
        }
       else if (cmd === _Char___init__impl__6a9atx(83) || cmd === _Char___init__impl__6a9atx(115)) {
        while (parse$isNextNumber(tl)) {
          var x2_1 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2_1 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x_0 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y_0 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x1_0 = lastCurve ? out.s3y_1.i2h_1 * 2 - lastCX : out.s3y_1.i2h_1;
          var y1_0 = lastCurve ? out.s3y_1.j2h_1 * 2 - lastCY : out.s3y_1.j2h_1;
          lastCX = x2_1;
          lastCY = y2_1;
          out.j3y(Vector2D.k2h(x1_0, y1_0), Vector2D.k2h(x2_1, y2_1), Vector2D.k2h(x_0, y_0));
          lastCurve = true;
        }
      } else if (cmd === _Char___init__impl__6a9atx(84) || cmd === _Char___init__impl__6a9atx(116)) {
        var n = 0;
        while (parse$isNextNumber(tl)) {
          var x2_2 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2_2 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var cx_0 = lastCurve ? out.s3y_1.i2h_1 * 2 - lastCX : out.s3y_1.i2h_1;
          var cy_0 = lastCurve ? out.s3y_1.j2h_1 * 2 - lastCY : out.s3y_1.j2h_1;
          lastCX = cx_0;
          lastCY = cy_0;
          out.h3y(Vector2D.k2h(cx_0, cy_0), Vector2D.k2h(x2_2, y2_2));
          n = n + 1 | 0;
          lastCurve = true;
        }
      } else if (cmd === _Char___init__impl__6a9atx(65) || cmd === _Char___init__impl__6a9atx(97)) {
        var EPSILON = 1.0E-6;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = parse$readNumber(tl, warningProcessor, tokens);
        var rx = Math.abs(this_0);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = parse$readNumber(tl, warningProcessor, tokens);
        var ry = Math.abs(this_1);
        var rotx = parse$readNumber(tl, warningProcessor, tokens) / 180.0 * 3.141592653589793;
        var tmp_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_2 = parse$readNumber(tl, warningProcessor, tokens);
        if (Math.abs(this_2) > EPSILON) {
          tmp_1 = 1;
        } else {
          tmp_1 = 0;
        }
        var fa = tmp_1;
        var tmp_2;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_3 = parse$readNumber(tl, warningProcessor, tokens);
        if (Math.abs(this_3) > EPSILON) {
          tmp_2 = 1;
        } else {
          tmp_2 = 0;
        }
        var fs = tmp_2;
        var x1_1 = out.s3y_1.i2h_1;
        var y1_1 = out.s3y_1.j2h_1;
        var x2_3 = parse$nX(out, tl, warningProcessor, tokens, relative);
        var y2_3 = parse$nY(out, tl, warningProcessor, tokens, relative);
        var dx = x1_1 - x2_3;
        var dy = y1_1 - y2_3;
        // Inline function 'kotlin.math.hypot' call
        var x_1 = dx;
        var y_1 = dy;
        var d_0 = hypot(x_1, y_1);
        if (d_0 < EPSILON || rx < EPSILON || ry < EPSILON) {
          out.g3y(Vector2D.k2h(x2_3, y2_3));
        } else {
          // Inline function 'kotlin.math.sin' call
          var sinrx = Math.sin(rotx);
          // Inline function 'kotlin.math.cos' call
          var cosrx = Math.cos(rotx);
          var x1p = cosrx * dx / 2.0 + sinrx * dy / 2.0;
          var y1p = -sinrx * dx / 2.0 + cosrx * dy / 2.0;
          var d_1 = sqr(this, x1p) / sqr(this, rx) + sqr(this, y1p) / sqr(this, ry);
          if (d_1 > 1) {
            d_1 = sqr(this, d_1);
            rx = rx * d_1;
            ry = ry * d_1;
          }
          var s = 0.0;
          var sa = sqr(this, rx) * sqr(this, ry) - sqr(this, rx) * sqr(this, y1p) - sqr(this, ry) * sqr(this, x1p);
          var sb = sqr(this, rx) * sqr(this, y1p) + sqr(this, ry) * sqr(this, x1p);
          if (sa < 0.0)
            sa = 0.0;
          if (sb > 0.0) {
            // Inline function 'kotlin.math.sqrt' call
            var x_2 = sa / sb;
            s = Math.sqrt(x_2);
          }
          if (fa === fs)
            s = -s;
          var cxp = s * rx * y1p / ry;
          var cyp = s * -ry * x1p / rx;
          var cx_1 = (x1_1 + x2_3) / 2.0 + cosrx * cxp - sinrx * cyp;
          var cy_1 = (y1_1 + y2_3) / 2.0 + sinrx * cxp + cosrx * cyp;
          var ux = (x1p - cxp) / rx;
          var uy = (y1p - cyp) / ry;
          var vx = (-x1p - cxp) / rx;
          var vy = (-y1p - cyp) / ry;
          var a1 = vecang(this, 1.0, 0.0, ux, uy);
          var da = vecang(this, ux, uy, vx, vy);
          if (fs === 0 && da > 0)
            da = da - 2 * 3.141592653589793;
          else if (fs === 1 && da < 0)
            da = da + 2 * 3.141592653589793;
          t[0] = cosrx;
          t[1] = sinrx;
          t[2] = -sinrx;
          t[3] = cosrx;
          t[4] = cx_1;
          t[5] = cy_1;
          // Inline function 'kotlin.math.abs' call
          var x_3 = da;
          var tmp$ret$8 = Math.abs(x_3);
          var ndivs = numberToInt(tmp$ret$8 / (3.141592653589793 * 0.5) + 1.0);
          var hda = da / ndivs / 2.0;
          // Inline function 'kotlin.math.abs' call
          var tmp_3 = 4.0 / 3.0;
          // Inline function 'kotlin.math.cos' call
          var tmp_4 = tmp_3 * (1.0 - Math.cos(hda));
          // Inline function 'kotlin.math.sin' call
          var x_4 = tmp_4 / Math.sin(hda);
          var kappa = Math.abs(x_4);
          if (da < 0.0)
            kappa = -kappa;
          var ptanx = 0.0;
          var ptany = 0.0;
          var px = 0.0;
          var py = 0.0;
          var inductionVariable = 0;
          if (inductionVariable <= ndivs)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var a = a1 + da * (i / ndivs);
              // Inline function 'kotlin.math.cos' call
              dx = Math.cos(a);
              // Inline function 'kotlin.math.sin' call
              dy = Math.sin(a);
              var x_5 = xformPointX(this, dx * rx, dy * ry, t);
              var y_2 = xformPointY(this, dx * rx, dy * ry, t);
              var tanx = xformVecX(this, -dy * rx * kappa, dx * ry * kappa, t);
              var tany = xformVecY(this, -dy * rx * kappa, dx * ry * kappa, t);
              if (i > 0) {
                out.j3y(Vector2D.k2h(px + ptanx, py + ptany), Vector2D.k2h(x_5 - tanx, y_2 - tany), Vector2D.k2h(x_5, y_2));
              }
              px = x_5;
              py = y_2;
              ptanx = tanx;
              ptany = tany;
            }
             while (!(i === ndivs));
          out.s3y_1 = Vector2D.k2h(x2_3, y2_3);
        }
      } else if (cmd === _Char___init__impl__6a9atx(90) || cmd === _Char___init__impl__6a9atx(122)) {
        out.u6();
      } else {
        // Inline function 'kotlin.TODO' call
        var reason = "Unsupported command '" + toString_1(cmd) + "' (" + Char__toInt_impl_vasixd(cmd) + ") : Parsed: '" + toSvgPathString_0(out) + "', Original: '" + d + "'";
        throw NotImplementedError.oe('An operation is not implemented: ' + reason);
      }
      lastCmd = cmd;
    }
    return out;
  }
  p7a(d, warningProcessor, $super) {
    warningProcessor = warningProcessor === VOID ? null : warningProcessor;
    return $super === VOID ? this.m7g(d, warningProcessor) : $super.m7g.call(this, d, warningProcessor);
  }
  n7g(str) {
    var sr = Companion_instance_8.sz(str);
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.m1();
    while (sr.uy()) {
      tokenizePath$skipSeparators(sr);
      var c = sr.jz();
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp;
      if ((_Char___init__impl__6a9atx(48) <= c ? c <= _Char___init__impl__6a9atx(57) : false) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43) || c === _Char___init__impl__6a9atx(46)) {
        tmp = new PathTokenNumber(tokenizePath$readNumber(sr));
      } else {
        tmp = new PathTokenCmd(sr.kz());
      }
      var element = tmp;
      out.f(element);
    }
    return out;
  }
  z78(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.m1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.m3y_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.k2h(tmp, path.n3y_1.i1(_unary__edvuaz_1));
          var x = destruct.km();
          var y = destruct.lm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.f(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.k2h(tmp_0, path.n3y_1.i1(_unary__edvuaz_3));
          var x_0 = destruct_0.km();
          var y_0 = destruct_0.lm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.f(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.k2h(tmp_1, path.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.k2h(tmp_2, path.n3y_1.i1(_unary__edvuaz_7));
          var x1 = destruct_1.km();
          var y1 = destruct_1.lm();
          var x2 = destruct_2.km();
          var y2 = destruct_2.lm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.f(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.k2h(tmp_3, path.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.k2h(tmp_4, path.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.k2h(tmp_5, path.n3y_1.i1(_unary__edvuaz_13));
          var x1_0 = destruct_3.km();
          var y1_0 = destruct_3.lm();
          var x2_0 = destruct_4.km();
          var y2_0 = destruct_4.lm();
          var x3 = destruct_5.km();
          var y3 = destruct_5.lm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.f(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.f('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.i73_1 = false;
    this.j73_1 = 2;
    this.k73_1 = 1;
    this.l73_1 = new PolygonScanline();
    this.m73_1 = new PolygonScanline();
    this.n73_1 = new IntSegmentSet();
    this.o73_1 = new IntSegmentSet();
    this.p73_1 = new IntSegmentSet();
    this.q73_1 = IntArrayList.f31(1024);
  }
  z33() {
    this.l73_1.z33();
    this.m73_1.z33();
  }
  o7g(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.z33();
    }
    var xmin = this.t47(bounds.p2i());
    var xmax = this.t47(bounds.q2i());
    var tempRect = this.l73_1.v3u();
    // Inline function 'kotlin.math.max' call
    var a = bounds.r2i();
    var b = tempRect.r2i();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.t47(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.s2i();
    var b_0 = tempRect.s2i();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.t47(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.q73_1.o3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.l48() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.l48()) / this.k73_1 | 0) / q | 0) | 0;
        this.q73_1.l31(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.q73_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.h13(_unary__edvuaz);
      this.l73_1.g48(y_0, winding, this.n73_1);
      edgesChecked = edgesChecked + this.l73_1.r47_1 | 0;
      if (this.m73_1.y2k()) {
        this.m73_1.g48(y_0, this.m73_1.c47_1, this.o73_1);
        edgesChecked = edgesChecked + this.m73_1.r47_1 | 0;
        this.p73_1.l3s(this.n73_1, this.o73_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.m73_1.y2k() ? this.p73_1 : this.n73_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.j1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.d3s_1.h13(n_1), this_1.e3s_1.h13(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.s7g(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  r73(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.j73_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.o7g(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.o7g.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_73();
    super();
    this.v7g_1 = width;
    this.w7g_1 = height;
  }
  j2y() {
    return this.v7g_1;
  }
  k2y() {
    return this.w7g_1;
  }
}
class Companion_55 extends DummyRenderer {
  constructor() {
    Companion_instance_65 = null;
    super(128, 128);
    Companion_instance_65 = this;
  }
}
class HtmlCanvas {
  x7g(width, height) {
    if (Companion_getInstance_13().zw()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.m5(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  t7h(width, height) {
    return HtmlCanvas_instance.x7g(width, height);
  }
  u7h(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  v7h(bmp, canvas) {
    return this.u7h(_RgbaArray___init__impl__oib4y4(bmp.g51().z4o_1), bmp.j2y(), bmp.k2y(), canvas);
  }
  y7g(bmp) {
    return this.v7h(bmp, this.t7h(bmp.j2y(), bmp.k2y()));
  }
}
class NodeJsNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NodeJsNativeImageFormatProvider_instance = null;
    super();
    NodeJsNativeImageFormatProvider_instance = this;
  }
  m6m() {
    return get_RegisteredImageFormats();
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  f6n(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0(this, data, props, $completion), $completion);
  }
  z6n(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1(this, vfs, path, props, $completion), $completion);
  }
  k54(width, height, premultiplied) {
    return HtmlNativeImage.s7h(HtmlCanvas_instance.x7g(width, height));
  }
  j54(bmp) {
    return HtmlNativeImage.s7h(HtmlImage_instance.y7g(bmp.o4q()));
  }
  i54(bmp, levels) {
    var out = ensureNative(bmp);
    var inductionVariable = 0;
    if (inductionVariable < levels)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = this.z7h(out);
      }
       while (inductionVariable < levels);
    return out;
  }
  z7h(bmp) {
    // Inline function 'kotlin.math.ceil' call
    var x = bmp.j2y() * 0.5;
    var tmp$ret$0 = Math.ceil(x);
    var tmp = numberToInt(tmp$ret$0);
    // Inline function 'kotlin.math.ceil' call
    var x_0 = bmp.k2y() * 0.5;
    var tmp$ret$1 = Math.ceil(x_0);
    var out = NativeImage_0(tmp, numberToInt(tmp$ret$1));
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = out.i4p_1;
    if (true) {
      out.w1w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = out.y4x(true);
      try {
        // Inline function 'korlibs.image.format.HtmlNativeImageFormatProvider.mipmap.<anonymous>' call
        ctx.a4y_1.c74(bmp, Companion_getInstance_1().a2i_1, toFloat(out.j1()));
      }finally {
        ctx.o18();
      }
    }finally {
      result = true ? out.q4q(rect) : 0;
    }
    return out;
  }
}
class HtmlNativeImage extends NativeImage {
  static c7i(texSourceBase, width, height) {
    var $this = this.h54(width, height, texSourceBase, true);
    $this.n7h_1 = texSourceBase;
    $this.o7h_1 = $this.n7h_1;
    var tmp = $this;
    tmp.p7h_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.q7h_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.r7h_1 = Monotonic_instance.bk();
    return $this;
  }
  w3() {
    return 'HtmlNativeImage';
  }
  static y7h(img) {
    return this.c7i(img, img.width, img.height);
  }
  static s7h(canvas) {
    return this.c7i(canvas, canvas.width, canvas.height);
  }
  b7i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p7h_1;
    lazyCanvasElement$factory();
    return this_0.b2();
  }
  d7i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q7h_1;
    ctx$factory();
    return this_0.b2();
  }
  b4r(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.n7h_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.bk();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.r7h_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.r7h_1 = now;
        this.d7i().clearRect(0.0, 0.0, width, height);
        this.d7i().drawImage(this.n7h_1, 0.0, 0.0);
      }
    }
    var idata = this.d7i().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.l4p_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  d4r(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.d7i().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.l4p_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.d7i().putImageData(idata, x, y);
  }
  y4x(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.b7i()));
  }
  e7i(type, quality) {
    return this.b7i().toDataURL(type, quality);
  }
  f7i(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.e7i(type, quality) : $super.e7i.call(this, type, quality);
  }
}
class BrowserImage {
  w7h(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd(this, bytes, props, $completion), $completion);
  }
  i7i(img) {
    return this.a7i(img, img.width, img.height);
  }
  a7i(img, width, height) {
    var canvas = HtmlCanvas_instance.x7g(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  x7h(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.u19();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_13().zw()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.m5(toString(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.g17();
  }
  h7i(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
    return $super === VOID ? this.x7h(jsUrl, props, $completion) : $super.x7h.call(this, jsUrl, props, $completion);
  }
  g7i(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi(this, jsUrl, $completion), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.l7i_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m7i_1 = this.l7i_1.getContext('2d');
    this.n7i_1 = NaN;
    this.o7i_1 = null;
  }
  j2y() {
    return this.l7i_1.width;
  }
  k2y() {
    return this.l7i_1.height;
  }
  s7i(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.u69_1.j1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.u69_1.h13(n);
        var color = paint.v69_1.h13(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  q7i(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.v59_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.n69_1.v3_1) {
            case 0:
              tmp_0 = this.s7i(this.m7i_1.createLinearGradient(_this__u8e3s4.o69_1, _this__u8e3s4.p69_1, _this__u8e3s4.r69_1, _this__u8e3s4.s69_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.s7i(this.m7i_1.createRadialGradient(_this__u8e3s4.o69_1, _this__u8e3s4.p69_1, _this__u8e3s4.q69_1, _this__u8e3s4.r69_1, _this__u8e3s4.s69_1, _this__u8e3s4.t69_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.m7i_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.m7i_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.a6a_1), _this__u8e3s4.o69_1, _this__u8e3s4.p69_1);
                tmp_1 = this.s7i(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.q6q_1).o7h_1;
            tmp = this.m7i_1.createPattern(tmp$ret$3, _this__u8e3s4.i6r() && _this__u8e3s4.k6r() ? 'repeat' : _this__u8e3s4.i6r() ? 'repeat-x' : _this__u8e3s4.k6r() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  t7i(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.v3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  u7i(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.v3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.u3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  p7i(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.t7i(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.u7i(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  r7i(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.n2m_1, m.o2m_1, m.p2m_1, m.q2m_1, m.r2m_1, m.s2m_1);
  }
  b74(image, pos, size, transform) {
    this.m7i_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.m7i_1.setTransform(transform.n2m_1, transform.o2m_1, transform.p2m_1, transform.q2m_1, transform.r2m_1, transform.s2m_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).o7h_1;
      this.m7i_1.drawImage(tmp$ret$2, pos.i2h_1, pos.j2h_1, size.d2j_1, size.e2j_1);
    }finally {
      this.m7i_1.restore();
    }
  }
  v7i(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.m3y_1;
    var n_0 = 0;
    while (n_0 < this_0.j1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.h13(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.n3y_1.i1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.k2h(tmp, path.n3y_1.i1(_unary__edvuaz_1));
          var x = destruct.km();
          var y = destruct.lm();
          this.m7i_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.n3y_1.i1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.k2h(tmp_0, path.n3y_1.i1(_unary__edvuaz_3));
          var x_0 = destruct_0.km();
          var y_0 = destruct_0.lm();
          this.m7i_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.n3y_1.i1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.k2h(tmp_1, path.n3y_1.i1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.n3y_1.i1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.k2h(tmp_2, path.n3y_1.i1(_unary__edvuaz_7));
          var cx = destruct_1.km();
          var cy = destruct_1.lm();
          var ax = destruct_2.km();
          var ay = destruct_2.lm();
          this.m7i_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.n3y_1.i1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.k2h(tmp_3, path.n3y_1.i1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.n3y_1.i1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.k2h(tmp_4, path.n3y_1.i1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.n3y_1.i1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.k2h(tmp_5, path.n3y_1.i1(_unary__edvuaz_13));
          var cx1 = destruct_3.km();
          var cy1 = destruct_3.lm();
          var cx2 = destruct_4.km();
          var cy2 = destruct_4.lm();
          var ax_0 = destruct_5.km();
          var ay_0 = destruct_5.lm();
          this.m7i_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.m7i_1.closePath();
          break;
      }
    }
  }
  s73(state, fill, winding) {
    if (state.u5m_1.a1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.m7i_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.t5m_1;
        if (!(clip == null)) {
          this.m7i_1.beginPath();
          this.v7i(clip);
          this.m7i_1.clip(this.w7i(winding == null ? clip.o3y_1 : winding));
        }
        this.m7i_1.beginPath();
        this.v7i(state.u5m_1);
        this.r7i(this.m7i_1, state.s5m_1);
        if (fill) {
          transformPaint(this, state.c5n_1);
          this.m7i_1.fill(this.w7i(winding == null ? state.u5m_1.o3y_1 : winding));
        } else {
          transformPaint(this, state.b5n_1);
          var lineDash = state.k5n_1;
          if (!(lineDash == null)) {
            this.m7i_1.lineDashOffset = state.l5n_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.c32();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.f1();
            while (_iterator__ex2g4s.g1()) {
              var v = _iterator__ex2g4s.h1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.t2d(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.m7i_1.setLineDash(tmp$ret$3);
          }
          this.m7i_1.stroke();
        }
        break $l$block;
      }finally {
        this.m7i_1.restore();
      }
    }
  }
  w7i(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.v3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.s3g() <= 0.25;
}
function *_generator_readAtlas__e60am7(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  var tmp = _this__u8e3s4.y22(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var content = tmp;
  var tmp_0;
  if (startsWith(content, '{')) {
    tmp_0 = Companion_instance_10.x4m(content);
  } else if (startsWith(content, '<')) {
    tmp_0 = Companion_instance_10.w4m(content);
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(10))) {
    tmp_0 = Companion_instance_10.v4m(content);
  } else if (startsWith(content, '\r\n')) {
    tmp_0 = Companion_instance_10.v4m(content);
  } else {
    var tmp_1 = firstOrNull(content);
    var message = "Unexpected atlas starting with '" + toString_0(tmp_1 == null ? null : new Char(tmp_1)) + "'";
    throw IllegalStateException.m5(toString(message));
  }
  var info = tmp_0;
  var folder = _this__u8e3s4.w15();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = info.m4m_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap.wc(capacity);
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'korlibs.image.atlas.readAtlas.<anonymous>' call
    var tmp_2 = readBitmapSlice(folder.bj(element.v4l_1), VOID, VOID, props, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var pair = to(element.v4l_1, tmp_2);
    destination.r3(pair.im_1, pair.jm_1);
  }
  var textures = destination;
  return Atlas.k4m(textures, info);
}
function readAtlas(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAtlas__e60am7(_this__u8e3s4, props, $completion), $completion);
}
var Companion_instance_9;
function Companion_getInstance_17() {
  return Companion_instance_9;
}
function toRect(_this__u8e3s4, $this) {
  return RectangleInt.d2u(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'w')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'h')));
}
function toSize(_this__u8e3s4, $this) {
  return SizeInt.c2v(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'w')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(_this__u8e3s4, 'h')));
}
function createEntry($this, name, it) {
  var rotated = _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80(it, 'rotated'));
  var sourceSize = toSize(Dyn__get_impl_6l2p80(it, 'sourceSize'), $this);
  var spriteSourceSize = toRect(Dyn__get_impl_6l2p80(it, 'spriteSourceSize'), $this);
  var sW = sourceSize.a2v_1;
  var sH = sourceSize.b2v_1;
  var frame = toRect(Dyn__get_impl_6l2p80(it, 'frame'), $this);
  return Region.z4m(name, !rotated ? frame : RectangleInt.d2u(frame.z2t_1, frame.a2u_1, frame.c2u_1, frame.b2u_1), RectangleInt.d2u(spriteSourceSize.z2t_1, spriteSourceSize.a2u_1, sW, sH), rotated ? Companion_getInstance_7().y40_1 : Companion_getInstance_7().v40_1);
}
function loadText$point(_this__u8e3s4) {
  var list = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(44)]), VOID, 2);
  // Inline function 'kotlin.text.trim' call
  var this_0 = first(list);
  var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp = toInt(tmp$ret$0);
  // Inline function 'kotlin.text.trim' call
  var this_1 = last(list);
  var tmp$ret$1 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  return Vector2D.k2l(tmp, toInt(tmp$ret$1));
}
function loadText$size(_this__u8e3s4) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.atlas.Companion.loadText.size.<anonymous>' call
  var it = loadText$point(_this__u8e3s4);
  return SizeInt.c2v(numberToInt(it.i2h_1), numberToInt(it.j2h_1));
}
function loadText$keyValue(_this__u8e3s4) {
  var list = split(_this__u8e3s4, charArrayOf([_Char___init__impl__6a9atx(58)]), VOID, 2);
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.text.trim' call
  var this_0 = first(list);
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
  // Inline function 'kotlin.text.trim' call
  var this_1 = last(list);
  var tmp$ret$3 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  return to(tmp, tmp$ret$3);
}
function loadText$filter(_this__u8e3s4) {
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  switch (_this__u8e3s4.toLowerCase()) {
    case 'nearest':
      return false;
    case 'linear':
      return true;
    case 'mipmap':
      return true;
    case 'mipmapnearestnearest':
      return false;
    case 'mipmaplinearnearest':
      return false;
    case 'mipmapnearestlinear':
      return false;
    case 'mipmaplinearlinear':
      return false;
    default:
      return false;
  }
}
var Companion_instance_10;
function Companion_getInstance_18() {
  return Companion_instance_10;
}
function AtlasPacker$pack$lambda($borderSize2) {
  return function (it) {
    return Size2D.f2j(it.jm_1.o41_1 + $borderSize2 | 0, it.jm_1.p41_1 + $borderSize2 | 0);
  };
}
var AtlasPacker_instance;
function AtlasPacker_getInstance() {
  return AtlasPacker_instance;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.g4q_1);
  $this.y4p_1 = Companion_instance_1.j3z(width, height);
  $this.e4q_1 = Bitmap32.c4p(width, height, VOID, $this.a4q_1);
  $this.f4q_1.o3();
  $this.f4q_1.f($this.e4q_1);
  $this.h4q_1.o3();
  $this.g4q_1.o3();
  var _iterator__ex2g4s = slices.f1();
  while (_iterator__ex2g4s.g1()) {
    var entry = _iterator__ex2g4s.h1();
    $this.j4q(entry.w4p_1, entry.x4p_1, entry.w4p_1.j41_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.c4q_1.v3_1) {
    case 0:
      reconstructWithSize($this, imul($this.j2y(), 2), imul($this.k2y(), 2));
      break;
    case 1:
      if (bmp.o41_1 > $this.j2y() || bmp.p41_1 > $this.k2y()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.j2y() + 'x' + $this.k2y() + ') to hold a slice of (' + bmp.o41_1 + 'x' + bmp.p41_1 + ')';
        throw IllegalStateException.m5(toString(message));
      }

      $this.y4p_1 = Companion_instance_1.j3z($this.j2y(), $this.k2y());
      $this.e4q_1 = Bitmap32.c4p($this.j2y(), $this.k2y(), VOID, $this.a4q_1);
      $this.f4q_1.f($this.e4q_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function add(_this__u8e3s4, bmp, name) {
  name = name === VOID ? 'Slice' + _this__u8e3s4.j1() : name;
  return _this__u8e3s4.m4q(bmp, Unit_instance, name);
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.j2y(), 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.b4r(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.p4p_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.i4p_1;
  if (false) {
    this_0.w1w();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.y4x(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.o18();
    }
  }finally {
    result = false ? this_0.q4q(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.u4q(true);
  _this__u8e3s4.l4p_1 = true;
  return _this__u8e3s4;
}
function Bitmap32Context2d_0(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = Bitmap32.c4p(width, height, VOID, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.i4p_1;
  if (false) {
    this_0.w1w();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.y4x(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.Bitmap32Context2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.o18();
    }
  }finally {
    result = false ? this_0.q4q(rect) : 0;
  }
  return this_0;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.w4q();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.h4y_1.x2u();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.sm(new RGBA($this.h4y_1.i4y(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_11;
function Companion_getInstance_19() {
  if (Companion_instance_11 === VOID)
    new Companion_1();
  return Companion_instance_11;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.p4z($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).z4o_1);
  var width = _this__u8e3s4.q2i() - _this__u8e3s4.p2i() | 0;
  var inductionVariable = _this__u8e3s4.r2i();
  var last = _this__u8e3s4.s2i();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.z4q(_this__u8e3s4.p2i(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.p2i() + ', top=' + _this__u8e3s4.r2i() + ', right=' + _this__u8e3s4.q2i() + ', bottom=' + _this__u8e3s4.s2i();
        throw IllegalStateException.m5(toString(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.r2i(), area.p2i(), area.s2i(), area.q2i(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.z4o_1;
  var x0Index = _this__u8e3s4.z4q(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.z4q(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.j2y() | 0;
      x1Index = x1Index + _this__u8e3s4.j2y() | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.z4q(x, areaTop), data, _this__u8e3s4.z4q(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.z4q(x, areaBottom - 1 | 0), data, _this__u8e3s4.z4q(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_12;
function Companion_getInstance_20() {
  return Companion_instance_12;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_13;
function Companion_getInstance_21() {
  BitmapChannel_initEntries();
  if (Companion_instance_13 === VOID)
    new Companion_3();
  return Companion_instance_13;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_21();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.g41_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.o33();
}
function slice_0(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.d2u(0, 0, _this__u8e3s4.j2y(), _this__u8e3s4.k2y()) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_7().v40_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().z2l_1 : padding;
  var left = clamp(bounds.p2i(), 0, _this__u8e3s4.j2y());
  var top = clamp(bounds.r2i(), 0, _this__u8e3s4.k2y());
  return new RectSlice(_this__u8e3s4, Companion_instance_0.h2t(left, top, clamp(bounds.q2i(), left, _this__u8e3s4.j2y()), clamp(bounds.s2i(), top, _this__u8e3s4.k2y())), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.h41_1) ? _this__u8e3s4.g41_1.b2u_1 : _this__u8e3s4.g41_1.c2u_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.h41_1) ? _this__u8e3s4.g41_1.c2u_1 : _this__u8e3s4.g41_1.b2u_1;
  var tmp = get_container(_this__u8e3s4).x4x(w + _this__u8e3s4.i41_1.x2l() | 0, h + _this__u8e3s4.i41_1.y2l() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).w4x(_this__u8e3s4.h41_1);
  raw.k4x(0, 0, out, _this__u8e3s4.i41_1.d2m_1, _this__u8e3s4.i41_1.a2m_1, raw.j2y(), raw.k2y());
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_7().v40_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().z2l_1 : padding;
  return slice_0(_this__u8e3s4, RectangleInt.d2u(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).x4x(_this__u8e3s4.g41_1.b2u_1, _this__u8e3s4.g41_1.c2u_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).h4x(_this__u8e3s4.g41_1.z2t_1, _this__u8e3s4.g41_1.a2u_1, out, 0, 0, _this__u8e3s4.g41_1.b2u_1, _this__u8e3s4.g41_1.c2u_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice_0(Companion_getInstance_19().j4y(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().l4r_1)), VOID, 'transparent');
    Bitmaps_white = slice_0(Companion_getInstance_19().j4y(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().g4r_1)), VOID, 'white');
  }
}
var Companion_instance_14;
function Companion_getInstance_22() {
  return Companion_instance_14;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.n4x(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.c4r(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.m52(x + dx | 0, y + dy | 0) + d < this$0.m52(x, y)) {
    this$0.i52(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.j52(x, y) | 0;
    var y_0 = y - this$0.k52(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.l52(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.j2y(), _this__u8e3s4.k2y()) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.o52(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.z4q(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.c4p(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function mipmap(_this__u8e3s4, levels) {
  return get_nativeImageFormatProvider().i54(_this__u8e3s4, levels);
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().j54(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().k54(width, height, premultiplied);
}
var Companion_instance_15;
function Companion_getInstance_23() {
  return Companion_instance_15;
}
function NinePatchInfo$Segment$bmp$delegate$lambda(this$0) {
  return function () {
    var tmp21_safe_receiver = this$0.o55_1;
    return tmp21_safe_receiver == null ? null : extract_0(tmp21_safe_receiver);
  };
}
function get_length(_this__u8e3s4) {
  return (_this__u8e3s4.l2_1 - _this__u8e3s4.k2_1 | 0) + 1 | 0;
}
function asNinePatchSimple(_this__u8e3s4, left, top, right, bottom) {
  return Companion_instance_15.m54(_this__u8e3s4, left, top, right, bottom);
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_19().k4y(_this__u8e3s4.j2y() + imul(safeBorder, 2) | 0, _this__u8e3s4.k2y() + imul(safeBorder, 2) | 0, _this__u8e3s4.v4q());
  out.e50(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.y56();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.r56_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.r56_1);
  }
  if (!(effect.u56_1 === 0) || !(effect.s56_1 === 0) || !(effect.t56_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.s56_1, effect.t56_1, effect.u56_1, effect.v56_1);
  }
  if (!(effect.w56_1 === 0)) {
    borderInline(_this__u8e3s4, effect.w56_1, effect.x56_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.j2y() / 2 | 0) - 1 | 0), (_this__u8e3s4.k2y() / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.f51(_this__u8e3s4.j2y(), _this__u8e3s4.k2y());
  var t2 = Bitmap8.f51(_this__u8e3s4.j2y(), _this__u8e3s4.k2y());
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_21().i1(n);
      _this__u8e3s4.j50(channel, t1);
      arraycopy_0(t1.n4z(), 0, t2.n4z(), 0, t2.x2u());
      gaussBlur(t1.n4z(), t2.n4z(), _this__u8e3s4.j2y(), _this__u8e3s4.k2y(), r_0);
      _this__u8e3s4.i50(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.f51(_this__u8e3s4.j2y() + imul(r, 2) | 0, _this__u8e3s4.k2y() + imul(r, 2) | 0);
  Companion_instance_12.p51(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.j2y(), _this__u8e3s4.k2y());
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.j2y() / 2 | 0) - 1 | 0), (_this__u8e3s4.k2y() / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.f51(_this__u8e3s4.j2y(), _this__u8e3s4.k2y());
  arraycopy_0(_this__u8e3s4.n4z(), 0, t2.n4z(), 0, _this__u8e3s4.x2u());
  gaussBlur(t2.n4z(), _this__u8e3s4.n4z(), _this__u8e3s4.j2y(), _this__u8e3s4.k2y(), r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().h4r_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.k2y();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.j2y();
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.m52(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.r4z(x, y, Companion_getInstance_28().z56(rcolor, out.t4z(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().h4r_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.j13();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.k50(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.u4q(true);
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.h4z_1, n, Companion_getInstance_28().a57(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.o4q();
  _this__u8e3s4.c50(Colors_getInstance().l4r_1);
  _this__u8e3s4.s4p(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.s4p(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
var BGRA_instance;
function BGRA_getInstance() {
  if (BGRA_instance === VOID)
    new BGRA();
  return BGRA_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.t4q()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.t4q());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_28().a57(_this__u8e3s4.l57(c), _this__u8e3s4.v57(c), _this__u8e3s4.w57(c), _this__u8e3s4.x57(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.t4q() / 8;
}
function decode_0(_this__u8e3s4, data, dataOffset, size, littleEndian) {
  dataOffset = dataOffset === VOID ? 0 : dataOffset;
  size = size === VOID ? numberToInt(data.length / get_bytesPerPixel(_this__u8e3s4)) : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var out = Companion_instance_19.q51(size);
  decode(_this__u8e3s4, data, dataOffset, out, 0, size, littleEndian);
  return out;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
function get_ColorAdd_NEUTRAL() {
  _init_properties_ColorTransform_kt__w2ajah();
  return ColorAdd_NEUTRAL;
}
var ColorAdd_NEUTRAL;
var Companion_instance_16;
function Companion_getInstance_24() {
  return Companion_instance_16;
}
function computeColorMul($this) {
  if (!$this.i58_1)
    return Unit_instance;
  $this.i58_1 = false;
  $this.k58_1 = Companion_getInstance_28().e53($this.a58_1, $this.b58_1, $this.c58_1, $this.d58_1);
}
function _ColorAdd___init__impl__q78um5(value) {
  return value;
}
function _ColorAdd___get_value__impl__up0ct3($this) {
  return $this;
}
function _ColorAdd___get_r__impl__j9xkne($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 0 | 0) & 255);
}
function _ColorAdd___get_g__impl__itrhk1($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 8 | 0) & 255);
}
function _ColorAdd___get_b__impl__grv87a($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 16 | 0) & 255);
}
function _ColorAdd___get_a__impl__c1r8ux($this) {
  return ColorAdd_unpackComponent((_ColorAdd___get_value__impl__up0ct3($this) >>> 24 | 0) & 255);
}
var Companion_instance_17;
function Companion_getInstance_25() {
  return Companion_instance_17;
}
function ColorAdd_unpackComponent(v) {
  _init_properties_ColorTransform_kt__w2ajah();
  return imul(v - 127 | 0, 2);
}
function ColorAdd_pack(r, g, b, a) {
  _init_properties_ColorTransform_kt__w2ajah();
  return ColorAdd_packComponent(r) << 0 | ColorAdd_packComponent(g) << 8 | ColorAdd_packComponent(b) << 16 | ColorAdd_packComponent(a) << 24;
}
function ColorAdd_packComponent(v) {
  _init_properties_ColorTransform_kt__w2ajah();
  return clamp(127 + (v >> 1) | 0, 0, 255);
}
var properties_initialized_ColorTransform_kt_ub7zbp;
function _init_properties_ColorTransform_kt__w2ajah() {
  if (!properties_initialized_ColorTransform_kt_ub7zbp) {
    properties_initialized_ColorTransform_kt_ub7zbp = true;
    ColorAdd_NEUTRAL = _ColorAdd___init__impl__q78um5(2139062143);
  }
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var MaterialColors_instance;
function MaterialColors_getInstance() {
  if (MaterialColors_instance === VOID)
    new MaterialColors();
  return MaterialColors_instance;
}
var Companion_instance_18;
function Companion_getInstance_26() {
  if (Companion_instance_18 === VOID)
    new Companion_8();
  return Companion_instance_18;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_19;
function Companion_getInstance_27() {
  return Companion_instance_19;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains_0(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__contains_impl_ofn00n_0($this, element) {
  if (!(element instanceof RGBA))
    return false;
  return RgbaArray__contains_impl_ofn00n($this.g5j_1, element instanceof RGBA ? element.v59_1 : THROW_CCE());
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.a1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.v59_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.g5j_1, elements);
}
function RgbaArray__indexOf_impl_d6b5pl($this, element) {
  return indexOf(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__indexOf_impl_d6b5pl_0($this, element) {
  if (!(element instanceof RGBA))
    return -1;
  return RgbaArray__indexOf_impl_d6b5pl($this.g5j_1, element instanceof RGBA ? element.v59_1 : THROW_CCE());
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.g5j_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.g5j_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  return numberToInt(c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor)) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_ad__impl__pt5rdj($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, numberToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.h();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.jc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.h();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.jc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.v59_1, other instanceof RGBA ? other.v59_1 : THROW_CCE());
}
function RGBA__interpolateWith_impl_mw7p5y($this, ratio, other) {
  return Companion_getInstance_28().l5j($this, other, ratio);
}
function RGBA__interpolateWith_impl_mw7p5y_0($this, ratio, other) {
  return new RGBA(RGBA__interpolateWith_impl_mw7p5y($this.v59_1, ratio, other instanceof RGBA ? other.v59_1 : THROW_CCE()));
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
function RGBA__times_impl_wehs9n($this, other) {
  return Companion_getInstance_28().m5j($this, other);
}
var Companion_instance_20;
function Companion_getInstance_28() {
  if (Companion_instance_20 === VOID)
    new Companion_10();
  return Companion_instance_20;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.v59_1 : THROW_CCE())))
    return false;
  return true;
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().l4r_1;
  } else {
    var ialpha = 255.0 / alpha;
    tmp = Companion_getInstance_28().a57(numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha), numberToInt(_RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha), numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha), alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, numberToInt(clamp01_0(alpha) * 256));
}
var Companion_instance_21;
function Companion_getInstance_29() {
  return Companion_instance_21;
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  var outA = numberToInt(_RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf);
  var outR = numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf);
  var outG = numberToInt(_RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf);
  var outB = numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_22;
function Companion_getInstance_30() {
  return Companion_instance_22;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.y5j_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_21.w5j(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function interpolate_4(_this__u8e3s4, a, b) {
  return interpolate_5(toRatio_0(_this__u8e3s4), a, b);
}
function interpolate_5(_this__u8e3s4, a, b) {
  return Companion_getInstance_28().l5j(a, b, _this__u8e3s4);
}
var BGRA_5551_instance;
function BGRA_5551_getInstance() {
  if (BGRA_5551_instance === VOID)
    new BGRA_5551();
  return BGRA_5551_instance;
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
var Companion_instance_23;
function Companion_getInstance_31() {
  return Companion_instance_23;
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
function RGBAf__clamp_impl_k7mph8($this) {
  // Inline function 'kotlin.apply' call
  var this_0 = new RGBAf($this);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBAf.clamp.<anonymous>' call
  var $this$apply = this_0.b5k_1;
  _RGBAf___set_r__impl__pz5j5e($this$apply, clamp01_0(_RGBAf___get_r__impl__jfq8gq($this$apply)));
  _RGBAf___set_g__impl__c4jj21($this$apply, clamp01_0(_RGBAf___get_g__impl__dhoraz($this$apply)));
  _RGBAf___set_b__impl__a2n9pa($this$apply, clamp01_0(_RGBAf___get_b__impl__fjl0nq($this$apply)));
  _RGBAf___set_a__impl__iqz7cx($this$apply, clamp01_0(_RGBAf___get_a__impl__qnwk97($this$apply)));
  return this_0.b5k_1;
}
function _RGBAf___get_rgba__impl__ui2t32($this) {
  return Companion_getInstance_28().e53(_RGBAf___get_r__impl__jfq8gq($this), _RGBAf___get_g__impl__dhoraz($this), _RGBAf___get_b__impl__fjl0nq($this), _RGBAf___get_a__impl__qnwk97($this));
}
function RGBAf__setTo_impl_x4m1oi($this, r, g, b, a) {
  _RGBAf___set_r__impl__pz5j5e($this, r);
  _RGBAf___set_g__impl__c4jj21($this, g);
  _RGBAf___set_b__impl__a2n9pa($this, b);
  _RGBAf___set_a__impl__iqz7cx($this, a);
  return $this;
}
function RGBAf__setTo_impl_x4m1oi_0($this, color) {
  return RGBAf__setTo_impl_x4m1oi($this, _RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
}
function RGBAf__setTo_impl_x4m1oi_1($this, color) {
  return RGBAf__setTo_impl_x4m1oi($this, _RGBAf___get_r__impl__jfq8gq(color), _RGBAf___get_g__impl__dhoraz(color), _RGBAf___get_b__impl__fjl0nq(color), _RGBAf___get_a__impl__qnwk97(color));
}
function RGBAf__add_impl_uilb1e($this, r, g, b, a) {
  _RGBAf___set_r__impl__pz5j5e($this, _RGBAf___get_r__impl__jfq8gq($this) + r);
  _RGBAf___set_g__impl__c4jj21($this, _RGBAf___get_g__impl__dhoraz($this) + g);
  _RGBAf___set_b__impl__a2n9pa($this, _RGBAf___get_b__impl__fjl0nq($this) + b);
  _RGBAf___set_a__impl__iqz7cx($this, _RGBAf___get_a__impl__qnwk97($this) + a);
  return RGBAf__clamp_impl_k7mph8($this);
}
function RGBAf__toString_impl_98o9o1($this) {
  return 'RGBAf(' + get_niceStr(_RGBAf___get_r__impl__jfq8gq($this)) + ', ' + get_niceStr(_RGBAf___get_g__impl__dhoraz($this)) + ', ' + get_niceStr(_RGBAf___get_b__impl__fjl0nq($this)) + ', ' + get_niceStr(_RGBAf___get_a__impl__qnwk97($this)) + ')';
}
function RGBAf__hashCode_impl_uzu6gw($this) {
  return hashCode($this);
}
function RGBAf__equals_impl_wa7r4s($this, other) {
  if (!(other instanceof RGBAf))
    return false;
  var tmp0_other_with_cast = other instanceof RGBAf ? other.b5k_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function setToColorPremultiplied(_this__u8e3s4, col) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.setToColorPremultiplied.<anonymous>' call
  toPremultipliedVector3D(col, _this__u8e3s4);
  return _this__u8e3s4;
}
function toPremultipliedVector3D(_this__u8e3s4, out) {
  out = out === VOID ? new MVector4() : out;
  return out.g4f(_RGBA___get_rf__impl__kvz75k(_this__u8e3s4) * _RGBA___get_af__impl__vu36qv(_this__u8e3s4), _RGBA___get_gf__impl__5gcu1f(_this__u8e3s4) * _RGBA___get_af__impl__vu36qv(_this__u8e3s4), _RGBA___get_bf__impl__1xz5yg(_this__u8e3s4) * _RGBA___get_af__impl__vu36qv(_this__u8e3s4), 1.0);
}
var Companion_instance_24;
function Companion_getInstance_32() {
  return Companion_instance_24;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.f5k_1).o4q();
  };
}
var Companion_instance_25;
function Companion_getInstance_33() {
  return Companion_instance_25;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.x5n_1;
    var baseline = 0.0;
    var tmp = -this$0.c5o_1;
    var tmp_0 = -this$0.c5o_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.y5n_1.m3().f1();
    while (_iterator__ex2g4s.g1()) {
      var glyph = _iterator__ex2g4s.h1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.f5k_1.o41_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.v5n_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.y5n_1.i1(this$0.y5n_1.l3().f1().h1());
    return tmp0_elvis_lhs == null ? this$0.h5o() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.v5n_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.y22(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.c9();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.oe('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull_0(xml.bj('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.e2g('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull_0(xml.bj('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.e2g('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull_0(xml.bj('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.e2g('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull_0(xml.bj('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.g2g('fieldType');
  var _iterator__ex2g4s = get(xml.bj('pages'), 'page').f1();
  while (_iterator__ex2g4s.g1()) {
    var page = _iterator__ex2g4s.h1();
    var id = page.c2g('id');
    var file = page.y2f('file');
    var texFile = fntFile.w15().bj(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice_0(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.r3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.bj('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.c2g('page');
    var tmp0_elvis_lhs_0 = textures.k3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first_0(textures.m3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.c2g('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.v42(item.c2g('x'), item.c2g('y'), item.c2g('width'), item.c2g('height'));
      tmp_1 = atlas.r4q(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.w4p_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.v42(item.c2g('x'), item.c2g('y'), item.c2g('width'), item.c2g('height')) : tmp1_elvis_lhs_0, item.c2g('xoffset'), item.c2g('yoffset'), item.c2g('xadvance'));
    destination.f(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.bj('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.f1();
  while (tmp0_iterator_0.g1()) {
    var item_0 = tmp0_iterator_0.h1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.c2g('first'), item_0.c2g('second'), item_0.c2g('amount'));
    destination_0.f(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.f1();
  while (tmp0_iterator_1.g1()) {
    var item_1 = tmp0_iterator_1.h1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.e5k_1, item_1);
    destination_1.f(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.f1();
  while (tmp0_iterator_2.g1()) {
    var item_2 = tmp0_iterator_2.h1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_24.c5k(item_2.v5l_1, item_2.w5l_1), item_2);
    destination_2.f(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps, atlas, $completion), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_10().i2d(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.j1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.i1(n).e3h_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.w15().bj(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice_0(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.r3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.e3h_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.k3(page_0);
    var texture = tmp0_elvis_lhs == null ? first_0(textures.m3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.v42(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.r4q(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.w4p_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.v42(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.f(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.f1();
  while (tmp0_iterator_0.g1()) {
    var item_0 = tmp0_iterator_0.h1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.e3h_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.f(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.f1();
  while (tmp0_iterator_1.g1()) {
    var item_1 = tmp0_iterator_1.h1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.e5k_1, item_1);
    destination_1.f(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.f1();
  while (tmp0_iterator_2.g1()) {
    var item_2 = tmp0_iterator_2.h1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_24.c5k(item_2.v5l_1, item_2.w5l_1), item_2);
    destination_2.f(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps, atlas, $completion), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.m1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.m1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).f1();
  while (_iterator__ex2g4s.g1()) {
    var rline = _iterator__ex2g4s.h1();
    // Inline function 'kotlin.text.trim' call
    var line = toString(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.vc();
    var _iterator__ex2g4s_0 = split(line, charArrayOf([_Char___init__impl__6a9atx(32)])).f1();
    while (_iterator__ex2g4s_0.g1()) {
      var part = _iterator__ex2g4s_0.h1();
      var _destruct__k2r9zo = plus_0(split(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf_0(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.i1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.i1(1);
      // Inline function 'kotlin.collections.set' call
      map.r3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.k3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.k3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.k3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.m5(toString(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.w15().bj(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice_0(mipmaps(tmp_0, mipmaps_0));
      textures.r3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.k3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.k3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.k3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.k3(page);
      var texture = tmp5_elvis_lhs == null ? first_0(textures.m3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.v42(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.r4q(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.w4p_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.v42(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.f(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.k3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.k3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.k3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.f(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.wc(capacity);
  var tmp0_iterator = glyphs.f1();
  while (tmp0_iterator.g1()) {
    var element_1 = tmp0_iterator.h1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.e5k_1;
    destination.r3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps, atlas, $completion), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_24.c5k(it.v5l_1, it.w5l_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.a5m();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.h5m();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.g5m();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.h5o();
  }, null);
}
var Companion_instance_26;
function Companion_getInstance_34() {
  if (Companion_instance_26 === VOID)
    new Companion_16();
  return Companion_instance_26;
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.bk();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.e5r(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.sr_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_15());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.m5k(size);
  var gmetrics = _this__u8e3s4.o5k(size, codePoint, VOID, reader);
  var gx = -gmetrics.p2i();
  var gy = gmetrics.k2y() + gmetrics.r2i();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.j2y()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.k2y()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.c4p(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.i4p_1;
  if (true) {
    image.w1w();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.y4x(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.o18();
    }
  }finally {
    result = true ? image.q4q(rect) : 0;
  }
  var imageOut = applyEffect(image.q4p(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.k2h(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_4().i2m_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf(glyph);
  var tmp_1 = listOf(listOf(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.p5r();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.p3y_1 = false;
    this_0.p4a(this$0.m5l_1.p2i(), -this$0.n5l_1.w5k_1, this$0.m5l_1.t5k_1, this$0.n5l_1.d5l());
    return applyTransform(this_0, Companion_getInstance_4().l2m().o2n(this$0.l5l_1).x2n(this$0.o5l_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.q5r());
    var tmp;
    if (!(curves.y3t_1.j1() === 4)) {
      println('curves=' + curves.y3t_1.j1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.r5r().y3t_1.i1(3).u3x();
    var tmp$ret$0 = Line2D.g2l(this_0.f2l_1, this_0.e2l_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.r5r().y3t_1.i1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_1().a2i_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_64().l5s_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.b5t();
  }
  invoke_1(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.z5r_1 = glyphs.c5t_1;
    outMetrics.a5s_1 = glyphs.d5t_1;
    var fmetrics = _this__u8e3s4.m5k(size);
    outMetrics.x5r_1 = fmetrics;
    var metrics = outMetrics.y5r_1;
    metrics.g5t_1.i5t(fmetrics);
    metrics.h5t_1 = glyphs.d5t_1.j1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.d5t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_5().y2i();
      var _iterator__ex2g4s = item.f1();
      while (_iterator__ex2g4s.g1()) {
        var g = _iterator__ex2g4s.h1();
        bb = plus_3(bb, g.q5r());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.f(tmp$ret$0);
    }
    tmp_1.f5t_1 = destination;
    metrics.e5t_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_5().y2i(), metrics.f5t_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_64().h5s_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke_1(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.j5m(size, out.g5t_1);
  out.h5t_1 = actions.y5t();
  var bb = Companion_getInstance_5().y2i();
  var dy = 0.0;
  var lineBounds = FastArrayList.g14();
  var offsetY = actions.c5u(align.a5u_1, out.g5t_1);
  var _iterator__ex2g4s = actions.w5t_1.f1();
  while (_iterator__ex2g4s.g1()) {
    var line = _iterator__ex2g4s.h1();
    var offsetX = line.g5u(align.z5t_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.h5u(), line.e5u_1, line.d5u_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.f(rect);
    dy = dy + line.d5u_1;
  }
  out.f5t_1 = lineBounds;
  out.e5t_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function getTextBoundsWithGlyphs(_this__u8e3s4, size, text, renderer, align) {
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_64().l5s_1 : align;
  var font = _this__u8e3s4;
  // Inline function 'kotlin.also' call
  var this_0 = new TextMetricsResult();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.getTextBoundsWithGlyphs.<anonymous>' call
  var tmp74_pos = Companion_getInstance_1().a2i_1;
  drawText(font, null, size, text, null, tmp74_pos, false, renderer, align, this_0);
  return this_0;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.p5n($paint);
  font.s5n(_this__u8e3s4, $size, $codePoint, Vector2D.k2h(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.k5u();
  } else {
    _this__u8e3s4.j5u();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.l5u_1;
        var strokeInfo = stroke == null ? null : stroke.m5u_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.n5u(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.n3s_1;
              var lineCap = strokeInfo.q3s_1;
              var lineJoin = strokeInfo.s3s_1;
              var miterLimit = strokeInfo.t3s_1;
              var lineDash = strokeInfo.u3s_1;
              var lineDashOffset = strokeInfo.v3s_1;
              if (false) {
                tmp67_safe_receiver.b5t();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.u5u();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.v5u(numberToDouble(lineWidth));
                tmp67_safe_receiver.w5u(lineCap);
                tmp67_safe_receiver.x5u(lineJoin);
                tmp67_safe_receiver.y5u(numberToDouble(miterLimit));
                tmp67_safe_receiver.z5u(lineDash);
                tmp67_safe_receiver.a5v(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.b5v(stroke_0);
              }finally {
                tmp67_safe_receiver.c5v();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.o5u();
            var lineCap_0 = tmp67_safe_receiver.p5u();
            var lineJoin_0 = tmp67_safe_receiver.q5u();
            var miterLimit_0 = tmp67_safe_receiver.r5u();
            var lineDash_0 = tmp67_safe_receiver.s5u();
            var lineDashOffset_0 = tmp67_safe_receiver.t5u();
            if (false) {
              tmp67_safe_receiver.b5t();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.u5u();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.v5u(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.w5u(lineCap_0);
              tmp67_safe_receiver.x5u(lineJoin_0);
              tmp67_safe_receiver.y5u(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.z5u(lineDash_0);
              tmp67_safe_receiver.a5v(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.b5v(stroke_0);
            }finally {
              tmp67_safe_receiver.c5v();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.k5u();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.j5u();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.b5t();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.q5r();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.r5r();
  }, null);
}
function caretStart$factory() {
  return getPropertyCallableRef('caretStart', 1, KProperty1, function (receiver) {
    return receiver.s5r();
  }, null);
}
function caretEnd$factory() {
  return getPropertyCallableRef('caretEnd', 1, KProperty1, function (receiver) {
    return receiver.t5r();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.u22(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion), $completion);
}
var SystemFontRegistryOrNull;
function get_lazyBitmap(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmap$delegate;
    var property = lazyBitmap$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_27;
function Companion_getInstance_35() {
  if (Companion_instance_27 === VOID)
    new Companion_17();
  return Companion_instance_27;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.q5x_1.i1(this$0.q5x_1.l3().f1().h1());
    return tmp0_elvis_lhs == null ? this$0.h5o() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.k5x_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.n5x_1.y5k_1 - this$0.n5x_1.a5l_1;
    var tmp78_size = this$0.n5x_1.u5k_1;
    var tmp79_top = this$0.n5x_1.v5k_1;
    var tmp80_ascent = this$0.n5x_1.w5k_1;
    var tmp81_baseline = this$0.n5x_1.x5k_1;
    var tmp82_maxWidth = this$0.n5x_1.b5l_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function get_lazyBitmap_0(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp;
  if (isInterface(_this__u8e3s4, VectorFont)) {
    tmp = get_lazyBitmap(_this__u8e3s4);
  } else {
    if (isInterface(_this__u8e3s4, BitmapFont)) {
      tmp = _this__u8e3s4;
    } else {
      throw NotImplementedError.oe();
    }
  }
  return tmp;
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmap$factory() {
  return getPropertyCallableRef('lazyBitmap', 1, KProperty1, function (receiver) {
    return get_lazyBitmap(receiver);
  }, null);
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.g5m();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.h5o();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.h5m();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
function set__nativeSystemFontProvider(_set____db54di) {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  _nativeSystemFontProvider = _set____db54di;
}
function get__nativeSystemFontProvider() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return _nativeSystemFontProvider;
}
var _nativeSystemFontProvider;
function get_cacheVfs() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return cacheVfs;
}
var cacheVfs;
var Companion_instance_28;
function Companion_getInstance_36() {
  if (Companion_instance_28 === VOID)
    new Companion_18();
  return Companion_instance_28;
}
function nativeSystemFontProvider(coroutineContext) {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  // Inline function 'korlibs.datastructure.cacheLazyNullable' call
  var field = _nativeSystemFontProvider$factory();
  var result = field.get();
  if (result == null) {
    // Inline function 'korlibs.image.font.nativeSystemFontProvider.<anonymous>' call
    result = createNativeSystemFontProvider(coroutineContext);
    field.set(result);
  }
  return ensureNotNull(result);
}
function createNativeSystemFontProvider(coroutineContext, platform) {
  platform = platform === VOID ? Companion_getInstance_13() : platform;
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  var tmp;
  if (platform.vw().xw()) {
    tmp = new FallbackNativeSystemFontProvider(get_DefaultTtfFont());
  } else {
    var folders;
    switch (platform.uw().v3_1) {
      case 4:
        folders = listOf_0(['%WINDIR%\\Fonts', '%LOCALAPPDATA%\\Microsoft\\Windows\\Fonts']);
        break;
      case 3:
        folders = listOf_0(['/usr/share/fonts', '/usr/local/share/fonts', '~/.fonts']);
        break;
      case 1:
        folders = listOf_0(['/System/Library/Fonts/', '/Library/Fonts/', '~/Library/Fonts/', '/Network/Library/Fonts/']);
        break;
      case 2:
      case 7:
        folders = listOf('/System/Library/Fonts');
        break;
      case 5:
        folders = listOf_0(['/system/fonts', '/system/font', '/data/fonts']);
        break;
      default:
        folders = listOf_0(['/usr/share/fonts', '/usr/local/share/fonts', '~/.fonts']);
        break;
    }
    tmp = new FolderBasedNativeSystemFontProvider(coroutineContext, folders);
  }
  return tmp;
}
function *_generator_invoke__zhh2q8_0($this, $this$runBlockingNoJs, $completion) {
  var out = LinkedHashMap.vc();
  // Inline function 'kotlin.time.measureTime' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.time.measureTime' call
  // Inline function 'kotlin.contracts.contract' call
  var mark = Monotonic_instance.bk();
  // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>' call
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_37().k61_1;
  var level = Level_INFO_getInstance();
  var tmp;
  if (this_0.u3g(level)) {
    // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = 'FolderBasedNativeSystemFontProvider.listFontNamesMap: ' + toString($this.q61_1.n61_1);
    this_0.v3g(level, tmp$ret$0);
    tmp = Unit_instance;
  }
  var fontCacheVfsFile = $this.q61_1.o61_1;
  var fileNamesToName = LinkedHashMap.vc();
  var tmp_0;
  try {
    var tmp_1 = fontCacheVfsFile.y22(VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      tmp_2 = '';
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var oldFontCacheVfsFileText = tmp_0;
  var _iterator__ex2g4s = split_0(oldFontCacheVfsFileText, ['\n']).f1();
  while (_iterator__ex2g4s.g1()) {
    var line = _iterator__ex2g4s.h1();
    var _destruct__k2r9zo = plus_0(split_0(line, ['='], VOID, 2), listOf_0(['', '']));
    // Inline function 'kotlin.collections.component1' call
    var file = _destruct__k2r9zo.i1(0);
    // Inline function 'kotlin.collections.component2' call
    var name = _destruct__k2r9zo.i1(1);
    // Inline function 'kotlin.collections.set' call
    fileNamesToName.r3(file, name);
  }
  var _iterator__ex2g4s_0 = $this.q61_1.n61_1.f1();
  while (_iterator__ex2g4s_0.g1()) {
    var folder = _iterator__ex2g4s_0.h1();
    try {
      var file_0 = localVfs(expand(Companion_instance_7, folder));
      var tmp_3 = file_0.b23(VOID, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var _iterator__ex2g4s_1 = tmp_3.f1();
      while (_iterator__ex2g4s_1.g1()) {
        var f = _iterator__ex2g4s_1.h1();
        try {
          // Inline function 'kotlin.collections.getOrPut' call
          var key = get_baseName(f);
          var value = fileNamesToName.k3(key);
          var tmp_4;
          if (value == null) {
            // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.time.measureTimedValue' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.time.measureTimedValue' call
            // Inline function 'kotlin.contracts.contract' call
            var mark_0 = Monotonic_instance.bk();
            // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp_5 = Companion_getInstance_41().s61(f, $completion);
            if (tmp_5 === get_COROUTINE_SUSPENDED())
              tmp_5 = yield tmp_5;
            var result = tmp_5;
            var _destruct__k2r9zo_0 = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark_0));
            var ttf = _destruct__k2r9zo_0.km();
            var totalTime = _destruct__k2r9zo_0.ur();
            var answer = ttf.y61();
            fileNamesToName.r3(key, answer);
            tmp_4 = answer;
          } else {
            tmp_4 = value;
          }
          var name_0 = tmp_4;
          if (!(name_0 === '')) {
            // Inline function 'kotlin.collections.set' call
            out.r3(name_0, f);
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            // Inline function 'kotlin.collections.getOrPut' call
            var key_0 = get_baseName(f);
            var value_0 = fileNamesToName.k3(key_0);
            var tmp_6;
            if (value_0 == null) {
              // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>' call
              var answer_0 = '';
              fileNamesToName.r3(key_0, answer_0);
              tmp_6 = answer_0;
            } else {
              tmp_6 = value_0;
            }
          } else {
            throw $p;
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        // Inline function 'korlibs.logger.Logger.info' call
        var this_1 = get_imageLoadingLogger();
        var level_0 = Level_INFO_getInstance();
        var tmp_7;
        if (this_1.u3g(level_0)) {
          // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>' call
          this_1.v3g(level_0, e_1);
          tmp_7 = Unit_instance;
        }
      } else {
        throw $p;
      }
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(fileNamesToName.j1());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = fileNamesToName.z1().f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$14 = item.a2() + '=' + item.b2();
    destination.f(tmp$ret$14);
  }
  var newFontCacheVfsFileText = joinToString(destination, '\n');
  if (!(newFontCacheVfsFileText === oldFontCacheVfsFileText)) {
    try {
      var tmp_8 = fontCacheVfsFile.a23(newFontCacheVfsFileText, [], VOID, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
    } catch ($p) {
      if ($p instanceof Error) {
        var e_2 = $p;
        if (e_2 instanceof CancellationException)
          throw e_2;
        // Inline function 'korlibs.logger.Logger.info' call
        var this_2 = get_imageLoadingLogger();
        var level_1 = Level_INFO_getInstance();
        var tmp_9;
        if (this_2.u3g(level_1)) {
          // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>.<anonymous>' call
          this_2.v3g(level_1, e_2);
          tmp_9 = Unit_instance;
        }
      } else {
        throw $p;
      }
    }
  }
  var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$22 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$22) >= 0) {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_37().k61_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_10;
    if (this_3.u3g(level_2)) {
      // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.listFontNamesMap.<anonymous>.<anonymous>' call
      var tmp$ret$23 = 'Load System font names in ' + Duration__toString_impl_8d916b(time);
      this_3.v3g(level_2, tmp$ret$23);
      tmp_10 = Unit_instance;
    }
  }
  return out;
}
function *_generator_invoke__zhh2q8_1($this, $this$runBlockingNoJs, $completion) {
  var tmp89_safe_receiver = _get_namesMapLC__yok9z4($this.z61_1).k3($this.z61_1.h61($this.a62_1));
  var tmp;
  if (tmp89_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FolderBasedNativeSystemFontProvider.loadFontByName.<anonymous>.<anonymous>' call
    var tmp_0 = tmp89_safe_receiver.v22($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = TtfFont.e5r(tmp_0);
  }
  return tmp;
}
var Companion_instance_29;
function Companion_getInstance_37() {
  if (Companion_instance_29 === VOID)
    new Companion_19();
  return Companion_instance_29;
}
function _get_namesMapLC__yok9z4($this) {
  if ($this.p61_1.kotlinx$atomicfu$value == null) {
    $this.p61_1.kotlinx$atomicfu$value = $this.b62();
  }
  return ensureNotNull($this.p61_1.kotlinx$atomicfu$value);
}
function FolderBasedNativeSystemFontProvider$listFontNamesMap$slambda_0(this$0) {
  var i = new FolderBasedNativeSystemFontProvider$listFontNamesMap$slambda(this$0);
  var l = function ($this$runBlockingNoJs, $completion) {
    return i.o1s($this$runBlockingNoJs, $completion);
  };
  l.$arity = 1;
  return l;
}
function FolderBasedNativeSystemFontProvider$loadFontByName$slambda_0(this$0, $name) {
  var i = new FolderBasedNativeSystemFontProvider$loadFontByName$slambda(this$0, $name);
  var l = function ($this$runBlockingNoJs, $completion) {
    return i.o1s($this$runBlockingNoJs, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_iosFolders() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return listOf('/System/Library/Fonts');
}
function get_androidFolders() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return listOf_0(['/system/fonts', '/system/font', '/data/fonts']);
}
function get_macosFolders() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return listOf_0(['/System/Library/Fonts/', '/Library/Fonts/', '~/Library/Fonts/', '/Network/Library/Fonts/']);
}
function get_windowsFolders() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return listOf_0(['%WINDIR%\\Fonts', '%LOCALAPPDATA%\\Microsoft\\Windows\\Fonts']);
}
function get_linuxFolders() {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return listOf_0(['/usr/share/fonts', '/usr/local/share/fonts', '~/.fonts']);
}
function userSharedCacheFile(name) {
  _init_properties_NativeSystemFontProvider_kt__rxp686();
  return Companion_getInstance_13().uw().qw() ? get_cacheVfs().bj('.' + name) : localVfs(expand(Companion_instance_7, '~/.' + removePrefix(name, '.')));
}
function _nativeSystemFontProvider$factory() {
  return getPropertyCallableRef('_nativeSystemFontProvider', 0, KMutableProperty0, function () {
    return get__nativeSystemFontProvider();
  }, function (value) {
    return set__nativeSystemFontProvider(value);
  });
}
var properties_initialized_NativeSystemFontProvider_kt_2j6bmg;
function _init_properties_NativeSystemFontProvider_kt__rxp686() {
  if (!properties_initialized_NativeSystemFontProvider_kt_2j6bmg) {
    properties_initialized_NativeSystemFontProvider_kt_2j6bmg = true;
    _nativeSystemFontProvider = null;
    cacheVfs = MemoryVfs();
  }
}
var Companion_instance_30;
function Companion_getInstance_38() {
  return Companion_instance_30;
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_31;
function Companion_getInstance_39() {
  Op_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_21();
  return Companion_instance_31;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_39();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_32;
function Companion_getInstance_40() {
  Op_initEntries_0();
  if (Companion_instance_32 === VOID)
    new Companion_22();
  return Companion_instance_32;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_40();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
function *_generator_readNames__k160f6($this, s, $completion) {
  // Inline function 'korlibs.io.stream.openUse' call
  // Inline function 'korlibs.io.async.use' call
  var tmp = s.t22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.image.font.Companion.readNames.<anonymous>' call
    var tmp_1 = Companion_getInstance_41();
    var tmp_2 = tmp_1.r64(this_0 instanceof AsyncStream ? this_0 : THROW_CCE(), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } catch ($p) {
    var tmp_3;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_3 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_3;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_4 = this_0.f1q($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function *_generator_readNames__k160f6_0($this, s, $completion) {
  var tmp = s.d1u(new Long(0, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = readBytesUpTo(s, 1024, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var header = tmp_0;
  var table = Companion_instance_36.s64(openFastStream(header));
  var tableName = ensureNotNull(table.k3('name'));
  var tmp_1 = s.d1u(toLong(tableName.v64_1), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = readBytesUpTo(s, tableName.w64_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var nameBytes = tmp_2;
  // Inline function 'kotlin.also' call
  var this_0 = new NamesInfo();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.Companion.readNames.<anonymous>' call
  Companion_instance_36.z64(openFastStream(nameBytes), this_0);
  return this_0;
}
var Companion_instance_33;
function Companion_getInstance_41() {
  if (Companion_instance_33 === VOID)
    new Companion_23();
  return Companion_instance_33;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.y64_1;
  ss$factory();
  return this_0.b2();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.x64_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.t1q($table.v64_1, $table.w64_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_34;
function Companion_getInstance_42() {
  return Companion_instance_34;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_35;
function Companion_getInstance_43() {
  Colrv1Paint_initEntries();
  if (Companion_instance_35 === VOID)
    new Companion_25();
  return Companion_instance_35;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_43();
}
var Companion_instance_36;
function Companion_getInstance_44() {
  return Companion_instance_36;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_37;
function Companion_getInstance_45() {
  return Companion_instance_37;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.v22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.e5r(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
function set_onlyReadVisibleLayers(_this__u8e3s4, _set____db54di) {
  _init_properties_ASE_kt__16anup();
  var this_0 = onlyReadVisibleLayers$delegate;
  var property = onlyReadVisibleLayers$factory();
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_onlyReadVisibleLayers(_this__u8e3s4) {
  _init_properties_ASE_kt__16anup();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = onlyReadVisibleLayers$delegate;
    var property = onlyReadVisibleLayers$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var onlyReadVisibleLayers$delegate;
var Companion_instance_38;
function Companion_getInstance_46() {
  return Companion_instance_38;
}
function ASE$AseSlice$sortKeys$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
  var tmp = a.u6e_1;
  // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
  var tmp$ret$1 = b.u6e_1;
  return compareValues(tmp, tmp$ret$1);
}
function takeLayersByName(_this__u8e3s4, $this, name) {
  var tmp;
  if (getExtra(_this__u8e3s4, 'layers') == null) {
    tmp = true;
  } else {
    var tmp_0 = getExtra(_this__u8e3s4, 'layers');
    tmp = contains_1((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE(), name);
  }
  return tmp;
}
function slicingEnabled(_this__u8e3s4, $this) {
  return getExtraTyped(_this__u8e3s4, 'disableSlicing') == null || !ensureNotNull(getExtraTyped(_this__u8e3s4, 'disableSlicing'));
}
function useSlicePosition(_this__u8e3s4, $this) {
  return !(getExtraTyped(_this__u8e3s4, 'useSlicePosition') == null) && ensureNotNull(getExtraTyped(_this__u8e3s4, 'useSlicePosition'));
}
function readImageContainer$createImageFrameLayer(imageLayers, image, key, value) {
  var resolved = value.g6f();
  var layer = imageLayers.i1(key);
  var tilemap = null;
  if (resolved instanceof AseTilemapCell) {
    var tileset = image.f6i_1.i1(layer.k6g_1);
    var tmp = Companion_instance_58;
    tilemap = tmp.g6i(resolved.s6f_1, tileset == null ? null : tileset.j6h_1, resolved.t6f_1, resolved.u6f_1, resolved.v6f_1, resolved.w6f_1);
  }
  return new ImageFrameLayer(layer, slice_0(resolved.a5m()), resolved.n4f(), resolved.p4f(), false, true, tilemap);
}
var ASE_instance;
function ASE_getInstance() {
  if (ASE_instance === VOID)
    ASE.j6i();
  return ASE_instance;
}
function _Fixed32___init__impl__8jizkq(raw) {
  return raw;
}
function _Fixed32___get_raw__impl__5vhc8t($this) {
  return $this;
}
function _Fixed32___get_double__impl__wjoyf6($this) {
  return _Fixed32___get_raw__impl__5vhc8t($this) / 65536.0;
}
var Companion_instance_39;
function Companion_getInstance_47() {
  return Companion_instance_39;
}
function onlyReadVisibleLayers$delegate$lambda() {
  _init_properties_ASE_kt__16anup();
  return true;
}
function onlyReadVisibleLayers$factory() {
  return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
    return get_onlyReadVisibleLayers(receiver);
  }, function (receiver, value) {
    return set_onlyReadVisibleLayers(receiver, value);
  });
}
function onlyReadVisibleLayers$factory_0() {
  return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
    return get_onlyReadVisibleLayers(receiver);
  }, function (receiver, value) {
    return set_onlyReadVisibleLayers(receiver, value);
  });
}
var properties_initialized_ASE_kt_jtvwzh;
function _init_properties_ASE_kt__16anup() {
  if (!properties_initialized_ASE_kt_jtvwzh) {
    properties_initialized_ASE_kt_jtvwzh = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = onlyReadVisibleLayers$delegate$lambda;
    onlyReadVisibleLayers$delegate = new Property(null, default_0);
  }
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_40;
function Companion_getInstance_48() {
  DataFormat_initEntries();
  if (Companion_instance_40 === VOID)
    new Companion_30();
  return Companion_instance_40;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_48();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString_0(s, 2, Charsets_instance.ly(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.m5(toString(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.x6k_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.u3g(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.v3g(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.t1t_1.q2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_48();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.i1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.x6k_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.u3g(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.v6k_1(nComponent);
          this_1.v3g(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact_0(s, dataFormat.v6k_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.x6k_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.u3g(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.v3g(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_7().v40_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_7().z40_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_7().x40_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_7().b41_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_7().c41_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_7().w40_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_7().a41_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_7().y40_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_7().v40_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.fw());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.fw());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.n6j_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.n6j_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_ONCE_REVERSE_getInstance() {
  Direction_initEntries();
  return Direction_ONCE_REVERSE_instance;
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
function Direction_REVERSE_getInstance() {
  Direction_initEntries();
  return Direction_REVERSE_instance;
}
function Direction_PING_PONG_getInstance() {
  Direction_initEntries();
  return Direction_PING_PONG_instance;
}
var info$delegate;
var Companion_instance_41;
function Companion_getInstance_49() {
  return Companion_instance_41;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.k6l()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.j6l().j2y(), b.j6l().k2y()), imul(b.j6l().t4q(), b.j6l().t4q()));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.k6l()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.j6l().j2y(), a.j6l().k2y()), imul(a.j6l().t4q(), a.j6l().t4q()));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
function packInMutableAtlas(_this__u8e3s4, mutableAtlas) {
  _init_properties_ImageData_kt__fnvt4j();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.y6l_1;
  var n = 0;
  while (n < this_0.j1()) {
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.i1(_unary__edvuaz);
    packInMutableAtlas_0(it, mutableAtlas);
  }
  return _this__u8e3s4;
}
function packInMutableAtlas_0(_this__u8e3s4, mutableAtlas) {
  _init_properties_ImageData_kt__fnvt4j();
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = _this__u8e3s4.m6l_1;
  var destination = ArrayList.m1();
  var tmp0_iterator = this_0.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var list = element.t6j_1;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.m1();
  var tmp0_iterator_0 = destination.f1();
  while (tmp0_iterator_0.g1()) {
    var element_0 = tmp0_iterator_0.h1();
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    if (element_0.b6k_1) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = packInMutableAtlas$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_2(tmp);
  var frameLayers = sortedWith(destination_0, tmp$ret$6);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < frameLayers.j1()) {
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var frameLayer = frameLayers.i1(_unary__edvuaz);
    frameLayer.b6m(mutableAtlas.j4q(frameLayer.g6k_1, Unit_instance, frameLayer.g6k_1.j41_1).w4p_1);
  }
  return _this__u8e3s4;
}
function info$delegate$lambda() {
  _init_properties_ImageData_kt__fnvt4j();
  return null;
}
function packInMutableAtlas$lambda(a, b) {
  _init_properties_ImageData_kt__fnvt4j();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
  var tmp = b.x2u();
  // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
  var tmp$ret$1 = a.x2u();
  return compareValues(tmp, tmp$ret$1);
}
var properties_initialized_ImageData_kt_3o5pbp;
function _init_properties_ImageData_kt__fnvt4j() {
  if (!properties_initialized_ImageData_kt_3o5pbp) {
    properties_initialized_ImageData_kt_3o5pbp = true;
    info$delegate = new Property(VOID, info$delegate$lambda);
  }
}
var Companion_instance_42;
function Companion_getInstance_50() {
  if (Companion_instance_42 === VOID)
    new Companion_32();
  return Companion_instance_42;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.k6k(tmp, props.g6m(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  return props.f6m(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.j6k();
  }, null);
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
    var s = openSync(data);
    var _iterator__ex2g4s = $this.m6m().f1();
    while (_iterator__ex2g4s.g1()) {
      var format = _iterator__ex2g4s.h1();
      if (format.l6k(sliceStart_0(s), props)) {
        // Inline function 'korlibs.image.format.ImageFormats.decodeSuspend.<anonymous>' call
        sliceStart_0(s);
        var tmp = format.r6k(data, props, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        tmp$ret$1 = tmp;
        break $l$block;
      }
    }
    throw UnsupportedOperationException.ua('No suitable image format : MAGIC:' + readString_1(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
  }
  return tmp$ret$1;
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.m1();
  var tmp0_iterator = _this__u8e3s4.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.m6m();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.q6m();
  }, function (receiver, value) {
    return receiver.p6m(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.q6m();
  }, function (receiver, value) {
    return receiver.p6m(value);
  });
}
var Companion_instance_43;
function Companion_getInstance_51() {
  return Companion_instance_43;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_44;
function Companion_getInstance_52() {
  Type_initEntries();
  if (Companion_instance_44 === VOID)
    new Companion_34();
  return Companion_instance_44;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_52();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.p13_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.o13();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.p13_1;
      tmp_0 = tmp0_safe_receiver.k3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.q13_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.p13_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.p13_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.e41_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.e41_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.e41_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.e41_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.j6k(), $completion);
}
function *_generator_readImageDataContainer__g8j6x6(_this__u8e3s4, props, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  atlas = atlas === VOID ? null : atlas;
  var tmp = props.j6k().d6m();
  var tmp_0 = _this__u8e3s4.p22($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var out = tmp.s6i(openSync(tmp_0), props.j6k().g6m(_this__u8e3s4));
  return !(atlas == null) ? packInMutableAtlas(out, atlas) : out;
}
function readImageDataContainer(_this__u8e3s4, props, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readImageDataContainer__g8j6x6(_this__u8e3s4, props, atlas, $completion), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.m4q(result.q4p(), Unit_instance, name).w4p_1 : slice_0(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  var prop = !(file == null) ? props.g6m(file) : props;
  var rformats = !prop.g6j_1 ? listOf(prop.h6j_1) : prop.h6j_1 == null ? listOf(null) : prop.f6j_1 ? listOf_0([prop.h6j_1, null]) : listOf_0([null, prop.h6j_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.f1();
  while (_iterator__ex2g4s.g1()) {
    var format = _iterator__ex2g4s.h1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.r6k(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.p6k(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.oe();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.c6j_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.u3g(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.v3g(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_50().s4m_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g(file, bytes, props, $completion), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.j6k(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion), $completion);
}
function readVectorImage(_this__u8e3s4, $completion) {
  return readSVG(_this__u8e3s4, $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_16().ez('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, vfs, path, props, $completion) {
  var tmp = vfs.w21(path).w22($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.f6n(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme_0($this, data, props, $completion) {
  var tmp = $this.f6n(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.b6o_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.z6n(file.p1z(), file.v1z(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.b6o_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.a6o(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_45;
function Companion_getInstance_53() {
  Colorspace_initEntries();
  if (Companion_instance_45 === VOID)
    new Companion_35();
  return Companion_instance_45;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_53();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.mv();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof_0(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.s6o_1;
  var height = header.t6o_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.z6o_1);
  var databb = uncompress(pngdata.rv(), Companion_getInstance_15());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.b6p_1.z6o_1;
  var row32 = context.e6p_1;
  var tmp_2;
  if (header.z6o_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
      var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_28().a57(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, item)));
      destination.f(tmp$ret$1);
    }
    tmp_2 = Bitmap8.f51(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray(destination)));
  } else {
    tmp_2 = Bitmap32.c4p(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.y6o_1 === 1 ? $this.j6p_1 : $this.k6p_1;
  var _iterator__ex2g4s = passes.f1();
  while (_iterator__ex2g4s.g1()) {
    var pass = _iterator__ex2g4s.h1();
    var progression = step(until(pass.l6o_1, height), pass.n6o_1);
    var inductionVariable = progression.k2_1;
    var last = progression.l2_1;
    var step_0 = progression.m2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var col = pass.m6o_1;
        var colIncrement = pass.o6o_1;
        var pixelsInThisRow = width >>> pass.r6o_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.z6o_1), header.u6o_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.d6p_1;
        var lastRow = context.c6p_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.m6p(filter, lastRow, currentRow, header.z6o_1);
          switch (header.u6o_1) {
            case 1:
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < width)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n / 8 | 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.y4w(x, y, color);
                }
                 while (inductionVariable_0 < width);
              break;
            case 2:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.y4w(x_0, y_0, color_0);
                }
                 while (inductionVariable_1 < width);
              break;
            case 4:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.y4w(x_1, y_1, color_1);
                }
                 while (inductionVariable_2 < width);
              break;
            case 8:
              bmp8.y51(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.u6o_1;
              throw IllegalStateException.m5(toString(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.u6o_1 === 8) {
            $this.l6p(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_26(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_28(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.oe('An operation is not implemented: ' + reason);
            }
            bmp32.o51(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.u6o_1;
            throw IllegalStateException.m5(toString(message_0));
          }
        }
        context.n6p();
      }
       while (!(row === last));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof_0(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream_0(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_53().k6o_1.k3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.p6i_1 = this_0.s6o_1;
      $info.q6i_1 = this_0.t6o_1;
      $info.r6i_1 = imul(this_0.u6o_1, this_0.v6o_1.j6o_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().q2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.k12(asByteArray(rgbPalette), 0, data.a().q2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().q2();
      paletteCount._v = Math.max(a_0, b_0);
      data.k12(asByteArray(aPalette), 0, data.a().q2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.pv(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.pe($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.q6p();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.x6m();
  }
}
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_46;
function Companion_getInstance_54() {
  return Companion_instance_46;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.a6q_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.z6p_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.l6q_1 = value;
  $this.h6q_1 = $this.l6q_1.j2y();
  $this.i6q_1 = $this.l6q_1.k2y();
  $this.j6q_1 = 1.0 / $this.h6q_1;
  $this.k6q_1 = 1.0 / $this.i6q_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.t6p(_this__u8e3s4.v59_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.b6q(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.p6q(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.oe();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.j1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().i4t_1 : _RGBA___init__impl__lqpay5(colors.kl());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.kl()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.h13(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.h13(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_28().l5j(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.v31()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.i1(n) * NCOLORS);
}
var Companion_instance_47;
function Companion_getInstance_55() {
  return Companion_instance_47;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.z31()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.v59_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().h4r_1;
}
function getPaintWithUnits(_this__u8e3s4, transform, path) {
  var paint = _this__u8e3s4;
  if (!isInterface(paint, TransformedPaint))
    return _this__u8e3s4;
  if (paint.a6r().equals(GradientUnits_USER_SPACE_ON_USE_getInstance()))
    return _this__u8e3s4;
  var bounds = path.v3u();
  var m = Companion_getInstance_4().i2m_1.v2n(bounds.i2i_1, bounds.j2i_1).m2n(bounds.k2i_1, bounds.l2i_1);
  return paint.g6r(paint.n5w().z2m(m).z2m(transform.y2n()));
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientKind_SWEEP_getInstance() {
  GradientKind_initEntries();
  return GradientKind_SWEEP_instance;
}
function GradientInterpolationMethod_LINEAR_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_LINEAR_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_USER_SPACE_ON_USE_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_USER_SPACE_ON_USE_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
var color$delegate;
function get_ratio(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = ratio$delegate;
    var property = ratio$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r.e10_1;
      break $l$block;
    }
    tmp$ret$0 = res.e10_1;
  }
  return tmp$ret$0;
}
var ratio$delegate;
function get_matrix(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = matrix$delegate;
    var property = matrix$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var matrix$delegate;
var transform$delegate;
function get_easing(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = easing$delegate;
    var property = easing$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var easing$delegate;
function get_animation(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = animation$delegate;
    var property = animation$factory();
    var tmp0_elvis_lhs = this_0.r13_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.s13_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.r13_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var animation$delegate;
function CSS$Expression$exprStr$lambda(it) {
  return it.n6r_1;
}
var Companion_instance_48;
function Companion_getInstance_56() {
  if (Companion_instance_48 === VOID)
    new Companion_38();
  return Companion_instance_48;
}
var Companion_instance_49;
function Companion_getInstance_57() {
  return Companion_instance_49;
}
function tokenize$flush(buffer, out) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(buffer) === 0)
    return Unit_instance;
  out.f(new Token(buffer.toString()));
  buffer.wh();
}
function parseTransform$double(doubleArgs, index) {
  // Inline function 'kotlin.collections.getOrElse' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  if (0 <= index ? index < doubleArgs.j1() : false) {
    tmp = doubleArgs.i1(index);
  } else {
    // Inline function 'korlibs.image.style.Companion.parseTransform.double.<anonymous>' call
    tmp = 0.0;
  }
  return tmp;
}
function parseEasing$parseEasing(tr) {
  var tmp;
  switch (tr.p1v()) {
    case 'ease':
      tmp = cubic(Companion_getInstance_12(), 0.25, 0.1, 0.25, 1.0);
      break;
    case 'linear':
      tmp = cubic(Companion_getInstance_12(), 0.0, 0.0, 1.0, 1.0);
      break;
    case 'ease-in':
      tmp = cubic(Companion_getInstance_12(), 0.42, 0.0, 1.0, 1.0);
      break;
    case 'ease-out':
      tmp = cubic(Companion_getInstance_12(), 0.0, 0.0, 0.58, 1.0);
      break;
    case 'ease-in-out':
      tmp = cubic(Companion_getInstance_12(), 0.42, 0.0, 0.58, 1.0);
      break;
    case 'cubic-bezier':
      // Inline function 'kotlin.collections.map' call

      var this_0 = Companion_instance_50.v6r(tr);
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var item = tmp0_iterator.h1();
        // Inline function 'korlibs.image.style.Companion.parseEasing.parseEasing.<anonymous>' call
        var tmp0_elvis_lhs = Companion_instance_50.w6r(item);
        var tmp$ret$0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        destination.f(tmp$ret$0);
      }

      var doubleArgs = destination;
      tmp = cubic(Companion_getInstance_12(), doubleArgs.i1(0), doubleArgs.i1(1), doubleArgs.i1(2), doubleArgs.i1(3));
      break;
    case 'jump-start':
    case 'start':
      tmp = get_EASE_CLAMP_START(Companion_getInstance_12());
      break;
    case 'jump-end':
    case 'end':
      tmp = get_EASE_CLAMP_END(Companion_getInstance_12());
      break;
    case 'step-start':
      var tmp_0 = CSS$Companion$parseEasing$parseEasing$lambda;
      tmp = new sam$korlibs_math_interpolation_Easing$0(tmp_0);
      break;
    case 'step-end':
      var tmp_1 = CSS$Companion$parseEasing$parseEasing$lambda_0;
      tmp = new sam$korlibs_math_interpolation_Easing$0(tmp_1);
      break;
    default:
      var reason = tr.z12(-1);
      throw NotImplementedError.oe('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function CSS$Companion$tokenize$lambda($prev) {
  return function (c) {
    // Inline function 'kotlin.also' call
    var this_0 = $prev._v.equals(new Char(_Char___init__impl__6a9atx(42))) && equals(c, new Char(_Char___init__impl__6a9atx(47)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.Companion.tokenize.<anonymous>.<anonymous>' call
    $prev._v = c;
    return !this_0;
  };
}
function CSS$Companion$parseEasing$parseEasing$lambda(it) {
  return 1.0;
}
function CSS$Companion$parseEasing$parseEasing$lambda_0(it) {
  return 0.0;
}
var Companion_instance_50;
function Companion_getInstance_58() {
  return Companion_instance_50;
}
function CSSReader$parseRuleset$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.style.CSSReader.parseRuleset.<anonymous>' call
  var tmp = new Ratio(a.k6s_1);
  // Inline function 'korlibs.image.style.CSSReader.parseRuleset.<anonymous>' call
  var tmp$ret$1 = new Ratio(b.k6s_1);
  return compareValues(tmp, tmp$ret$1);
}
function getMatrix(_this__u8e3s4, key, default_0) {
  default_0 = default_0 === VOID ? Companion_getInstance_4().l2m() : default_0;
  _init_properties_CSS_kt__uqsclt();
  var tmp = toRatio_0(_this__u8e3s4.n6s_1);
  var tmp246_safe_receiver = _this__u8e3s4.o6s_1.bj(key);
  var tmp247_safe_receiver = tmp246_safe_receiver == null ? null : get_matrix(tmp246_safe_receiver);
  var tmp_0;
  if (tmp247_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_1;
    // Inline function 'korlibs.image.style.getMatrix.<anonymous>' call
    if (tmp247_safe_receiver.o2i()) {
      tmp_1 = tmp247_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  var tmp_2 = tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  var tmp248_safe_receiver = _this__u8e3s4.p6s_1.bj(key);
  var tmp1_elvis_lhs = tmp248_safe_receiver == null ? null : get_matrix(tmp248_safe_receiver);
  return interpolate(tmp, tmp_2, tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs);
}
function getRatio(_this__u8e3s4, key, default_0) {
  default_0 = default_0 === VOID ? Companion_getInstance_11().f10_1 : default_0;
  _init_properties_CSS_kt__uqsclt();
  var tmp = toRatio_0(_this__u8e3s4.n6s_1);
  var tmp244_safe_receiver = _this__u8e3s4.o6s_1.bj(key);
  var tmp0_elvis_lhs = tmp244_safe_receiver == null ? null : get_ratio(tmp244_safe_receiver);
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new Ratio(tmp_1)) == null) {
    tmp_0 = default_0;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var tmp_2 = tmp_0;
  var tmp245_safe_receiver = _this__u8e3s4.p6s_1.bj(key);
  var tmp1_elvis_lhs = tmp245_safe_receiver == null ? null : get_ratio(tmp245_safe_receiver);
  var tmp_3;
  var tmp_4 = tmp1_elvis_lhs;
  if ((tmp_4 == null ? null : new Ratio(tmp_4)) == null) {
    tmp_3 = default_0;
  } else {
    tmp_3 = tmp1_elvis_lhs;
  }
  return interpolate_2(tmp, tmp_2, tmp_3);
}
function color$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return new RGBA(Companion_instance_50.n6t($this$extraPropertyThis.e6s_1));
}
function color$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function ratio$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return new Ratio(Companion_instance_50.q6r($this$extraPropertyThis.e6s_1));
}
function ratio$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function matrix$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return Companion_instance_50.l6t($this$extraPropertyThis.e6s_1);
}
function matrix$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function transform$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return get_immutable(get_matrix($this$extraPropertyThis)).a2o();
}
function transform$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function easing$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return Companion_instance_50.o6t($this$extraPropertyThis.e6s_1);
}
function easing$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function animation$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  var tmp241_safe_receiver = $this$extraPropertyThis.bj('animation');
  var tmp;
  if (tmp241_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.animation$delegate.<anonymous>.<anonymous>' call
    tmp = Companion_instance_50.q6t(tmp241_safe_receiver.e6s_1);
  }
  return tmp;
}
function animation$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function ratio$factory() {
  return getPropertyCallableRef('ratio', 1, KProperty1, function (receiver) {
    return new Ratio(get_ratio(receiver));
  }, null);
}
function matrix$factory() {
  return getPropertyCallableRef('matrix', 1, KProperty1, function (receiver) {
    return get_matrix(receiver);
  }, null);
}
function easing$factory() {
  return getPropertyCallableRef('easing', 1, KProperty1, function (receiver) {
    return get_easing(receiver);
  }, null);
}
function animation$factory() {
  return getPropertyCallableRef('animation', 1, KProperty1, function (receiver) {
    return get_animation(receiver);
  }, null);
}
var properties_initialized_CSS_kt_ks83l9;
function _init_properties_CSS_kt__uqsclt() {
  if (!properties_initialized_CSS_kt_ks83l9) {
    properties_initialized_CSS_kt_ks83l9 = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = color$delegate$lambda;
    var transform = color$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.t13_1 = transform;
    color$delegate = this_0;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_1 = ratio$delegate$lambda;
    var transform_0 = ratio$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_1 = new PropertyThis(null, default_1);
    this_1.t13_1 = transform_0;
    ratio$delegate = this_1;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_2 = matrix$delegate$lambda;
    var transform_1 = matrix$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_2 = new PropertyThis(null, default_2);
    this_2.t13_1 = transform_1;
    matrix$delegate = this_2;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_3 = transform$delegate$lambda;
    var transform_2 = transform$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_3 = new PropertyThis(null, default_3);
    this_3.t13_1 = transform_2;
    transform$delegate = this_3;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_4 = easing$delegate$lambda;
    var transform_3 = easing$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_4 = new PropertyThis(null, default_4);
    this_4.t13_1 = transform_3;
    easing$delegate = this_4;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_5 = animation$delegate$lambda;
    var transform_4 = animation$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_5 = new PropertyThis(null, default_5);
    this_5.t13_1 = transform_4;
    animation$delegate = this_5;
  }
}
function _get_listener__4cngyf($this) {
  return $this.r6u_1.q6u_1;
}
var Companion_instance_51;
function Companion_getInstance_59() {
  return Companion_instance_51;
}
function RichTextData$Line$defaultStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.n6v_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      if (element instanceof TextNode) {
        destination.f(element);
      }
    }
    var tmp260_safe_receiver = firstOrNull_1(destination);
    var tmp0_elvis_lhs = tmp260_safe_receiver == null ? null : tmp260_safe_receiver.y6v_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.o6v_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_60().a6w_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$defaultLastStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.n6v_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      if (element instanceof TextNode) {
        destination.f(element);
      }
    }
    var tmp261_safe_receiver = lastOrNull_0(destination);
    var tmp0_elvis_lhs = tmp261_safe_receiver == null ? null : tmp261_safe_receiver.y6v_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.o6v_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_60().a6w_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$text$delegate$lambda$lambda(it) {
  var tmp0_elvis_lhs = it.o2f();
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function RichTextData$Line$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.n6v_1, '', VOID, VOID, VOID, VOID, RichTextData$Line$text$delegate$lambda$lambda);
  };
}
function RichTextData$Line$width$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.n6v_1.a1()) {
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var tmp0_iterator = this$0.n6v_1.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        var tmp_0 = sum;
        // Inline function 'korlibs.image.text.Line.width$delegate.<anonymous>.<anonymous>' call
        sum = tmp_0 + element.j2y();
      }
      tmp = sum;
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
}
function RichTextData$Line$maxLineHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.n6v_1.a1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.n6v_1.f1();
      if (!iterator.g1())
        throw NoSuchElementException.c7();
      // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.h1().d5l();
      while (iterator.g1()) {
        // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.h1().d5l();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.b6w())).d5l();
    }
    return tmp;
  };
}
function RichTextData$Line$maxHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.n6v_1.a1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.n6v_1.f1();
      if (!iterator.g1())
        throw NoSuchElementException.c7();
      // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.h1().k2y();
      while (iterator.g1()) {
        // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.h1().k2y();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.b6w())).k2y();
    }
    return tmp;
  };
}
function RichTextData$Line$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.l1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Line.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.n6v_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var node = _iterator__ex2g4s.h1();
      if (node instanceof TextNode) {
        this_0.f(node.y6v_1.c6w_1);
      }
    }
    return this_0;
  };
}
var Companion_instance_52;
function Companion_getInstance_60() {
  if (Companion_instance_52 === VOID)
    new Companion_42();
  return Companion_instance_52;
}
function RichTextData$TextNode$bounds$delegate$lambda(this$0) {
  return function () {
    return getTextBounds(this$0.y6v_1.c6w_1, this$0.y6v_1.d6w_1, this$0.x6v_1);
  };
}
var Companion_instance_53;
function Companion_getInstance_61() {
  if (Companion_instance_53 === VOID)
    new Companion_43();
  return Companion_instance_53;
}
function wordWrap$addNode(currentLine, currentLineWidth, node) {
  var lastNode = lastOrNull_0(currentLine);
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!currentLine.a1()) {
    tmp_4 = node instanceof TextNode;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = lastNode instanceof TextNode;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = lastNode.q6w(node.x6v_1).equals(node);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = node.y6v_1.i6w_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = node.x6v_1;
    tmp_0 = !isBlank(this_0);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = lastNode.x6v_1;
    tmp = !isBlank(this_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    removeLast(currentLine);
    currentLineWidth._v = currentLineWidth._v - lastNode.f6c().j2y();
    return wordWrap$addNode(currentLine, currentLineWidth, node.q6w(lastNode.x6v_1 + node.x6v_1));
  } else {
    currentLine.f(node);
    currentLineWidth._v = currentLineWidth._v + node.j2y();
  }
}
function wordWrap$finishLine(currentLine, outLines, currentLineWidth) {
  if (currentLine.a1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var element = Line.j6w(toList(currentLine));
  outLines.f(element);
  currentLine.o3();
  currentLineWidth._v = 0.0;
}
function RichTextData$text$delegate$lambda$lambda(it) {
  return it.o2f();
}
function RichTextData$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.u6w_1, '\n', VOID, VOID, VOID, VOID, RichTextData$text$delegate$lambda$lambda);
  };
}
function RichTextData$width$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = this$0.u6w_1.f1();
    if (!iterator.g1())
      throw NoSuchElementException.c7();
    // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
    var maxValue = iterator.h1().j2y();
    while (iterator.g1()) {
      // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
      var v = iterator.h1().j2y();
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    return maxValue;
  };
}
function RichTextData$height$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this$0.u6w_1.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.RichTextData.height$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.m6w();
    }
    return sum;
  };
}
function RichTextData$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.l1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.RichTextData.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.u6w_1.f1();
    while (_iterator__ex2g4s.g1()) {
      var line = _iterator__ex2g4s.h1();
      this_0.k1(line.o6w());
    }
    return this_0;
  };
}
function text$factory() {
  return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
    return receiver.o2f();
  }, null);
}
function width$factory() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.j2y();
  }, null);
}
function height$factory() {
  return getPropertyCallableRef('height', 1, KProperty1, function (receiver) {
    return receiver.k2y();
  }, null);
}
function allFonts$factory() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.o6w();
  }, null);
}
function defaultStyle$factory() {
  return getPropertyCallableRef('defaultStyle', 1, KProperty1, function (receiver) {
    return receiver.b6w();
  }, null);
}
function defaultLastStyle$factory() {
  return getPropertyCallableRef('defaultLastStyle', 1, KProperty1, function (receiver) {
    return receiver.l6w();
  }, null);
}
function text$factory_0() {
  return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
    return receiver.o2f();
  }, null);
}
function width$factory_0() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.j2y();
  }, null);
}
function maxLineHeight$factory() {
  return getPropertyCallableRef('maxLineHeight', 1, KProperty1, function (receiver) {
    return receiver.m6w();
  }, null);
}
function maxHeight$factory() {
  return getPropertyCallableRef('maxHeight', 1, KProperty1, function (receiver) {
    return receiver.n6w();
  }, null);
}
function allFonts$factory_0() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.o6w();
  }, null);
}
function bounds$factory() {
  return getPropertyCallableRef('bounds', 1, KProperty1, function (receiver) {
    return receiver.f6c();
  }, null);
}
function fromHTML(_this__u8e3s4, html, style) {
  style = style === VOID ? Companion_getInstance_60().a6w_1 : style;
  var lines = fastArrayListOf([]);
  var nodes = fastArrayListOf([]);
  fromHTML$processNode(nodes, lines, Xml('<div>' + html + '<\/div>'), style);
  fromHTML$flushLine(nodes, lines);
  return RichTextData.k6x(lines);
}
function fromHTML$flushLine(nodes, lines, force) {
  force = force === VOID ? false : force;
  if (nodes.a1() && !force)
    return Unit_instance;
  lines.f(Line.j6w(toList(nodes)));
  nodes.o3();
}
function fromHTML$processNode(nodes, lines, node, style) {
  if (node.s2e_1 === 'br') {
    nodes.f(new TextNode('', style));
    fromHTML$flushLine(nodes, lines, true);
    return Unit_instance;
  }
  if (get_isText(node)) {
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new TextNode(node.o2f(), style);
    nodes.f(element);
  }
  var tmp264_bold = node.s2e_1 === 'b' || node.s2e_1 === 'strong' ? true : style.f6w_1;
  var tmp265_italic = node.s2e_1 === 'i' || node.s2e_1 === 'em' ? true : style.e6w_1;
  var tmp266_underline = node.s2e_1 === 'u' ? true : style.g6w_1;
  var tmp0_elvis_lhs = node.e2g('size');
  var tmp267_textSize = tmp0_elvis_lhs == null ? style.d6w_1 : tmp0_elvis_lhs;
  var tmp263_safe_receiver = node.g2g('color');
  var tmp;
  if (tmp263_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.fromHTML.processNode.<anonymous>' call
    tmp = Colors_getInstance().r59(tmp263_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  var tmp_1 = tmp1_elvis_lhs;
  if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
    tmp_0 = style.h6w_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var tmp268_color = tmp_0;
  var rstyle = style.c6x(VOID, tmp267_textSize, tmp265_italic, tmp264_bold, tmp266_underline, tmp268_color);
  var _iterator__ex2g4s = node.q2f().f1();
  while (_iterator__ex2g4s.g1()) {
    var child = _iterator__ex2g4s.h1();
    fromHTML$processNode(nodes, lines, child, rstyle);
  }
}
function bounds(_this__u8e3s4, maxHeight) {
  maxHeight = maxHeight === VOID ? 2147483647 : maxHeight;
  return bounds_0(place(_this__u8e3s4, Companion_getInstance_2().d2t(0, 0, 2147483647, maxHeight)));
}
function drawRichText(_this__u8e3s4, text, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, textRangeStart, textRangeEnd) {
  bounds = bounds === VOID ? Companion_getInstance_2().d2t(0, 0, _this__u8e3s4.j2y(), _this__u8e3s4.k2y()) : bounds;
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_64().h5s_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  var result = place(text, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways);
  var n = 0;
  var metrics = new TextMetricsResult();
  var _iterator__ex2g4s = result.s6x_1.f1();
  while (_iterator__ex2g4s.g1()) {
    var place_0 = _iterator__ex2g4s.h1();
    var tmp274_text = place_0.t6x_1;
    var tmp275_pos = place_0.u6x_1;
    var tmp276_size = place_0.v6x_1;
    var tmp277_font = place_0.w6x_1;
    var tmp278_fillStyle = place_0.x6x_1;
    var tmp279_stroke = place_0.y6x_1;
    var tmp280_align = Companion_getInstance_64().l5s_1;
    var tmp281_textRangeStart = textRangeStart - n | 0;
    var tmp282_textRangeEnd = textRangeEnd - n | 0;
    var tmp283_renderer = get_DefaultStringTextRenderer();
    _this__u8e3s4.z6x(tmp274_text, tmp275_pos, VOID, VOID, tmp277_font, tmp276_size, tmp283_renderer, tmp280_align, metrics, tmp278_fillStyle, tmp279_stroke, tmp281_textRangeStart, tmp282_textRangeEnd);
    n = n + metrics.z5r_1.j1() | 0;
  }
  return n;
}
function place(_this__u8e3s4, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, out) {
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_64().h5s_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  out = out === VOID ? new RichTextDataPlacements() : out;
  var text = _this__u8e3s4;
  out.s6x_1.o3();
  if (text.u6w_1.a1())
    return out;
  var tmp271_maxLineWidth = wordWrap ? bounds.k2i_1 : Infinity;
  var tmp272_maxHeight = bounds.l2i_1;
  var rtext = text.p6x(tmp271_maxLineWidth, tmp272_maxHeight, includePartialLines, ellipsis, true, includeFirstLineAlways);
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!rtext.u6w_1.a1()) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = dropLast(rtext.u6w_1, 1).f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      var tmp_0 = sum;
      // Inline function 'korlibs.image.text.place.<anonymous>' call
      sum = tmp_0 + element.m6w();
    }
    tmp = sum + last(rtext.u6w_1).n6w();
  } else {
    tmp = 0.0;
  }
  var totalHeight = tmp;
  var y = {_v: bounds.j2i_1 + (bounds.l2i_1 - totalHeight) * _VerticalAlign___get_ratioFake0__impl__5adpb3(align.a5u_1)};
  var _iterator__ex2g4s = rtext.u6w_1.f1();
  while (_iterator__ex2g4s.g1()) {
    var line = _iterator__ex2g4s.h1();
    var x = {_v: bounds.i2i_1 - HorizontalAlign__getOffsetX_impl_urzzxf(align.z5t_1, line.j2y()) + HorizontalAlign__getOffsetX_impl_urzzxf(align.z5t_1, bounds.k2i_1)};
    var wordSpacing = equals(align.z5t_1, Companion_getInstance_63().d6y_1) ? (bounds.k2i_1 - line.j2y()) / (line.n6v_1.j1() - 1) : 0.0;
    y._v = y._v + line.n6w();
    var _iterator__ex2g4s_0 = line.n6v_1.f1();
    while (_iterator__ex2g4s_0.g1()) {
      var node = _iterator__ex2g4s_0.h1();
      if (node instanceof TextNode) {
        if (node.y6v_1.f6w_1) {
          place$render(out, node, x, y, fill, stroke, 1.0, 0.0);
        }
        place$render(out, node, x, y, fill, stroke, 0.0, 0.0);
        x._v = x._v + node.j2y();
        x._v = x._v + wordSpacing;
      }
    }
    y._v = y._v + (line.m6w() - line.n6w());
  }
  return out;
}
function bounds_0(_this__u8e3s4) {
  var bb = Companion_getInstance_5().y2i();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = _this__u8e3s4.s6x_1.f1();
  while (tmp0_iterator.g1()) {
    var element = tmp0_iterator.h1();
    // Inline function 'korlibs.image.text.bounds.<anonymous>' call
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, getTextBounds(element.w6x_1, element.v6x_1, element.t6x_1).e5t_1);
  }
  return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
}
function place$render($out, node, x, y, $fill, $stroke, dx, dy) {
  var tmp = Vector2D.k2h(x._v + dx, y._v + dy);
  var tmp0_elvis_lhs = node.y6v_1.h6w_1;
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
    tmp_0 = $fill;
  } else {
    var tmp_2 = tmp0_elvis_lhs;
    tmp_0 = tmp_2 == null ? null : new RGBA(tmp_2);
  }
  $out.s6x_1.f(new Placement(node.x6v_1, tmp, node.y6v_1.d6w_1, node.y6v_1.c6w_1, tmp_0, $stroke));
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_62().m6y_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function _VerticalAlign___get_ratioFake0__impl__5adpb3($this) {
  return equals($this, Companion_getInstance_62().m6y_1) ? 0.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_54;
function Companion_getInstance_62() {
  if (Companion_instance_54 === VOID)
    new Companion_44();
  return Companion_instance_54;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_62().m6y_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_62().m6y_1) ? 0.0 : interpolate_3(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.v5k_1, font.v5k_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_62().j6y_1) ? 'TOP' : equals($this, Companion_getInstance_62().k6y_1) ? 'MIDDLE' : equals($this, Companion_getInstance_62().l6y_1) ? 'BOTTOM' : equals($this, Companion_getInstance_62().m6y_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.p6y_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_63().d6y_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_55;
function Companion_getInstance_63() {
  if (Companion_instance_55 === VOID)
    new Companion_45();
  return Companion_instance_55;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_63().d6y_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_63().e6y_1) ? 'LEFT' : equals($this, Companion_getInstance_63().f6y_1) ? 'CENTER' : equals($this, Companion_getInstance_63().g6y_1) ? 'RIGHT' : equals($this, Companion_getInstance_63().d6y_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.q6y_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_56;
function Companion_getInstance_64() {
  if (Companion_instance_56 === VOID)
    new Companion_46();
  return Companion_instance_56;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add_0($this, x, y) {
  var rx = $this.lz().i2h_1 + $this.n5w().d2n(x, y);
  var ry = $this.lz().j2h_1 + $this.n5w().g2n(x, y);
  $this.u5t_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.u5t_1, Vector2D.k2h(rx, ry));
  if ($this.v5t_1 === 0) {
    $this.t5t_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.t5t_1, Vector2D.k2h(rx, ry));
  }
  var _receiver__tnumb7 = $this.x5t_1;
  _receiver__tnumb7.f5u_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.f5u_1, Vector2D.k2h(rx, ry));
}
function add_1($this, rect) {
  var fx = rect.p2i();
  var fy = rect.r2i();
  var w = rect.k2i_1;
  var h = rect.l2i_1;
  add_0($this, fx, fy);
  add_0($this, fx + w, fy);
  add_0($this, fx + w, fy + h);
  add_0($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke_1(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke_1(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.t6y(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.z5v(text, c);
  $this$CreateWStringTextRenderer.v5w(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.z5v(text, c);
  $this$CreateStringTextRenderer.v5w(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function _Tile___init__impl__tdix77(raw) {
  return raw;
}
function _Tile___get_raw__impl__kp6cq8($this) {
  return $this;
}
function _Tile___get_rawLow__impl__rdabpi($this) {
  return get_low(_Tile___get_raw__impl__kp6cq8($this));
}
function _Tile___get_rawHigh__impl__7pktiq($this) {
  return get_high(_Tile___get_raw__impl__kp6cq8($this));
}
function _Tile___get_data__impl__sfu1ss($this) {
  return _Tile___get_rawLow__impl__rdabpi($this);
}
function _Tile___get_isValid__impl__nlo03e($this) {
  return !_Tile___get_raw__impl__kp6cq8($this).equals(new Long(-1, -1));
}
function _Tile___get_isInvalid__impl__yfg9ed($this) {
  return _Tile___get_raw__impl__kp6cq8($this).equals(new Long(-1, -1));
}
function _Tile___get_tile__impl__nfq1aw($this) {
  return extract(_Tile___get_rawLow__impl__rdabpi($this), 0, 26);
}
function _Tile___get_rotate__impl__5kjdv9($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_Tile___get_rawLow__impl__rdabpi($this) >>> 29 | 0) & 1) === 0);
}
function _Tile___get_flipY__impl__95aqcs($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_Tile___get_rawLow__impl__rdabpi($this) >>> 30 | 0) & 1) === 0);
}
function _Tile___get_flipX__impl__jobqpf($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_Tile___get_rawLow__impl__rdabpi($this) >>> 31 | 0) & 1) === 0);
}
function _Tile___get_offsetX__impl__qwhdsd($this) {
  return extract16Signed(_Tile___get_rawHigh__impl__7pktiq($this), 0);
}
function _Tile___get_offsetY__impl__1x539u($this) {
  return extract16Signed(_Tile___get_rawHigh__impl__7pktiq($this), 16);
}
var Companion_instance_57;
function Companion_getInstance_65() {
  if (Companion_instance_57 === VOID)
    new Companion_47();
  return Companion_instance_57;
}
function Tile__toString_impl_iy9thp($this) {
  return 'Tile(raw=' + $this.toString() + ')';
}
function Tile__hashCode_impl_ubobok($this) {
  return $this.hashCode();
}
var Companion_instance_58;
function Companion_getInstance_66() {
  return Companion_instance_58;
}
var TileMapRepeat_NONE_instance;
var TileMapRepeat_REPEAT_instance;
var TileMapRepeat_MIRROR_instance;
function TileMapRepeat$lambda(v, max) {
  return v;
}
function TileMapRepeat$lambda_0(v, max) {
  return umod(v, max);
}
function TileMapRepeat$lambda_1(v, max) {
  var r = umod(v, max);
  return ((v / max | 0) % 2 | 0) === 0 ? r : (max - 1 | 0) - r | 0;
}
var TileMapRepeat_entriesInitialized;
function TileMapRepeat_initEntries() {
  if (TileMapRepeat_entriesInitialized)
    return Unit_instance;
  TileMapRepeat_entriesInitialized = true;
  TileMapRepeat_NONE_instance = new TileMapRepeat('NONE', 0, TileMapRepeat$lambda);
  TileMapRepeat_REPEAT_instance = new TileMapRepeat('REPEAT', 1, TileMapRepeat$lambda_0);
  TileMapRepeat_MIRROR_instance = new TileMapRepeat('MIRROR', 2, TileMapRepeat$lambda_1);
}
function TileMapRepeat_NONE_getInstance() {
  TileMapRepeat_initEntries();
  return TileMapRepeat_NONE_instance;
}
var Companion_instance_59;
function Companion_getInstance_67() {
  if (Companion_instance_59 === VOID)
    new Companion_49();
  return Companion_instance_59;
}
function TileSet$base$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.v71_1.g37_1 === 0) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = get_bmp(this$0.v71_1.v37().n71_1);
    }
    return tmp;
  };
}
function TileSet$hasMultipleBaseBitmaps$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this$0.v71_1.m3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.a1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.f1();
      while (tmp0_iterator.g1()) {
        var element = tmp0_iterator.h1();
        // Inline function 'korlibs.image.tiles.TileSet.hasMultipleBaseBitmaps$delegate.<anonymous>.<anonymous>' call
        if (!(element === null) && !(get_bmp(element.n71_1) === this$0.o33())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function TileSet$infos$delegate$lambda(this$0) {
  return function () {
    var tmp = 0;
    var tmp300_safe_receiver = maxOrNull(this$0.v71_1.l3());
    var tmp0_elvis_lhs = tmp300_safe_receiver == null ? null : tmp300_safe_receiver + 1 | 0;
    var tmp_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this$0.v71_1.i1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function TileSet$textures$delegate$lambda(this$0) {
  return function () {
    var tmp = 0;
    var tmp301_safe_receiver = maxOrNull(this$0.v71_1.l3());
    var tmp0_elvis_lhs = tmp301_safe_receiver == null ? null : tmp301_safe_receiver + 1 | 0;
    var tmp_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp302_safe_receiver = this$0.v71_1.i1(tmp_2);
      tmp_1[tmp_2] = tmp302_safe_receiver == null ? null : tmp302_safe_receiver.n71_1;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function base$factory() {
  return getPropertyCallableRef('base', 1, KProperty1, function (receiver) {
    return receiver.o33();
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.w3u();
  }, null);
}
function textures$factory() {
  return getPropertyCallableRef('textures', 1, KProperty1, function (receiver) {
    return receiver.d72();
  }, null);
}
function Tile(tile, orientation, offsetX, offsetY) {
  var tmp;
  if (orientation === VOID) {
    // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call
    tmp = Companion_getInstance_7().v40_1;
  } else {
    tmp = orientation;
  }
  orientation = tmp;
  offsetX = offsetX === VOID ? 0 : offsetX;
  offsetY = offsetY === VOID ? 0 : offsetY;
  return Companion_getInstance_65().o70(tile, offsetX, offsetY, get_tileFlipX(orientation), get_tileFlipY(orientation), get_tileRot(orientation));
}
function get_tileFlipX(_this__u8e3s4) {
  return _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 1 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 2 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 4 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 5;
}
function get_tileFlipY(_this__u8e3s4) {
  return _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 2 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 3 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 5 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 6;
}
function get_tileRot(_this__u8e3s4) {
  return (_SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) % 2 | 0) === 1;
}
function flippedX(_this__u8e3s4) {
  return withOrientation(_this__u8e3s4, SliceOrientation__flippedX_impl_m25zo9(get_orientation_0(_this__u8e3s4)));
}
function flippedY(_this__u8e3s4) {
  return withOrientation(_this__u8e3s4, SliceOrientation__flippedY_impl_mj7m2g(get_orientation_0(_this__u8e3s4)));
}
function rotatedRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  return withOrientation(_this__u8e3s4, SliceOrientation__rotatedRight_impl_m8di3g(get_orientation_0(_this__u8e3s4), offset));
}
function withOrientation(_this__u8e3s4, orientation) {
  return Tile(_Tile___get_tile__impl__nfq1aw(_this__u8e3s4), orientation, _Tile___get_offsetX__impl__qwhdsd(_this__u8e3s4), _Tile___get_offsetY__impl__1x539u(_this__u8e3s4));
}
function get_orientation_0(_this__u8e3s4) {
  return _Tile___get_flipY__impl__95aqcs(_this__u8e3s4) ? _Tile___get_flipX__impl__jobqpf(_this__u8e3s4) ? _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_7().a41_1 : Companion_getInstance_7().x40_1 : _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_7().y40_1 : Companion_getInstance_7().b41_1 : _Tile___get_flipX__impl__jobqpf(_this__u8e3s4) ? _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_7().w40_1 : Companion_getInstance_7().z40_1 : _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_7().c41_1 : Companion_getInstance_7().v40_1;
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.x72_1.l73_1.y2k()) {
    this$0.x72_1.j73_1 = this$0.v72_1 ? 4 : 1;
    this$0.b73_1.h72_1 = filler;
    this$0.b73_1.q72_1 = $state.i5n_1;
    this$0.b73_1.z33();
    var tmp = $winding == null ? fillPath.o3y_1 : $winding;
    this$0.x72_1.r73(this$0.w72_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.b73_1.fd();
    this$0.x72_1.l73_1.z33();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.b73_1.f73(x0, x1, y);
    return Unit_instance;
  };
}
function _get_bmp32__jeda37($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.z74_1;
  bmp32$factory();
  return this_0.b2();
}
function BitmapVector$nativeImage$delegate$lambda($width, $height, this$0, $premultiplied) {
  return function () {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_0 = NativeImageOrBitmap32($width, $height, this$0.v74_1, $premultiplied);
    var antialiased = this$0.u74_1;
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.i4p_1;
    if (true) {
      this_0.w1w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.y4x(antialiased);
      try {
        // Inline function 'korlibs.image.vector.BitmapVector.nativeImage$delegate.<anonymous>.<anonymous>' call
        ctx.o6e(this$0.s74_1, this$0.s74_1);
        ctx.m5w(-this$0.r74_1.i2i_1, -this$0.r74_1.j2i_1);
        ctx.a75(this$0.q74_1, this$0.t74_1, this$0.v74_1);
      }finally {
        ctx.o18();
      }
    }finally {
      result = true ? this_0.q4q(rect) : 0;
    }
    return this_0;
  };
}
function BitmapVector$bmp32$delegate$lambda(this$0) {
  return function () {
    return this$0.b75().q4p();
  };
}
function nativeImage$factory() {
  return getPropertyCallableRef('nativeImage', 1, KProperty1, function (receiver) {
    return receiver.b75();
  }, null);
}
function bmp32$factory() {
  return getPropertyCallableRef('bmp32', 1, KProperty1, function (receiver) {
    return _get_bmp32__jeda37(receiver);
  }, null);
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.y5j_1, dstN, src.y5j_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_60;
function Companion_getInstance_68() {
  if (Companion_instance_60 === VOID)
    new Companion_50();
  return Companion_instance_60;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_61;
function Companion_getInstance_69() {
  return Companion_instance_61;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.y5j_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.y5j_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.y5j_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.y5j_1, dstN, dst.y5j_1, dstN, src.y5j_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.y5j_1, dstN, src.y5j_1, srcN, dst.y5j_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_68();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.f75(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_68().e75_1);
  var tmp_0 = Companion_getInstance_68();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.f75(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_68();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.f75(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_68().e75_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_68().e75_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_68().e75_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_68().e75_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_68().e75_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_68().e75_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_68().e75_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_68().e75_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_61.i4b();
}
var BlendMode_NORMAL_instance;
var BlendMode_MULTIPLY_instance;
var BlendMode_SCREEN_instance;
var BlendMode_OVERLAY_instance;
var BlendMode_DARKEN_instance;
var BlendMode_LIGHTEN_instance;
var BlendMode_COLOR_DODGE_instance;
var BlendMode_COLOR_BURN_instance;
var BlendMode_HARD_LIGHT_instance;
var BlendMode_SOFT_LIGHT_instance;
var BlendMode_DIFFERENCE_instance;
var BlendMode_EXCLUSION_instance;
var BlendMode_HUE_instance;
var BlendMode_SATURATION_instance;
var BlendMode_COLOR_instance;
var BlendMode_LUMINOSITY_instance;
var BlendMode_ADDITION_instance;
var BlendMode_SUBTRACT_instance;
var BlendMode_DIVIDE_instance;
var BlendMode_entriesInitialized;
function BlendMode_initEntries() {
  if (BlendMode_entriesInitialized)
    return Unit_instance;
  BlendMode_entriesInitialized = true;
  BlendMode_NORMAL_instance = new BlendMode('NORMAL', 0, Companion_getInstance_68().e75_1);
  BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 1, Companion_getInstance_68().e75_1);
  BlendMode_SCREEN_instance = new BlendMode('SCREEN', 2, Companion_getInstance_68().e75_1);
  BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 3, Companion_getInstance_68().e75_1);
  BlendMode_DARKEN_instance = new BlendMode('DARKEN', 4, Companion_getInstance_68().e75_1);
  BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 5, Companion_getInstance_68().e75_1);
  BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 6, Companion_getInstance_68().e75_1);
  BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 7, Companion_getInstance_68().e75_1);
  BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 8, Companion_getInstance_68().e75_1);
  BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 9, Companion_getInstance_68().e75_1);
  BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 10, Companion_getInstance_68().e75_1);
  BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 11, Companion_getInstance_68().e75_1);
  BlendMode_HUE_instance = new BlendMode('HUE', 12, Companion_getInstance_68().e75_1);
  BlendMode_SATURATION_instance = new BlendMode('SATURATION', 13, Companion_getInstance_68().e75_1);
  BlendMode_COLOR_instance = new BlendMode('COLOR', 14, Companion_getInstance_68().e75_1);
  BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 15, Companion_getInstance_68().e75_1);
  BlendMode_ADDITION_instance = new BlendMode('ADDITION', 16, Companion_getInstance_68().e75_1);
  BlendMode_SUBTRACT_instance = new BlendMode('SUBTRACT', 17, Companion_getInstance_68().e75_1);
  BlendMode_DIVIDE_instance = new BlendMode('DIVIDE', 18, Companion_getInstance_68().e75_1);
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function BlendMode_NORMAL_getInstance() {
  BlendMode_initEntries();
  return BlendMode_NORMAL_instance;
}
function BlendMode_MULTIPLY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_MULTIPLY_instance;
}
function BlendMode_SCREEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SCREEN_instance;
}
function BlendMode_OVERLAY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_OVERLAY_instance;
}
function BlendMode_DARKEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DARKEN_instance;
}
function BlendMode_LIGHTEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_LIGHTEN_instance;
}
function BlendMode_COLOR_DODGE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_DODGE_instance;
}
function BlendMode_COLOR_BURN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_BURN_instance;
}
function BlendMode_HARD_LIGHT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_HARD_LIGHT_instance;
}
function BlendMode_SOFT_LIGHT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SOFT_LIGHT_instance;
}
function BlendMode_DIFFERENCE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DIFFERENCE_instance;
}
function BlendMode_EXCLUSION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_EXCLUSION_instance;
}
function BlendMode_HUE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_HUE_instance;
}
function BlendMode_SATURATION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SATURATION_instance;
}
function BlendMode_COLOR_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_instance;
}
function BlendMode_LUMINOSITY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_LUMINOSITY_instance;
}
function BlendMode_ADDITION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_ADDITION_instance;
}
function BlendMode_SUBTRACT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SUBTRACT_instance;
}
function BlendMode_DIVIDE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DIVIDE_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.s5m_1.z2n();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.d4y_1.s5m_1;
    if (this_0.n2i()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2h(this_0.d2n(p.i2h_1, p.j2h_1), this_0.g2n(p.i2h_1, p.j2h_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.m3y_1;
  var n_0 = 0;
  while (n_0 < this_0.j1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.h13(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.n3y_1.i1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2h(tmp, path.n3y_1.i1(_unary__edvuaz_1));
        _this__u8e3s4.e3y(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.n3y_1.i1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2h(tmp_0, path.n3y_1.i1(_unary__edvuaz_3));
        _this__u8e3s4.g3y(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.n3y_1.i1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.k2h(tmp_1, path.n3y_1.i1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.n3y_1.i1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.k2h(tmp_2, path.n3y_1.i1(_unary__edvuaz_7));
        _this__u8e3s4.h3y(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.n3y_1.i1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.k2h(tmp_3, path.n3y_1.i1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.n3y_1.i1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.k2h(tmp_4, path.n3y_1.i1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.n3y_1.i1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.k2h(tmp_5, path.n3y_1.i1(_unary__edvuaz_13));
        _this__u8e3s4.j3y(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.u6();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_5().y2i();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.u5m_1.v3u());
  var tmp = bb;
  var tmp332_safe_receiver = state.t5m_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp332_safe_receiver == null ? null : tmp332_safe_receiver.v3u());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).j2u(state.s5m_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.c4p(toIntCeil_0(bounds.k2i_1), toIntCeil_0(bounds.l2i_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.x6p(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_4().l2m().q2n(-bounds.p2i(), -bounds.r2i()));
}
function scaled_0(_this__u8e3s4, sx, sy) {
  sx = sx === VOID ? 1.0 : sx;
  sy = sy === VOID ? sx : sy;
  return new scaled$1(_this__u8e3s4, sx, sy);
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.m75();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_62;
function Companion_getInstance_70() {
  CycleMethod_initEntries();
  if (Companion_instance_62 === VOID)
    new Companion_52();
  return Companion_instance_62;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_70();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.v3_1, 0), y.v3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_70().m77_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_70().m77_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.k2h(_CycleMethodPair___get_x__impl__dgz5uj($this).o77(ratio.i2h_1), _CycleMethodPair___get_y__impl__fcnb7o($this).o77(ratio.j2h_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.n6e(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.n6e(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.j2y() - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.k2y() - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.z4q(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.f53(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.g53(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.h53(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.i53(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.j53(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.q53(-1.0);
  msdf_0.s53(-1.0, +1.0);
  msdf_0.p53();
  var msdfBitmap = msdf_0.o4q();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.i57(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).o4q(), VOID, 0);
  return newImage.b57_1.q4p();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.d53(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.i2l();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.y3t_1, item.z3t_1);
    destination.f(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.m1();
  var tmp0_iterator_0 = colorizedCurves.f1();
  while (tmp0_iterator_0.g1()) {
    var element = tmp0_iterator_0.h1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.p77_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.k2y();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.j2y();
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.k2h(x + 0.5, y + 0.5);
          var inside = path.u4b(p);
          var allDist = allColorizedCurves.x77().b78(p);
          var redDist = allColorizedCurves.c78().b78(p);
          var greenDist = allColorizedCurves.d78().b78(p);
          var blueDist = allColorizedCurves.e78().b78(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.j53(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.p77_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.g78_1) === 0)) {
        destination.f(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.p77_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.g78_1) === 0)) {
        destination.f(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.p77_1;
    var destination = ArrayList.m1();
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var element = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.g78_1) === 0)) {
        destination.f(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.p77_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.f78_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.h78();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.f78_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.i78();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.f78_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.j78();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.f1();
    while (tmp0_iterator.g1()) {
      var item = tmp0_iterator.h1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.f78_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.j1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.f(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().g4r_1;
  if (index === 0)
    return Colors_getInstance().i4t_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().w4w_1 : Colors_getInstance().g4s_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().g4r_1);
    if (true) {
      $this$NativeImageContext2d.b5t();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.x76(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.h78();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.i78();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.j78();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.x77();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.c78();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.d78();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.e78();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.m1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.m3y_1;
  var n_0 = 0;
  while (n_0 < this_1.j1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.h13(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.k2h(tmp, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_1));
        var x = destruct.km();
        var y = destruct.lm();
        this_0.f('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.k2h(tmp_0, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_3));
        var x_0 = destruct_0.km();
        var y_0 = destruct_0.lm();
        this_0.f('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.k2h(tmp_1, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.k2h(tmp_2, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_7));
        var cx = destruct_1.km();
        var cy = destruct_1.lm();
        var ax = destruct_2.km();
        var ay = destruct_2.lm();
        this_0.f('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.k2h(tmp_3, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.k2h(tmp_4, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.n3y_1.i1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.k2h(tmp_5, _this__u8e3s4.n3y_1.i1(_unary__edvuaz_13));
        var cx1 = destruct_3.km();
        var cy1 = destruct_3.lm();
        var cx2 = destruct_4.km();
        var cy2 = destruct_4.lm();
        var ax_0 = destruct_5.km();
        var ay_0 = destruct_5.lm();
        this_0.f('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.f('close()');
        break;
    }
  }
  var this_2 = this_0.o8();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.f1();
  while (tmp0_iterator.g1()) {
    var item = tmp0_iterator.h1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.f(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.m78_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp350_safe_receiver = this$0.n78_1;
    return tmp350_safe_receiver == null ? null : toCurvesList(tmp350_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.z78(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.a79_1, this$0.e79_1), this$0.b79_1, this$0.c79_1, this$0.d79_1, this$0.f79_1);
  };
}
function TextShape$primitiveShapes$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.TextShape.primitiveShapes$delegate.<anonymous>.<anonymous>' call
    this_0.o5w(get_immutable(this$0.y79_1));
    this_0.a77(this$0.u79_1);
    if (!(this$0.v79_1 == null)) {
      var tmp354_safe_receiver = this$0.s79_1;
      if (tmp354_safe_receiver == null)
        null;
      else
        drawText(tmp354_safe_receiver, this_0, this$0.t79_1, this$0.q79_1, this$0.v79_1, this$0.r79_1, true);
    }
    if (!(this$0.w79_1 == null)) {
      var tmp355_safe_receiver = this$0.s79_1;
      if (tmp355_safe_receiver == null)
        null;
      else
        drawText(tmp355_safe_receiver, this_0, this$0.t79_1, this$0.q79_1, this$0.w79_1, this$0.r79_1, false);
    }
    return this_0.p5r();
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.u78();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.v78();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.n3s_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.p3s_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.q3s_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.r3s_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.s3s_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.t3s_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.u3s_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.v3s_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.b7a();
  }, null);
}
var ShapeRasterizerMethod_NONE_instance;
var ShapeRasterizerMethod_X1_instance;
var ShapeRasterizerMethod_X2_instance;
var ShapeRasterizerMethod_X4_instance;
function values_7() {
  return [ShapeRasterizerMethod_NONE_getInstance(), ShapeRasterizerMethod_X1_getInstance(), ShapeRasterizerMethod_X2_getInstance(), ShapeRasterizerMethod_X4_getInstance()];
}
var ShapeRasterizerMethod_entriesInitialized;
function ShapeRasterizerMethod_initEntries() {
  if (ShapeRasterizerMethod_entriesInitialized)
    return Unit_instance;
  ShapeRasterizerMethod_entriesInitialized = true;
  ShapeRasterizerMethod_NONE_instance = new ShapeRasterizerMethod('NONE', 0, 1.0);
  ShapeRasterizerMethod_X1_instance = new ShapeRasterizerMethod('X1', 1, 1.0);
  ShapeRasterizerMethod_X2_instance = new ShapeRasterizerMethod('X2', 2, 2.0);
  ShapeRasterizerMethod_X4_instance = new ShapeRasterizerMethod('X4', 3, 4.0);
}
function ShapeRasterizerMethod_NONE_getInstance() {
  ShapeRasterizerMethod_initEntries();
  return ShapeRasterizerMethod_NONE_instance;
}
function ShapeRasterizerMethod_X1_getInstance() {
  ShapeRasterizerMethod_initEntries();
  return ShapeRasterizerMethod_X1_instance;
}
function ShapeRasterizerMethod_X2_getInstance() {
  ShapeRasterizerMethod_initEntries();
  return ShapeRasterizerMethod_X2_instance;
}
function ShapeRasterizerMethod_X4_getInstance() {
  ShapeRasterizerMethod_initEntries();
  return ShapeRasterizerMethod_X4_instance;
}
function SVG$PolySvgElement$pps$lambda(it) {
  return !get_isNumeric(it.t2_1);
}
function SVG$PolySvgElement$pps$lambda_0(it) {
  return !get_isNumeric(it.t2_1);
}
function SVG$PathSvgElement$path$delegate$lambda(this$0) {
  return function () {
    return SvgPath_instance.p7a(this$0.m7a_1);
  };
}
var Companion_instance_63;
function Companion_getInstance_71() {
  return Companion_instance_63;
}
function _get__dom__d2l6i0($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.e7b_1;
  _dom$factory();
  return this_0.b2();
}
var Mappings_instance;
function Mappings_getInstance() {
  if (Mappings_instance === VOID)
    new Mappings();
  return Mappings_instance;
}
var Companion_instance_64;
function Companion_getInstance_72() {
  if (Companion_instance_64 === VOID)
    new Companion_54();
  return Companion_instance_64;
}
function SVG$defs$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.hashMapOf' call
    var this_0 = HashMap.c9();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.format.SVG.defs$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.s7a_1.t2f('defs').f1();
    while (_iterator__ex2g4s.g1()) {
      var defs = _iterator__ex2g4s.h1();
      var _iterator__ex2g4s_0 = defs.r2f().f1();
      while (_iterator__ex2g4s_0.g1()) {
        var def = _iterator__ex2g4s_0.h1();
        var svgDef = new SvgDef(def);
        // Inline function 'kotlin.collections.set' call
        var key = svgDef.j7b_1;
        this_0.r3(key, svgDef);
      }
    }
    return this_0;
  };
}
function SVG$cssList$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.m1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.format.SVG.cssList$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.s7a_1.t2f('style').f1();
    while (_iterator__ex2g4s.g1()) {
      var style = _iterator__ex2g4s.h1();
      // Inline function 'kotlin.collections.plusAssign' call
      var element = Companion_instance_50.d6t(style.o2f());
      this_0.f(element);
    }
    return this_0;
  };
}
function SVG$cssCombined$delegate$lambda(this$0) {
  return function () {
    return CSS.x6t(this$0.g7g());
  };
}
function SVG$_dom$delegate$lambda(this$0) {
  return function () {
    return new DOM(this$0.h7g());
  };
}
function SVG$dom$delegate$lambda(this$0) {
  return function () {
    this$0.i7g();
    return _get__dom__d2l6i0(this$0);
  };
}
function SVG$renderElement$delegate$lambda(this$0) {
  return function () {
    return new SvgElement(this$0, this$0.s7a_1);
  };
}
function SVG$animator$delegate$lambda(this$0) {
  return function () {
    return new DOMAnimator(this$0.j7g());
  };
}
function *_generator_readSVG__9pep6u(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.y22(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return SVG.l7g(tmp);
}
function readSVG(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readSVG__9pep6u(_this__u8e3s4, $completion), $completion);
}
function defs$factory() {
  return getPropertyCallableRef('defs', 1, KProperty1, function (receiver) {
    return receiver.n7c();
  }, null);
}
function cssList$factory() {
  return getPropertyCallableRef('cssList', 1, KProperty1, function (receiver) {
    return receiver.g7g();
  }, null);
}
function cssCombined$factory() {
  return getPropertyCallableRef('cssCombined', 1, KProperty1, function (receiver) {
    return receiver.h7g();
  }, null);
}
function _dom$factory() {
  return getPropertyCallableRef('_dom', 1, KProperty1, function (receiver) {
    return _get__dom__d2l6i0(receiver);
  }, null);
}
function dom$factory() {
  return getPropertyCallableRef('dom', 1, KProperty1, function (receiver) {
    return receiver.j7g();
  }, null);
}
function renderElement$factory() {
  return getPropertyCallableRef('renderElement', 1, KProperty1, function (receiver) {
    return receiver.i7g();
  }, null);
}
function transform$factory() {
  return getPropertyCallableRef('transform', 1, KMutableProperty1, function (receiver) {
    return receiver.d7c_1;
  }, function (receiver, value) {
    receiver.d7c_1 = value;
    return Unit_instance;
  });
}
function opacity$factory() {
  return getPropertyCallableRef('opacity', 1, KMutableProperty1, function (receiver) {
    return receiver.e7c_1;
  }, function (receiver, value) {
    receiver.e7c_1 = value;
    return Unit_instance;
  });
}
function path$factory() {
  return getPropertyCallableRef('path', 1, KProperty1, function (receiver) {
    return receiver.v1z();
  }, null);
}
function sqr($this, v) {
  return v * v;
}
function vmag($this, x, y) {
  // Inline function 'kotlin.math.sqrt' call
  var x_0 = x * x + y * y;
  return Math.sqrt(x_0);
}
function vecrat($this, ux, uy, vx, vy) {
  return (ux * vx + uy * vy) / (vmag($this, ux, uy) * vmag($this, vx, vy));
}
function vecang($this, ux, uy, vx, vy) {
  var r = vecrat($this, ux, uy, vx, vy);
  if (r < -1.0)
    r = -1.0;
  if (r > 1.0)
    r = 1.0;
  var tmp = ux * vy < uy * vx ? -1.0 : 1.0;
  // Inline function 'kotlin.math.acos' call
  var x = r;
  return tmp * Math.acos(x);
}
function xformPointX($this, x, y, t) {
  return x * t[0] + y * t[2] + t[4];
}
function xformPointY($this, x, y, t) {
  return x * t[1] + y * t[3] + t[5];
}
function xformVecX($this, x, y, t) {
  return x * t[0] + y * t[2];
}
function xformVecY($this, x, y, t) {
  return x * t[1] + y * t[3];
}
function parse$dumpTokens(tokens, $warningProcessor) {
  var iterator = tokens.f1();
  var index = 0;
  while (iterator.g1()) {
    var n = index;
    index = index + 1 | 0;
    var token = iterator.h1();
    if ($warningProcessor == null)
      null;
    else
      $warningProcessor('- ' + n + ': ' + toString(token));
  }
}
function parse$isNextNumber(tl) {
  var tmp;
  if (tl.uy()) {
    var tmp_0 = tl.v38();
    tmp = tmp_0 instanceof PathTokenNumber;
  } else {
    tmp = false;
  }
  return tmp;
}
function parse$readNumber(tl, $warningProcessor, tokens) {
  while (tl.uy()) {
    var token = tl.p1v();
    if (token instanceof PathTokenNumber)
      return token.e7g_1;
    if ($warningProcessor == null)
      null;
    else
      $warningProcessor('Invalid path (expected number but found ' + toString(token) + ') at ' + (tl.u38_1 - 1 | 0));
    parse$dumpTokens(tokens, $warningProcessor);
  }
  return 0.0;
}
function parse$n(tl, $warningProcessor, tokens) {
  return parse$readNumber(tl, $warningProcessor, tokens);
}
function parse$nX(out, tl, $warningProcessor, tokens, relative) {
  return relative ? out.s3y_1.i2h_1 + parse$readNumber(tl, $warningProcessor, tokens) : parse$readNumber(tl, $warningProcessor, tokens);
}
function parse$nY(out, tl, $warningProcessor, tokens, relative) {
  return relative ? out.s3y_1.j2h_1 + parse$readNumber(tl, $warningProcessor, tokens) : parse$readNumber(tl, $warningProcessor, tokens);
}
function parse$readNextTokenCmd(tl, $warningProcessor, tokens) {
  while (tl.uy()) {
    var token = tl.p1v();
    if (token instanceof PathTokenCmd)
      return token.f7g_1;
    if ($warningProcessor == null)
      null;
    else
      $warningProcessor('Invalid path (expected command but found ' + toString(token) + ') at ' + (tl.u38_1 - 1 | 0));
    parse$dumpTokens(tokens, $warningProcessor);
  }
  return null;
}
function tokenizePath$skipSeparators(_this__u8e3s4) {
  skipWhile(_this__u8e3s4, SvgPath$tokenizePath$skipSeparators$lambda);
}
function tokenizePath$readNumber(_this__u8e3s4) {
  tokenizePath$skipSeparators(_this__u8e3s4);
  var first = true;
  var pointCount = 0;
  // Inline function 'korlibs.util.readWhileBuilder' call
  // Inline function 'korlibs.util.readUntilBuilder' call
  var out = StringBuilder.h();
  $l$loop: while (_this__u8e3s4.uy()) {
    var c = _this__u8e3s4.jz();
    // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.image.vector.format.SvgPath.tokenizePath.readNumber.<anonymous>' call
      if (c === _Char___init__impl__6a9atx(46)) {
        if (pointCount > 0) {
          tmp$ret$0 = false;
          break $l$block;
        }
        pointCount = pointCount + 1 | 0;
      }
      var tmp;
      if (first) {
        first = false;
        tmp = isDigit(c) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43) || c === _Char___init__impl__6a9atx(46);
      } else if (c === _Char___init__impl__6a9atx(101) || c === _Char___init__impl__6a9atx(69)) {
        first = true;
        tmp = true;
      } else {
        tmp = isDigit(c) || c === _Char___init__impl__6a9atx(46);
      }
      tmp$ret$0 = tmp;
    }
    if (!tmp$ret$0) {
      if (false) {
        _this__u8e3s4.kz();
        out.jc(c);
      }
      break $l$loop;
    }
    _this__u8e3s4.kz();
    out.jc(c);
  }
  var str = out.toString();
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(str) === 0) {
    tmp_0 = 0.0;
  } else {
    var tmp_1;
    try {
      tmp_1 = toDouble(str);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_2 = 0.0;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function SvgPath$tokenizePath$skipSeparators$lambda(it) {
  return equals(it, new Char(_Char___init__impl__6a9atx(44))) || equals(it, new Char(_Char___init__impl__6a9atx(32))) || equals(it, new Char(_Char___init__impl__6a9atx(9))) || equals(it, new Char(_Char___init__impl__6a9atx(10))) || equals(it, new Char(_Char___init__impl__6a9atx(13)));
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function toSvgPathString_0(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.z78(_this__u8e3s4, separator, decimalPlaces);
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.i73_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.o4a($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_65;
function Companion_getInstance_73() {
  if (Companion_instance_65 === VOID)
    new Companion_55();
  return Companion_instance_65;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.s7h(HtmlImage_instance.y7g(_this__u8e3s4.o4q()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_tempB() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return tempB;
}
var tempB;
function get_tempI() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return tempI;
}
var tempI;
function get_temp8() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return temp8;
}
var temp8;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  // Inline function 'kotlin.getValue' call
  var this_0 = isLittleEndian$delegate;
  isLittleEndian$factory();
  return this_0.b2();
}
var isLittleEndian$delegate;
var NodeJsNativeImageFormatProvider_instance;
function NodeJsNativeImageFormatProvider_getInstance() {
  if (NodeJsNativeImageFormatProvider_instance === VOID)
    new NodeJsNativeImageFormatProvider();
  return NodeJsNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  var tmp = BrowserImage_instance.w7h(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.s7h(tmp));
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.x7h(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.y7h(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.n24(path);
      var tmp_1 = BrowserImage_instance.x7h(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.y7h(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.bj(path).v22($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.w7h(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.s7h(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.o7h_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.o7h_1;
      tmp = tmp_0.a7i(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.o7h_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.o7h_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.b7i().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_13().zw()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.m5(toString(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.g7i(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.h7i(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.i7i(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.id(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.db('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.id(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.w3()) == $this.o7i_1) {
    tmp = fontSize === $this.n7i_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.o7i_1 = font == null ? null : font.w3();
  $this.n7i_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.w3();
  $this.m7i_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.m7i_1.globalAlpha = state.i5n_1;
  $this.m7i_1.globalCompositeOperation = $this.p7i(state.j5n_1);
  if (doSetFont) {
    setFont($this, state.e5n_1, state.f5n_1);
  }
  if (fill) {
    $this.m7i_1.fillStyle = $this.q7i(state.c5n_1);
  } else {
    $this.m7i_1.lineWidth = state.w5m_1;
    var tmp;
    switch (state.z5m_1.v3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.m7i_1.lineJoin = tmp;
    var tmp_0;
    switch (state.p5u().v3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.m7i_1.lineCap = tmp_0;
    $this.m7i_1.strokeStyle = $this.q7i(state.b5n_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.r7i($this.m7i_1, paint.n5w());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function isLittleEndian$delegate$lambda() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  get_tempI()[0] = 1;
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  return get_temp8()[0] === 1;
}
function isLittleEndian$factory() {
  return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
    return get_isLittleEndian();
  }, null);
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.b7i();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.d7i();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_13().zw() ? NodeJsNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    tempB = new ArrayBuffer(4);
    tempI = new Int32Array(get_tempB());
    temp8 = new Uint8Array(get_tempB());
    isLittleEndian$delegate = lazy(isLittleEndian$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Atlas, 'Atlas');
initMetadataForCompanion(Companion);
initMetadataForClass(Meta, 'Meta', Meta);
initMetadataForClass(FrameTag, 'FrameTag', FrameTag);
initMetadataForClass(Layer, 'Layer', Layer);
initMetadataForClass(Slice, 'Slice');
initMetadataForClass(Key, 'Key');
initMetadataForClass(Page, 'Page');
initMetadataForClass(Region, 'Region');
initMetadataForCompanion(Companion_0);
initMetadataForClass(AtlasInfo, 'AtlasInfo', AtlasInfo.p4m);
initMetadataForClass(Entry_0, 'Entry');
initMetadataForClass(AtlasResult, 'AtlasResult');
initMetadataForClass(Result, 'Result');
initMetadataForObject(AtlasPacker, 'AtlasPacker');
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry_1, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.l4q);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion_1, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_3);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_4);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage');
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForCompanion(Companion_5);
initMetadataForClass(NinePatchBmpSlice, 'NinePatchBmpSlice');
initMetadataForClass(AxisSegment, 'AxisSegment');
initMetadataForClass(AxisInfo, 'AxisInfo');
initMetadataForClass(Segment, 'Segment');
initMetadataForClass(NinePatchInfo, 'NinePatchInfo');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(BitmapEffect, 'BitmapEffect', BitmapEffect);
initMetadataForClass(Result_0, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForObject(BGRA, 'BGRA');
initMetadataForClass(Mixin_0, 'Mixin');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForCompanion(Companion_6);
initMetadataForClass(ColorTransform, 'ColorTransform');
initMetadataForCompanion(Companion_7);
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForClass(WithDefault, 'WithDefault');
initMetadataForObject(Colors, 'Colors');
initMetadataForObject(MaterialColors, 'MaterialColors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_8);
initMetadataForCompanion(Companion_9);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_11);
initMetadataForCompanion(Companion_12);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForObject(BGRA_5551, 'BGRA_5551');
initMetadataForCompanion(Companion_13);
initMetadataForClass(RGBAf, 'RGBAf');
initMetadataForCompanion(Companion_14);
initMetadataForCompanion(Companion_15);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).f5m = get_baseBmp;
protoOf(BitmapFontImpl).j5m = getFontMetrics;
protoOf(BitmapFontImpl).m5k = getFontMetrics$default;
protoOf(BitmapFontImpl).l5m = getGlyphMetrics;
protoOf(BitmapFontImpl).o5k = getGlyphMetrics$default;
protoOf(BitmapFontImpl).t5n = getKerning;
protoOf(BitmapFontImpl).o5m = getTextScale;
protoOf(BitmapFontImpl).i1 = get_0;
protoOf(BitmapFontImpl).p5m = get_1;
protoOf(BitmapFontImpl).q5m = getGlyph;
protoOf(BitmapFontImpl).r5m = renderGlyph;
protoOf(BitmapFontImpl).s5n = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForCompanion(Companion_16);
initMetadataForClass(CharacterSet, 'CharacterSet');
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).z33 = reset;
protoOf(TextRendererActions).v5w = advance;
protoOf(TextRendererActions).w5w = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_17);
protoOf(LazyBitmapFont).f5m = get_baseBmp;
protoOf(LazyBitmapFont).j5m = getFontMetrics;
protoOf(LazyBitmapFont).m5k = getFontMetrics$default;
protoOf(LazyBitmapFont).l5m = getGlyphMetrics;
protoOf(LazyBitmapFont).o5k = getGlyphMetrics$default;
protoOf(LazyBitmapFont).t5n = getKerning;
protoOf(LazyBitmapFont).o5m = getTextScale;
protoOf(LazyBitmapFont).s14 = getOrNull_2;
protoOf(LazyBitmapFont).i1 = get_0;
protoOf(LazyBitmapFont).p5m = get_1;
protoOf(LazyBitmapFont).q5m = getGlyph;
protoOf(LazyBitmapFont).r5m = renderGlyph;
protoOf(LazyBitmapFont).s5n = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_18);
initMetadataForClass(NativeSystemFontProvider, 'NativeSystemFontProvider', NativeSystemFontProvider);
initMetadataForClass(TtfNativeSystemFontProvider, 'TtfNativeSystemFontProvider');
initMetadataForClass(FallbackNativeSystemFontProvider, 'FallbackNativeSystemFontProvider');
initMetadataForCompanion(Companion_19);
initMetadataForLambda(FolderBasedNativeSystemFontProvider$listFontNamesMap$slambda, VOID, VOID, [1]);
initMetadataForLambda(FolderBasedNativeSystemFontProvider$loadFontByName$slambda, VOID, VOID, [1]);
initMetadataForClass(FolderBasedNativeSystemFontProvider, 'FolderBasedNativeSystemFontProvider');
initMetadataForCompanion(Companion_20, VOID, VOID, [0]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(SystemFont).m5k = getFontMetrics$default;
protoOf(SystemFont).o5k = getGlyphMetrics$default;
protoOf(SystemFont).i62 = getGlyphPath$default;
protoOf(SystemFont).r5m = renderGlyph_0;
protoOf(SystemFont).s5n = renderGlyph$default;
protoOf(SystemFont).s14 = getOrNull_2;
initMetadataForClass(SystemFont, 'SystemFont', VOID, VOID, [VectorFont], [0]);
initMetadataForCompanion(Companion_21);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.m63, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_22);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_23, VOID, VOID, [1]);
protoOf(BaseTtfFont).m5k = getFontMetrics$default;
protoOf(BaseTtfFont).o5k = getGlyphMetrics$default;
protoOf(BaseTtfFont).i62 = getGlyphPath$default;
protoOf(BaseTtfFont).r5m = renderGlyph_0;
protoOf(BaseTtfFont).s5n = renderGlyph$default;
protoOf(BaseTtfFont).s14 = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_24);
initMetadataForCompanion(Companion_25);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_26);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).w6b = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).w6b = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).s4a = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$1$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$1$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$1$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_27);
initMetadataForCompanion(Companion_28);
initMetadataForClass(Mixin_1, 'Mixin', Mixin_1);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForInterface(AseCell, 'AseCell');
protoOf(AseBitmapCell).g6f = resolve;
initMetadataForClass(AseBitmapCell, 'AseBitmapCell', VOID, VOID, [AseCell]);
initMetadataForClass(AseLinkedCell, 'AseLinkedCell', VOID, VOID, [AseCell]);
protoOf(AseTilemapCell).g6f = resolve;
initMetadataForClass(AseTilemapCell, 'AseTilemapCell', VOID, VOID, [AseCell]);
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(AseLayer, 'AseLayer');
initMetadataForClass(AseFrame, 'AseFrame');
initMetadataForClass(AsePalette, 'AsePalette');
initMetadataForClass(AseTileset, 'AseTileset');
initMetadataForClass(AseSliceKey, 'AseSliceKey');
initMetadataForClass(AseSlice, 'AseSlice');
initMetadataForClass(AseTag, 'AseTag');
initMetadataForClass(AseImage, 'AseImage', AseImage);
initMetadataForInterface(ImageFormatDecoder, 'ImageFormatDecoder', VOID, VOID, VOID, [2]);
protoOf(ImageFormat).q6k = decode$default;
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, [ImageFormatDecoder], [2, 1]);
initMetadataForClass(ImageFormatWithContainer, 'ImageFormatWithContainer', VOID, VOID, VOID, [2, 1]);
initMetadataForObject(ASE, 'ASE', VOID, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_29);
initMetadataForCompanion(Companion_30);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_31);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_32);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.x6m, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_33);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_34);
initMetadataForClass(Type, 'Type');
protoOf(NativeImageFormatProvider).q6k = decode$default;
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', VOID, VOID, [ImageFormatDecoder], [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [2, 1, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_35);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_36);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_37);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_38);
initMetadataForCompanion(Companion_39);
initMetadataForClass(Token, 'Token');
protoOf(sam$korlibs_math_interpolation_Easing$0).yz = invoke;
protoOf(sam$korlibs_math_interpolation_Easing$0).zz = invoke_0;
initMetadataForClass(sam$korlibs_math_interpolation_Easing$0, 'sam$korlibs_math_interpolation_Easing$0', VOID, VOID, [Easing]);
initMetadataForClass(IdSelector, 'IdSelector');
initMetadataForClass(ClassSelector, 'ClassSelector');
initMetadataForClass(UnknownSelector, 'UnknownSelector');
initMetadataForClass(Expression, 'Expression');
initMetadataForClass(Declaration, 'Declaration');
initMetadataForClass(Declarations, 'Declarations');
initMetadataForClass(RuleSet, 'RuleSet');
initMetadataForClass(KeyFrame, 'KeyFrame');
initMetadataForClass(InterpolationResult, 'InterpolationResult', InterpolationResult);
initMetadataForClass(Animation, 'Animation');
initMetadataForClass(KeyFrames, 'KeyFrames');
initMetadataForCompanion(Companion_40);
initMetadataForClass(CSS, 'CSS');
initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(CSSReader, 'CSSReader');
initMetadataForClass(RatioMapping, 'RatioMapping');
initMetadataForClass(MatrixMapping, 'MatrixMapping');
initMetadataForClass(DomPropertyMapping, 'DomPropertyMapping', DomPropertyMapping);
initMetadataForClass(DomElement, 'DomElement');
initMetadataForInterface(DomListener, 'DomListener');
initMetadataForClass(ComposedDomListener, 'ComposedDomListener', VOID, VOID, [DomListener]);
initMetadataForCompanion(Companion_41);
protoOf(DOM$internalListener$1).f6v = updatedElement;
initMetadataForClass(DOM$internalListener$1, VOID, VOID, VOID, [DomListener]);
initMetadataForClass(DOM, 'DOM');
protoOf(DOMAnimator$1).a6v = removedId;
protoOf(DOMAnimator$1).b6v = addedId;
initMetadataForClass(DOMAnimator$1, VOID, VOID, VOID, [DomListener]);
initMetadataForClass(DOMAnimator, 'DOMAnimator');
initMetadataForCompanion(Companion_42);
initMetadataForClass(Line, 'Line');
initMetadataForInterface(Node, 'Node');
initMetadataForClass(Style, 'Style');
initMetadataForClass(TextNode, 'TextNode', VOID, VOID, [Node]);
initMetadataForCompanion(Companion_43);
initMetadataForClass(RichTextData, 'RichTextData', VOID, VOID, [KtList]);
initMetadataForClass(Placement, 'Placement');
initMetadataForClass(RichTextDataPlacements, 'RichTextDataPlacements', RichTextDataPlacements, VOID, [KtList]);
initMetadataForCompanion(Companion_44);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_45);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_46);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_2, 'Entry', Entry_2);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForCompanion(Companion_47);
initMetadataForCompanion(Companion_48);
initMetadataForClass(TileMapData, 'TileMapData', VOID, VOID, [BaseDelegatedStackedArray2, IStackedArray2Base]);
initMetadataForClass(TileMapRepeat, 'TileMapRepeat');
initMetadataForCompanion(Companion_49);
initMetadataForClass(TileSet, 'TileSet');
initMetadataForClass(TileSetTileInfo, 'TileSetTileInfo');
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(BitmapVector, 'BitmapVector');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_50);
initMetadataForCompanion(Companion_51);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).b48 = moveTo;
protoOf(Context2d).c48 = lineTo;
protoOf(Context2d).l4a = line;
protoOf(Context2d).m4a = arcTo;
protoOf(Context2d).a1 = isEmpty;
protoOf(Context2d).n4a = rect;
protoOf(Context2d).o4a = rect_0;
protoOf(Context2d).p4a = rect_1;
protoOf(Context2d).a4b = rect_2;
protoOf(Context2d).q4a = roundRect;
protoOf(Context2d).b4b = roundRect_0;
protoOf(Context2d).r4a = arc;
protoOf(Context2d).s4a = arc$default;
protoOf(Context2d).m3s = circle;
protoOf(Context2d).c4b = ellipse;
protoOf(Context2d).t4a = lineToH;
protoOf(Context2d).u4a = lineToV;
protoOf(Context2d).v4a = rLineToH;
protoOf(Context2d).w4a = rLineToV;
protoOf(Context2d).x4a = rMoveTo;
protoOf(Context2d).y4a = rLineTo;
protoOf(Context2d).j2u = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForClass(scaled$1);
initMetadataForCompanion(Companion_52);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForInterface(BoundsDrawable, 'BoundsDrawable');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape', VOID, VOID, [BoundsDrawable]);
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).l78 = getBounds;
protoOf(FillShape).k78 = getPath_0;
protoOf(FillShape).y5x = getPath$default;
protoOf(FillShape).f5x = draw;
protoOf(FillShape).f6c = get_bounds;
protoOf(FillShape).j2y = get_width;
protoOf(FillShape).k2y = get_height;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).y5x = getPath$default;
protoOf(CompoundShape).f6c = get_bounds;
protoOf(CompoundShape).j2y = get_width;
protoOf(CompoundShape).k2y = get_height;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).k78 = getPath_0;
protoOf(PolylineShape).y5x = getPath$default;
protoOf(PolylineShape).f5x = draw;
protoOf(PolylineShape).f6c = get_bounds;
protoOf(PolylineShape).j2y = get_width;
protoOf(PolylineShape).k2y = get_height;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
protoOf(TextShape).v1z = get_path;
protoOf(TextShape).k78 = getPath_0;
protoOf(TextShape).y5x = getPath$default;
protoOf(TextShape).f5x = draw;
protoOf(TextShape).f6c = get_bounds;
protoOf(TextShape).j2y = get_width;
protoOf(TextShape).k2y = get_height;
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).k78 = getPath;
protoOf(EmptyShape).y5x = getPath$default;
protoOf(EmptyShape).f6c = get_bounds;
protoOf(EmptyShape).j2y = get_width;
protoOf(EmptyShape).k2y = get_height;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForClass(ShapeRasterizerMethod, 'ShapeRasterizerMethod');
initMetadataForCompanion(Companion_53);
initMetadataForClass(SvgDef, 'SvgDef');
initMetadataForObject(Mappings, 'Mappings');
initMetadataForClass(SvgElement, 'SvgElement');
initMetadataForClass(RectSvgElement, 'RectSvgElement');
initMetadataForClass(CircleSvgElement, 'CircleSvgElement');
initMetadataForClass(EllipseSvgElement, 'EllipseSvgElement');
initMetadataForClass(PolySvgElement, 'PolySvgElement');
initMetadataForClass(LineSvgElement, 'LineSvgElement');
initMetadataForClass(TextSvgElement, 'TextSvgElement');
initMetadataForClass(PathSvgElement, 'PathSvgElement');
initMetadataForClass(CSSDeclarations, 'CSSDeclarations', CSSDeclarations);
initMetadataForCompanion(Companion_54);
initMetadataForClass(PathTokenNumber, 'PathTokenNumber');
initMetadataForClass(PathTokenCmd, 'PathTokenCmd');
initMetadataForClass(SVG, 'SVG');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_55);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NodeJsNativeImageFormatProvider, 'NodeJsNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_9 = new Companion();
Companion_instance_10 = new Companion_0();
AtlasPacker_instance = new AtlasPacker();
Companion_instance_12 = new Companion_2();
Bitmaps_instance = new Bitmaps();
Companion_instance_14 = new Companion_4();
Companion_instance_15 = new Companion_5();
NewSDF_instance = new NewSDF();
Companion_instance_16 = new Companion_6();
Companion_instance_17 = new Companion_7();
Companion_instance_19 = new Companion_9();
Companion_instance_21 = new Companion_11();
Companion_instance_22 = new Companion_12();
Companion_instance_23 = new Companion_13();
Companion_instance_24 = new Companion_14();
Companion_instance_25 = new Companion_15();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
Companion_instance_30 = new Companion_20();
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_34 = new Companion_24();
Companion_instance_36 = new Companion_26();
Companion_instance_37 = new Companion_27();
Companion_instance_38 = new Companion_28();
Companion_instance_39 = new Companion_29();
Companion_instance_41 = new Companion_31();
Companion_instance_43 = new Companion_33();
Companion_instance_46 = new Companion_36();
Companion_instance_47 = new Companion_37();
NonePaint_instance = new NonePaint();
Companion_instance_49 = new Companion_39();
Companion_instance_50 = new Companion_40();
Companion_instance_51 = new Companion_41();
Companion_instance_58 = new Companion_48();
Companion_instance_61 = new Companion_51();
EmptyShape_instance = new EmptyShape();
Companion_instance_63 = new Companion_53();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  BitmapChannel_ALPHA_getInstance as BitmapChannel_ALPHA_getInstance2af1cve68aq1s,
  Direction_FORWARD_getInstance as Direction_FORWARD_getInstance2z9se4ftbc6nn,
  Direction_ONCE_REVERSE_getInstance as Direction_ONCE_REVERSE_getInstance2zwiu4ujrmbas,
  Direction_REVERSE_getInstance as Direction_REVERSE_getInstance345lw1ugqe83y,
  GradientInterpolationMethod_LINEAR_getInstance as GradientInterpolationMethod_LINEAR_getInstance3o4xsg00vfgv6,
  GradientInterpolationMethod_NORMAL_getInstance as GradientInterpolationMethod_NORMAL_getInstance25j9adkqotkam,
  GradientKind_LINEAR_getInstance as GradientKind_LINEAR_getInstance2913i2r9znmz6,
  GradientKind_RADIAL_getInstance as GradientKind_RADIAL_getInstance1ck78a4imhrkm,
  GradientKind_SWEEP_getInstance as GradientKind_SWEEP_getInstance2nsgf0mxeho86,
  TileMapRepeat_NONE_getInstance as TileMapRepeat_NONE_getInstance1rwcpdxdrcp50,
  CycleMethod_NO_CYCLE_getInstance as CycleMethod_NO_CYCLE_getInstancebe2q8ehvdorv,
  CycleMethod_REFLECT_getInstance as CycleMethod_REFLECT_getInstancejnj3c4t5urcx,
  CycleMethod_REPEAT_getInstance as CycleMethod_REPEAT_getInstance5g0up2ih5p7m,
  ShapeRasterizerMethod_NONE_getInstance as ShapeRasterizerMethod_NONE_getInstancewicc6udl8ru7,
  ShapeRasterizerMethod_X4_getInstance as ShapeRasterizerMethod_X4_getInstance2a78eqls9c7ts,
  readAtlas as readAtlas2ph83xfha5q5t,
  readFont as readFont45tmpsdawgck,
  readTtfFont as readTtfFont31q01sbixp9wj,
  readBitmapSlice as readBitmapSlice1mxfjm5uys58e,
  readBitmap_0 as readBitmap1xlsnvr8f9icc,
  readBitmap as readBitmap1dn2o52mvbpv4,
  readImageDataContainer as readImageDataContainerm9mp5km2d0ql,
  readVectorImage as readVectorImage3lc7lmj3f80g8,
  _ColorAdd___init__impl__q78um5 as _ColorAdd___init__impl__q78um5gky0ff72uk7r,
  _ColorAdd___get_a__impl__c1r8ux as _ColorAdd___get_a__impl__c1r8ux3viqig9khweua,
  _ColorAdd___get_b__impl__grv87a as _ColorAdd___get_b__impl__grv87amaxn3ehj16vp,
  _ColorAdd___get_g__impl__itrhk1 as _ColorAdd___get_g__impl__itrhk12ga6a629kamfn,
  _ColorAdd___get_r__impl__j9xkne as _ColorAdd___get_r__impl__j9xkne17vuqwxy9emvi,
  _RGBA___get_a__impl__6msvu7 as _RGBA___get_a__impl__6msvu72gkofe1pz7ypd,
  _RGBA___get_ad__impl__pt5rdj as _RGBA___get_ad__impl__pt5rdj3f7zi8gf9z65b,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3iv1uv3wd82oh,
  _RGBA___get_b__impl__m6tl80 as _RGBA___get_b__impl__m6tl80172fwst9o63y,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg3ni93gubw9yz3,
  _RGBA___get_g__impl__o8pukr as _RGBA___get_g__impl__o8pukr1ulyqj17gj1s1,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1u2gy3h5k9nkx,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf63jsbsnnrny7w3,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmzp2nzhttcejz,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqcbb8bnh8j0y24,
  _RGBA___get_premultipliedFast__impl__qiau4g as _RGBA___get_premultipliedFast__impl__qiau4g1xqusknfne7tm,
  _RGBA___get_r__impl__duz7mo as _RGBA___get_r__impl__duz7mo1b9m6cls2dem1,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k3pk03bu2ddet,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqt1opkd4mw5vm2z,
  RGBA__times_impl_wehs9n as RGBA__times_impl_wehs9nfzkdmuyd5ryl,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2cnrrhh9rakoc,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8v1fb2bqjo5n70o,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralaopec5nyxs57ng,
  RGBA__withAf_impl_dpdu32 as RGBA__withAf_impl_dpdu321jt40ermi0we8,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn1b7069ioje2c2,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on213rxeu9ptyi9h,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron74okc5xdveso1,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4y18zok6tr9apch,
  _RGBAf___init__impl__idjpgn_0 as _RGBAf___init__impl__idjpgn3v4e95yu3zu9w,
  _RGBAf___get_a__impl__qnwk97 as _RGBAf___get_a__impl__qnwk97nsawxd1lbayz,
  _RGBAf___set_a__impl__iqz7cx as _RGBAf___set_a__impl__iqz7cx1qajwl4l0k985,
  RGBAf__add_impl_uilb1e as RGBAf__add_impl_uilb1e36b62lk2wc3u,
  _RGBAf___get_b__impl__fjl0nq as _RGBAf___get_b__impl__fjl0nq1o2dnt97u8qzk,
  _RGBAf___set_b__impl__a2n9pa as _RGBAf___set_b__impl__a2n9pahuqyycqk52np,
  _RGBAf___get_g__impl__dhoraz as _RGBAf___get_g__impl__dhoraz13ppxfta6enl4,
  _RGBAf___set_g__impl__c4jj21 as _RGBAf___set_g__impl__c4jj2120t27iiarj9x0,
  _RGBAf___get_r__impl__jfq8gq as _RGBAf___get_r__impl__jfq8gq22u7iwwxqf9kv,
  _RGBAf___set_r__impl__pz5j5e as _RGBAf___set_r__impl__pz5j5e15wzi2b78qt85,
  _RGBAf___get_rgba__impl__ui2t32 as _RGBAf___get_rgba__impl__ui2t323bpqee4gahejg,
  RGBAf__setTo_impl_x4m1oi as RGBAf__setTo_impl_x4m1oi752w68zt7ajs,
  RGBAf__setTo_impl_x4m1oi_1 as RGBAf__setTo_impl_x4m1oi2i8ob5z12xmk,
  RGBAf__setTo_impl_x4m1oi_0 as RGBAf__setTo_impl_x4m1oi26jznhcu6qich,
  _RgbaArray___init__impl__oib4y4 as _RgbaArray___init__impl__oib4y43cjeodgxd0rus,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hyhrkrjwkiqj0l,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfwwtut2j2hfgv,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y61hxbkot1sg4z0,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv3b9t7y5yljykc,
  _Tile___get_data__impl__sfu1ss as _Tile___get_data__impl__sfu1ss2s3x8eomzpvh5,
  _Tile___get_flipX__impl__jobqpf as _Tile___get_flipX__impl__jobqpfe9cgmzzfemed,
  _Tile___get_flipY__impl__95aqcs as _Tile___get_flipY__impl__95aqcseyyd2ly5g92f,
  Tile__hashCode_impl_ubobok as Tile__hashCode_impl_ubobok3tqsleujf9ax8,
  _Tile___get_isInvalid__impl__yfg9ed as _Tile___get_isInvalid__impl__yfg9ed173l8j2a3h38e,
  _Tile___get_isValid__impl__nlo03e as _Tile___get_isValid__impl__nlo03e2mhmmy4urkdxd,
  _Tile___get_offsetX__impl__qwhdsd as _Tile___get_offsetX__impl__qwhdsd2u0qshojurkrv,
  _Tile___get_offsetY__impl__1x539u as _Tile___get_offsetY__impl__1x539um3hkx58tbqvt,
  _Tile___get_rotate__impl__5kjdv9 as _Tile___get_rotate__impl__5kjdv91g1hqxlteoxnf,
  _Tile___get_tile__impl__nfq1aw as _Tile___get_tile__impl__nfq1aw343zt1qckjepn,
  Tile__toString_impl_iy9thp as Tile__toString_impl_iy9thpd5dj258mzgi6,
  AtlasPacker_instance as AtlasPacker_instance3njp6qtlzeo8x,
  Bitmaps_instance as Bitmaps_instancebct336c8d0m7,
  BGRA_5551_getInstance as BGRA_5551_getInstance2mf7chkayi3uu,
  BGRA_getInstance as BGRA_getInstance1jlz9n65lstj1,
  Companion_instance_17 as Companion_instance28pvop2a7cl7d,
  Colors_getInstance as Colors_getInstance1qvds1isfbag2,
  MaterialColors_getInstance as MaterialColors_getInstance1lpfveu52xgfj,
  Companion_getInstance_28 as Companion_getInstanceocd6ti8e4l21,
  Companion_instance_25 as Companion_instancevwyx2uq9kvqe,
  Companion_instance_24 as Companion_instance307r99gfwddav,
  Companion_getInstance_34 as Companion_getInstance1p5o3grjloafn,
  ASE_getInstance as ASE_getInstance1eqtiryc16lrg,
  Companion_getInstance_50 as Companion_getInstance29pn999oa011x,
  PNG_getInstance as PNG_getInstance2phopdctkwslg,
  NonePaint_instance as NonePaint_instancek3yy5o7n1y50,
  Companion_getInstance_61 as Companion_getInstanceqt8o2xg52sv0,
  Companion_getInstance_64 as Companion_getInstance2fl1toxz5lf8a,
  Companion_getInstance_62 as Companion_getInstance1rfeljt05xntw,
  Companion_getInstance_65 as Companion_getInstance1y19lmoptxnwi,
  Companion_getInstance_67 as Companion_getInstancenwobv30yoie,
  Companion_getInstance_70 as Companion_getInstance2idzw3eipflw0,
  EmptyShape_instance as EmptyShape_instance7pcf1jiur1zr,
  MutableAtlas as MutableAtlas41tbjanvwcb0,
  add as add2qjqug2ygwo4y,
  BitmapEffect as BitmapEffect3nrrxebx6tit3,
  Bitmap32Context2d_0 as Bitmap32Context2d1xx7pfswf9phl,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage_0 as NativeImage33w1i7ec8zfym,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  get_bounds_0 as get_bounds3v18gk1bgnv5r,
  extract_0 as extractrn4rijx1x4kx,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  sliceWithSize as sliceWithSize2okpd9nq8v6n3,
  slice_0 as slice2pfxfvku0ybgy,
  get_ColorAdd_NEUTRAL as get_ColorAdd_NEUTRAL1xv2kr8lpc2tn,
  ColorAdd_pack as ColorAdd_pack3r2zgiosu4kvu,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  ColorTransform as ColorTransform3dmo0aeuiflxt,
  RGBAf as RGBAf2yz23qr0gb5h3,
  RGBA as RGBA34obx2i62wcl3,
  decode_0 as decode23c6atnc2eonu,
  interpolate_4 as interpolate2qv1iflz655kr,
  setToColorPremultiplied as setToColorPremultiplied262aculpj6azp,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFont as get_DefaultTtfFontddovg6zy24ck,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  GlyphMetrics as GlyphMetrics287h9a5nacttn,
  SystemFont as SystemFont1o0xb03tghhtk,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBoundsWithGlyphs as getTextBoundsWithGlyphsa2ggkffutq4d,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  get_lazyBitmap_0 as get_lazyBitmap3pyj425xl7cp4,
  get_lazyBitmapSDF as get_lazyBitmapSDF1i790bqc57mil,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  get_nativeImageFormatProvider as get_nativeImageFormatProvidery5ujkkhajtmi,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  toProps as toPropsuld7zaezrb2a,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  Style as Style3c9y3it7ye9du,
  RichTextData as RichTextData1m4oei1jdcuz5,
  Entry_2 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  bounds as bounds39r89eou7x4l9,
  drawRichText as drawRichTextyqpa5ren8u0j,
  fromHTML as fromHTMLu0erjeijja8h,
  invoke_1 as invoke2ot88cm6qcfmr,
  place as placem8wpiy4fm4tw,
  TileMapData as TileMapData285v3okd3krdh,
  TileSetTileInfo as TileSetTileInfo253o60hp1pekl,
  Tile as Tilejvhqhoacncec,
  flippedX as flippedX1d8oy0yl9d737,
  flippedY as flippedY21xqtg7yj14hj,
  rotatedRight as rotatedRight1d92miv84rwna,
  SVG as SVG3gleh7ai3c141,
  BitmapVector as BitmapVector1i7qp6908cg6h,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  values_7 as values3n9ql9zpv12og,
  TextShape as TextShape3u9vrw15swk1x,
  scaled_0 as scaled3gdp9stc6gl4n,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
